
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("QtTDf", function(module, exports) {

$parcel$export(module.exports, "ConfirmationPage", function () { return $8326bec15031b53f$export$a822667bb1b64a01; });
// @ts-nocheck

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("bN37s");
var $g1c3n = parcelRequire("g1c3n");

var $aO3Hl = parcelRequire("aO3Hl");

var $9Dbz6 = parcelRequire("9Dbz6");
const $8326bec15031b53f$export$a822667bb1b64a01 = ({ availableProducts: availableProducts })=>{
    const { getProfileCallback: getProfileCallback } = (0, $aO3Hl.useGupsStatus)();
    const [subAnchor, setSubAnchor] = (0, $iSvIT.useState)();
    (0, $iSvIT.useEffect)(()=>{
        const getData = async ()=>{
            const result = await getProfileCallback();
            if (result?.error) console.log(`gups profile error ${result.error}`);
            if (result?.data) {
                const { data: data } = result;
                setSubAnchor(data?.paidChannelContext?.confluence?.subAnchor);
            }
        };
        getData();
    }, [
        getProfileCallback
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g1c3n.ConfirmationPageTemplate), {
        featureFlags: window.featureFlags || (0, $9Dbz6.getFeatureFlagValues)(window.location.search.split("&")),
        isProduction: true,
        subAnchor: subAnchor,
        availableProducts: availableProducts
    });
};

});
parcelRegister("bN37s", function(module, exports) {
$parcel$export(module.exports, "ConfirmationPageTemplate", function () { return (parcelRequire("g1c3n")).ConfirmationPageTemplate; });

var $g1c3n = parcelRequire("g1c3n");
parcelRequire("cIEaV");

});
parcelRegister("g1c3n", function(module, exports) {

$parcel$export(module.exports, "ConfirmationPageTemplate", function () { return $7dff9f544d553523$export$5b684a50cbb41089; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $jXTzN = parcelRequire("jXTzN");
var $g9kzu = parcelRequire("g9kzu");
parcelRequire("6U37U");
var $iCjX3 = parcelRequire("iCjX3");

var $jgJpJ = parcelRequire("jgJpJ");

var $gkhN4 = parcelRequire("gkhN4");

var $eQzlz = parcelRequire("eQzlz");

var $k4Qty = parcelRequire("k4Qty");

var $5wOn9 = parcelRequire("5wOn9");

var $4KDmv = parcelRequire("4KDmv");

var $aO3Hl = parcelRequire("aO3Hl");

var $77Hlt = parcelRequire("77Hlt");

var $dmKCp = parcelRequire("dmKCp");

var $cyj4X = parcelRequire("cyj4X");

var $fHG2S = parcelRequire("fHG2S");

var $b24io = parcelRequire("b24io");
var $7dff9f544d553523$require$ApolloProvider = $b24io.ApolloProvider;
const { GRAPHQL_WEBHOOK_SETUP: $7dff9f544d553523$var$GRAPHQL_WEBHOOK_SETUP } = (0, $jgJpJ.UfoCustomTimingKey);
const $7dff9f544d553523$export$5b684a50cbb41089 = ({ isProduction: isProduction, featureFlags: featureFlags, availableProducts: availableProducts, subAnchor: subAnchor })=>{
    const { products: products, cloudId: cloudId, provisioningRequestId: provisioningRequestId, onDemandUrl: onDemandUrl, platform: platform, requestId: requestId, orchestrationId: orchestrationId } = (0, $aO3Hl.useSearchParameters)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const userInfo = (0, $5wOn9.useLoggedInUser)();
    const productKey = products.length > 0 ? products[0] : undefined;
    const bundleProductKeys = products.length > 0 ? products.map((product)=>product).join(",") : "";
    const { apolloClient: apolloClient } = (0, $eQzlz.useGraphqlClient)({
        reactComponent: "ConfirmationPageTemplate",
        orchestrationId: orchestrationId,
        logParams: {
            productKey: productKey,
            bundleProductKeys: bundleProductKeys
        }
    });
    (0, $jgJpJ.ufoEventRedirectToProduct).endSubstep($7dff9f544d553523$var$GRAPHQL_WEBHOOK_SETUP);
    const isDirectBuy = window.location.pathname === "/buy/cloud/confirmation";
    (0, $iSvIT.useEffect)(()=>{
        /**
     * Start UFO to measure the performance and reliability
     * of product landing from confirmation page
     *   - https://go/signup-slo
     *   - https://go/signup-ufo
     **/ (0, $jgJpJ.ufoEventRedirectToProduct).start({
            productKey: productKey,
            bundleProductKeys: bundleProductKeys
        });
        (0, $jgJpJ.ufoEventRedirectToProduct).setCustomData({
            provisioningRequestId: provisioningRequestId,
            cloudId: cloudId,
            orchestrationId: orchestrationId
        });
    }, []); // Empty dependency array required to run once for analytics, initialization, etc.
    // ATLAS-61644: update user profile with local storage team type
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const { getAnchorLocalStorage: getAnchorLocalStorage } = (0, $k4Qty.useAnchorLocalStorage)();
    (0, $iSvIT.useEffect)(()=>{
        const anchorLocalStorage = getAnchorLocalStorage();
        if (anchorLocalStorage) try {
            const localStorageObj = JSON.parse(anchorLocalStorage);
            if (localStorageObj && localStorageObj.team) (0, $dmKCp.updateUserProfile)({
                selectedTeamType: localStorageObj.team,
                stargateClient: stargateClient
            });
        } catch (err) {
            console.log(err);
        }
    }, []);
    /*
   * when the user is logged out coming to confirmation page causing errors
   * re-directing them to identity to login and then comeback.
   */ (0, $iSvIT.useEffect)(()=>{
        const loginUrl = `${(0, $jgJpJ.getIdentityBaseUrl)()}/login?`;
        if (!userInfo.requestInProgress && !userInfo.isUserLoggedIn) window.location.assign(`${loginUrl}continue=${encodeURIComponent(window.location.href)}`);
    }, [
        userInfo
    ]);
    // Don't show the UI if the user is not logged in.
    // The user will be redirected to the login page if they're not logged in.
    if (!userInfo.isUserLoggedIn) return;
    // Confluence loading page
    if (products.length === 1 && products[0] === "confluence.ondemand") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4KDmv.ClientOnly), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)($7dff9f544d553523$require$ApolloProvider, {
            client: apolloClient,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iCjX3.SignupProvisioningModule), {
                subAnchor: subAnchor
            })
        })
    });
    const defaultAnalyticsData = {
        schemaVersion: 1,
        event: "event",
        // event verb, in past tense (eg, "clicked")
        eventType: "ui",
        eventComponent: "signUpConfirmationPage",
        // name of component being interacted with, in camelCase
        eventContainer: "signUpConfirmationPage",
        // container, in camelCase; eg, component that contains this component within a page
        eventColumn: "signUpConfirmationPage",
        // should be bundleInformation or signUpForm
        eventName: "signUpConfirmationPageEvent",
        label: "",
        // the text present on the component being clicked (exact text, not camelCase)
        parentLabel: "",
        // optional, if this is a nested click (exact text, not camelCase)
        uuid: "signUpConfirmationPage",
        products: // required for Magnolia events, unique id for a given component if available
        products
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4KDmv.ClientOnly), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jXTzN.default), {
            data: defaultAnalyticsData,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $77Hlt.ConfirmationPageProvider), {
                createAnalyticsEvent: createAnalyticsEvent,
                availableProducts: availableProducts,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aO3Hl.JiraTemplateChoiceProvider), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)($7dff9f544d553523$require$ApolloProvider, {
                        client: apolloClient,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aO3Hl.GupsProvider), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aO3Hl.CloudStatusProvider), {
                                isProduction: isProduction,
                                onDemandUrl: onDemandUrl ?? "",
                                cloudId: cloudId,
                                platform: platform,
                                requestId: requestId,
                                isDirectBuy: isDirectBuy,
                                children: isDirectBuy ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $aO3Hl.CloudStatusDirectBuyRedirectionProvider), {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cyj4X.BundleViewSwitch), {})
                                }) : products.length > 1 ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $aO3Hl.CloudStatusBundleRedirectionProvider), {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cyj4X.BundleViewSwitch), {})
                                }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $aO3Hl.CloudStatusRedirectionProvider), {
                                    featureFlags: featureFlags,
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fHG2S.ProductViewSwitch), {})
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("6U37U", function(module, exports) {

$parcel$export(module.exports, "SignupProvisioningModule", function () { return (parcelRequire("iCjX3")).SignupProvisioningModule; });

var $iCjX3 = parcelRequire("iCjX3");

});
parcelRegister("iCjX3", function(module, exports) {

$parcel$export(module.exports, "SignupProvisioningModule", function () { return $81b2fcb695217378$export$9d886131699dcb7f; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $aR9rM = parcelRequire("aR9rM");

var $jXTzN = parcelRequire("jXTzN");

var $iMdoL = parcelRequire("iMdoL");

var $aO3Hl = parcelRequire("aO3Hl");

var $gyY7b = parcelRequire("gyY7b");

var $1LPIk = parcelRequire("1LPIk");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");

var $gTIJy = parcelRequire("gTIJy");

var $2y9w7 = parcelRequire("2y9w7");

var $c3QWr = parcelRequire("c3QWr");

var $kmxlM = parcelRequire("kmxlM");

(parcelRequire("7sANf")).then(({ loadErrorMessages: loadErrorMessages, loadDevMessages: loadDevMessages })=>{
    loadErrorMessages();
    loadDevMessages();
});
const $81b2fcb695217378$export$9d886131699dcb7f = ({ subAnchor: subAnchor })=>{
    const { linkAccountToAnonymousIdCallback: linkAccountToAnonymousIdCallback } = (0, $aO3Hl.useGupsStatus)();
    const hasTargetedSubAnchor = (0, $aR9rM.isInProductJourneySubAnchor)(subAnchor);
    const cfind356SetupByJtbdExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).cfind356SetupByJtbd);
    (0, $iSvIT.useEffect)(()=>{
        linkAccountToAnonymousIdCallback();
    }, [
        linkAccountToAnonymousIdCallback
    ]);
    const searchParameters = new URLSearchParams(location.search);
    const products = (0, $iSvIT.useMemo)(()=>(searchParameters.get("products") ?? "").split(","), [
        location.search
    ]);
    const { profile: profile } = (0, $iMdoL.useUserContext)();
    const sites = profile.attributes?.existingSites;
    const hasOnlyConfluenceSites = sites ? sites.every((site)=>{
        const products = site.products;
        return products.every(({ productName: productName })=>productName === "confluence");
    }) : true;
    const isXflow = !hasOnlyConfluenceSites;
    const edition = searchParameters.get("edition") ?? undefined;
    const templateId = searchParameters.get("templateId") ?? undefined;
    const defaultAnalyticsAttributes = {
        schemaVersion: 1,
        event: "event",
        // event verb, in past tense (eg, "clicked")
        eventType: "ui",
        eventComponent: "signUpProvisioningModule",
        // name of component being interacted with, in camelCase
        eventContainer: "signUpConfirmationPage",
        // container, in camelCase; eg, component that contains this component within a page
        eventColumn: "signUpConfirmationPage",
        // should be bundleInformation or signUpForm
        eventName: "signUpConfirmationPageEvent",
        label: "",
        // the text present on the component being clicked (exact text, not camelCase)
        parentLabel: "",
        // optional, if this is a nested click (exact text, not camelCase)
        uuid: "signUpConfirmationPage",
        products: // required for Magnolia events, unique id for a given component if available
        products
    };
    const productKey = (0, $iSvIT.useMemo)(()=>products.length > 0 ? products[0] : undefined, [
        products
    ]);
    const dataFoundationAttributes = {
        productKey: productKey,
        edition: edition
    };
    const layout = (0, $iSvIT.useMemo)(()=>(0, $gTIJy.getLayout)(products), [
        products
    ]);
    const isEligibleForTailorSubAnchorJourneyExp = !isXflow && !templateId && hasTargetedSubAnchor && layout === "confluence";
    (0, $1MbAx.useFeatureExposed)("cfind-3233-in-product-sub-anchors-journeys", "enrolled", {
        conditions: [
            isEligibleForTailorSubAnchorJourneyExp
        ]
    });
    const cfind356SetupByJtbdExperimentExposure = layout === "confluence" && !templateId && !isXflow && cfind356SetupByJtbdExperiment.type === "enrolled";
    if (cfind356SetupByJtbdExperimentExposure) cfind356SetupByJtbdExperiment.fireExposure();
    const content = (0, $iSvIT.useMemo)(()=>{
        switch(layout){
            case "confluence":
                return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2y9w7.ConfluenceLayout), {});
            default:
                return /*#__PURE__*/ (0, $loA2J.jsx)((0, $c3QWr.DefaultCircleLayout), {});
        }
    }, [
        layout
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jXTzN.default), {
        data: defaultAnalyticsAttributes,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1LPIk.DataFoundationsWrapper), {
            dataFoundationsEventOption: "ProvisioningScreenViewed",
            attributes: dataFoundationAttributes,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kmxlM.SignupProvisioningContextProvider), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gyY7b.PerceivedProvisioningStartTimer), {
                    children: content
                })
            })
        })
    });
};
var $81b2fcb695217378$export$2e2bcd8739ae039 = $81b2fcb695217378$export$9d886131699dcb7f;

});
parcelRegister("gyY7b", function(module, exports) {

$parcel$export(module.exports, "PerceivedProvisioningStartTimer", function () { return $8a9227548d9a3225$export$34299b0270b495c8; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $aO3Hl = parcelRequire("aO3Hl");
const $8a9227548d9a3225$export$34299b0270b495c8 = ({ children: children })=>{
    const { startPerceivedProvisioningTimer: startPerceivedProvisioningTimer } = (0, $aO3Hl.useCloudStatus)();
    (0, $iSvIT.useEffect)(()=>{
        startPerceivedProvisioningTimer();
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
        children: children
    });
};

});

parcelRegister("gTIJy", function(module, exports) {

$parcel$export(module.exports, "TIMEOUT", function () { return $1604e7e4b1a6bf5f$export$3cf918ebc7e29d7a; });
$parcel$export(module.exports, "getLayout", function () { return $1604e7e4b1a6bf5f$export$15b332947189bc50; });
const $1604e7e4b1a6bf5f$export$3cf918ebc7e29d7a = 600000;
function $1604e7e4b1a6bf5f$export$15b332947189bc50(products) {
    if (products.some((product)=>product.includes("confluence"))) return "confluence";
    return null;
}

});

parcelRegister("2y9w7", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLayout", function () { return $28a52bbfe6d024d2$export$97497acfccf8f80c; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");
parcelRequire("7dgKV");
var $kJsdP = parcelRequire("kJsdP");

var $jgJpJ = parcelRequire("jgJpJ");

var $OOa63 = parcelRequire("OOa63");

var $kmxlM = parcelRequire("kmxlM");

var $9FetZ = parcelRequire("9FetZ");
const $28a52bbfe6d024d2$export$97497acfccf8f80c = ()=>{
    const { status: status, createRedirectUrl: createRedirectUrl } = (0, $kmxlM.useSignupProvisioningContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const [firedProvisioningCompleteEvent, setFiredProvisioningCompleteEvent] = (0, $iSvIT.useState)(false);
    // Start analytics timer for time spent on provisioning (perceived provisioning)
    const provisioningStartTimestamp = (0, $iSvIT.useRef)(Date.now() / 1000);
    const fireProvisioningTimeSpentEvent = (0, $iSvIT.useCallback)(()=>{
        const endTimestamp = Date.now() / 1000;
        const startTimestamp = provisioningStartTimestamp.current ?? 0;
        const time = Math.round(endTimestamp - startTimestamp);
        createAnalyticsEvent({
            eventType: "track",
            action: "viewed",
            actionSubject: "provisioningScreen",
            attributes: {
                time: time
            },
            containerId: "provisioningPage"
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!provisioningStartTimestamp.current) provisioningStartTimestamp.current = Date.now() / 1000;
        /* istanbul ignore next */ const waitForProvisioningToComplete = async ()=>{
            if (status !== "success") return;
            const redirectUrl = createRedirectUrl();
            // SLO "good event" for redirect into product
            (0, $jgJpJ.ufoEventRedirectToProduct).success({
                customData: {
                    reactComponent: "ConfluenceLayout default",
                    analyticsEvent: "redirected",
                    redirectFrom: "confirmationPage",
                    provisioningStatus: status
                }
            });
            if (!firedProvisioningCompleteEvent) {
                fireProvisioningTimeSpentEvent();
                (0, $OOa63.trackPerceivedProvisioningEvent)({
                    createAnalyticsEvent: createAnalyticsEvent,
                    productKey: "confluence",
                    finalProvisioningScreen: "provisioning-screen",
                    startTimeSeconds: provisioningStartTimestamp.current
                });
            }
            setFiredProvisioningCompleteEvent(true);
            window.location.assign(redirectUrl);
        };
        waitForProvisioningToComplete();
    }, [
        createRedirectUrl,
        status,
        fireProvisioningTimeSpentEvent,
        createAnalyticsEvent,
        firedProvisioningCompleteEvent,
        provisioningStartTimestamp
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jgJpJ.UfoCustomTimingWrapper), {
        ufoEvent: (0, $jgJpJ.ufoEventRedirectToProduct),
        ufoCustomTimingKey: (0, $jgJpJ.UfoCustomTimingKey).CONFLUENCE_ONBOARDING_SPINNER_DWELL_TIME,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kJsdP.ConfluenceBackground), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $9FetZ.LoadingAnimation), {
                isLoadingComplete: status === "success"
            })
        ]
    });
};

});
parcelRegister("7dgKV", function(module, exports) {
$parcel$export(module.exports, "ConfluenceBackground", function () { return (parcelRequire("kJsdP")).ConfluenceBackground; });
parcelRequire("kJsdP");

});
parcelRegister("kJsdP", function(module, exports) {

$parcel$export(module.exports, "ConfluenceBackground", function () { return $4e5bbdc7eea8b0e5$export$b0d291b61d581ffd; });
/* confluence-background.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $kS8zk = parcelRequire("kS8zk");

var $kvSTX = parcelRequire("kvSTX");
const $4e5bbdc7eea8b0e5$export$b0d291b61d581ffd = ({ allowDarkMode: allowDarkMode })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_4t3i1osq _kqsw1n9t _152tidpf _1e02idpf _rjxpidpf _u7coidpf _1reo15vq _18m915vq"
        ]),
        children: [
            allowDarkMode && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_15b0glyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kS8zk.default), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    allowDarkMode && "_1lv8glyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kvSTX.default), {})
            })
        ]
    });
};
const $4e5bbdc7eea8b0e5$var$backgroundStyles = null;
const $4e5bbdc7eea8b0e5$var$prefersLightHideDark = null;
const $4e5bbdc7eea8b0e5$var$prefersDarkHideLight = null;

});
parcelRegister("kS8zk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a844e24c4bd0e553$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
const $a844e24c4bd0e553$var$DarkConfluenceBackground = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        viewBox: "0 1 1729 1118",
        fill: "none",
        style: {
            minWidth: "100%",
            minHeight: "100%",
            position: "absolute"
        },
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                clipPath: "url(#clip0_6402_38719)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "1728",
                        height: "1117",
                        transform: "translate(0.109375 0.867188)",
                        fill: "#1D2125"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "1728",
                        height: "1117",
                        transform: "translate(0.109375 0.867188)",
                        fill: "#1D2125"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                        clipPath: "url(#clip1_6402_38719)",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                width: "1488",
                                height: "1059",
                                transform: "translate(240.109 58.8672)",
                                fill: "#1D2125"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                clipPath: "url(#clip2_6402_38719)",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                        clipPath: "url(#clip3_6402_38719)",
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                width: "24",
                                                height: "24",
                                                transform: "translate(1460.11 90.8672)",
                                                fill: "white",
                                                fillOpacity: "0.01"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M1464.13 110.097C1464.1 110.259 1464.1 110.427 1464.15 110.585C1464.2 110.744 1464.29 110.888 1464.4 111.005C1464.52 111.121 1464.66 111.208 1464.82 111.255C1464.98 111.303 1465.15 111.31 1465.31 111.277L1469.12 110.497L1464.91 106.287L1464.13 110.097ZM1470.05 107.477L1467.93 105.357L1476.42 96.8672H1476.42L1478.54 98.9882L1470.05 107.478L1470.05 107.477ZM1479.95 97.5742L1477.83 95.4522C1477.65 95.2663 1477.43 95.1189 1477.18 95.0185C1476.94 94.9181 1476.68 94.8667 1476.42 94.8672C1475.91 94.8672 1475.39 95.0622 1475 95.4522L1465.25 105.21L1470.2 110.16L1479.95 100.402C1480.33 100.027 1480.54 99.5185 1480.54 98.9882C1480.54 98.4579 1480.33 97.9492 1479.95 97.5742H1479.95Z",
                                                fill: "#738496"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                width: "24",
                                                height: "24",
                                                transform: "translate(1492.11 90.8672)",
                                                fill: "white",
                                                fillOpacity: "0.01"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M1497.11 102.38C1497.11 99.3422 1500.25 96.8702 1504.11 96.8702C1507.97 96.8702 1511.11 99.3422 1511.11 102.38C1511.11 105.419 1507.97 107.89 1504.11 107.89C1500.25 107.89 1497.11 105.419 1497.11 102.38ZM1511.95 110.151V110.149C1511.95 110.149 1510.38 107.889 1511.18 107.033L1511.14 107.053C1512.37 105.769 1513.11 104.146 1513.11 102.38C1513.11 98.2382 1509.07 94.8672 1504.11 94.8672C1499.15 94.8672 1495.11 98.2372 1495.11 102.38C1495.11 106.523 1499.15 109.894 1504.11 109.894C1505.53 109.894 1506.87 109.609 1508.07 109.118C1509.07 110.14 1510.35 110.69 1511.31 110.837L1511.31 110.834C1511.36 110.854 1511.42 110.865 1511.47 110.867C1511.56 110.867 1511.64 110.846 1511.72 110.806C1511.79 110.766 1511.85 110.707 1511.9 110.636C1511.95 110.566 1511.98 110.484 1511.99 110.399C1511.99 110.315 1511.98 110.229 1511.95 110.151Z",
                                                fill: "#738496"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                d: "M1508.11 99.8672H1500.11C1499.56 99.8672 1499.11 100.315 1499.11 100.867C1499.11 101.419 1499.56 101.867 1500.11 101.867H1508.11C1508.66 101.867 1509.11 101.419 1509.11 100.867C1509.11 100.315 1508.66 99.8672 1508.11 99.8672Z",
                                                fill: "#738496"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                d: "M1503.11 102.867H1500.11C1499.56 102.867 1499.11 103.315 1499.11 103.867C1499.11 104.419 1499.56 104.867 1500.11 104.867H1503.11C1503.66 104.867 1504.11 104.419 1504.11 103.867C1504.11 103.315 1503.66 102.867 1503.11 102.867Z",
                                                fill: "#738496"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                width: "24",
                                                height: "24",
                                                transform: "translate(1524.11 90.8672)",
                                                fill: "white",
                                                fillOpacity: "0.01"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                d: "M1536.11 107.24L1540.09 109.433L1539.33 104.778L1542.6 101.431L1538.08 100.741L1536.11 96.5542L1534.14 100.743L1529.61 101.432L1532.89 104.777L1532.13 109.432L1536.11 107.24ZM1536.11 109.523L1533.09 111.185C1532.76 111.366 1532.39 111.451 1532.02 111.43C1531.64 111.41 1531.28 111.284 1530.97 111.067C1530.67 110.851 1530.43 110.553 1530.28 110.207C1530.14 109.86 1530.09 109.481 1530.15 109.11L1530.75 105.454L1528.18 102.83C1527.92 102.567 1527.74 102.238 1527.66 101.879C1527.58 101.52 1527.6 101.146 1527.71 100.796C1527.83 100.447 1528.04 100.137 1528.32 99.9C1528.61 99.663 1528.95 99.5084 1529.31 99.4532L1532.78 98.9252L1534.3 95.7012C1534.46 95.3581 1534.72 95.0682 1535.04 94.8651C1535.36 94.662 1535.73 94.5541 1536.11 94.5541C1536.49 94.5541 1536.86 94.662 1537.18 94.8651C1537.5 95.0682 1537.76 95.3581 1537.92 95.7012L1539.44 98.9252L1542.91 99.4532C1543.27 99.5087 1543.61 99.6635 1543.89 99.9007C1544.18 100.138 1544.39 100.448 1544.5 100.797C1544.62 101.146 1544.64 101.521 1544.55 101.88C1544.47 102.238 1544.29 102.567 1544.03 102.83L1541.46 105.454L1542.06 109.11C1542.12 109.481 1542.08 109.861 1541.93 110.207C1541.79 110.553 1541.55 110.852 1541.24 111.068C1540.94 111.285 1540.58 111.41 1540.2 111.431C1539.83 111.452 1539.45 111.367 1539.12 111.185L1536.11 109.523Z",
                                                fill: "#738496"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                width: "24",
                                                height: "24",
                                                transform: "translate(1556.11 90.8672)",
                                                fill: "white",
                                                fillOpacity: "0.01"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M1568.11 108.867C1563.57 108.867 1560.11 104.607 1560.11 102.867C1560.11 100.866 1563.57 96.8672 1568.11 96.8672C1572.49 96.8672 1576.11 100.84 1576.11 102.867C1576.11 104.607 1572.65 108.867 1568.11 108.867H1568.11ZM1568.11 94.8672C1562.59 94.8672 1558.11 99.7082 1558.11 102.867C1558.11 105.953 1562.69 110.867 1568.11 110.867C1573.53 110.867 1578.11 105.953 1578.11 102.867C1578.11 99.7082 1573.63 94.8672 1568.11 94.8672",
                                                fill: "#738496"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M1568.09 104.851C1566.98 104.851 1566.09 103.954 1566.09 102.851C1566.09 101.748 1566.98 100.851 1568.09 100.851C1569.19 100.851 1570.09 101.748 1570.09 102.851C1570.09 103.954 1569.19 104.851 1568.09 104.851ZM1568.09 98.8512C1565.88 98.8512 1564.09 100.645 1564.09 102.851C1564.09 105.057 1565.88 106.851 1568.09 106.851C1570.29 106.851 1572.09 105.057 1572.09 102.851C1572.09 100.645 1570.29 98.8512 1568.09 98.8512Z",
                                                fill: "#738496"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        x: "1590.11",
                                        y: "86.8672",
                                        width: "60",
                                        height: "32",
                                        rx: "3",
                                        fill: "#A1BDD9",
                                        fillOpacity: "0.08"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        x: "1598.11",
                                        y: "99.8672",
                                        width: "44",
                                        height: "6",
                                        rx: "3",
                                        fill: "#454F59"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        width: "24",
                                        height: "24",
                                        transform: "translate(1660.11 90.8672)",
                                        fill: "white",
                                        fillOpacity: "0.01"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M1665.11 104.867C1666.21 104.867 1667.11 103.972 1667.11 102.867C1667.11 101.763 1666.21 100.867 1665.11 100.867C1664 100.867 1663.11 101.763 1663.11 102.867C1663.11 103.972 1664 104.867 1665.11 104.867Z",
                                        fill: "#738496"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M1672.11 104.867C1673.21 104.867 1674.11 103.972 1674.11 102.867C1674.11 101.763 1673.21 100.867 1672.11 100.867C1671 100.867 1670.11 101.763 1670.11 102.867C1670.11 103.972 1671 104.867 1672.11 104.867Z",
                                        fill: "#738496"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M1679.11 104.867C1680.21 104.867 1681.11 103.972 1681.11 102.867C1681.11 101.763 1680.21 100.867 1679.11 100.867C1678 100.867 1677.11 101.763 1677.11 102.867C1677.11 103.972 1678 104.867 1679.11 104.867Z",
                                        fill: "#738496"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "146.867",
                                width: "503",
                                height: "20",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                clipPath: "url(#clip4_6402_38719)",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                    x: "648.109",
                                    y: "206.867",
                                    width: "192",
                                    height: "6",
                                    rx: "3",
                                    fill: "#454F59"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                clipPath: "url(#clip5_6402_38719)",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                    x: "648.109",
                                    y: "194.867",
                                    width: "119",
                                    height: "6",
                                    rx: "3",
                                    fill: "#454F59"
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                clipPath: "url(#clip6_6402_38719)",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M636.109 206.867C636.109 198.031 628.946 190.867 620.109 190.867C611.273 190.867 604.109 198.031 604.109 206.867C604.109 215.704 611.273 222.867 620.109 222.867C628.946 222.867 636.109 215.704 636.109 206.867Z",
                                        fill: "#FFC400"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M620.13 218.415C622.101 218.408 623.622 217.599 624.713 216.303H624.748C624.434 216.096 624.17 215.904 624.172 215.896C624.047 215.804 623.927 214.452 623.845 213.132C622.762 214.017 621.615 214.376 621.006 214.844C620.535 215.205 618.725 215.054 618.259 214.614C617.652 214.043 617.048 213.485 616.508 212.906C616.454 214.312 616.354 215.848 616.244 215.955C616.244 215.958 615.947 216.157 615.602 216.365C616.69 217.624 618.192 218.408 620.13 218.415Z",
                                        fill: "url(#paint0_linear_6402_38719)"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M624.813 216.303H624.713C623.622 217.599 622.101 218.408 620.13 218.415C618.192 218.408 616.69 217.624 615.602 216.365C615.584 216.344 615.566 216.324 615.548 216.303H615.448C615.448 216.303 612.501 217.716 609.908 219.114C612.678 221.408 616.231 222.788 620.107 222.788C623.991 222.788 627.552 221.403 630.324 219.101C627.739 217.711 624.81 216.306 624.81 216.306L624.813 216.303Z",
                                        fill: "#FF991F"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M626.509 206.606C626.458 207.233 626.348 207.978 626.202 208.695C626.223 208.692 626.243 208.685 626.264 208.687C626.41 208.7 626.517 208.826 626.504 208.972C626.492 209.117 626.366 209.225 626.22 209.212C626.174 209.21 626.133 209.189 626.097 209.166C626.067 209.299 626.033 209.43 626 209.558C626.389 209.458 626.645 209.123 626.689 208.529C626.748 207.697 627.229 206.092 626.868 205.526C626.778 205.892 626.655 206.181 626.522 206.404C626.517 206.47 626.515 206.537 626.509 206.604V206.606Z",
                                        fill: "#F7DAC6"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M614.37 208.347C614.224 208.334 614.116 208.209 614.129 208.063C614.142 207.917 614.267 207.809 614.413 207.822C614.441 207.822 614.467 207.835 614.493 207.845C614.429 207.169 614.382 206.465 614.393 205.938C614.249 205.751 614.096 205.477 613.993 205.088C613.868 205.807 613.975 206.885 613.919 207.505C613.858 208.17 614.116 208.557 614.577 208.68C614.564 208.557 614.549 208.431 614.536 208.301C614.487 208.334 614.431 208.355 614.37 208.349V208.347Z",
                                        fill: "#F7DAC6"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M626.504 208.972C626.517 208.826 626.407 208.7 626.263 208.687C626.243 208.687 626.222 208.692 626.202 208.695C626.169 208.854 626.135 209.012 626.1 209.166C626.135 209.189 626.176 209.21 626.222 209.212C626.368 209.225 626.494 209.115 626.507 208.972H626.504Z",
                                        fill: "#253858"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M614.13 208.063C614.117 208.209 614.227 208.334 614.371 208.347C614.432 208.352 614.488 208.331 614.537 208.298C614.522 208.15 614.506 207.996 614.493 207.843C614.468 207.832 614.442 207.822 614.414 207.819C614.268 207.807 614.143 207.917 614.13 208.06V208.063Z",
                                        fill: "#253858"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M618.258 214.614C618.724 215.054 620.534 215.205 621.005 214.844C621.614 214.376 622.764 214.017 623.844 213.132C624.461 212.625 625.058 211.949 625.521 210.979C625.695 210.615 625.859 210.116 626.002 209.56C626.036 209.432 626.066 209.302 626.1 209.169C626.135 209.012 626.171 208.856 626.202 208.698C626.35 207.981 626.458 207.236 626.509 206.609C626.514 206.542 626.517 206.476 626.522 206.409C626.156 207.023 625.723 207.167 625.723 207.167C625.723 207.167 625.808 206.563 625.785 205.866C625.639 201.537 623.299 199.988 621.847 199.558C620.931 199.991 619.525 201.061 619.538 203.578C619.538 203.578 617.012 204.028 615.537 202.93C615.281 203.519 615.066 204.202 614.91 204.991C614.777 205.674 614.761 206.284 614.761 206.284C614.761 206.284 614.585 206.189 614.39 205.938C614.38 206.465 614.426 207.167 614.49 207.845C614.505 207.999 614.518 208.152 614.533 208.301C614.546 208.431 614.562 208.557 614.574 208.68C614.661 209.46 614.746 210.06 614.746 210.06C615.033 211.135 615.693 212.043 616.502 212.906C617.042 213.485 617.649 214.043 618.253 214.614H618.258Z",
                                        fill: "#FFE5D4"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M621.512 196.148L620.683 196.082C618.555 195.967 614.464 196.625 613.896 203.688C613.85 204.269 613.901 204.724 613.996 205.085C614.098 205.475 614.249 205.748 614.395 205.935C614.59 206.186 614.766 206.281 614.766 206.281C614.766 206.281 614.779 205.669 614.915 204.988C615.071 204.2 615.286 203.516 615.542 202.927C615.371 202.799 615.212 202.648 615.074 202.474C614.933 202.298 614.815 202.098 614.72 201.868C614.72 201.868 615.678 196.033 621.945 197.006C621.97 197.006 622.111 197.615 622.242 198.209C622.367 198.772 622.482 199.318 622.482 199.318C622.347 199.354 622.119 199.43 621.853 199.556C623.302 199.986 625.644 201.535 625.79 205.864C625.813 206.56 625.728 207.164 625.728 207.164C625.728 207.164 626.164 207.018 626.527 206.406C626.66 206.181 626.783 205.892 626.873 205.528C626.929 205.298 626.975 205.042 626.998 204.745C627.566 197.679 623.634 196.376 621.515 196.151L621.512 196.148Z",
                                        fill: "url(#paint1_linear_6402_38719)"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M622.24 198.209C622.109 197.618 621.969 197.009 621.943 197.006C615.676 196.033 614.719 201.868 614.719 201.868C614.811 202.098 614.931 202.298 615.072 202.474C615.21 202.648 615.369 202.799 615.541 202.927C617.015 204.028 619.542 203.575 619.542 203.575C619.529 201.059 620.934 199.988 621.851 199.556C622.117 199.43 622.345 199.356 622.481 199.318C622.481 199.318 622.365 198.77 622.24 198.209Z",
                                        fill: "#0065FF"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "246.867",
                                width: "760",
                                height: "86",
                                rx: "5",
                                fill: "#092957"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M632.109 284.867C626.586 284.867 622.109 280.39 622.109 274.867C622.109 269.344 626.586 264.867 632.109 264.867C637.632 264.867 642.109 269.344 642.109 274.867C642.109 280.39 637.632 284.867 632.109 284.867ZM633.109 270.867C633.109 271.419 632.662 271.867 632.109 271.867C631.557 271.867 631.109 271.419 631.109 270.867C631.109 270.315 631.557 269.867 632.109 269.867C632.662 269.867 633.109 270.315 633.109 270.867ZM632.109 272.867C632.662 272.867 633.109 273.315 633.109 273.867V278.867C633.109 279.419 632.662 279.867 632.109 279.867C631.557 279.867 631.109 279.419 631.109 278.867V273.867C631.109 273.315 631.557 272.867 632.109 272.867Z",
                                fill: "#388BFF"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "670.109",
                                y: "272.867",
                                width: "659",
                                height: "12",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "670.109",
                                y: "294.867",
                                width: "325",
                                height: "12",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "364.867",
                                width: "117",
                                height: "20",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "400.867",
                                width: "98.5",
                                height: "20",
                                rx: "10",
                                fill: "#092957"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "M616.85 417.467C613.322 417.467 611.087 415.252 611.087 411.766V411.752C611.087 408.375 613.384 406.058 616.733 406.058C619.967 406.058 622.216 408.122 622.216 411.082V411.096C622.216 413.317 621.218 414.732 619.646 414.732C618.859 414.732 618.258 414.288 618.148 413.625L618.142 413.584H618.032C617.738 414.281 617.123 414.671 616.323 414.671C614.901 414.671 613.944 413.502 613.944 411.772V411.759C613.944 410.104 614.922 408.942 616.323 408.942C617.041 408.942 617.656 409.312 617.923 409.906H618.032V409.072H619.064V413.085C619.064 413.563 619.345 413.844 619.837 413.844C620.698 413.844 621.252 412.757 621.252 411.082V411.068C621.252 408.607 619.379 406.919 616.645 406.919C613.972 406.919 612.051 408.956 612.051 411.793V411.807C612.051 414.719 613.938 416.599 616.863 416.599C617.8 416.599 618.723 416.469 619.153 416.271V417.132C618.538 417.344 617.711 417.467 616.85 417.467ZM616.48 413.707C617.417 413.707 618.019 412.962 618.019 411.8V411.786C618.019 410.624 617.424 409.886 616.494 409.886C615.578 409.886 615.038 410.597 615.038 411.786V411.8C615.038 412.982 615.585 413.707 616.48 413.707Z",
                                fill: "#8696A7"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "625.609",
                                y: "407.867",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "710.609",
                                y: "400.867",
                                width: "98.5",
                                height: "20",
                                rx: "10",
                                fill: "#A1BDD9",
                                fillOpacity: "0.08"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "M723.35 417.467C719.822 417.467 717.587 415.252 717.587 411.766V411.752C717.587 408.375 719.884 406.058 723.233 406.058C726.467 406.058 728.716 408.122 728.716 411.082V411.096C728.716 413.317 727.718 414.732 726.146 414.732C725.359 414.732 724.758 414.288 724.648 413.625L724.642 413.584H724.532C724.238 414.281 723.623 414.671 722.823 414.671C721.401 414.671 720.444 413.502 720.444 411.772V411.759C720.444 410.104 721.422 408.942 722.823 408.942C723.541 408.942 724.156 409.312 724.423 409.906H724.532V409.072H725.564V413.085C725.564 413.563 725.845 413.844 726.337 413.844C727.198 413.844 727.752 412.757 727.752 411.082V411.068C727.752 408.607 725.879 406.919 723.145 406.919C720.472 406.919 718.551 408.956 718.551 411.793V411.807C718.551 414.719 720.438 416.599 723.363 416.599C724.3 416.599 725.223 416.469 725.653 416.271V417.132C725.038 417.344 724.211 417.467 723.35 417.467ZM722.98 413.707C723.917 413.707 724.519 412.962 724.519 411.8V411.786C724.519 410.624 723.924 409.886 722.994 409.886C722.078 409.886 721.538 410.597 721.538 411.786V411.8C721.538 412.982 722.085 413.707 722.98 413.707Z",
                                fill: "#8696A7"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "732.109",
                                y: "407.867",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "817.109",
                                y: "400.867",
                                width: "98.5",
                                height: "20",
                                rx: "10",
                                fill: "#A1BDD9",
                                fillOpacity: "0.08"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "M829.85 417.467C826.322 417.467 824.087 415.252 824.087 411.766V411.752C824.087 408.375 826.384 406.058 829.733 406.058C832.967 406.058 835.216 408.122 835.216 411.082V411.096C835.216 413.317 834.218 414.732 832.646 414.732C831.859 414.732 831.258 414.288 831.148 413.625L831.142 413.584H831.032C830.738 414.281 830.123 414.671 829.323 414.671C827.901 414.671 826.944 413.502 826.944 411.772V411.759C826.944 410.104 827.922 408.942 829.323 408.942C830.041 408.942 830.656 409.312 830.923 409.906H831.032V409.072H832.064V413.085C832.064 413.563 832.345 413.844 832.837 413.844C833.698 413.844 834.252 412.757 834.252 411.082V411.068C834.252 408.607 832.379 406.919 829.645 406.919C826.972 406.919 825.051 408.956 825.051 411.793V411.807C825.051 414.719 826.938 416.599 829.863 416.599C830.8 416.599 831.723 416.469 832.153 416.271V417.132C831.538 417.344 830.711 417.467 829.85 417.467ZM829.48 413.707C830.417 413.707 831.019 412.962 831.019 411.8V411.786C831.019 410.624 830.424 409.886 829.494 409.886C828.578 409.886 828.038 410.597 828.038 411.786V411.8C828.038 412.982 828.585 413.707 829.48 413.707Z",
                                fill: "#8696A7"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "838.609",
                                y: "407.867",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "452.867",
                                width: "290",
                                height: "20",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "488.867",
                                width: "730",
                                height: "12",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "516.867",
                                width: "730",
                                height: "12",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "544.867",
                                width: "343",
                                height: "12",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "620.109",
                                y: "582.867",
                                width: "12",
                                height: "12",
                                rx: "2",
                                fill: "#1D2125"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M622.109 582.867H630.109C631.214 582.867 632.109 583.763 632.109 584.867V592.867C632.109 593.972 631.214 594.867 630.109 594.867H622.109C621.005 594.867 620.109 593.972 620.109 592.867V584.867C620.109 583.763 621.005 582.867 622.109 582.867ZM623.492 587.936C623.614 587.989 623.724 588.065 623.816 588.16L625.109 589.453L628.402 586.16C628.495 586.065 628.605 585.989 628.727 585.936C628.849 585.884 628.98 585.856 629.113 585.855C629.246 585.854 629.377 585.879 629.5 585.929C629.623 585.98 629.735 586.054 629.829 586.148C629.923 586.242 629.997 586.353 630.047 586.476C630.097 586.599 630.123 586.731 630.122 586.864C630.12 586.996 630.093 587.128 630.04 587.25C629.988 587.372 629.912 587.482 629.816 587.574L625.816 591.574C625.629 591.762 625.375 591.867 625.109 591.867C624.844 591.867 624.59 591.762 624.402 591.574L622.402 589.574C622.307 589.482 622.231 589.372 622.178 589.25C622.126 589.128 622.098 588.996 622.097 588.864C622.096 588.731 622.121 588.599 622.172 588.476C622.222 588.353 622.296 588.242 622.39 588.148C622.484 588.054 622.596 587.98 622.718 587.929C622.841 587.879 622.973 587.854 623.106 587.855C623.239 587.856 623.37 587.884 623.492 587.936Z",
                                fill: "#388BFF"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "640.109",
                                y: "585.867",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "620.109",
                                y: "614.867",
                                width: "12",
                                height: "12",
                                rx: "2",
                                fill: "#1D2125"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M622.109 614.867H630.109C631.214 614.867 632.109 615.763 632.109 616.867V624.867C632.109 625.972 631.214 626.867 630.109 626.867H622.109C621.005 626.867 620.109 625.972 620.109 624.867V616.867C620.109 615.763 621.005 614.867 622.109 614.867ZM623.492 619.936C623.614 619.989 623.724 620.065 623.816 620.16L625.109 621.453L628.402 618.16C628.495 618.065 628.605 617.989 628.727 617.936C628.849 617.884 628.98 617.856 629.113 617.855C629.246 617.854 629.377 617.879 629.5 617.929C629.623 617.98 629.735 618.054 629.829 618.148C629.923 618.242 629.997 618.353 630.047 618.476C630.097 618.599 630.123 618.731 630.122 618.864C630.12 618.996 630.093 619.128 630.04 619.25C629.988 619.372 629.912 619.482 629.816 619.574L625.816 623.574C625.629 623.762 625.375 623.867 625.109 623.867C624.844 623.867 624.59 623.762 624.402 623.574L622.402 621.574C622.307 621.482 622.231 621.372 622.178 621.25C622.126 621.128 622.098 620.996 622.097 620.864C622.096 620.731 622.121 620.599 622.172 620.476C622.222 620.353 622.296 620.242 622.39 620.148C622.484 620.054 622.596 619.98 622.718 619.929C622.841 619.879 622.973 619.854 623.106 619.855C623.239 619.856 623.37 619.884 623.492 619.936Z",
                                fill: "#388BFF"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "640.109",
                                y: "617.867",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "621.109",
                                y: "647.867",
                                width: "10",
                                height: "10",
                                rx: "1",
                                stroke: "#8696A7",
                                strokeWidth: "2"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "640.109",
                                y: "649.867",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "621.109",
                                y: "679.867",
                                width: "10",
                                height: "10",
                                rx: "1",
                                stroke: "#8696A7",
                                strokeWidth: "2"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "640.109",
                                y: "681.867",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "621.109",
                                y: "711.867",
                                width: "10",
                                height: "10",
                                rx: "1",
                                stroke: "#8696A7",
                                strokeWidth: "2"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "640.109",
                                y: "713.867",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "748.867",
                                width: "730",
                                height: "12",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "776.867",
                                width: "730",
                                height: "12",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "804.867",
                                width: "343",
                                height: "12",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "880.867",
                                width: "290",
                                height: "20",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "916.867",
                                width: "730",
                                height: "12",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "944.867",
                                width: "730",
                                height: "12",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "972.867",
                                width: "730",
                                height: "12",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "1000.87",
                                width: "730",
                                height: "12",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "604.109",
                                y: "1028.87",
                                width: "343",
                                height: "12",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "272.109",
                                y: "99.8672",
                                width: "100",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "385.109",
                                y: "99.8672",
                                width: "54",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "M380.811 97.5312L377.796 110.342H376.401L379.416 97.5312H380.811Z",
                                fill: "#9FADBC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "240",
                        height: "1059",
                        transform: "translate(0.109375 58.8672)",
                        fill: "#161A1D"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                        clipPath: "url(#clip7_6402_38719)",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "22.1094",
                                y: "142.867",
                                width: "32",
                                height: "32",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "66.1094",
                                y: "155.867",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "22.1094",
                                y: "186.867",
                                width: "32",
                                height: "32",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "66.1094",
                                y: "199.867",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "22.1094",
                                y: "230.867",
                                width: "32",
                                height: "32",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "66.1094",
                                y: "243.867",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "22.1094",
                                y: "274.867",
                                width: "32",
                                height: "32",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "66.1094",
                                y: "287.867",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "22.1094",
                                y: "344.867",
                                width: "32",
                                height: "32",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "66.1094",
                                y: "357.867",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "16.1094",
                                y: "384.867",
                                width: "208",
                                height: "40",
                                rx: "3",
                                fill: "#2C333A"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                                cx: "52.1094",
                                cy: "404.867",
                                r: "2",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "72.1094",
                                y: "401.867",
                                width: "125",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                                cx: "52.1094",
                                cy: "448.867",
                                r: "2",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "72.1094",
                                y: "445.867",
                                width: "125",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                                cx: "52.1094",
                                cy: "492.867",
                                r: "2",
                                fill: "#454F59"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "72.1094",
                                y: "489.867",
                                width: "125",
                                height: "6",
                                rx: "3",
                                fill: "#454F59"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "18.1094",
                        y: "82.8672",
                        width: "40",
                        height: "40",
                        rx: "3",
                        fill: "#092957"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "66.1094",
                        y: "87.8672",
                        width: "97",
                        height: "12",
                        rx: "3",
                        fill: "#454F59"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "66.1094",
                        y: "111.867",
                        width: "141",
                        height: "6",
                        rx: "3",
                        fill: "#454F59"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "1727",
                        height: "56",
                        transform: "translate(0.109375 0.867188)",
                        fill: "#1D2125"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "0.109375",
                        y: "56.8672",
                        width: "1727",
                        height: "2",
                        fill: "#A6C5E2",
                        fillOpacity: "0.16"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "32",
                        height: "32",
                        transform: "translate(1671.11 12.8672)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                        clipPath: "url(#clip8_6402_38719)",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "M1702.04 28.8636C1702.04 20.6171 1695.35 13.932 1687.11 13.932C1678.86 13.932 1672.18 20.6171 1672.18 28.8636C1672.18 37.1101 1678.86 43.7952 1687.11 43.7952C1695.35 43.7952 1702.04 37.1101 1702.04 28.8636Z",
                                fill: "#B2D4FF"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "M1693.5 40.5576C1691.9 39.9 1690.85 38.34 1690.85 36.6072C1690.84 35.3688 1691.38 34.1904 1692.32 33.3888C1698.21 28.4448 1694.55 18.8712 1686.96 19.0248C1679.51 19.152 1676.12 28.548 1681.9 33.3888C1682.84 34.1904 1683.38 35.3688 1683.37 36.6072C1683.37 38.34 1682.32 39.9024 1680.72 40.5576C1680.26 40.7496 1679.8 40.9632 1679.35 41.1888C1679.23 41.2536 1679.11 41.328 1678.99 41.3952C1681.33 42.9144 1684.11 43.8024 1687.11 43.8024C1690.11 43.8024 1692.9 42.9144 1695.24 41.3928C1695.03 41.2752 1694.81 41.16 1694.59 41.052C1694.24 40.8696 1693.87 40.7136 1693.51 40.5576H1693.5Z",
                                fill: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                        clipPath: "url(#clip9_6402_38719)",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "1340.11",
                                y: "12.8672",
                                width: "238",
                                height: "32",
                                rx: "3",
                                fill: "#A1BDD9",
                                fillOpacity: "0.08"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M1361.11 27.8672C1361.11 30.0763 1359.32 31.8672 1357.11 31.8672C1354.9 31.8672 1353.11 30.0763 1353.11 27.8672C1353.11 25.658 1354.9 23.8672 1357.11 23.8672C1359.32 23.8672 1361.11 25.658 1361.11 27.8672ZM1360.59 32.7579C1359.61 33.4564 1358.41 33.8672 1357.11 33.8672C1353.8 33.8672 1351.11 31.1809 1351.11 27.8672C1351.11 24.5535 1353.8 21.8672 1357.11 21.8672C1360.42 21.8672 1363.11 24.5535 1363.11 27.8672C1363.11 29.163 1362.7 30.3629 1362 31.3437L1364.82 34.1601C1365.21 34.5506 1365.21 35.1838 1364.82 35.5743C1364.43 35.9648 1363.79 35.9648 1363.4 35.5743L1360.59 32.7579Z",
                                fill: "#738496"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                clipPath: "url(#clip10_6402_38719)",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        width: "24",
                                        height: "24",
                                        transform: "translate(1589.11 16.8672)",
                                        fill: "white",
                                        fillOpacity: "0.01"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M1595.59 34.5362C1595.78 34.722 1596 34.8694 1596.24 34.9699C1596.49 35.0705 1596.75 35.1223 1597.01 35.1223C1597.27 35.1223 1597.53 35.0705 1597.77 34.9699C1598.02 34.8694 1598.24 34.722 1598.42 34.5362L1595.59 31.7062C1595.41 31.8919 1595.26 32.1125 1595.16 32.3553C1595.06 32.5981 1595.01 32.8584 1595.01 33.1212C1595.01 33.384 1595.06 33.6443 1595.16 33.8871C1595.26 34.1299 1595.41 34.3504 1595.59 34.5362ZM1600.49 22.3452L1599.77 23.0702C1598.98 23.8522 1597.56 24.8832 1596.56 25.3812L1593.54 26.8902C1593.05 27.1382 1592.96 27.6642 1593.36 28.0612L1601.91 36.6172C1602.31 37.0132 1602.83 36.9302 1603.08 36.4292L1604.59 33.4132C1605.09 32.4252 1606.12 30.9932 1606.9 30.2072L1607.63 29.4812C1608.45 28.658 1608.97 27.5756 1609.08 26.4173C1609.2 25.259 1608.91 24.0959 1608.27 23.1252C1608.38 23.039 1608.47 22.9318 1608.53 22.81C1608.59 22.6882 1608.63 22.5546 1608.64 22.4172C1608.66 22.2798 1608.64 22.1417 1608.59 22.0113C1608.55 21.8808 1608.48 21.7608 1608.39 21.6587C1608.29 21.5566 1608.18 21.4745 1608.06 21.4175C1607.93 21.3605 1607.79 21.3298 1607.66 21.3272C1607.52 21.3246 1607.38 21.3502 1607.25 21.4025C1607.13 21.4548 1607.01 21.5326 1606.92 21.6312C1606.89 21.6562 1606.87 21.6802 1606.85 21.7062C1606.02 21.1581 1605.05 20.866 1604.06 20.8662C1603.4 20.8654 1602.74 20.9955 1602.13 21.2492C1601.52 21.5028 1600.96 21.8749 1600.49 22.3442V22.3452Z",
                                        fill: "#738496"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        width: "24",
                                        height: "24",
                                        transform: "translate(1629.11 16.8672)",
                                        fill: "white",
                                        fillOpacity: "0.01"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M1651.11 28.8672C1651.11 34.39 1646.63 38.8672 1641.11 38.8672C1635.59 38.8672 1631.11 34.39 1631.11 28.8672C1631.11 23.3443 1635.59 18.8672 1641.11 18.8672C1646.63 18.8672 1651.11 23.3443 1651.11 28.8672ZM1643.94 24.0272C1644.46 24.5466 1644.83 25.201 1645 25.9172C1645.23 26.8752 1645.1 27.8853 1644.63 28.7528C1644.16 29.6203 1643.39 30.2837 1642.46 30.6152C1642.26 30.6882 1642.11 30.8702 1642.11 31.0872V31.8692C1642.11 32.1349 1642.01 32.3898 1641.82 32.5777C1641.63 32.7656 1641.38 32.8712 1641.11 32.8712C1640.85 32.8712 1640.59 32.7656 1640.4 32.5777C1640.21 32.3898 1640.11 32.1349 1640.11 31.8692V29.8552C1640.11 29.5922 1640.22 29.3412 1640.41 29.1565C1640.59 28.9718 1640.85 28.8682 1641.11 28.8682H1641.1C1642.21 28.8682 1643.11 27.9702 1643.11 26.8682C1643.09 26.3446 1642.88 25.8465 1642.5 25.4805C1642.13 25.1145 1641.62 24.9097 1641.1 24.9099C1640.58 24.9102 1640.07 25.1155 1639.7 25.4819C1639.33 25.8482 1639.11 26.3466 1639.1 26.8702C1639.1 27.4212 1638.65 27.8682 1638.1 27.8682C1637.85 27.8667 1637.61 27.7732 1637.43 27.606C1637.25 27.4389 1637.14 27.21 1637.11 26.9642L1637.11 26.8172C1637.13 24.3132 1639.43 22.3812 1642.04 22.9752C1642.76 23.1435 1643.42 23.5077 1643.94 24.0272ZM1642.11 34.8672C1642.11 35.4195 1641.66 35.8672 1641.11 35.8672C1640.56 35.8672 1640.11 35.4195 1640.11 34.8672C1640.11 34.3149 1640.56 33.8672 1641.11 33.8672C1641.66 33.8672 1642.11 34.3149 1642.11 34.8672Z",
                                        fill: "#738496"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                        clipPath: "url(#clip11_6402_38719)",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                clipPath: "url(#clip12_6402_38719)",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M88.3141 35.3586C87.3459 35.9792 85.8128 36.2379 84.199 36.2379C79.0888 36.2379 76.2109 33.2896 76.2109 28.5568C76.2109 24.0051 79.0888 20.8241 84.1721 20.8241C85.6783 20.8241 87.2114 21.1086 88.3141 21.8586V23.8499C87.2114 23.1775 85.9742 22.8155 84.1721 22.8155C80.5143 22.8155 78.3626 25.143 78.3626 28.5827C78.3626 32.0224 80.6219 34.2982 84.3066 34.2982C85.9473 34.2982 87.2114 33.9361 88.341 33.393V35.3586H88.3141Z",
                                        fill: "#9FADBC"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M89.7934 30.3155C89.7934 26.9017 91.8644 24.4189 95.4146 24.4189C98.938 24.4189 101.009 26.9017 101.009 30.3155C101.009 33.7293 98.938 36.2637 95.4146 36.2637C91.8913 36.2379 89.7934 33.7293 89.7934 30.3155ZM91.7837 30.3155C91.7837 32.4879 92.8864 34.4275 95.4415 34.4275C97.9429 34.4275 99.0456 32.462 99.0456 30.3155C99.0456 28.1689 97.9698 26.2293 95.4415 26.2293C92.8864 26.2293 91.7837 28.143 91.7837 30.3155Z",
                                        fill: "#9FADBC"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M113.435 36.031H111.391V29.1517C111.391 27.1086 110.53 26.2034 108.594 26.2034C106.711 26.2034 105.393 27.4189 105.393 29.7206V36.0568H103.349V24.6775H105.393V26.5396C106.146 25.1948 107.545 24.4448 109.132 24.4448C111.848 24.4448 113.408 26.2551 113.408 29.3844V36.031H113.435Z",
                                        fill: "#9FADBC"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M122.176 24.6517V26.462H119.11V36.031H117.12V26.462H115.21V24.6517H117.12V23.4103C117.12 21.2896 118.357 19.8672 120.885 19.8672C121.504 19.8672 121.907 19.9706 122.257 20.0482V21.8586C121.907 21.781 121.45 21.7551 120.966 21.7551C119.702 21.7551 119.083 22.4534 119.083 23.4879V24.6517H122.176Z",
                                        fill: "#9FADBC"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M127.528 36.0827C125.592 36.0827 124.355 35.2034 124.355 33.1086V19.893H126.399V32.8758C126.399 33.9103 127.098 34.2724 127.986 34.2724C128.201 34.2724 128.335 34.2724 128.577 34.2465V36.0051C128.389 36.0568 128.039 36.0827 127.528 36.0827Z",
                                        fill: "#9FADBC"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M130.299 24.6517H132.343V31.531C132.343 33.5741 133.203 34.4793 135.14 34.4793C137.023 34.4793 138.341 33.2637 138.341 30.962V24.6517H140.385V36.031H138.341V34.1689C137.587 35.5137 136.189 36.2637 134.602 36.2637C131.886 36.2637 130.326 34.4534 130.326 31.3241V24.6517H130.299Z",
                                        fill: "#9FADBC"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M149.099 36.2379C144.661 36.2379 142.725 33.781 142.725 30.2896C142.725 26.8499 144.715 24.393 148.319 24.393C151.977 24.393 153.429 26.8241 153.429 30.2896V31.1689H144.796C145.092 33.1086 146.383 34.3499 149.18 34.3499C150.551 34.3499 151.708 34.0913 152.784 33.7293V35.5396C151.789 36.0568 150.282 36.2379 149.099 36.2379ZM144.742 29.5137H151.358C151.251 27.3931 150.256 26.2034 148.211 26.2034C146.06 26.2034 144.957 27.5224 144.742 29.5137Z",
                                        fill: "#9FADBC"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M165.882 36.031H163.838V29.1517C163.838 27.1086 162.977 26.2034 161.041 26.2034C159.158 26.2034 157.84 27.4189 157.84 29.7206V36.0568H155.796V24.6775H157.84V26.5396C158.593 25.1948 159.992 24.4448 161.579 24.4448C164.295 24.4448 165.855 26.2551 165.855 29.3844V36.031H165.882Z",
                                        fill: "#9FADBC"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M177.098 35.7206C176.398 36.0827 175.296 36.2379 174.22 36.2379C169.997 36.2379 168.034 33.781 168.034 30.2896C168.034 26.8499 169.997 24.393 174.22 24.393C175.296 24.393 176.103 24.5224 177.044 24.9362V26.7465C176.291 26.4103 175.484 26.2034 174.381 26.2034C171.315 26.2034 170.051 28.0655 170.051 30.2896C170.051 32.5137 171.342 34.3758 174.435 34.3758C175.645 34.3758 176.398 34.2206 177.125 33.962V35.7206H177.098Z",
                                        fill: "#9FADBC"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M185.059 36.2379C180.621 36.2379 178.684 33.781 178.684 30.2896C178.684 26.8499 180.675 24.393 184.279 24.393C187.937 24.393 189.389 26.8241 189.389 30.2896V31.1689H180.755C181.051 33.1086 182.342 34.3499 185.14 34.3499C186.511 34.3499 187.668 34.0913 188.744 33.7293V35.5396C187.748 36.0568 186.269 36.2379 185.059 36.2379ZM180.729 29.5137H187.345C187.237 27.3931 186.242 26.2034 184.198 26.2034C182.02 26.2034 180.944 27.5224 180.729 29.5137Z",
                                        fill: "#9FADBC"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M52.7301 33.2924C52.5687 33.5924 52.3536 33.9197 52.1922 34.1925C52.0308 34.4379 52.1115 34.7652 52.3804 34.9288L55.8769 37.1107C56.1459 37.2743 56.4686 37.1925 56.63 36.9198C56.7645 36.6743 56.9528 36.3743 57.141 36.047C58.5396 33.7288 59.9113 34.0015 62.4395 35.2288L65.9091 36.8925C66.1781 37.0289 66.5008 36.8925 66.6353 36.6198L68.3028 32.8015C68.4104 32.5288 68.3028 32.2015 68.0339 32.0924C67.3077 31.7379 65.8553 31.056 64.5374 30.4015C59.8037 28.1105 55.7962 28.2469 52.7301 33.2924Z",
                                        fill: "url(#paint2_linear_6402_38719)"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M68.4113 24.6468C68.5727 24.3468 68.7878 24.0195 68.9492 23.7468C69.1106 23.5014 69.0299 23.1741 68.7609 23.0104L65.2645 20.8286C64.9955 20.665 64.6728 20.7468 64.5114 21.0195C64.3769 21.265 64.1886 21.565 64.0004 21.8922C62.6018 24.2105 61.2301 23.9377 58.7019 22.7104L55.2592 21.0195C54.9902 20.8831 54.6675 21.0195 54.533 21.2922L52.8654 25.1105C52.7579 25.3832 52.8654 25.7105 53.1344 25.8196C53.8606 26.1741 55.313 26.856 56.6309 27.5105C61.3377 29.8287 65.3452 29.6924 68.4113 24.6468Z",
                                        fill: "url(#paint3_linear_6402_38719)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                clipPath: "url(#clip13_6402_38719)",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                        clipPath: "url(#clip14_6402_38719)",
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                width: "86",
                                                height: "56",
                                                transform: "translate(213.109 0.867188)",
                                                fill: "white",
                                                fillOpacity: "0.01"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                x: "220.609",
                                                y: "25.8672",
                                                width: "71",
                                                height: "6",
                                                rx: "3",
                                                fill: "#454F59"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                width: "86",
                                                height: "56",
                                                transform: "translate(307.109 0.867188)",
                                                fill: "white",
                                                fillOpacity: "0.01"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                x: "311.109",
                                                y: "25.8672",
                                                width: "64",
                                                height: "6",
                                                rx: "3",
                                                fill: "#454F59"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                                opacity: "0.6",
                                                clipPath: "url(#clip15_6402_38719)",
                                                children: [
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                        width: "8",
                                                        height: "20",
                                                        transform: "translate(381.109 18.8672)",
                                                        fill: "white",
                                                        fillOpacity: "0.01"
                                                    }),
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        clipRule: "evenodd",
                                                        d: "M381.401 27.1602C381.214 27.3491 381.109 27.604 381.109 27.8697C381.109 28.1354 381.214 28.3903 381.401 28.5792L384.34 31.5442C384.558 31.7592 384.84 31.8662 385.119 31.8662C385.398 31.8662 385.675 31.7592 385.888 31.5442L388.818 28.5892C389.005 28.4002 389.109 28.1453 389.109 27.8797C389.109 27.6141 389.005 27.3592 388.818 27.1702C388.726 27.077 388.617 27.003 388.496 26.9525C388.375 26.902 388.246 26.876 388.115 26.876C387.984 26.876 387.855 26.902 387.734 26.9525C387.613 27.003 387.504 27.077 387.412 27.1702L385.114 29.4872L382.807 27.1602C382.715 27.0674 382.605 26.9937 382.485 26.9434C382.364 26.8931 382.235 26.8672 382.104 26.8672C381.973 26.8672 381.844 26.8931 381.723 26.9434C381.602 26.9937 381.493 27.0674 381.401 27.1602Z",
                                                        fill: "#8696A7"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                width: "86",
                                                height: "56",
                                                transform: "translate(401.109 0.867188)",
                                                fill: "white",
                                                fillOpacity: "0.01"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                x: "405.109",
                                                y: "25.8672",
                                                width: "64",
                                                height: "6",
                                                rx: "3",
                                                fill: "#454F59"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                                opacity: "0.6",
                                                clipPath: "url(#clip16_6402_38719)",
                                                children: [
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                        width: "8",
                                                        height: "20",
                                                        transform: "translate(475.109 18.8672)",
                                                        fill: "white",
                                                        fillOpacity: "0.01"
                                                    }),
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        clipRule: "evenodd",
                                                        d: "M475.401 27.1602C475.214 27.3491 475.109 27.604 475.109 27.8697C475.109 28.1354 475.214 28.3903 475.401 28.5792L478.34 31.5442C478.558 31.7592 478.84 31.8662 479.119 31.8662C479.398 31.8662 479.675 31.7592 479.888 31.5442L482.818 28.5892C483.005 28.4002 483.109 28.1453 483.109 27.8797C483.109 27.6141 483.005 27.3592 482.818 27.1702C482.726 27.077 482.617 27.003 482.496 26.9525C482.375 26.902 482.246 26.876 482.115 26.876C481.984 26.876 481.855 26.902 481.734 26.9525C481.613 27.003 481.504 27.077 481.412 27.1702L479.114 29.4872L476.807 27.1602C476.715 27.0674 476.605 26.9937 476.485 26.9434C476.364 26.8931 476.235 26.8672 476.104 26.8672C475.973 26.8672 475.844 26.8931 475.723 26.9434C475.602 26.9937 475.493 27.0674 475.401 27.1602Z",
                                                        fill: "#8696A7"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                width: "86",
                                                height: "56",
                                                transform: "translate(495.109 0.867188)",
                                                fill: "white",
                                                fillOpacity: "0.01"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                x: "499.109",
                                                y: "25.8672",
                                                width: "64",
                                                height: "6",
                                                rx: "3",
                                                fill: "#454F59"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                                opacity: "0.6",
                                                clipPath: "url(#clip17_6402_38719)",
                                                children: [
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                        width: "8",
                                                        height: "20",
                                                        transform: "translate(569.109 18.8672)",
                                                        fill: "white",
                                                        fillOpacity: "0.01"
                                                    }),
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                        fillRule: "evenodd",
                                                        clipRule: "evenodd",
                                                        d: "M569.401 27.1602C569.214 27.3491 569.109 27.604 569.109 27.8697C569.109 28.1354 569.214 28.3903 569.401 28.5792L572.34 31.5442C572.558 31.7592 572.84 31.8662 573.119 31.8662C573.398 31.8662 573.675 31.7592 573.888 31.5442L576.818 28.5892C577.005 28.4002 577.109 28.1453 577.109 27.8797C577.109 27.6141 577.005 27.3592 576.818 27.1702C576.726 27.077 576.617 27.003 576.496 26.9525C576.375 26.902 576.246 26.876 576.115 26.876C575.984 26.876 575.855 26.902 575.734 26.9525C575.613 27.003 575.504 27.077 575.412 27.1702L573.114 29.4872L570.807 27.1602C570.715 27.0674 570.605 26.9937 570.485 26.9434C570.364 26.8931 570.235 26.8672 570.104 26.8672C569.973 26.8672 569.844 26.8931 569.723 26.9434C569.602 26.9937 569.493 27.0674 569.401 27.1602Z",
                                                        fill: "#8696A7"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                width: "86",
                                                height: "56",
                                                transform: "translate(589.109 0.867188)",
                                                fill: "white",
                                                fillOpacity: "0.01"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                                x: "596.609",
                                                y: "25.8672",
                                                width: "71",
                                                height: "6",
                                                rx: "3",
                                                fill: "#454F59"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        x: "691.109",
                                        y: "12.8672",
                                        width: "61",
                                        height: "32",
                                        rx: "3",
                                        fill: "#09326C"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        x: "699.109",
                                        y: "25.8672",
                                        width: "44",
                                        height: "6",
                                        rx: "3",
                                        fill: "#454F59"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "24",
                        height: "24",
                        transform: "translate(18.1094 16.8672)",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M22.1094 21.8772C22.1094 21.3182 22.5524 20.8672 23.1194 20.8672H25.0994C25.6584 20.8672 26.1094 21.3102 26.1094 21.8772V23.8572C26.1094 24.4162 25.6664 24.8672 25.0994 24.8672H23.1194C22.5604 24.8672 22.1094 24.4242 22.1094 23.8572V21.8772ZM22.1094 27.8772C22.1094 27.3192 22.5524 26.8672 23.1194 26.8672H25.0994C25.6574 26.8672 26.1094 27.3102 26.1094 27.8772V29.8572C26.1094 30.4162 25.6664 30.8672 25.0994 30.8672H23.1194C22.5604 30.8672 22.1094 30.4242 22.1094 29.8572V27.8772ZM28.1094 21.8772C28.1094 21.3192 28.5524 20.8672 29.1194 20.8672H31.0994C31.6574 20.8672 32.1094 21.3102 32.1094 21.8772V23.8572C32.1094 24.4162 31.6664 24.8672 31.0994 24.8672H29.1194C28.5604 24.8672 28.1094 24.4242 28.1094 23.8572V21.8772ZM28.1094 27.8772C28.1094 27.3192 28.5524 26.8672 29.1194 26.8672H31.0994C31.6574 26.8672 32.1094 27.3102 32.1094 27.8772V29.8572C32.1094 30.4152 31.6664 30.8672 31.0994 30.8672H29.1194C28.5614 30.8672 28.1094 30.4242 28.1094 29.8572V27.8772ZM34.1094 21.8772C34.1094 21.3192 34.5524 20.8672 35.1194 20.8672H37.0994C37.6574 20.8672 38.1094 21.3102 38.1094 21.8772V23.8572C38.1094 24.4162 37.6664 24.8672 37.0994 24.8672H35.1194C34.5604 24.8672 34.1094 24.4242 34.1094 23.8572V21.8772ZM34.1094 27.8772C34.1094 27.3192 34.5524 26.8672 35.1194 26.8672H37.0994C37.6574 26.8672 38.1094 27.3102 38.1094 27.8772V29.8572C38.1094 30.4152 37.6664 30.8672 37.0994 30.8672H35.1194C34.5614 30.8672 34.1094 30.4242 34.1094 29.8572V27.8772ZM22.1094 33.8772C22.1094 33.3192 22.5524 32.8672 23.1194 32.8672H25.0994C25.6574 32.8672 26.1094 33.3102 26.1094 33.8772V35.8572C26.1094 36.4162 25.6664 36.8672 25.0994 36.8672H23.1194C22.5604 36.8672 22.1094 36.4242 22.1094 35.8572V33.8772ZM28.1094 33.8772C28.1094 33.3192 28.5524 32.8672 29.1194 32.8672H31.0994C31.6574 32.8672 32.1094 33.3102 32.1094 33.8772V35.8572C32.1094 36.4152 31.6664 36.8672 31.0994 36.8672H29.1194C28.5614 36.8672 28.1094 36.4242 28.1094 35.8572V33.8772ZM34.1094 33.8772C34.1094 33.3192 34.5524 32.8672 35.1194 32.8672H37.0994C37.6574 32.8672 38.1094 33.3102 38.1094 33.8772V35.8572C38.1094 36.4152 37.6664 36.8672 37.0994 36.8672H35.1194C34.5614 36.8672 34.1094 36.4242 34.1094 35.8572V33.8772Z",
                        fill: "#8696A7"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "1728",
                        height: "1117",
                        transform: "translate(0.109375 0.867188)",
                        fill: "#101214",
                        fillOpacity: "0.6"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint0_linear_6402_38719",
                        x1: "620.174",
                        y1: "224.462",
                        x2: "620.174",
                        y2: "210.564",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "#FFE5D4"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.4",
                                stopColor: "#FCE1CF"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.83",
                                stopColor: "#F5D6C2"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F2D1BB"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint1_linear_6402_38719",
                        x1: "618.878",
                        y1: "212.602",
                        x2: "622.178",
                        y2: "194.597",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.35",
                                stopColor: "#91562D"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.41",
                                stopColor: "#775852"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.51",
                                stopColor: "#4D5D8F"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.6",
                                stopColor: "#2B60BF"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.68",
                                stopColor: "#1362E2"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.75",
                                stopColor: "#0564F7"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.8",
                                stopColor: "#0065FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint2_linear_6402_38719",
                        x1: "68.1906",
                        y1: "38.2432",
                        x2: "57.5395",
                        y2: "32.2074",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.9182",
                                stopColor: "#2380FB"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint3_linear_6402_38719",
                        x1: "52.965",
                        y1: "19.6937",
                        x2: "63.6161",
                        y2: "25.7294",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0.9182",
                                stopColor: "#2380FB"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip0_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "1728",
                            height: "1117",
                            fill: "white",
                            transform: "translate(0.109375 0.867188)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip1_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "1488",
                            height: "1059",
                            fill: "white",
                            transform: "translate(240.109 58.8672)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip2_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "232",
                            height: "32",
                            fill: "white",
                            transform: "translate(1456.11 86.8672)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip3_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "128",
                            height: "32",
                            fill: "white",
                            transform: "translate(1456.11 86.8672)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip4_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "192",
                            height: "6",
                            fill: "white",
                            transform: "translate(648.109 206.867)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip5_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "119",
                            height: "14",
                            fill: "white",
                            transform: "translate(648.109 190.867)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip6_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "32",
                            height: "32",
                            fill: "white",
                            transform: "translate(604.109 190.867)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip7_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "208",
                            height: "374",
                            fill: "white",
                            transform: "translate(16.1094 138.867)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip8_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "30",
                            height: "30",
                            fill: "white",
                            transform: "translate(1672.11 13.8672)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip9_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "314",
                            height: "34",
                            fill: "white",
                            transform: "translate(1339.11 11.8672)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip10_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "64",
                            height: "34",
                            fill: "white",
                            transform: "translate(1589.11 11.8672)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip11_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "700",
                            height: "56",
                            fill: "white",
                            transform: "translate(52.1094 0.867188)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip12_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "137",
                            height: "24",
                            fill: "white",
                            transform: "translate(52.1094 16.8672)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip13_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "543",
                            height: "56",
                            fill: "white",
                            transform: "translate(209.109 0.867188)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip14_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "470",
                            height: "56",
                            fill: "white",
                            transform: "translate(209.109 0.867188)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip15_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "8",
                            height: "20",
                            fill: "white",
                            transform: "translate(381.109 18.8672)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip16_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "8",
                            height: "20",
                            fill: "white",
                            transform: "translate(475.109 18.8672)"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "clip17_6402_38719",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "8",
                            height: "20",
                            fill: "white",
                            transform: "translate(569.109 18.8672)"
                        })
                    })
                ]
            })
        ]
    });
};
var $a844e24c4bd0e553$export$2e2bcd8739ae039 = $a844e24c4bd0e553$var$DarkConfluenceBackground;

});

parcelRegister("kvSTX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd2ac48dec543e58$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
const $bd2ac48dec543e58$var$LightConfluenceBackground = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        viewBox: "0 0 1728 1117",
        fill: "none",
        style: {
            minWidth: "100%",
            minHeight: "100%",
            position: "absolute"
        },
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h1728v1117H0z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#fff",
                        d: "M240 58h1488v1059H240z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#fff",
                        d: "M240 58h1488v88H240z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                        clipPath: "url(#b)",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                clipPath: "url(#c)",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        x: "1456",
                                        y: "86",
                                        width: "32",
                                        height: "32",
                                        rx: "3",
                                        fill: "#fff",
                                        fillOpacity: ".01"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fill: "#fff",
                                        fillOpacity: ".01",
                                        d: "M1460 90h24v24h-24z"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M1464.02 109.23c-.03.162-.03.33.02.488.05.158.14.302.25.419.12.117.26.203.42.251.16.048.33.055.49.022l3.81-.78-4.21-4.21-.78 3.81Zm5.92-2.62-2.12-2.12 8.49-8.49 2.12 2.121-8.49 8.49v-.001Zm9.9-9.903-2.12-2.122c-.18-.1859-.4-.3333-.65-.4337-.24-.1004-.5-.1518-.76-.1513-.51 0-1.03.195-1.42.585l-9.75 9.758 4.95 4.95 9.75-9.758c.38-.3751.59-.8837.59-1.414 0-.5303-.21-1.0389-.59-1.414Z",
                                        fill: "#C1C7D0"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        x: "1488",
                                        y: "86",
                                        width: "32",
                                        height: "32",
                                        rx: "3",
                                        fill: "#fff",
                                        fillOpacity: ".01"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fill: "#fff",
                                        fillOpacity: ".01",
                                        d: "M1492 90h24v24h-24z"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M1497 101.513c0-3.038 3.14-5.51 7-5.51s7 2.472 7 5.51c0 3.039-3.14 5.51-7 5.51s-7-2.471-7-5.51Zm14.84 7.771v-.002s-1.57-2.26-.77-3.116l-.04.02c1.23-1.284 1.97-2.907 1.97-4.673 0-4.142-4.04-7.513-9-7.513s-9 3.37-9 7.513 4.04 7.514 9 7.514c1.42 0 2.76-.285 3.96-.776 1 1.022 2.28 1.572 3.24 1.719v-.003c.05.02.11.031.16.033.09 0 .17-.021.25-.061.07-.041.14-.099.18-.17.05-.071.08-.152.09-.237 0-.084-.01-.17-.04-.248Z",
                                        fill: "#C1C7D0"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M1508 99h-8c-.55 0-1 .4477-1 1 0 .552.45 1 1 1h8c.55 0 1-.448 1-1 0-.5523-.45-1-1-1ZM1503 102h-3c-.55 0-1 .448-1 1s.45 1 1 1h3c.55 0 1-.448 1-1s-.45-1-1-1Z",
                                        fill: "#C1C7D0"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        x: "1520",
                                        y: "86",
                                        width: "32",
                                        height: "32",
                                        rx: "3",
                                        fill: "#fff",
                                        fillOpacity: ".01"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fill: "#fff",
                                        fillOpacity: ".01",
                                        d: "M1524 90h24v24h-24z"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "m1536 106.373 3.98 2.193-.76-4.655 3.28-3.347-4.53-.6899-1.97-4.187-1.97 4.189-4.53.6889 3.28 3.345-.76 4.655 3.98-2.192Zm0 2.283-3.02 1.662c-.32.181-.7.266-1.07.245-.38-.02-.74-.146-1.04-.363-.31-.216-.55-.514-.7-.861-.14-.346-.19-.726-.13-1.096l.6-3.656-2.57-2.624c-.25-.263-.43-.592-.52-.951-.08-.359-.06-.733.06-1.0827.11-.3492.32-.6594.61-.8964.28-.237.62-.3917.98-.4468l3.47-.528 1.52-3.224c.16-.3431.42-.6331.74-.8362.32-.2031.69-.3109 1.07-.3109.38 0 .75.1078 1.07.3109.32.2031.58.4931.74.8362l1.52 3.224 3.47.528c.36.0554.7.2103.98.4474.29.2372.5.5474.61.8966.12.3489.14.7239.06 1.0829-.09.358-.27.687-.53.95l-2.56 2.624.59 3.656c.07.371.02.751-.12 1.097-.15.346-.39.645-.7.861-.3.217-.66.342-1.04.363-.37.021-.75-.065-1.08-.246l-3.01-1.662Z",
                                        fill: "#C1C7D0"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        x: "1552",
                                        y: "86",
                                        width: "32",
                                        height: "32",
                                        rx: "3",
                                        fill: "#fff",
                                        fillOpacity: ".01"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fill: "#fff",
                                        fillOpacity: ".01",
                                        d: "M1556 90h24v24h-24z"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M1568 108c-4.54 0-8-4.26-8-6 0-2.001 3.46-6 8-6 4.38 0 8 3.973 8 6 0 1.74-3.46 6-8 6Zm0-14c-5.52 0-10 4.841-10 8 0 3.086 4.58 8 10 8s10-4.914 10-8c0-3.159-4.48-8-10-8",
                                        fill: "#C1C7D0"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M1567.98 103.984c-1.11 0-2-.897-2-2s.89-2 2-2c1.1 0 2 .897 2 2s-.9 2-2 2Zm0-6c-2.21 0-4 1.794-4 4s1.79 4 4 4c2.2 0 4-1.794 4-4s-1.8-4-4-4Z",
                                        fill: "#C1C7D0"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "1590",
                                y: "86",
                                width: "60",
                                height: "32",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".08"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "1598",
                                y: "99",
                                width: "44",
                                height: "6",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".13"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "1656",
                                y: "86",
                                width: "32",
                                height: "32",
                                rx: "3",
                                fill: "#fff",
                                fillOpacity: ".01"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fill: "#fff",
                                fillOpacity: ".01",
                                d: "M1660 90h24v24h-24z"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "M1665 104c1.1 0 2-.895 2-2s-.9-2-2-2-2 .895-2 2 .9 2 2 2ZM1672 104c1.1 0 2-.895 2-2s-.9-2-2-2-2 .895-2 2 .9 2 2 2ZM1679 104c1.1 0 2-.895 2-2s-.9-2-2-2-2 .895-2 2 .9 2 2 2Z",
                                fill: "#C1C7D0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "146",
                        width: "503",
                        height: "20",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                        clipPath: "url(#d)",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            x: "648",
                            y: "206",
                            width: "192",
                            height: "6",
                            rx: "3",
                            fill: "#091E42",
                            fillOpacity: ".13"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "648",
                        y: "194",
                        width: "119",
                        height: "6",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                        cx: "620",
                        cy: "206",
                        r: "17",
                        fill: "url(#e)",
                        stroke: "#fff",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "246",
                        width: "760",
                        height: "86",
                        rx: "5",
                        fill: "#DEEBFF"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#fff",
                        fillOpacity: ".01",
                        d: "M620 262h24v24h-24z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M632 284c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm1-14c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1Zm-1 2c.552 0 1 .448 1 1v5c0 .552-.448 1-1 1s-1-.448-1-1v-5c0-.552.448-1 1-1Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "670",
                        y: "272",
                        width: "659",
                        height: "12",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "670",
                        y: "294",
                        width: "325",
                        height: "12",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "364",
                        width: "117",
                        height: "20",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "400",
                        width: "98.5",
                        height: "20",
                        rx: "10",
                        fill: "#B3D4FF"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M616.624 405.19c-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.431.199-1.354.328-2.29.328-2.926 0-4.813-1.879-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.415 2.769-.493 0-.773-.281-.773-.759v-4.013h-1.032v.834h-.11c-.266-.595-.881-.964-1.599-.964-1.402 0-2.379 1.162-2.379 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.109c.082.67.704 1.148 1.504 1.148 1.572 0 2.57-1.415 2.57-3.643 0-2.967-2.249-5.032-5.482-5.032Zm-.239 3.829c.929 0 1.524.738 1.524 1.907s-.601 1.914-1.538 1.914c-.895 0-1.442-.725-1.442-1.914 0-1.197.54-1.907 1.456-1.907Z",
                        fill: "#091E42",
                        fillOpacity: ".48"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "625.5",
                        y: "407",
                        width: "71",
                        height: "6",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "710.5",
                        y: "400",
                        width: "98.5",
                        height: "20",
                        rx: "10",
                        fill: "#091E42",
                        fillOpacity: ".08"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M723.124 405.19c-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.431.199-1.354.328-2.29.328-2.926 0-4.813-1.879-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.415 2.769-.493 0-.773-.281-.773-.759v-4.013h-1.032v.834h-.11c-.266-.595-.881-.964-1.599-.964-1.402 0-2.379 1.162-2.379 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.109c.082.67.704 1.148 1.504 1.148 1.572 0 2.57-1.415 2.57-3.643 0-2.967-2.249-5.032-5.482-5.032Zm-.239 3.829c.929 0 1.524.738 1.524 1.907s-.601 1.914-1.538 1.914c-.895 0-1.442-.725-1.442-1.914 0-1.197.54-1.907 1.456-1.907Z",
                        fill: "#091E42",
                        fillOpacity: ".48"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "732",
                        y: "407",
                        width: "71",
                        height: "6",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "817",
                        y: "400",
                        width: "98.5",
                        height: "20",
                        rx: "10",
                        fill: "#091E42",
                        fillOpacity: ".08"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M829.624 405.19c-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.431.199-1.354.328-2.29.328-2.926 0-4.813-1.879-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.415 2.769-.493 0-.773-.281-.773-.759v-4.013h-1.032v.834h-.11c-.266-.595-.881-.964-1.599-.964-1.402 0-2.379 1.162-2.379 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.109c.082.67.704 1.148 1.504 1.148 1.572 0 2.57-1.415 2.57-3.643 0-2.967-2.249-5.032-5.482-5.032Zm-.239 3.829c.929 0 1.524.738 1.524 1.907s-.601 1.914-1.538 1.914c-.895 0-1.442-.725-1.442-1.914 0-1.197.54-1.907 1.456-1.907Z",
                        fill: "#091E42",
                        fillOpacity: ".48"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "838.5",
                        y: "407",
                        width: "71",
                        height: "6",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "452",
                        width: "290",
                        height: "20",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "488",
                        width: "730",
                        height: "12",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "516",
                        width: "730",
                        height: "12",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "544",
                        width: "343",
                        height: "12",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "620",
                        y: "582",
                        width: "12",
                        height: "12",
                        rx: "2",
                        fill: "#DFE1E6"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M622 582h8c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2h-8c-1.105 0-2-.895-2-2v-8c0-1.105.895-2 2-2Zm1.382 5.069c.122.052.233.129.325.224l1.293 1.293 3.293-3.293c.092-.095.203-.172.325-.224.122-.052.253-.08.386-.081.132-.001.264.024.387.074.123.05.235.125.328.219.094.094.169.205.219.328.05.123.075.255.074.387-.001.133-.028.264-.081.386-.052.122-.128.233-.224.325l-4 4c-.188.187-.442.293-.707.293-.265 0-.519-.106-.707-.293l-2-2c-.096-.092-.172-.203-.224-.325-.053-.122-.08-.253-.081-.386-.001-.132.024-.264.074-.387.05-.123.125-.234.219-.328.093-.094.205-.169.328-.219.123-.05.255-.075.387-.074.133.001.264.029.386.081Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "640",
                        y: "585",
                        width: "71",
                        height: "6",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "620",
                        y: "614",
                        width: "12",
                        height: "12",
                        rx: "2",
                        fill: "#DFE1E6"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M622 614h8c1.105 0 2 .895 2 2v8c0 1.105-.895 2-2 2h-8c-1.105 0-2-.895-2-2v-8c0-1.105.895-2 2-2Zm1.382 5.069c.122.052.233.129.325.224l1.293 1.293 3.293-3.293c.092-.095.203-.172.325-.224.122-.052.253-.08.386-.081.132-.001.264.024.387.074.123.05.235.125.328.219.094.094.169.205.219.328.05.123.075.255.074.387-.001.133-.028.264-.081.386-.052.122-.128.233-.224.325l-4 4c-.188.187-.442.293-.707.293-.265 0-.519-.106-.707-.293l-2-2c-.096-.092-.172-.203-.224-.325-.053-.122-.08-.253-.081-.386-.001-.132.024-.264.074-.387.05-.123.125-.234.219-.328.093-.094.205-.169.328-.219.123-.05.255-.075.387-.074.133.001.264.029.386.081Z",
                        fill: "#0052CC"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "640",
                        y: "617",
                        width: "71",
                        height: "6",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "621",
                        y: "647",
                        width: "10",
                        height: "10",
                        rx: "1",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "621",
                        y: "647",
                        width: "10",
                        height: "10",
                        rx: "1",
                        stroke: "#7A869A",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "640",
                        y: "649",
                        width: "71",
                        height: "6",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "621",
                        y: "679",
                        width: "10",
                        height: "10",
                        rx: "1",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "621",
                        y: "679",
                        width: "10",
                        height: "10",
                        rx: "1",
                        stroke: "#7A869A",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "640",
                        y: "681",
                        width: "71",
                        height: "6",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "621",
                        y: "711",
                        width: "10",
                        height: "10",
                        rx: "1",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "621",
                        y: "711",
                        width: "10",
                        height: "10",
                        rx: "1",
                        stroke: "#7A869A",
                        strokeWidth: "2"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "640",
                        y: "713",
                        width: "71",
                        height: "6",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "748",
                        width: "730",
                        height: "12",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "776",
                        width: "730",
                        height: "12",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "804",
                        width: "343",
                        height: "12",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "880",
                        width: "290",
                        height: "20",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "916",
                        width: "730",
                        height: "12",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "944",
                        width: "730",
                        height: "12",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "972",
                        width: "730",
                        height: "12",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "1000",
                        width: "730",
                        height: "12",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "604",
                        y: "1028",
                        width: "343",
                        height: "12",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "272",
                        y: "99",
                        width: "100",
                        height: "6",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "385",
                        y: "99",
                        width: "54",
                        height: "6",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m377.372 109.105 3.548-12.4409h-1.299l-3.541 12.4409h1.292Z",
                        fill: "#6B778C"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#F4F5F7",
                        d: "M0 58h240v1059H0z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                        clipPath: "url(#f)",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fill: "#fff",
                                fillOpacity: ".01",
                                d: "M26 146h24v24H26z"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "22",
                                y: "142",
                                width: "32",
                                height: "32",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".08"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "66",
                                y: "155",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".13"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fill: "#fff",
                                fillOpacity: ".01",
                                d: "M26 190h24v24H26z"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "22",
                                y: "186",
                                width: "32",
                                height: "32",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".08"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "66",
                                y: "199",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".13"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fill: "#fff",
                                fillOpacity: ".01",
                                d: "M26 234h24v24H26z"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "22",
                                y: "230",
                                width: "32",
                                height: "32",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".08"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "66",
                                y: "243",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".13"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fill: "#fff",
                                fillOpacity: ".01",
                                d: "M26 278h24v24H26z"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "22",
                                y: "274",
                                width: "32",
                                height: "32",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".08"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "66",
                                y: "287",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".13"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fill: "#fff",
                                fillOpacity: ".01",
                                d: "M26 348h24v24H26z"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "22",
                                y: "344",
                                width: "32",
                                height: "32",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".08"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "66",
                                y: "357",
                                width: "71",
                                height: "6",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".13"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "16",
                                y: "384",
                                width: "208",
                                height: "40",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".04"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fill: "#fff",
                                fillOpacity: ".01",
                                d: "M40 392h24v24H40z"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                                cx: "52",
                                cy: "404",
                                r: "2",
                                fill: "#091E42",
                                fillOpacity: ".13"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "72",
                                y: "401",
                                width: "125",
                                height: "6",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".13"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fill: "#fff",
                                fillOpacity: ".01",
                                d: "M40 436h24v24H40z"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                                cx: "52",
                                cy: "448",
                                r: "2",
                                fill: "#091E42",
                                fillOpacity: ".13"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "72",
                                y: "445",
                                width: "125",
                                height: "6",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".13"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fill: "#fff",
                                fillOpacity: ".01",
                                d: "M40 480h24v24H40z"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                                cx: "52",
                                cy: "492",
                                r: "2",
                                fill: "#091E42",
                                fillOpacity: ".13"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "72",
                                y: "489",
                                width: "125",
                                height: "6",
                                rx: "3",
                                fill: "#091E42",
                                fillOpacity: ".13"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "18",
                        y: "82",
                        width: "40",
                        height: "40",
                        rx: "3",
                        fill: "#DEEBFF"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "66",
                        y: "87",
                        width: "97",
                        height: "12",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "66",
                        y: "111",
                        width: "141",
                        height: "6",
                        rx: "3",
                        fill: "#091E42",
                        fillOpacity: ".13"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#fff",
                        d: "M1 0h1727v56H1z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#DFE1E6",
                        d: "M1 56h1727v2H1z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#fff",
                        fillOpacity: ".01",
                        d: "M1672 12h32v32h-32z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M1701.33 28.0001c0 7.3638-5.97 13.3333-13.33 13.3333s-13.33-5.9695-13.33-13.3333c0-7.3638 5.97-13.3334 13.33-13.3334s13.33 5.9696 13.33 13.3334Zm-9.33-4c0 2.2091-1.79 4-4 4s-4-1.7909-4-4c0-2.2092 1.79-4 4-4s4 1.7908 4 4Zm-4 14.6666c-2.42.0037-4.78-.822-6.67-2.34v-4.3266c0-1.4734 1.19-2.6667 2.67-2.6667h8c1.47 0 2.67 1.18 2.67 2.6667v4.3266c-1.83 1.464-4.15 2.34-6.67 2.34Z",
                        fill: "#DFE1E6"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                        clipPath: "url(#g)",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                x: "1341",
                                y: "12",
                                width: "238",
                                height: "32",
                                rx: "3",
                                fill: "#F4F5F7"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M1362 27c0 2.2091-1.79 4-4 4s-4-1.7909-4-4c0-2.2091 1.79-4 4-4s4 1.7909 4 4Zm-.52 4.8907C1360.5 32.5892 1359.3 33 1358 33c-3.31 0-6-2.6863-6-6s2.69-6 6-6 6 2.6863 6 6c0 1.2958-.41 2.4957-1.11 3.4765l2.82 2.8164c.39.3905.39 1.0237 0 1.4142-.39.3905-1.03.3905-1.42 0l-2.81-2.8164Z",
                                fill: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fill: "#fff",
                                fillOpacity: ".01",
                                d: "M1590 16h24v24h-24z"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M1596.49 33.669c.18.1858.4.3332.64.4338.25.1005.51.1523.77.1523s.52-.0518.77-.1523c.24-.1006.46-.248.64-.4338l-2.82-2.83c-.19.1858-.34.4063-.44.6491-.1.2428-.15.5031-.15.7659 0 .2629.05.5231.15.7659.1.2428.25.4634.44.6491Zm4.89-12.191-.72.725c-.78.782-2.21 1.813-3.21 2.311l-3.02 1.509c-.49.248-.58.774-.18 1.171l8.55 8.556c.4.396.93.313 1.17-.188l1.51-3.016c.5-.988 1.53-2.42 2.32-3.206l.72-.726c.82-.8231 1.34-1.9055 1.45-3.0639.12-1.1583-.17-2.3213-.81-3.2921.11-.0861.2-.1934.26-.3152.07-.1217.1-.2554.12-.3928.01-.1373-.01-.2755-.06-.4059-.04-.1304-.11-.2504-.2-.3525-.1-.1021-.21-.1842-.33-.2412-.13-.0571-.26-.0878-.4-.0904-.14-.0026-.28.0231-.4.0754-.13.0522-.25.1301-.34.2286-.03.025-.05.049-.07.075-.83-.548-1.8-.8402-2.79-.84-.66-.0008-1.32.1294-1.93.383-.61.2537-1.17.6258-1.64 1.095v.001Z",
                                fill: "#C1C7D0"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fill: "#fff",
                                fillOpacity: ".01",
                                d: "M1630 16h24v24h-24z"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M1652 28c0 5.5228-4.48 10-10 10s-10-4.4772-10-10 4.48-10 10-10 10 4.4772 10 10Zm-7.17-4.84c.52.5195.89 1.1738 1.06 1.89.23.958.1 1.9681-.37 2.8356-.46.8675-1.24 1.5309-2.17 1.8624-.2.073-.35.255-.35.472v.782c0 .2657-.1.5206-.29.7085-.19.1879-.44.2935-.71.2935-.26 0-.52-.1056-.71-.2935-.18-.1879-.29-.4428-.29-.7085v-2.014c0-.263.11-.514.3-.6987.18-.1847.44-.2883.7-.2883h-.01c1.11 0 2.01-.898 2.01-2-.02-.5236-.23-1.0217-.61-1.3877-.37-.366-.87-.5708-1.4-.5706-.52.0003-1.03.2056-1.4.572-.37.3663-.59.8647-.6 1.3883 0 .551-.45.998-1 .998-.25-.0015-.49-.095-.67-.2622-.18-.1671-.29-.396-.31-.6418l-.01-.147c.02-2.504 2.32-4.436 4.93-3.842.72.1683 1.38.5325 1.9 1.052ZM1643 34c0 .5523-.45 1-1 1s-1-.4477-1-1 .45-1 1-1 1 .4477 1 1Z",
                                fill: "#C1C7D0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                        clipPath: "url(#h)",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                clipPath: "url(#i)",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fill: "#fff",
                                        fillOpacity: ".01",
                                        d: "M53 16h137v24H53z"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M89.175 34.4914c-.9683.6207-2.5014.8793-4.1151.8793-5.1103 0-7.9881-2.9483-7.9881-7.6811 0-4.5517 2.8778-7.7327 7.9612-7.7327 1.5062 0 3.0392.2845 4.142 1.0345v1.9914c-1.1028-.6725-2.34-1.0345-4.142-1.0345-3.6579 0-5.8095 2.3276-5.8095 5.7672 0 3.4397 2.2592 5.7155 5.944 5.7155 1.6406 0 2.9047-.362 4.0344-.9051v1.9655h-.0269ZM90.6542 29.4483c0-3.4138 2.071-5.8966 5.6213-5.8966 3.5234 0 5.5945 2.4828 5.5945 5.8966s-2.0711 5.9482-5.5945 5.9482c-3.5234-.0258-5.6213-2.5344-5.6213-5.9482Zm1.9903 0c0 2.1724 1.1028 4.112 3.6579 4.112 2.5013 0 3.604-1.9655 3.604-4.112 0-2.1466-1.0758-4.0862-3.604-4.0862-2.5551 0-3.6579 1.9138-3.6579 4.0862ZM114.296 35.1638h-2.044v-6.8793c0-2.0431-.861-2.9483-2.797-2.9483-1.883 0-3.201 1.2155-3.201 3.5172v6.3362h-2.044V23.8103h2.044v1.8621c.753-1.3448 2.152-2.0948 3.738-2.0948 2.717 0 4.277 1.8103 4.277 4.9396v6.6466h.027ZM123.037 23.7845v1.8103h-3.066v9.569h-1.99v-9.569h-1.91v-1.8103h1.91v-1.2414c0-2.1207 1.237-3.5431 3.765-3.5431.619 0 1.022.1034 1.372.181v1.8104c-.35-.0776-.807-.1035-1.291-.1035-1.264 0-1.883.6983-1.883 1.7328v1.1638h3.093ZM128.389 35.2155c-1.936 0-3.173-.8793-3.173-2.9741V19.0259h2.044v12.9827c0 1.0345.699 1.3966 1.586 1.3966.216 0 .35 0 .592-.0259v1.7586c-.188.0518-.538.0776-1.049.0776ZM131.159 23.7845h2.045v6.8793c0 2.0431.86 2.9483 2.797 2.9483 1.882 0 3.2-1.2155 3.2-3.5173v-6.3103h2.044v11.3793h-2.044v-1.8621c-.753 1.3449-2.151 2.0949-3.738 2.0949-2.717 0-4.277-1.8104-4.277-4.9397v-6.6724h-.027ZM149.96 35.3707c-4.438 0-6.374-2.4569-6.374-5.9483 0-3.4396 1.99-5.8965 5.594-5.8965 3.658 0 5.11 2.431 5.11 5.8965v.8793h-8.633c.295 1.9397 1.586 3.1811 4.384 3.1811 1.371 0 2.528-.2587 3.604-.6207v1.8103c-.996.5173-2.502.6983-3.685.6983Zm-4.357-6.7241h6.616c-.107-2.1207-1.103-3.3104-3.147-3.3104-2.151 0-3.254 1.319-3.469 3.3104ZM166.743 35.1638h-2.044v-6.8793c0-2.0431-.861-2.9483-2.797-2.9483-1.883 0-3.201 1.2155-3.201 3.5172v6.3362h-2.044V23.8103h2.044v1.8621c.753-1.3448 2.152-2.0948 3.739-2.0948 2.716 0 4.276 1.8103 4.276 4.9396v6.6466h.027ZM177.959 34.8534c-.7.3621-1.803.5173-2.878.5173-4.223 0-6.186-2.4569-6.186-5.9483 0-3.4396 1.963-5.8965 6.186-5.8965 1.075 0 1.882.1293 2.824.5431v1.8103c-.753-.3362-1.56-.5431-2.663-.5431-3.066 0-4.33 1.8621-4.33 4.0862 0 2.2242 1.291 4.0862 4.384 4.0862 1.21 0 1.963-.1552 2.689-.4138v1.7586h-.026ZM185.92 35.3707c-4.438 0-6.375-2.4569-6.375-5.9483 0-3.4396 1.991-5.8965 5.595-5.8965 3.658 0 5.11 2.431 5.11 5.8965v.8793h-8.634c.296 1.9397 1.587 3.1811 4.384 3.1811 1.372 0 2.529-.2587 3.604-.6207v1.8103c-.995.5173-2.474.6983-3.684.6983Zm-4.331-6.7241h6.617c-.108-2.1207-1.103-3.3104-3.147-3.3104-2.179 0-3.254 1.319-3.47 3.3104Z",
                                        fill: "#253858"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M53.5918 32.425c-.1614.3-.3766.6273-.5379.9001-.1614.2454-.0807.5727.1882.7363l3.4965 2.1819c.269.1636.5917.0818.7531-.1909.1345-.2455.3228-.5455.511-.8728 1.3986-2.3182 2.7703-2.0455 5.2985-.8182l3.4696 1.6637c.269.1364.5917 0 .7262-.2727l1.6675-3.8183c.1076-.2727 0-.6-.2689-.7091-.7262-.3545-2.1786-1.0364-3.4965-1.6909-4.7337-2.291-8.7412-2.1546-11.8073 2.8909Z",
                                        fill: "url(#j)"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        d: "M69.2721 23.7794c.1614-.3.3765-.6273.5379-.9.1614-.2455.0807-.5728-.1883-.7364l-3.4964-2.1818c-.269-.1637-.5918-.0819-.7531.1909-.1345.2454-.3228.5454-.5111.8727-1.3985 2.3182-2.7702 2.0455-5.2985.8182L56.12 20.1521c-.269-.1364-.5917 0-.7262.2727l-1.6676 3.8182c-.1076.2728 0 .6001.269.7091.7262.3546 2.1786 1.0364 3.4965 1.691 4.7067 2.3182 8.7142 2.1818 11.7804-2.8637Z",
                                        fill: "url(#k)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                clipPath: "url(#l)",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fill: "#fff",
                                        fillOpacity: ".01",
                                        d: "M214 0h86v56h-86z"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        x: "221.5",
                                        y: "25",
                                        width: "71",
                                        height: "6",
                                        rx: "3",
                                        fill: "#091E42",
                                        fillOpacity: ".13"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fill: "#fff",
                                        fillOpacity: ".01",
                                        d: "M308 0h86v56h-86z"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        x: "312",
                                        y: "25",
                                        width: "64",
                                        height: "6",
                                        rx: "3",
                                        fill: "#091E42",
                                        fillOpacity: ".13"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                        opacity: ".6",
                                        clipPath: "url(#m)",
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                fill: "#fff",
                                                fillOpacity: ".01",
                                                d: "M382 18h8v20h-8z"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M382.292 26.2929c-.187.1889-.292.4439-.292.7095 0 .2657.105.5206.292.7095l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955c.187-.189.291-.4439.291-.7095 0-.2655-.104-.5204-.291-.7095-.092-.0931-.201-.1671-.322-.2176-.121-.0506-.25-.0766-.381-.0766s-.26.026-.381.0766c-.121.0505-.23.1245-.322.2176l-2.298 2.317-2.307-2.327c-.092-.0928-.202-.1665-.322-.2167-.121-.0503-.25-.0762-.381-.0762s-.26.0259-.381.0762c-.12.0502-.23.1239-.322.2167Z",
                                                fill: "#344563"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fill: "#fff",
                                        fillOpacity: ".01",
                                        d: "M402 0h86v56h-86z"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        x: "406",
                                        y: "25",
                                        width: "64",
                                        height: "6",
                                        rx: "3",
                                        fill: "#091E42",
                                        fillOpacity: ".13"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                        opacity: ".6",
                                        clipPath: "url(#n)",
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                fill: "#fff",
                                                fillOpacity: ".01",
                                                d: "M476 18h8v20h-8z"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M476.292 26.2929c-.187.1889-.292.4439-.292.7095 0 .2657.105.5206.292.7095l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955c.187-.189.291-.4439.291-.7095 0-.2655-.104-.5204-.291-.7095-.092-.0931-.201-.1671-.322-.2176-.121-.0506-.25-.0766-.381-.0766s-.26.026-.381.0766c-.121.0505-.23.1245-.322.2176l-2.298 2.317-2.307-2.327c-.092-.0928-.202-.1665-.322-.2167-.121-.0503-.25-.0762-.381-.0762s-.26.0259-.381.0762c-.12.0502-.23.1239-.322.2167Z",
                                                fill: "#344563"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fill: "#fff",
                                        fillOpacity: ".01",
                                        d: "M496 0h86v56h-86z"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        x: "500",
                                        y: "25",
                                        width: "64",
                                        height: "6",
                                        rx: "3",
                                        fill: "#091E42",
                                        fillOpacity: ".13"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                                        opacity: ".6",
                                        clipPath: "url(#o)",
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                fill: "#fff",
                                                fillOpacity: ".01",
                                                d: "M570 18h8v20h-8z"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                                fillRule: "evenodd",
                                                clipRule: "evenodd",
                                                d: "M570.292 26.2929c-.187.1889-.292.4439-.292.7095 0 .2657.105.5206.292.7095l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955c.187-.189.291-.4439.291-.7095 0-.2655-.104-.5204-.291-.7095-.092-.0931-.201-.1671-.322-.2176-.121-.0506-.25-.0766-.381-.0766s-.26.026-.381.0766c-.121.0505-.23.1245-.322.2176l-2.298 2.317-2.307-2.327c-.092-.0928-.202-.1665-.322-.2167-.121-.0503-.25-.0762-.381-.0762s-.26.0259-.381.0762c-.12.0502-.23.1239-.322.2167Z",
                                                fill: "#344563"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                        fill: "#fff",
                                        fillOpacity: ".01",
                                        d: "M590 0h86v56h-86z"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        x: "597.5",
                                        y: "25",
                                        width: "71",
                                        height: "6",
                                        rx: "3",
                                        fill: "#091E42",
                                        fillOpacity: ".13"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        x: "692",
                                        y: "12",
                                        width: "61",
                                        height: "32",
                                        rx: "3",
                                        fill: "#B3D4FF"
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                        x: "700",
                                        y: "25",
                                        width: "44",
                                        height: "6",
                                        rx: "3",
                                        fill: "#091E42",
                                        fillOpacity: ".13"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#fff",
                        fillOpacity: ".01",
                        d: "M19 16h24v24H19z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M23 21.01c0-.559.443-1.01 1.01-1.01h1.98c.559 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Z",
                        fill: "#A5ADBA"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#091E42",
                        fillOpacity: ".54",
                        d: "M0 0h1728v1117H0z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "a",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h1728v1117H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "b",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(1456 86)",
                            d: "M0 0h232v32H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "c",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(1456 86)",
                            d: "M0 0h128v32H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "d",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(648 206)",
                            d: "M0 0h192v6H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "f",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(16 138)",
                            d: "M0 0h208v374H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "g",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(1340 11)",
                            d: "M0 0h314v34H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "h",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(53)",
                            d: "M0 0h700v56H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "i",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(53 16)",
                            d: "M0 0h137v24H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "l",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(210)",
                            d: "M0 0h543v56H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "m",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(382 18)",
                            d: "M0 0h8v20H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "n",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(476 18)",
                            d: "M0 0h8v20H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                        id: "o",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(570 18)",
                            d: "M0 0h8v20H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "j",
                        x1: "69.0523",
                        y1: "37.3758",
                        x2: "58.4012",
                        y2: "31.34",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: ".9182",
                                stopColor: "#2380FB"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "k",
                        x1: "53.8258",
                        y1: "18.8262",
                        x2: "64.4769",
                        y2: "24.862",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "#0052CC"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: ".9182",
                                stopColor: "#2380FB"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "1",
                                stopColor: "#2684FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $bd2ac48dec543e58$export$2e2bcd8739ae039 = $bd2ac48dec543e58$var$LightConfluenceBackground;

});



parcelRegister("kmxlM", function(module, exports) {

$parcel$export(module.exports, "useSignupProvisioningContext", function () { return $d5708baaa7987870$export$355dfd0b5b3951aa; });
$parcel$export(module.exports, "SignupProvisioningContextProvider", function () { return $d5708baaa7987870$export$2b4857659b19a546; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $aYwtv = parcelRequire("aYwtv");

var $e66ZO = parcelRequire("e66ZO");

var $dkYGl = parcelRequire("dkYGl");

var $OOa63 = parcelRequire("OOa63");

var $1LPIk = parcelRequire("1LPIk");

var $9iWJ8 = parcelRequire("9iWJ8");

var $2ovs0 = parcelRequire("2ovs0");

var $aP4CP = parcelRequire("aP4CP");

var $dWbel = parcelRequire("dWbel");
parcelRequire("7xMFD");
var $eKfEs = parcelRequire("eKfEs");
var $5SFEW = parcelRequire("5SFEW");
var $ejZ0o = parcelRequire("ejZ0o");
var $lvtpi = parcelRequire("lvtpi");
const { ACTIVATE_STATUS_CCP_POLLING_API: $d5708baaa7987870$var$ACTIVATE_STATUS_CCP_POLLING_API, CLOUD_STATUS_HAMS_POLLING_API: $d5708baaa7987870$var$CLOUD_STATUS_HAMS_POLLING_API, GRAPHQL_SUBSCRIPTION_ACK: $d5708baaa7987870$var$GRAPHQL_SUBSCRIPTION_ACK, GRAPHQL_WEBHOOK_PROVISIONING_LATENCY: $d5708baaa7987870$var$GRAPHQL_WEBHOOK_PROVISIONING_LATENCY } = (0, $jgJpJ.UfoCustomTimingKey);
const $d5708baaa7987870$var$SignupProvisioningContext = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $d5708baaa7987870$export$355dfd0b5b3951aa = ()=>{
    const context = (0, $iSvIT.useContext)($d5708baaa7987870$var$SignupProvisioningContext);
    if (!context) throw new Error("useSignupProvisioningContext must be used within a SignupProvisioningContextProvider");
    return context;
};
const $d5708baaa7987870$export$2b4857659b19a546 = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const searchParameters = (0, $eKfEs.useSearchParameters)();
    const stargateClient = (0, $aYwtv.useBxpWebStargateClient)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const streamlineRedirectToProductConfluence = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).streamlineRedirectToProductConfluence);
    const { cloudId: cloudId, onDemandUrl: onDemandUrl, platform: platform, products: products, provisioningRequestId: provisioningRequestId, requestId: requestId, siteRenameRequestId: siteRenameRequestId, signupSource: signupSource, isFoundingAdmin: isFoundingAdmin, dataRegion: dataRegion, admin: admin, orchestrationId: orchestrationId, edition: edition } = searchParameters;
    const productKey = (0, $iSvIT.useMemo)(()=>products.length > 0 ? products[0] : undefined, [
        products
    ]);
    const hasRequiredParameters = (0, $iSvIT.useMemo)(()=>!!onDemandUrl && !!products.length, [
        onDemandUrl,
        products
    ]);
    const [startTime] = (0, $iSvIT.useState)(Date.now());
    const currentTime = Date.now();
    const [status, setStatus] = (0, $iSvIT.useState)(!hasRequiredParameters ? "error" : "pending");
    const graphqlProvisioningMS = (0, $iSvIT.useRef)(0);
    const [enrolledInGraphqlExperiment, setEnrolledInGraphqlExperiment] = (0, $iSvIT.useState)(orchestrationId ? true : false);
    const [startPolling, setStartPolling] = (0, $iSvIT.useState)(false);
    const [graphqlProvisionComplete, setGraphqlProvisionComplete] = (0, $iSvIT.useState)(false);
    const provisionPollingTimes = (0, $iSvIT.useRef)(0);
    const [ccpProvisioningCloudId, setCCPProvisioningCloudId] = (0, $iSvIT.useState)("");
    const [perceivedProvisioningStartTime, setPerceivedProvisioningStartTime] = (0, $iSvIT.useState)(undefined);
    // Start time for perceived provisioning based on time spent on loading screens (dwell time)
    const perceivedProvisioningStartTimeRef = (0, $iSvIT.useRef)();
    (0, $iSvIT.useEffect)(()=>{
        perceivedProvisioningStartTimeRef.current = perceivedProvisioningStartTime;
    }, [
        perceivedProvisioningStartTime
    ]);
    const setCloudIdIfPresent = (cloudId)=>{
        cloudId?.length && setCCPProvisioningCloudId(cloudId);
    };
    const createRedirectUrl = (0, $iSvIT.useCallback)((urlModifier)=>{
        let url = new URL((0, $5SFEW.createBaseUrl)(onDemandUrl, products, dataRegion, cloudId, admin, createAnalyticsEvent));
        createAnalyticsEvent({
            ...(0, $1LPIk.getDataFoundationEvent)("ProductNavigationInitialized"),
            actionSubjectId: "newSite",
            attributes: {
                url: url,
                productKey: productKey,
                edition: edition
            }
        }).fire();
        // This causes browser to retry for 30 seconds if site isn't ready
        url.searchParams.set("src", "signup");
        if (siteRenameRequestId) url.searchParams.set("rename", "true");
        if (signupSource === "bbbundle" && isFoundingAdmin === "true") {
            url.searchParams.set("signupSource", signupSource);
            url.searchParams.set("isFoundingAdmin", isFoundingAdmin);
        }
        if (urlModifier) url = urlModifier(url);
        if (streamlineRedirectToProductConfluence.type === "enrolled") {
            streamlineRedirectToProductConfluence.fireExposure();
            if (streamlineRedirectToProductConfluence.value) return `${(0, $jgJpJ.getIdentityBaseUrl)()}/login?${new URLSearchParams({
                continue: url.toString(),
                application: "confluence"
            })}`;
        }
        return url.toString();
    }, [
        onDemandUrl,
        products,
        dataRegion,
        cloudId,
        admin,
        createAnalyticsEvent,
        siteRenameRequestId,
        signupSource,
        isFoundingAdmin,
        streamlineRedirectToProductConfluence
    ]);
    // TODO: Add test coverage based on query params
    /* istanbul ignore next */ const getProvisioningCloudStatus = (0, $iSvIT.useCallback)(async ()=>{
        provisionPollingTimes.current = provisionPollingTimes.current + 1;
        if (platform === "ccp") {
            if (!provisioningRequestId) return false;
            const getProductActivationStatus = async (product)=>{
                return (0, $ejZ0o.measureTime)(()=>stargateClient.getProductActivationStatus({
                        provisioningRequestId: product,
                        provisionPollingTimes: provisionPollingTimes.current
                    }), `getProductActivationStatus`, createAnalyticsEvent);
            };
            const requestIds = await Promise.all(provisioningRequestId.split(",").map(async (product)=>{
                try {
                    return await getProductActivationStatus(product);
                } catch (error) {
                    // @ts-ignore
                    if (error.response?.status === 400) {
                        (0, $jgJpJ.ufoEventRedirectToProduct).abort({
                            customData: {
                                reactComponent: "SignupProvisioningContextProvider",
                                analyticsEvent: "redirect",
                                redirectFrom: "confirmationPage",
                                errorOrigin: "StaleProvisioningRedirect"
                            },
                            error: error
                        });
                        window.location.assign(createRedirectUrl());
                    }
                    // retry if the first call fails
                    return await getProductActivationStatus(product);
                }
            }));
            // Get cloud id from provisioning status, since ccp sign up
            // doesn't provide cloud id query parameter for provisioning screen
            const cloudId = requestIds[0]?.resourcePackages[0]?.resourceAris.find((resourceAri)=>resourceAri.includes("ari:cloud:platform::site"))?.split("/")[1];
            setCloudIdIfPresent(cloudId);
            for (const resource of requestIds){
                if (resource.resourcePackages.find((item)=>item.action.status === "IN_PROGRESS")) return false;
                if (resource.resourcePackages.find((item)=>item.action.status === "PROVISIONING_FAILURE")) return Promise.reject(new Error(`Provisioning Failure CCP with cloudId ${cloudId}: ${JSON.stringify(resource.resourcePackages[0]?.action.errorDetails)}`));
            }
            return true;
        } else {
            if (!cloudId || !requestId) return false;
            setCloudIdIfPresent(cloudId);
            const getCloudStatus = async ()=>{
                return (0, $ejZ0o.measureTime)(async ()=>{
                    const { completed: completed, successful: successful } = await stargateClient.getCloudStatus({
                        cloudId: cloudId,
                        requestId: requestId
                    });
                    return completed && successful;
                }, "getCloudStatus", createAnalyticsEvent);
            };
            try {
                return await getCloudStatus();
            } catch  {
                return await getCloudStatus();
            }
        }
    }, [
        platform,
        provisioningRequestId,
        cloudId,
        requestId,
        stargateClient,
        createRedirectUrl
    ]);
    const { data: subscriptionData, loading: subscriptionLoading, error: subscriptionError } = (0, $aP4CP.useGraphQlSubscription)({
        reactComponent: "SignupProvisioningContextProvider GraphQL",
        skip: !enrolledInGraphqlExperiment,
        subscriptionQuery: (0, $2ovs0.graphqlSubscriptionsQueries).provisioningStatusQuery,
        orchestrationId: orchestrationId,
        onErrorCb: (_error)=>{
            setEnrolledInGraphqlExperiment(false);
        }
    });
    // GraphQL experiment to listen to status change
    /* istanbul ignore next */ (0, $iSvIT.useEffect)(()=>{
        if (!enrolledInGraphqlExperiment || graphqlProvisionComplete) return;
        (0, $dkYGl.fireFrontendProvisioningCompletedEvent)("graphql", productKey, edition, createAnalyticsEvent);
        if (!!subscriptionData) {
            // SLO "good event" for GraphQL subscription
            (0, $jgJpJ.ufoEventGraphQLSubscriptionSetup).success({
                customData: {
                    reactComponent: "SignupProvisioningContextProvider GraphQL",
                    analyticsEvent: "succeeded",
                    orchestrationId: orchestrationId
                }
            });
            (0, $jgJpJ.ufoEventRedirectToProduct).endSubstep($d5708baaa7987870$var$GRAPHQL_SUBSCRIPTION_ACK);
        }
        try {
            // Guard to redirect users who bookmarked Confirmation page
            (0, $jgJpJ.ufoEventGraphQLGetProvisioningStatus).start({
                productKey: productKey
            });
            if (!!getProvisioningCloudStatus && provisionPollingTimes.current === 0) {
                const before = Date.now();
                getProvisioningCloudStatus().then((ready)=>{
                    (0, $jgJpJ.ufoEventGraphQLGetProvisioningStatus).setCustomData({
                        isInitialStatusPollingStatusOk: true
                    });
                    if (ready) {
                        setGraphqlProvisionComplete(true);
                        onSuccess(before, Date.now(), Date.now() - before);
                    }
                }).catch((_error)=>{
                    // Do not throw on initial polling failure. Wait for GraphQL response
                    (0, $jgJpJ.ufoEventGraphQLGetProvisioningStatus).setCustomData({
                        isInitialStatusPollingStatusOk: false
                    });
                });
            }
            (0, $jgJpJ.ufoEventRedirectToProduct).startSubstep($d5708baaa7987870$var$GRAPHQL_WEBHOOK_PROVISIONING_LATENCY);
            if (subscriptionData?.signup?.signupProvisioningStatus) {
                const { provisionComplete: provisionComplete, orchestrationId: orchestrationIdFromSubscription, cloudId: cloudId } = subscriptionData.signup.signupProvisioningStatus;
                setCloudIdIfPresent(cloudId);
                if (provisionComplete && orchestrationIdFromSubscription) {
                    if (analyticsClient) {
                        const elapsedTimeSeconds = Math.round(graphqlProvisioningMS.current / 1000);
                        (0, $OOa63.trackGetProvisioningStatusLatencyEvent)({
                            createAnalyticsEvent: createAnalyticsEvent,
                            productKey: productKey,
                            fetchType: "graphql-webhook",
                            elapsedTimeSeconds: elapsedTimeSeconds
                        });
                        if (elapsedTimeSeconds > 35) {
                            const event = createAnalyticsEvent({
                                event: "succeeded",
                                eventName: "provisioningStatusPollingLatencyAbove35s",
                                eventType: "track",
                                action: "loaded",
                                actionSubject: "getProvisioningStatusLatency greater than 35s",
                                attributes: {
                                    elapsedTimeSeconds: elapsedTimeSeconds,
                                    productKey: productKey,
                                    provisioningScreenOnComplete: "provisioning-screen",
                                    fetchType: "graphql-webhook"
                                },
                                containerId: "perceivedProvisioningPage"
                            });
                            event.fire();
                        }
                    }
                    // SLO "good event" for GraphQL get provisioning status
                    (0, $jgJpJ.ufoEventGraphQLGetProvisioningStatus).success({
                        customData: {
                            reactComponent: "SignupProvisioningContextProvider GraphQL",
                            analyticsEvent: "succeeded",
                            elapsedTimeMs: graphqlProvisioningMS.current,
                            orchestrationId: orchestrationIdFromSubscription
                        }
                    });
                    setGraphqlProvisionComplete(true);
                    onSuccess(currentTime, Date.now(), graphqlProvisioningMS.current);
                }
            }
            if (subscriptionError) {
                // SLO "bad event" for GraphQL subscription
                (0, $jgJpJ.ufoEventGraphQLSubscriptionSetup).failure({
                    error: subscriptionError,
                    customData: {
                        reactComponent: "SignupProvisioningContextProvider GraphQL",
                        analyticsEvent: "errored",
                        errorOrigin: "useSubscription, useEffect",
                        orchestrationId: orchestrationId
                    }
                });
                throw subscriptionError;
            }
        } catch (error) {
            // SLO "bad event" for GraphQL get provisioning status
            (0, $jgJpJ.ufoEventGraphQLGetProvisioningStatus).failure({
                error: error,
                customData: {
                    reactComponent: "SignupProvisioningContextProvider GraphQL",
                    analyticsEvent: "errored",
                    elapsedTimeMs: graphqlProvisioningMS.current,
                    errorOrigin: "useEffect",
                    orchestrationId: orchestrationId
                }
            });
            (0, $jgJpJ.ufoEventRedirectToProduct).endSubstep($d5708baaa7987870$var$GRAPHQL_WEBHOOK_PROVISIONING_LATENCY, {
                customData: {
                    orchestrationId: orchestrationId
                }
            });
            onError(currentTime, Date.now(), graphqlProvisioningMS.current, error);
            // fallback to control status polling
            setEnrolledInGraphqlExperiment(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscriptionData,
        subscriptionLoading,
        subscriptionError,
        getProvisioningCloudStatus,
        enrolledInGraphqlExperiment,
        graphqlProvisionComplete,
        createAnalyticsEvent,
        orchestrationId
    ]);
    // GraphQL experiment timeout listener
    const fallbackGraphqlToStatusPolling = (0, $iSvIT.useCallback)(()=>{
        if (!enrolledInGraphqlExperiment || graphqlProvisionComplete) return;
        // SLO "bad event" for GraphQL webhook provisioning status
        (0, $jgJpJ.ufoEventGraphQLGetProvisioningStatus).failure({
            error: new Error("GraphQL timeout"),
            customData: {
                reactComponent: "SignupProvisioningContextProvider",
                analyticsEvent: "timedOut",
                orchestrationId: orchestrationId
            }
        });
        // fallback to control status polling
        setEnrolledInGraphqlExperiment(false);
        return;
    }, [
        enrolledInGraphqlExperiment,
        graphqlProvisionComplete,
        orchestrationId
    ]);
    /* istanbul ignore next */ (0, $iSvIT.useEffect)(()=>{
        if (!enrolledInGraphqlExperiment || graphqlProvisionComplete) return;
        const intervalId = setInterval(()=>{
            if (graphqlProvisioningMS.current > (0, $e66ZO.GRAPHQL_FALLBACK_TIMEOUT)) {
                fallbackGraphqlToStatusPolling();
                return;
            }
            graphqlProvisioningMS.current += 1000;
        }, 1000);
        return ()=>clearInterval(intervalId);
    }, [
        enrolledInGraphqlExperiment,
        graphqlProvisionComplete,
        platform,
        orchestrationId
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (enrolledInGraphqlExperiment || startPolling) return;
        // Add product cohort to UFO event (ie. metrics by product)
        const productKey = products.length > 0 ? products[0] : undefined;
        // Start UFO to measure the total duration and reliability of provisioning status polling
        (0, $jgJpJ.ufoEventConfirmationPageStatusPolling).start({
            productKey: productKey,
            webPlatform: "bxp-ui"
        });
        const ufoSubstepKey = platform === "ccp" ? $d5708baaa7987870$var$ACTIVATE_STATUS_CCP_POLLING_API : $d5708baaa7987870$var$CLOUD_STATUS_HAMS_POLLING_API;
        const ufoReqPath = platform === "ccp" ? "/activate/status/:provisioningRequestId" : "/cofs/:cloudId/status/:requestId";
        (0, $jgJpJ.ufoEventRedirectToProduct).startSubstep(ufoSubstepKey);
        setStartPolling(true);
        (0, $lvtpi.pollCloudStatus)({
            getCloudStatus: getProvisioningCloudStatus,
            onError: (startTime, endTime, elapsedTime, error)=>{
                onError(startTime, endTime, elapsedTime, error);
                // GasV3 event to measure polling provisioning latency
                (0, $OOa63.trackGetProvisioningStatusLatencyEvent)({
                    createAnalyticsEvent: createAnalyticsEvent,
                    productKey: "confluence.ondemand",
                    fetchType: "polling",
                    elapsedTimeSeconds: Math.round(elapsedTime / 1000)
                });
                // SLO "bad event" for provisioning status polling
                (0, $jgJpJ.ufoEventConfirmationPageStatusPolling).failure({
                    error: error,
                    customData: {
                        reactComponent: "SignupProvisioningContextProvider",
                        analyticsEvent: "errored",
                        elapsedTimeMs: elapsedTime
                    }
                });
                (0, $jgJpJ.ufoEventRedirectToProduct).endSubstep(ufoSubstepKey, {
                    error: error,
                    customData: {
                        reqPath: ufoReqPath,
                        elapsedTimeMs: elapsedTime,
                        errorOrigin: "SignupProvisioningContextProvider onError"
                    }
                });
            },
            onSuccess: (startTime, endTime, elapsedTime)=>{
                onSuccess(startTime, endTime, elapsedTime);
                (0, $dkYGl.fireFrontendProvisioningCompletedEvent)("polling", productKey, edition, createAnalyticsEvent);
                // GasV3 event to measure polling provisioning latency
                (0, $OOa63.trackGetProvisioningStatusLatencyEvent)({
                    createAnalyticsEvent: createAnalyticsEvent,
                    productKey: "confluence.ondemand",
                    fetchType: "polling",
                    elapsedTimeSeconds: Math.round(elapsedTime / 1000)
                });
                // SLO "good event" for provisioning status polling
                (0, $jgJpJ.ufoEventConfirmationPageStatusPolling).success({
                    customData: {
                        reactComponent: "SignupProvisioningContextProvider",
                        analyticsEvent: "succeeded",
                        elapsedTimeMs: elapsedTime
                    }
                });
                (0, $jgJpJ.ufoEventRedirectToProduct).endSubstep(ufoSubstepKey, {
                    customData: {
                        reqPath: ufoReqPath,
                        elapsedTimeMs: elapsedTime
                    }
                });
            },
            onTimeout: (startTime, endTime, elapsedTime)=>{
                onTimeout(startTime, endTime, elapsedTime);
                // GasV3 event to measure polling provisioning latency
                (0, $OOa63.trackGetProvisioningStatusLatencyEvent)({
                    createAnalyticsEvent: createAnalyticsEvent,
                    productKey: "confluence.ondemand",
                    fetchType: "polling",
                    elapsedTimeSeconds: Math.round(elapsedTime / 1000)
                });
                // SLO "bad event" for provisioning status polling
                (0, $jgJpJ.ufoEventConfirmationPageStatusPolling).failure({
                    error: new Error("Polling timeout"),
                    customData: {
                        reactComponent: "SignupProvisioningContextProvider",
                        analyticsEvent: "timedOut",
                        elapsedTimeMs: elapsedTime
                    }
                });
                (0, $jgJpJ.ufoEventRedirectToProduct).endSubstep(ufoSubstepKey, {
                    error: new Error("Polling timeout"),
                    customData: {
                        reqPath: ufoReqPath,
                        elapsedTimeMs: elapsedTime,
                        errorOrigin: "SignupProvisioningContextProvider onTimeout"
                    }
                });
            },
            startTime: perceivedProvisioningStartTimeRef.current ?? Date.now()
        });
    }, [
        startPolling,
        products,
        platform,
        getProvisioningCloudStatus,
        createAnalyticsEvent,
        enrolledInGraphqlExperiment
    ]);
    const onSuccess = (0, $iSvIT.useCallback)((startTime, endTime, elapsedTime)=>{
        setStatus("success");
        createAnalyticsEvent({
            action: "cloudStatus",
            event: "succeeded",
            eventName: "createCloudSucceeded",
            startTime: startTime,
            endTime: endTime,
            elapsedTime: elapsedTime
        }).fire("signup");
    }, [
        createAnalyticsEvent
    ]);
    const onError = (0, $iSvIT.useCallback)((startTime, endTime, elapsedTime, error)=>{
        setStatus("error");
        createAnalyticsEvent({
            action: "cloudStatus",
            event: "errored",
            eventName: "createCloudErrored",
            startTime: startTime,
            endTime: endTime,
            elapsedTime: elapsedTime,
            error: error
        }).fire("signup");
    }, [
        createAnalyticsEvent
    ]);
    const onTimeout = (0, $iSvIT.useCallback)((startTime, endTime, elapsedTime)=>{
        setStatus("timeout");
        createAnalyticsEvent({
            action: "cloudStatus",
            event: "timedOut",
            eventName: "createCloudTimedOut",
            startTime: startTime,
            endTime: endTime,
            elapsedTime: elapsedTime
        }).fire("signup");
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($d5708baaa7987870$var$SignupProvisioningContext.Provider, {
        value: {
            startTime: startTime,
            status: status,
            parameters: searchParameters,
            createRedirectUrl: createRedirectUrl,
            ccpData: {
                cloudId: ccpProvisioningCloudId
            },
            perceivedProvisioningStartTime: perceivedProvisioningStartTime,
            setPerceivedProvisioningStartTime: setPerceivedProvisioningStartTime,
            onSuccess: onSuccess,
            onError: onError,
            onTimeout: onTimeout
        },
        children: children
    });
};

});
parcelRegister("7xMFD", function(module, exports) {
$parcel$export(module.exports, "createBaseUrl", function () { return (parcelRequire("5SFEW")).createBaseUrl; });
$parcel$export(module.exports, "useSearchParameters", function () { return (parcelRequire("eKfEs")).useSearchParameters; });
$parcel$export(module.exports, "pollCloudStatus", function () { return (parcelRequire("lvtpi")).pollCloudStatus; });
$parcel$export(module.exports, "measureTime", function () { return (parcelRequire("ejZ0o")).measureTime; });
parcelRequire("5SFEW");
parcelRequire("eKfEs");
parcelRequire("lvtpi");
parcelRequire("ejZ0o");

});
parcelRegister("5SFEW", function(module, exports) {

$parcel$export(module.exports, "createBaseUrl", function () { return $1bc05a4a7825942c$export$691721f731a513a9; });

var $jgJpJ = parcelRequire("jgJpJ");
const $1bc05a4a7825942c$export$691721f731a513a9 = (onDemandUrl, products, dataRegion, cloudId, _admin, createAnalyticsEvent)=>{
    if (!$1bc05a4a7825942c$var$isValidOnDemandUrl(onDemandUrl || "")) {
        createAnalyticsEvent({
            action: "validateOnDemandUrl",
            actionSubject: "invalidUrlOnRedirect",
            eventComponent: "confirmationPage",
            event: "event",
            eventType: "ui"
        }).fire("signup");
        window.history.back();
    }
    const instanceUrl = "https://" + encodeURIComponent(String(onDemandUrl)) + $1bc05a4a7825942c$var$getTopLevelDomain();
    const primaryProduct = $1bc05a4a7825942c$export$59840c81aaf7fd49(products);
    // admin hub is using the confirmation page for polling should redirect to site not back to admin hub
    // https://atlassian.slack.com/archives/C05R8TWUXR9/p1740946058149969
    // if (admin) {
    //     return getAdminhubRedirectUrl(cloudId);
    // }
    if (typeof primaryProduct !== "string") return instanceUrl;
    if (primaryProduct === "opsgenie") return $1bc05a4a7825942c$var$getOpsgenieRedirectUrl(onDemandUrl, dataRegion);
    if (primaryProduct === "statuspage") return $1bc05a4a7825942c$var$getStatuspageRedirectUrl(cloudId);
    if (primaryProduct === "com.atlassian.bitbucket") return $1bc05a4a7825942c$var$getBitbucketRedirectUrl();
    if (primaryProduct === "confluence.ondemand") return $1bc05a4a7825942c$var$getConfluenceJiraRedirectUrl(instanceUrl);
    return instanceUrl;
};
function $1bc05a4a7825942c$export$f0af8a1ebbe2ddd1(customerSubdomain, templateId) {
    const instanceUrl = `https://${encodeURIComponent(customerSubdomain ?? "")}${$1bc05a4a7825942c$var$getTopLevelDomain()}`;
    // navigate to welcome/software to load recommended template.
    const url = new URL("/welcome/software", instanceUrl);
    // This causes browser to retry for 30 seconds if site isn't ready
    url.searchParams.set("src", "signup");
    // this will prepopulate the create project screen with the given template.
    url.searchParams.set("templateId", templateId);
    return url.toString();
}
function $1bc05a4a7825942c$export$98936367fa889e3e(customerSubdomain, path) {
    const instanceUrl = `https://${encodeURIComponent(customerSubdomain ?? "")}${$1bc05a4a7825942c$var$getTopLevelDomain()}`;
    // navigate to welcome/software to load recommended template.
    const url = new URL(path, instanceUrl);
    return url.toString();
}
const $1bc05a4a7825942c$export$59840c81aaf7fd49 = (products)=>{
    if (products.length > 0 && products[0] !== "") return products[0];
    else return undefined;
};
const $1bc05a4a7825942c$var$getTopLevelDomain = ()=>{
    if ((0, $jgJpJ.isProduction)()) return ".atlassian.net";
    else return ".jira-dev.com";
};
const $1bc05a4a7825942c$var$isValidOnDemandUrl = (siteName)=>{
    const isUrl = siteName.includes(".");
    return !isUrl;
};
const $1bc05a4a7825942c$var$getConfluenceJiraRedirectUrl = function(instanceUrl) {
    return instanceUrl + "/wiki";
};
const $1bc05a4a7825942c$var$getBitbucketRedirectUrl = function() {
    if (!(0, $jgJpJ.isProduction)()) return "https://integration.bb-inf.net/dashboard/overview";
    return "https://bitbucket.org/dashboard/overview";
};
const $1bc05a4a7825942c$var$getOpsgenieRedirectUrl = function(onDemandUrl, dataRegion) {
    if (!(0, $jgJpJ.isProduction)()) return `https://${onDemandUrl}.atlassian-app.opsgeni.us`;
    if (dataRegion === "europe") return `https://${onDemandUrl}.atlassian-app.eu.opsgenie.com`;
    return `https://${onDemandUrl}.atlassian-app.opsgenie.com`;
};
const $1bc05a4a7825942c$var$getStatuspageRedirectUrl = function(cloudId) {
    if (!(0, $jgJpJ.isProduction)()) return "https://manage.statuspagestaging.com/cloud/" + cloudId;
    return "https://manage.statuspage.io/cloud/" + cloudId;
}; // const getAdminhubRedirectUrl = (cloudId: string) => {
 //     if (!isProduction()) {
 //         return "https://admin.stg.atlassian.com/s/" + cloudId + "/setup";
 //     }
 //
 //     return "https://admin.atlassian.com/s/" + cloudId + "/setup";
 // };

});

parcelRegister("eKfEs", function(module, exports) {

$parcel$export(module.exports, "useSearchParameters", function () { return $0c656c1662d1be03$export$a301eca0a780f275; });
// eslint-disable-next-line complexity
function $0c656c1662d1be03$export$a301eca0a780f275() {
    const searchParameters = new URLSearchParams(location.search);
    const cloudId = searchParameters.get("cloudId") ?? "";
    const requestId = searchParameters.get("requestId") ?? "";
    const products = searchParameters.get("products") ?? "";
    const referrer = searchParameters.get("referrer") ?? undefined;
    const isClaiming = searchParameters.get("claim") === "true";
    const dataRegion = searchParameters.get("dataRegion") ?? undefined;
    let onDemandUrl = searchParameters.get("ondemandurl") ?? undefined;
    onDemandUrl = onDemandUrl?.includes(".") ? "" : onDemandUrl;
    const admin = searchParameters.get("admin") === "true";
    const siteRenameRequestId = searchParameters.get("siteRenameRequestId") ?? undefined;
    const locale = searchParameters.get("locale") ?? "";
    const platformParam = searchParameters.get("platform");
    const platform = platformParam === "ccp" || platformParam === "hams" ? platformParam : "routing";
    const provisioningRequestId = searchParameters.get("provisioningRequestId") ?? undefined;
    const signupSource = searchParameters.get("signupSource") ?? undefined;
    const isFoundingAdmin = searchParameters.get("isFoundingAdmin") ?? undefined;
    const provisionApp = searchParameters.get("provisionApp") ?? undefined;
    const hideUserSegmentation = searchParameters.get("hideUserSegmentation") ?? undefined;
    const appKey = searchParameters.get("appKey") ?? undefined;
    const templateId = searchParameters.get("templateId") ?? undefined;
    const edition = searchParameters.get("edition") ?? undefined;
    const asp = searchParameters.get("asp") ?? "";
    const n2n = searchParameters.get("n2n") === "true";
    const userSegComplete = searchParameters.get("userSegComplete") === "true";
    const orchestrationId = searchParameters.get("orchestrationId") ?? undefined;
    return {
        cloudId: cloudId,
        requestId: requestId,
        products: products.split(","),
        referrer: referrer,
        isClaiming: isClaiming,
        onDemandUrl: onDemandUrl,
        dataRegion: dataRegion,
        siteRenameRequestId: siteRenameRequestId,
        admin: admin,
        locale: locale,
        platform: platform,
        provisioningRequestId: provisioningRequestId,
        signupSource: signupSource,
        isFoundingAdmin: isFoundingAdmin,
        provisionApp: provisionApp,
        hideUserSegmentation: hideUserSegmentation,
        appKey: appKey,
        templateId: templateId,
        edition: edition,
        asp: asp,
        n2n: n2n,
        userSegComplete: userSegComplete,
        orchestrationId: orchestrationId
    };
}

});

parcelRegister("lvtpi", function(module, exports) {

$parcel$export(module.exports, "pollCloudStatus", function () { return $bc1bc65b0a599a20$export$4c34e3153919c268; });

var $gTIJy = parcelRequire("gTIJy");
function $bc1bc65b0a599a20$export$4c34e3153919c268(options) {
    const { getCloudStatus: getCloudStatus, onError: onError, onSuccess: onSuccess, onTimeout: onTimeout, startTime: startTime } = options;
    const endTime = Date.now();
    const elapsedTime = endTime - startTime;
    if (elapsedTime < (0, $gTIJy.TIMEOUT)) getCloudStatus().then((ready)=>{
        if (ready) onSuccess(startTime, endTime, elapsedTime);
        else setTimeout(()=>$bc1bc65b0a599a20$export$4c34e3153919c268(options), 5000);
    }).catch((error)=>onError(startTime, endTime, elapsedTime, error));
    else onTimeout(startTime, endTime, elapsedTime);
}

});

parcelRegister("ejZ0o", function(module, exports) {

$parcel$export(module.exports, "measureTime", function () { return $85ad3b2b8170daba$export$61b7115cffb02fd8; });
function $85ad3b2b8170daba$export$61b7115cffb02fd8(fn, label, createAnalyticsEvent) {
    const start = performance.now();
    return fn().then((result)=>{
        const end = performance.now();
        const elapsedTime = (end - start) / 1000;
        createAnalyticsEvent({
            eventType: "track",
            action: "viewed",
            actionSubject: "measureTime",
            containerId: label,
            attributes: {
                start: start,
                end: end,
                elapsedTime: elapsedTime
            }
        }).fire();
        return result;
    });
}

});



parcelRegister("9FetZ", function(module, exports) {

$parcel$export(module.exports, "LoadingAnimation", function () { return $fd4bf270cfed06a7$export$cd092c96f205fe24; });
/* loading-animation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $2lKjb = parcelRequire("2lKjb");

var $9gh2a = parcelRequire("9gh2a");

var $5ohHq = parcelRequire("5ohHq");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");

var $aOuDE = parcelRequire("aOuDE");

var $9IYz9 = parcelRequire("9IYz9");
const $fd4bf270cfed06a7$var$backdropContainer = null;
const $fd4bf270cfed06a7$var$modalContainer = null;
const $fd4bf270cfed06a7$var$progressContainer = null;
const $fd4bf270cfed06a7$var$logoContainer = null;
const $fd4bf270cfed06a7$var$animationContainer = null;
const $fd4bf270cfed06a7$var$animationTextContainer = null;
const $fd4bf270cfed06a7$var$animationHeader = null;
const $fd4bf270cfed06a7$var$animationSubtext = null;
const $fd4bf270cfed06a7$var$systemFonts = null;
const $fd4bf270cfed06a7$var$loopBeginIndex = 1;
const $fd4bf270cfed06a7$var$loopEndIndex = 3;
const $fd4bf270cfed06a7$var$outroAnimationIndex = 4;




















const $fd4bf270cfed06a7$var$LoadingAnimationComponent = ({ isLoadingComplete: isLoadingComplete })=>{
    const isDesktop = !(0, $aOuDE.useIsMobile)(800);
    const signUpWithImageOverlayExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).cfind3467SignUpWithImageOverlay);
    const signUpWithImageOverlayExperimentTreatment = signUpWithImageOverlayExperiment.type === "enrolled" && signUpWithImageOverlayExperiment.value;
    const shouldUseSystemFonts = !(isDesktop && signUpWithImageOverlayExperimentTreatment);
    const { locale: locale } = (0, $f6qj2.default)();
    const [currentIndex, setCurrentIndex] = (0, $iSvIT.useState)(0);
    const [animationsMap, setAnimationsMap] = (0, $iSvIT.useState)({
        en: []
    });
    const getAnimationMap = (locale)=>{
        const keys = Object.keys(animationsMap);
        const validLocale = keys.includes(locale);
        if (validLocale) // @ts-ignore
        return animationsMap[locale];
        else return animationsMap["en"];
    };
    (0, $iSvIT.useEffect)(()=>{
        const runSetAnimationMap = async ()=>{
            const [intro, outro, EN02, EN03, EN04, DE02, DE03, DE04, FR02, FR03, FR04, ES02, ES03, ES04, JA02, JA03, JA04, PTBR02, PTBR03, PTBR04] = await Promise.all([
                (parcelRequire("4dOTY")),
                (parcelRequire("jc4t8")),
                (parcelRequire("e94DD")),
                (parcelRequire("2bomX")),
                (parcelRequire("eFgqD")),
                (parcelRequire("lkGcm")),
                (parcelRequire("ithtk")),
                (parcelRequire("hk0pP")),
                (parcelRequire("8beVu")),
                (parcelRequire("5UmOT")),
                (parcelRequire("bSsED")),
                (parcelRequire("hz66F")),
                (parcelRequire("1dYPO")),
                (parcelRequire("1BJkA")),
                (parcelRequire("hd4uT")),
                (parcelRequire("e3rQY")),
                (parcelRequire("SDiu0")),
                (parcelRequire("fusT4")),
                (parcelRequire("2j3tY")),
                (parcelRequire("kKgbh"))
            ]);
            const animationsMap = {
                en: [
                    intro,
                    EN02,
                    EN03,
                    EN04,
                    outro
                ],
                de: [
                    intro,
                    DE02,
                    DE03,
                    DE04,
                    outro
                ],
                fr: [
                    intro,
                    FR02,
                    FR03,
                    FR04,
                    outro
                ],
                es: [
                    intro,
                    ES02,
                    ES03,
                    ES04,
                    outro
                ],
                ja: [
                    intro,
                    JA02,
                    JA03,
                    JA04,
                    outro
                ],
                br: [
                    intro,
                    PTBR02,
                    PTBR03,
                    PTBR04,
                    outro
                ]
            };
            setAnimationsMap(animationsMap);
        };
        runSetAnimationMap();
    }, [
        animationsMap
    ]); // @ts-ignore
    const animations = getAnimationMap(locale);
    const eventListener = [
        {
            eventName: "complete",
            callback: ()=>{
                // When provisioning is complete, play outro animation.
                // When outro animation is complete, redirect to product.
                if (isLoadingComplete) {
                    setCurrentIndex($fd4bf270cfed06a7$var$outroAnimationIndex);
                    return;
                } else if (currentIndex < $fd4bf270cfed06a7$var$loopEndIndex) setCurrentIndex(currentIndex + 1);
                else if (currentIndex === $fd4bf270cfed06a7$var$loopEndIndex) setCurrentIndex($fd4bf270cfed06a7$var$loopBeginIndex);
            }
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _kqsw1n9t _1bah1h6o _4cvr1h6o _152tidpf _rjxpidpf _1e02idpf _u7coidpf"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_bfhkcd5j _16qs14iz _2rko1y44 _1reo15vq _18m915vq _1e0c1txw _1bah1e5h _4cvr1h6o _19pk1wug _2hwxzwfg _otyr1wug _18u0zwfg _ca0q1tcg _u5f31tcg _n3td1tcg _19bv1tcg _1tkekvcq _1bsb7y6i _p12f1osq _q5ug1wug _7tldftgi _14ad1wug _4uroftgi"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    "data-testid": "signup-provisioning-module",
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rthymf6 _17521h67 _srwz53f4"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2lKjb.ConfluenceLogo), {
                                appearance: "brand",
                                size: "large"
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _6rthp1rm _k8emdgin _p12fdgin _476dp1rm _1rkbajgb _x7x8ajgb"
                            ]),
                            children: animationsMap && /*#__PURE__*/ (0, $loA2J.jsx)((0, $9IYz9.LottieAnimation), {
                                options: {
                                    loop: false,
                                    autoplay: true,
                                    animationData: animations[currentIndex],
                                    rendererSettings: {
                                        preserveAspectRatio: "xMidYMid slice"
                                    }
                                },
                                eventListener: eventListener,
                                isAnimationBrandRefresh: true
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _4cvr1h6o _1pfh10yn _y3gn1h6o _suga1ule _476d1ul9"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
                                    size: "medium"
                                }),
                                currentIndex <= 1 && /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                    className: (0, $esG4f.default)([
                                        "_1pfhidpf _6rthidpf _ahbq1crf _k48pni7l _1wyb1pa9 _476d7vkz _1jw8bfng _1cqs1tcg",
                                        shouldUseSystemFonts && "_ect41qje"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "SignupProvisioning.inProgressText.confluence.preparingWorkspace",
                                        defaultMessage: "Preparing your workspace..."
                                    })
                                }),
                                currentIndex === 2 && /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                    className: (0, $esG4f.default)([
                                        "_1pfhidpf _6rthidpf _ahbq1crf _k48pni7l _1wyb1pa9 _476d7vkz _1jw8bfng _1cqs1tcg",
                                        shouldUseSystemFonts && "_ect41qje"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "SignupProvisioning.inProgressText.confluence.optimizingNewIdeas",
                                        defaultMessage: "Optimizing for new ideas..."
                                    })
                                }),
                                currentIndex === 3 && /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                    className: (0, $esG4f.default)([
                                        "_1pfhidpf _6rthidpf _ahbq1crf _k48pni7l _1wyb1pa9 _476d7vkz _1jw8bfng _1cqs1tcg",
                                        shouldUseSystemFonts && "_ect41qje"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "SignupProvisioning.inProgressText.confluence.limitlessColaboration",
                                        defaultMessage: "Loading limitless collaboration..."
                                    })
                                }),
                                currentIndex === 4 && /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                                    className: (0, $esG4f.default)([
                                        "_1pfhidpf _6rthidpf _ahbq1crf _k48pni7l _1wyb1pa9 _476d7vkz _1jw8bfng _1cqs1tcg",
                                        shouldUseSystemFonts && "_ect41qje"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        id: "SignupProvisioning.inProgressText.confluence.letsGo",
                                        defaultMessage: "Lets go!"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1pfhys9h _6rthidpf _ahbqi2wt _12l2i2wt _y3gn1h6o _1wyb7vkz _syaz1p0d _so7ddlk8",
                                shouldUseSystemFonts && "_ect41qje"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                id: "SignupProvisioning.inProgressText.confluence.keepWindowOpen",
                                defaultMessage: "Keep this window open while Confluence is loading."
                            })
                        })
                    ]
                })
            })
        })
    });
};
const $fd4bf270cfed06a7$export$cd092c96f205fe24 = (0, $1MbAx.withFeatureExposed)("cfind-1867-better-provisioning-user-experience", "Test", $fd4bf270cfed06a7$var$LoadingAnimationComponent);

});
parcelRegister("9IYz9", function(module, exports) {

$parcel$export(module.exports, "LottieAnimation", function () { return $fb50fae522eb2f53$export$fd187eefb1144831; });
/* lottie-animation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eVwxl = parcelRequire("eVwxl");
const $fb50fae522eb2f53$var$wireFrameStyle = null;
const $fb50fae522eb2f53$var$animationBrandRefreshExpStyle = null;
const $fb50fae522eb2f53$export$fd187eefb1144831 = ({ options: options, eventListener: eventListener, isAnimationBrandRefresh: isAnimationBrandRefresh = false })=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1reo15vq _18m915vq _1pbykb7n",
            isAnimationBrandRefresh && "_4t3idgin _1jop1c3h _kiyap1rm"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eVwxl))), {
            options: options,
            eventListeners: eventListener
        })
    });

});

parcelRegister("4dOTY", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("7H9zx").then(()=>parcelRequire("6GtqT"));

});
parcelRegister("bBxN9", function(module, exports) {
"use strict";

function $872d5cbd7458b7c1$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("hzK4Z")).resolve(id));
}
module.exports = $872d5cbd7458b7c1$var$load;

});
parcelRegister("hzK4Z", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf; }, function (v) { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ccb972f8f1c5733b$export$f7ad0328861e2f03; }, function (v) { return $ccb972f8f1c5733b$export$f7ad0328861e2f03 = v; });
var $ccb972f8f1c5733b$export$6503ec6e8aabbaf;
var $ccb972f8f1c5733b$export$f7ad0328861e2f03;
"use strict";
var $ccb972f8f1c5733b$var$mapping = new Map();
function $ccb972f8f1c5733b$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ccb972f8f1c5733b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ccb972f8f1c5733b$var$resolve(id) {
    var resolved = $ccb972f8f1c5733b$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ccb972f8f1c5733b$export$6503ec6e8aabbaf = $ccb972f8f1c5733b$var$register;
$ccb972f8f1c5733b$export$f7ad0328861e2f03 = $ccb972f8f1c5733b$var$resolve;

});



parcelRegister("jc4t8", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("1gxHN").then(()=>parcelRequire("fEiUp"));

});

parcelRegister("e94DD", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("fOXwx").then(()=>parcelRequire("h0zLA"));

});

parcelRegister("2bomX", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("jR1dY").then(()=>parcelRequire("599Xu"));

});

parcelRegister("eFgqD", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("fygxg").then(()=>parcelRequire("4GBVW"));

});

parcelRegister("lkGcm", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("f8QFu").then(()=>parcelRequire("7OxL5"));

});

parcelRegister("ithtk", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("f0hvp").then(()=>parcelRequire("4f2xu"));

});

parcelRegister("hk0pP", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("h8iSh").then(()=>parcelRequire("9pjpt"));

});

parcelRegister("8beVu", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("4Bo1q").then(()=>parcelRequire("k87ju"));

});

parcelRegister("5UmOT", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("jaGIj").then(()=>parcelRequire("gsgxm"));

});

parcelRegister("bSsED", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("d5uGg").then(()=>parcelRequire("lz6GZ"));

});

parcelRegister("hz66F", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("aZWwn").then(()=>parcelRequire("8CtDr"));

});

parcelRegister("1dYPO", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("aM7eQ").then(()=>parcelRequire("6gzZk"));

});

parcelRegister("1BJkA", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("jxXZL").then(()=>parcelRequire("eh61X"));

});

parcelRegister("hd4uT", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("jbpwU").then(()=>parcelRequire("hwDgz"));

});

parcelRegister("e3rQY", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("3BL8n").then(()=>parcelRequire("aSe8y"));

});

parcelRegister("SDiu0", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("gbGhY").then(()=>parcelRequire("1FjXe"));

});

parcelRegister("fusT4", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("iYtLx").then(()=>parcelRequire("28BDW"));

});

parcelRegister("2j3tY", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("knDtL").then(()=>parcelRequire("3x5qu"));

});

parcelRegister("kKgbh", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("4GGb6").then(()=>parcelRequire("dlapl"));

});



parcelRegister("c3QWr", function(module, exports) {

$parcel$export(module.exports, "DefaultCircleLayout", function () { return $4e88d2b6b3074f8b$export$d150707592369e7; });
/* default-circle.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $57Gq0 = parcelRequire("57Gq0");

var $kmxlM = parcelRequire("kmxlM");
const $4e88d2b6b3074f8b$export$7ac7d6a768c2e9b2 = null;
const $4e88d2b6b3074f8b$export$d150707592369e7 = ({ skipDefaultRedirect: skipDefaultRedirect, ...progressContainerProps })=>{
    const { status: status, createRedirectUrl: createRedirectUrl } = (0, $kmxlM.useSignupProvisioningContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    createAnalyticsEvent({
        eventName: "signupProvisioningModuleViewed",
        eventComponent: "confirmationPage",
        event: "viewed",
        eventType: "ui"
    }).fire("signup");
    (0, $iSvIT.useEffect)(()=>{
        if (skipDefaultRedirect) return;
        if (status === "success") {
            const redirectUrl = createRedirectUrl();
            createAnalyticsEvent({
                eventName: "redirectedToProduct",
                eventComponent: "confirmationPage",
                event: "redirected",
                eventType: "ui",
                action: "redirected"
            }).fire(); // SLO "good event" for redirect into product
            (0, $jgJpJ.ufoEventRedirectToProduct).success({
                customData: {
                    reactComponent: "DefaultCircleLayout",
                    analyticsEvent: "redirected",
                    redirectFrom: "confirmationPage",
                    provisioningStatus: status
                }
            });
            window.location.assign(redirectUrl);
            return;
        }
    }, [
        createRedirectUrl,
        status
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.UfoCustomTimingWrapper), {
        ufoEvent: (0, $jgJpJ.ufoEventRedirectToProduct),
        ufoCustomTimingKey: (0, $jgJpJ.UfoCustomTimingKey).CONFLUENCE_DEFAULT_CIRCLE_DWELL_TIME,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1tke1kxc _1e0c1txw _4cvr1h6o _1bah1h6o"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $57Gq0.ProgressCircleContainer), {
                ...progressContainerProps
            })
        })
    });
};

});
parcelRegister("57Gq0", function(module, exports) {

$parcel$export(module.exports, "ProgressCircleContainer", function () { return $9298496e0b3e021a$export$dc4d0f80eeb41754; });
/* progress-circle-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $jgJpJ = parcelRequire("jgJpJ");

var $1Q9Ky = parcelRequire("1Q9Ky");

var $kmxlM = parcelRequire("kmxlM");

var $csa3B = parcelRequire("csa3B");
const $9298496e0b3e021a$var$ProgressWrapper = null;
const $9298496e0b3e021a$var$ProgressContainerStyle = null;
const $9298496e0b3e021a$export$dc4d0f80eeb41754 = ({ timeoutText: timeoutText, inProgressText: inProgressText, errorPollingText: errorPollingText })=>{
    const { startTime: startTime, status: status } = (0, $kmxlM.useSignupProvisioningContext)();
    const timeoutTextToUse = timeoutText ?? (0, $1Q9Ky.provisioningMessagesI18n)["SignupProvisioning.timeoutText.default"];
    const inProgressTextToUse = inProgressText ?? (0, $1Q9Ky.provisioningMessagesI18n)["SignupProvisioning.inProgressText.default"];
    const errorPollingTextToUse = errorPollingText ?? (0, $1Q9Ky.provisioningMessagesI18n)["SignupProvisioning.errorPollingText.default"]; /**
                                                                                                                              * UFOs for Signup's FE Observability & "Product Landing" SLOs
                                                                                                                              *   - https://go/signup-ufo
                                                                                                                              *   - https://go/signup-slo
                                                                                                                              **/ 
    (0, $iSvIT.useEffect)(()=>{
        if (status === "error") // SLO "bad event" for redirect into product
        (0, $jgJpJ.ufoEventRedirectToProduct).failure({
            customData: {
                reactComponent: "ProgressCircleContainer",
                analyticsEvent: "errored",
                provisioningStatus: status
            }
        });
        else if (status === "timeout") // SLO "bad event" for redirect into product
        (0, $jgJpJ.ufoEventRedirectToProduct).failure({
            customData: {
                reactComponent: "ProgressCircleContainer",
                analyticsEvent: "timedOut",
                provisioningStatus: status
            }
        });
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "signup-provisioning-module",
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _1bsb1osq _1bah1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1wybdlk8 _p12f1vno _y3gn1h6o _1bsb1osq"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $csa3B.ProgressCircle), {
                startTime: startTime,
                message: status === "error" ? errorPollingTextToUse : status === "timeout" ? timeoutTextToUse : inProgressTextToUse
            })
        })
    });
};

});
parcelRegister("1Q9Ky", function(module, exports) {

$parcel$export(module.exports, "provisioningMessagesI18n", function () { return $9f0b243f863e0818$export$66f9f502c337bb9a; });

var $6x1qA = parcelRequire("6x1qA");
const $9f0b243f863e0818$export$66f9f502c337bb9a = (0, $6x1qA.defineMessages)({
    "SignupProvisioning.timeoutText.default": {
        id: "SignupProvisioning.timeoutText.default",
        defaultMessage: "<h1>This is taking longer than expected.</h1><p>You should receive an email that your product is ready soon. Once this happens, you can access your product at <href-start>start.atlassian.com</href-start>. If you continue having trouble, <href-support>contact support</href-support>.</p>"
    },
    "SignupProvisioning.inProgressText.default": {
        id: "SignupProvisioning.inProgressText.default",
        defaultMessage: "<p>Personalizing your workspace...</p>"
    },
    "SignupProvisioning.errorPollingText.default": {
        id: "SignupProvisioning.errorPollingText.default",
        defaultMessage: "<h1>Something went wrong on our end.</h1><p>Please try <href-reload>refreshing this page</href-reload>. If this continues happening, <href-support>contact support</href-support>.</p>"
    },
    "SignupProvisioning.inProgressText.confluence": {
        id: "SignupProvisioning.inProgressText.confluence",
        defaultMessage: "<p>Creating your Confluence site...</p>"
    },
    "SignupProvisioning.inProgressText.confluence2": {
        id: "SignupProvisioning.inProgressText.confluence2",
        defaultMessage: "<p>Setting up your team to work better, together...</p>"
    },
    "SignupProvisioning.inProgressText.confluence3": {
        id: "SignupProvisioning.inProgressText.confluence3",
        defaultMessage: "<p>Personalizing your Confluence space...</p>"
    },
    "SignupProvisioning.inProgressText.confluence4": {
        id: "SignupProvisioning.inProgressText.confluence4",
        defaultMessage: "<p>Adding some finishing touches...</p>"
    },
    "SignupProvisioning.inProgressText.confluence5": {
        id: "SignupProvisioning.inProgressText.confluence5",
        defaultMessage: "<p>Preparing your template...</p>"
    },
    "SignupProvisioning.inProgressText.confluence6": {
        id: "SignupProvisioning.inProgressText.confluence6",
        defaultMessage: "<p>Get ready to create your first page!</p>"
    }
});

});

parcelRegister("csa3B", function(module, exports) {

$parcel$export(module.exports, "ProgressCircle", function () { return $b55bed3cba6a2baf$export$c79b9d6b4cc92af7; });
/* progress-circle.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $htmh8 = parcelRequire("htmh8");

var $jgJpJ = parcelRequire("jgJpJ");

var $lcONz = parcelRequire("lcONz");

var $kE3lm = parcelRequire("kE3lm");
parcelRequire("eYMbf");
var $kY61F = parcelRequire("kY61F");
const $b55bed3cba6a2baf$var$B200 = "#2684ff";
const $b55bed3cba6a2baf$var$N0 = "#ffffff";
const $b55bed3cba6a2baf$var$N30 = "#ebecf0";
const $b55bed3cba6a2baf$var$R300 = "#ff5630";
const $b55bed3cba6a2baf$var$Y300 = "#ffab00";
const $b55bed3cba6a2baf$var$size = 175;
const $b55bed3cba6a2baf$var$barWidth = 8;
const $b55bed3cba6a2baf$export$5abc0d4218e5cc2d = 500;
const $b55bed3cba6a2baf$var$circleWrapCss = null;
const $b55bed3cba6a2baf$var$containerStyleCss = null;
const $b55bed3cba6a2baf$export$c79b9d6b4cc92af7 = ({ startTime: startTime, status: status, message: message })=>{
    // progress is a number 0 to 1
    const [progress, setProgress] = (0, $iSvIT.useState)(status ? 1 : (0, $kY61F.getProgressAmount)(startTime));
    const interval = (0, $iSvIT.useRef)(null);
    const rotation = {
        transform: `rotate(${progress * 180}deg)`
    }; // start timer
    (0, $iSvIT.useEffect)(()=>{
        if (status) return;
        interval.current = setInterval(()=>{
            const progressAmount = (0, $kY61F.getProgressAmount)(startTime);
            setProgress(progressAmount);
            if (interval.current && progressAmount === 1) clearInterval(interval.current);
        }, 100);
        return ()=>{
            if (interval.current) clearInterval(interval.current);
        };
    }, []); // don't show error icon before the bar reaches 100%
    const [delayedStatus, setDelayedStatus] = (0, $iSvIT.useState)(status);
    (0, $iSvIT.useEffect)(()=>{
        let timeout;
        if (status && !delayedStatus) {
            if (interval.current) clearInterval(interval.current);
            setProgress(1);
            timeout = setTimeout(()=>{
                setDelayedStatus(status);
            }, $b55bed3cba6a2baf$export$5abc0d4218e5cc2d);
        } else setDelayedStatus(status);
        return ()=>clearTimeout(timeout);
    }, [
        status
    ]); /**
                 * UFOs for Signup's FE Observability & "Product Landing" SLOs
                 *   - https://go/signup-ufo
                 *   - https://go/signup-slo
                 **/ 
    (0, $iSvIT.useEffect)(()=>{
        if (delayedStatus === "error") // SLO "bad event" for redirect into product
        (0, $jgJpJ.ufoEventRedirectToProduct).failure({
            customData: {
                reactComponent: "ProgressCircle",
                analyticsEvent: "errored",
                provisioningStatus: delayedStatus
            }
        });
        else if (delayedStatus === "timeout") // SLO "bad event" for redirect into product
        (0, $jgJpJ.ufoEventRedirectToProduct).failure({
            customData: {
                reactComponent: "ProgressCircle",
                analyticsEvent: "timedOut",
                provisioningStatus: delayedStatus
            }
        });
    }, [
        delayedStatus
    ]);
    const ariaProperties = status ? {} : {
        "aria-valuemax": 100,
        "aria-valuemin": 0,
        "aria-valuenow": progress * 100
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ...ariaProperties,
        "aria-busy": progress !== 1,
        "aria-labelledby": "progress-label",
        "data-testid": "progress-circle",
        role: "progressbar",
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _1bah1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_bfhk4m1f _2rko1ssb _4t3ijidk _1bsbjidk _eomq1ssb _1k4t1ssb _1dl8jidk _1u8ujidk _1ahrstnw _1q38stnw _cevojidk _1tw5jidk _l4s91uog _1ig11s51 _1uv5du3w _gwaykizl _42wb18rw _3ejbu67f _1cy61ssb _t2mrdu3w _gjrw1ns2 _19paftgi _5by8ftgi _kvx6ftgi _19reftgi _apvgstnw _1v9c1ns2 _12yh13la _1blm1h6o _1gsa1h6o _1hni1osq _15b11osq _4pc91ms5 _jbnh1ms5 _1rnlt7kz _6akwt7kz"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: delayedStatus ? `circle ${delayedStatus}` : "circle",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "mask full",
                            style: rotation,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: "fill",
                                style: rotation
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "mask half",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: "fill",
                                style: rotation
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "inside-circle",
                            children: delayedStatus === "error" || delayedStatus === "timeout" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $lcONz.ErrorIcon), {}) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $htmh8.AtlassianIcon), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kE3lm.Message), {
                message: message
            })
        ]
    });
};

});
parcelRegister("lcONz", function(module, exports) {

$parcel$export(module.exports, "ErrorIcon", function () { return $2e6ab81ad9aa7def$export$19bc16ee58e19b3d; });

var $loA2J = parcelRequire("loA2J");
const $2e6ab81ad9aa7def$export$19bc16ee58e19b3d = ()=>{
    // vertically center (visually) by adding bottom padding (image is bottom-heavy)
    const style = {
        paddingBottom: "10%"
    };
    const N300 = "#5e6c84";
    const N600 = "#344563";
    const N700 = "#253858";
    const Y200 = "#ffc400";
    const Y300 = "#ffe380";
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
            viewBox: "0 0 72 96",
            fill: "none",
            style: style,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M41.7979 35.3176L71.0741 85.9598C71.6755 86.973 71.9966 88.1276 72.0047 89.3055C72.0127 90.4834 71.7074 91.6422 71.1198 92.6635C70.5323 93.6848 69.6837 94.532 68.6608 95.1182C67.6379 95.7045 66.4775 96.0089 65.2982 96.0002H6.70175C5.52245 96.0089 4.36201 95.7045 3.33913 95.1182C2.31625 94.532 1.46765 93.6848 0.880119 92.6635C0.292593 91.6422 -0.0127679 90.4834 -0.00472806 89.3055C0.00331176 88.1276 0.324464 86.973 0.925877 85.9598L30.2021 35.3176C30.7819 34.2915 31.6243 33.4378 32.6431 32.8437C33.6618 32.2496 34.8203 31.9365 36 31.9365C37.1797 31.9365 38.3382 32.2496 39.3569 32.8437C40.3756 33.4378 41.218 34.2915 41.7979 35.3176Z",
                    fill: "url(#paint0_linear_2403_131334)"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M38.4474 72.088L39.726 52.5798C39.7558 52.0274 39.6732 51.4747 39.4833 50.9551C39.2934 50.4355 39.0001 49.9597 38.621 49.5564C38.2419 49.1531 37.785 48.8307 37.2777 48.6086C36.7705 48.3865 36.2235 48.2693 35.6696 48.2642C35.1157 48.2625 34.5675 48.3755 34.0594 48.5959C33.5514 48.8162 33.0945 49.1393 32.7176 49.5447C32.3407 49.9501 32.0519 50.4291 31.8695 50.9514C31.687 51.4738 31.6148 52.0282 31.6574 52.5798L32.8919 72.088C32.9469 72.7892 33.2623 73.4444 33.7763 73.9252C34.2902 74.4059 34.9656 74.6774 35.6696 74.6862C36.3768 74.6876 37.0578 74.4196 37.574 73.9369C38.0901 73.4541 38.4025 72.7929 38.4474 72.088Z",
                    fill: N700
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M31.4809 82.4368C31.4721 83.0248 31.5875 83.6082 31.8196 84.1487C32.0517 84.6892 32.3953 85.1748 32.828 85.5737C33.2607 85.9726 33.7728 86.276 34.3308 86.4639C34.8888 86.6518 35.4802 86.7201 36.0664 86.6643C36.8983 86.6042 37.6945 86.3023 38.3569 85.796C39.0193 85.2897 39.5189 84.601 39.7944 83.8146C40.0699 83.0283 40.1091 82.1786 39.9073 81.3703C39.7055 80.5619 39.2714 79.8302 38.6585 79.2651C38.0456 78.7001 37.2806 78.3263 36.4577 78.1899C35.6349 78.0536 34.79 78.1605 34.0272 78.4976C33.2644 78.8346 32.617 79.3871 32.1646 80.087C31.7121 80.7869 31.4745 81.6037 31.4809 82.4368Z",
                    fill: N700
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M40.4314 11.9781L37.1687 0.176224C37.1628 0.106148 37.1294 0.0412626 37.0756 -0.00415906C37.0219 -0.0495807 36.9523 -0.0718176 36.8821 -0.065978C36.8119 -0.0601384 36.747 -0.0267005 36.7015 0.0269796C36.656 0.0806597 36.6338 0.150185 36.6396 0.22026L34.5673 11.2735L32.0101 10.7891C31.9631 10.7778 31.914 10.7795 31.868 10.7941C31.822 10.8088 31.7808 10.8357 31.749 10.872C31.7173 10.9082 31.696 10.9525 31.6876 11C31.6792 11.0475 31.684 11.0964 31.7014 11.1414L35.0082 22.8992C35.0288 22.9463 35.0627 22.9864 35.1058 23.0146C35.1489 23.0428 35.1993 23.0578 35.2507 23.0578C35.3022 23.0578 35.3526 23.0428 35.3957 23.0146C35.4388 22.9864 35.4727 22.9463 35.4932 22.8992L37.5655 11.8459L40.1228 12.2863C40.165 12.2942 40.2086 12.2917 40.2496 12.279C40.2907 12.2663 40.328 12.2438 40.3584 12.2134C40.3888 12.1831 40.4113 12.1458 40.4241 12.1048C40.4368 12.0637 40.4393 12.0203 40.4314 11.9781Z",
                    fill: Y200
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M28.7029 18.4075L23.897 14.6644C23.8089 14.5763 23.6766 14.6644 23.7207 14.7965L26.1897 19.8167L24.9993 20.3891C24.9111 20.4332 24.9111 20.5212 24.9993 20.6093L29.7611 24.3524C29.8493 24.4405 30.0256 24.3084 29.9375 24.2203L27.5125 19.1561L28.7029 18.6277C28.747 18.5836 28.7911 18.4515 28.7029 18.4075Z",
                    fill: Y300
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M44.5755 24.969H44.311C44.2384 24.9043 44.187 24.8193 44.1635 24.7251C44.1399 24.6308 44.1452 24.5317 44.1787 24.4405C44.0905 24.0882 43.1646 23.1635 42.6356 22.635C41.3128 21.2699 40.431 20.4332 40.916 19.7726C41.401 19.1121 42.5033 19.6405 44.1787 20.5213C44.8074 20.8528 45.4552 21.1469 46.1187 21.402C45.6953 20.8203 45.2072 20.2885 44.6637 19.8167C43.3851 18.4956 42.5033 17.6148 42.9883 16.9543C43.4733 16.2937 44.5755 16.8662 46.251 17.7029C46.8797 18.0344 47.5275 18.3285 48.191 18.5836C47.7561 18.0114 47.269 17.4807 46.736 16.9983C45.4574 15.6772 44.5755 14.7965 45.0605 14.1359C45.5455 13.4754 46.6478 14.0479 48.2792 14.8846C48.9846 15.2368 50.131 15.8093 50.4837 15.8093C50.5564 15.7443 50.6506 15.7084 50.7482 15.7084C50.8458 15.7084 50.94 15.7443 51.0128 15.8093C51.0626 15.8406 51.1056 15.8816 51.1393 15.9297C51.173 15.9779 51.1967 16.0323 51.209 16.0897C51.2213 16.1472 51.222 16.2065 51.2111 16.2642C51.2001 16.322 51.1776 16.3769 51.145 16.4258C50.6601 17.0864 49.5578 16.5139 47.8823 15.6772C47.2627 15.3275 46.6136 15.0328 45.9424 14.7965C46.3849 15.349 46.8558 15.8781 47.3533 16.3818C48.676 17.7029 49.5578 18.5836 49.0728 19.2442C48.5878 19.9047 47.4855 19.3323 45.8101 18.4956C45.1815 18.1508 44.5338 17.8421 43.8701 17.5708C44.3034 18.1578 44.7905 18.7033 45.3251 19.2002C46.6037 20.5213 47.4855 21.402 47.0005 22.0185C46.5155 22.635 45.4133 22.1506 43.7819 21.2699C43.1385 20.9376 42.476 20.6435 41.7978 20.3891C42.1065 20.8295 42.8119 21.5341 43.2528 22.0185C44.5755 23.3396 45.4133 24.2203 44.9283 24.8368C44.885 24.8863 44.8302 24.9243 44.7686 24.9474C44.707 24.9704 44.6407 24.9779 44.5755 24.969Z",
                    fill: N600
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M47.0444 31.31C46.9653 31.3084 46.8878 31.2875 46.8186 31.2491C46.7494 31.2107 46.6907 31.156 46.6476 31.0898C46.2067 30.2531 45.6776 29.2843 46.2508 28.7558C46.8239 28.2274 47.7057 28.8439 48.6757 29.5045C49.0793 29.7907 49.5072 30.0412 49.9544 30.2531C49.8066 29.774 49.5992 29.3154 49.3371 28.8879C48.7639 27.8751 48.2348 26.9503 48.808 26.4219C49.3812 25.8934 50.3071 26.51 51.233 27.1265C51.6455 27.4587 52.1064 27.726 52.5998 27.9191C52.6416 27.8728 52.6929 27.8359 52.75 27.8108C52.8072 27.7858 52.8691 27.7731 52.9316 27.7737C52.994 27.7744 53.0556 27.7882 53.1123 27.8144C53.169 27.8406 53.2195 27.8785 53.2604 27.9257C53.3013 27.9728 53.3317 28.0281 53.3496 28.0879C53.3675 28.1476 53.3725 28.2105 53.3642 28.2724C53.356 28.3342 53.3346 28.3936 53.3017 28.4465C53.2687 28.4995 53.2248 28.5449 53.173 28.5797C52.5998 29.1081 51.6739 28.4916 50.748 27.8751C50.3444 27.5889 49.9166 27.3384 49.4694 27.1265C49.6184 27.5911 49.8258 28.0351 50.0866 28.4476C50.6598 29.4604 51.1889 30.4292 50.6157 30.9577C50.0425 31.4861 49.1166 30.8696 48.1907 30.209C47.7785 29.9121 47.335 29.661 46.868 29.4604C47.0235 29.8729 47.2153 30.2708 47.4412 30.6494C47.4895 30.7495 47.4982 30.864 47.4655 30.9702C47.4328 31.0764 47.3611 31.1663 47.2648 31.2219L47.0444 31.31Z",
                    fill: N300
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M23.1034 30.033L22.7947 29.9449C22.0893 29.6366 22.2657 28.5797 22.442 27.4788C22.5446 26.9866 22.589 26.4841 22.5743 25.9816C22.2225 26.3382 21.8982 26.721 21.6043 27.1265C20.9429 28.0513 20.3257 28.932 19.5761 28.6238C19.4721 28.5757 19.3909 28.4891 19.3497 28.3822C19.3085 28.2753 19.3107 28.1566 19.3557 28.0513C19.3704 27.9975 19.3962 27.9474 19.4316 27.9043C19.467 27.8612 19.5111 27.826 19.5611 27.801C19.611 27.7761 19.6656 27.762 19.7214 27.7596C19.7772 27.7572 19.8329 27.7665 19.8848 27.7871C20.1052 27.699 20.5902 26.9944 20.8988 26.5981C21.2075 26.2018 22.2216 24.7926 22.927 25.1008C23.6325 25.4091 23.5002 26.466 23.3238 27.6109C23.2073 28.1015 23.1481 28.604 23.1475 29.1082C23.5136 28.7648 23.839 28.3807 24.1175 27.9632C24.7788 27.0385 25.4402 26.1577 26.1456 26.466C26.8511 26.7742 26.7188 27.8311 26.5424 28.7559C26.5507 28.8235 26.5431 28.8921 26.5202 28.9563C26.4974 29.0205 26.46 29.0786 26.4109 29.1259C26.3618 29.1732 26.3024 29.2085 26.2373 29.2289C26.1723 29.2494 26.1034 29.2546 26.036 29.2439C25.9686 29.2333 25.9046 29.2072 25.8491 29.1677C25.7935 29.1282 25.7479 29.0764 25.7157 29.0162C25.6836 28.9561 25.6659 28.8894 25.664 28.8213C25.6621 28.7532 25.676 28.6856 25.7047 28.6238C25.756 28.1999 25.7854 27.7736 25.7929 27.3467C25.4163 27.6799 25.0896 28.0655 24.8229 28.4917C24.2497 29.2843 23.6766 30.033 23.1034 30.033Z",
                    fill: N300
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "paint0_linear_2403_131334",
                        x1: "59.0197",
                        y1: "60.0795",
                        x2: "-1.20379",
                        y2: "88.1961",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                stopColor: "#FFD740"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "1",
                                stopColor: Y300
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});

parcelRegister("kE3lm", function(module, exports) {

$parcel$export(module.exports, "Message", function () { return $e99aa3114b092f01$export$f69c19e57285b83a; });
/* message.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
const $e99aa3114b092f01$var$B300 = "#0065ff";
const $e99aa3114b092f01$export$f69c19e57285b83a = ({ message: message })=>{
    const progressLabelCss = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_ect41qje _19pk1kwk _y3gn1h6o _1vfh1kw7 _11eb1kw7 _ggmh1kw7 _8kc91kw7 _wm401kw7 _1twlni7l _l5k1ni7l _r8ntni7l _1a7kni7l _5gkfni7l _cadt1kw7 _8v2f1kw7 _1yzi1kw7 _16011kw7 _qen61kw7 _1xd215x9 _17z415x9 _1axi15x9 _1euy15x9 _c9nz15x9 _rzby1j6v _1n461j6v _1x1t1j6v _1b4d1j6v _1gtf1j6v _8k2zidpf _if5yidpf _s9kqidpf _vo4eidpf _qxmeidpf _nd4u1j6v _1gnp1j6v _4wzt1j6v _wotz1j6v _f5hn1j6v _9u9nidpf _7e5bidpf _98csidpf _1ugbidpf _1cwuidpf _zcqx15x9 _clfd1j6v _11pqidpf _q0a51j6v _c3k8idpf _43dsoelr _59381r31 _yha2glyw _1nmznqa1 _9m7f1r31 _rfqo1r31 _w7sw8stv _1bgk8stv _15a9nqa1 _1t0pnqa1"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            ...message,
            values: {
                "href-support": (node)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                        href: "https://support.atlassian.com/contact/",
                        children: node
                    }),
                "href-start": (node)=>/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                        href: "https://start.atlassian.com",
                        children: node
                    }),
                "href-reload": (node)=>// eslint-disable-next-line jsx-a11y/anchor-is-valid
                    /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                        href: "javascript:window.location.reload(true)",
                        children: node
                    }),
                "p": (node)=>/*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        children: node
                    }),
                "h1": (node)=>/*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                        children: node
                    }),
                "h2": (node)=>/*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        children: node
                    }),
                "h3": (node)=>/*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        children: node
                    })
            }
        })
    });
};

});

parcelRegister("eYMbf", function(module, exports) {
$parcel$export(module.exports, "getProgressAmount", function () { return (parcelRequire("kY61F")).getProgressAmount; });
parcelRequire("kY61F");

});
parcelRegister("kY61F", function(module, exports) {

$parcel$export(module.exports, "getProgressAmount", function () { return $9fc2c5480920e6bd$export$38a9484962d47f0; });

var $gTIJy = parcelRequire("gTIJy");
function $9fc2c5480920e6bd$export$38a9484962d47f0(startTime) {
    const currentTime = Date.now();
    const elapsedTime = currentTime - startTime;
    const pivotPercentage = 0.8; // The progress bar will fill up to 80% by the pivot time
    const progressBarPivotPoint = 60000; // 1 minute is the pivot point after which the progress bar will slow down
    if (elapsedTime >= (0, $gTIJy.TIMEOUT)) return 1;
    if (elapsedTime <= progressBarPivotPoint) // before pivot point, go fast
    return $9fc2c5480920e6bd$var$rounded(pivotPercentage / progressBarPivotPoint * elapsedTime);
    // after pivot point, go slow
    return $9fc2c5480920e6bd$var$rounded(pivotPercentage + (1 - pivotPercentage) * (elapsedTime - progressBarPivotPoint) / ((0, $gTIJy.TIMEOUT) - progressBarPivotPoint));
}
function $9fc2c5480920e6bd$var$rounded(decimal) {
    return Math.round(decimal * 1000) / 1000;
}

});





parcelRegister("7sANf", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("avTVb").then(()=>parcelRequire("l237a"));

});



parcelRegister("dmKCp", function(module, exports) {

$parcel$export(module.exports, "updateUserProfile", function () { return $35ef6f63d2061f7f$export$c92c4ec7a2418617; });

var $jgJpJ = parcelRequire("jgJpJ");
const $35ef6f63d2061f7f$export$c92c4ec7a2418617 = async ({ selectedTeamType: selectedTeamType, stargateClient: stargateClient, source: source })=>{
    (0, $jgJpJ.ufoEventConfirmationPageUpdateUserProfile).start();
    (0, $jgJpJ.ufoEventConfirmationPageUpdateUserProfile).setCustomData({
        teamType: selectedTeamType,
        ...source ? {
            source: source
        } : {}
    });
    const { accountId: aaid } = await stargateClient.me({}).then((res)=>{
        console.log(`Send analytics event: 'success me'`);
        return res;
    }).catch((e)=>{
        (0, $jgJpJ.ufoEventConfirmationPageUpdateUserProfile).failure({
            error: e
        });
        console.error(`Send analytics event: 'error me'`);
        console.error(e.response);
        return {
            accountId: ""
        };
    });
    if (aaid === undefined || aaid === "") {
        (0, $jgJpJ.ufoEventConfirmationPageUpdateUserProfile).failure({
            error: new Error("AAID not found")
        });
        console.warn("Could not resolve aaid");
        return;
    }
    const extendedProfile = {
        team_type: selectedTeamType
    };
    await stargateClient.updateIdentityProfile({
        aaid: aaid,
        extendedProfile: extendedProfile
    }).then(()=>{
        (0, $jgJpJ.ufoEventConfirmationPageUpdateUserProfile).success();
        console.log(`Send analytics event: 'success updateIdentityProfile'`);
    }).catch((e)=>{
        (0, $jgJpJ.ufoEventConfirmationPageUpdateUserProfile).failure({
            error: e
        });
        console.error(`Send analytics event error 'error updateIdentityProfile'`);
        console.error(e.response);
    });
    return;
};

});

parcelRegister("cyj4X", function(module, exports) {

$parcel$export(module.exports, "BundleViewSwitch", function () { return $962b068cc3c22516$export$64be623ab0a846ac; });

var $loA2J = parcelRequire("loA2J");

var $aO3Hl = parcelRequire("aO3Hl");

var $gd3el = parcelRequire("gd3el");

var $gG3lv = parcelRequire("gG3lv");

var $j5z4Z = parcelRequire("j5z4Z");

var $5jx2H = parcelRequire("5jx2H");

var $7pLpT = parcelRequire("7pLpT");
const $962b068cc3c22516$export$64be623ab0a846ac = ()=>{
    let confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gG3lv.default), {});
    const { createCloudStatus: createCloudStatus, startPerceivedProvisioningTimer: startPerceivedProvisioningTimer } = (0, $aO3Hl.useCloudStatus)();
    const { deferRedirectView: deferRedirectView } = (0, $aO3Hl.useCloudStatusRedirection)();
    const confirmationPageType = (0, $aO3Hl.useConfirmationPageType)(createCloudStatus, deferRedirectView);
    switch(confirmationPageType){
        case "tips":
            confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)((0, $5jx2H.default), {});
            break;
        case "timeout":
            confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)((0, $j5z4Z.default), {});
            break;
        case "error":
            confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gd3el.default), {});
            break;
        case "redirect":
            startPerceivedProvisioningTimer();
            confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                id: "redirectToProductContainer"
            });
            break;
        default:
            startPerceivedProvisioningTimer();
            confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gG3lv.default), {});
    }
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7pLpT.LegacyConfirmationPageLayout), {
        children: confirmationPageView
    });
};

});
parcelRegister("gd3el", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05166e313fbedae6$export$2e2bcd8739ae039; });
/* error-view.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $1UUq1 = parcelRequire("1UUq1");

var $dWbel = parcelRequire("dWbel");

var $2CpWf = parcelRequire("2CpWf");
const $05166e313fbedae6$var$MessageContainer = null;
const $05166e313fbedae6$var$ParagraphStyles = null;
const $05166e313fbedae6$var$ErrorView = ()=>{
    const signUpUrl = "https://www.atlassian.com/try/cloud/signup";
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    (0, $iSvIT.useEffect)(()=>{
        // Confirming analyticsClient is initialized before firing event
        analyticsClient && createAnalyticsEvent({
            eventName: "errorPageViewed",
            eventComponent: "errorPage",
            event: "viewed"
        }).fire("signup");
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    // SLO "bad event" for redirect into product
    (0, $iSvIT.useEffect)(()=>{
        (0, $jgJpJ.ufoEventRedirectToProduct).failure({
            customData: {
                reactComponent: "ErrorView",
                analyticsEvent: "errored",
                redirectFrom: "confirmationPage"
            }
        });
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $2CpWf.default), {
        showHeader: false,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                width: "164",
                height: "218",
                fill: "none",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                        id: "error-icon-gradient",
                        x1: "133.86",
                        x2: "-2.79",
                        y1: "136.43",
                        y2: "200.15",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "0",
                                stopColor: "#ffd740"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                                offset: "1",
                                stopColor: "#ffab00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "url(#error-icon-gradient)",
                        d: "m94.8 80.2 66.4 115a15.1 15.1 0 0 1-13.1 22.8H15.2a15.1 15.1 0 0 1-13.1-22.8l66.4-115a15.099 15.099 0 0 1 26.3 0z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#253858",
                        d: "m87.2 163.7 2.9-44.3a9.3 9.3 0 0 0-9.2-9.8 9.086 9.086 0 0 0-6.695 2.908A9.094 9.094 0 0 0 71.8 119.4l2.8 44.3a6.402 6.402 0 0 0 6.3 5.9 6.303 6.303 0 0 0 6.3-5.9zM71.4 187.2a9.496 9.496 0 0 0 6.464 9.145 9.49 9.49 0 0 0 3.936.455 9.702 9.702 0 0 0 8.712-12.022A9.7 9.7 0 0 0 71.4 187.2z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#ffc400",
                        d: "M91.699 27.2 84.299.4a.602.602 0 0 0-1.2.1l-4.7 25.1-5.8-1.1a.601.601 0 0 0-.7.8l7.5 26.7a.6.6 0 0 0 1.1 0l4.7-25.1 5.8 1a.6.6 0 0 0 .7-.7z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#ffab00",
                        d: "m65.1 41.8-10.9-8.5c-.2-.2-.5 0-.4.3L59.4 45l-2.7 1.3c-.2.1-.2.3 0 .5l10.8 8.5c.2.2.6-.1.4-.3l-5.5-11.5 2.7-1.2c.1-.1.2-.4 0-.5z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#344563",
                        d: "M101.1 56.7h-.6a1.101 1.101 0 0 1-.3-1.2c-.2-.8-2.3-2.9-3.5-4.1-3-3.1-5-5-3.9-6.5s3.6-.3 7.4 1.7a40.9 40.9 0 0 0 4.4 2 21.651 21.651 0 0 0-3.3-3.6c-2.9-3-4.9-5-3.8-6.5s3.6-.2 7.4 1.7a40.9 40.9 0 0 0 4.4 2 26.43 26.43 0 0 0-3.3-3.6c-2.9-3-4.9-5-3.8-6.5s3.6-.2 7.3 1.7c1.6.8 4.2 2.1 5 2.1a.899.899 0 0 1 1.2 0 1.006 1.006 0 0 1 .445.637 1 1 0 0 1-.145.763c-1.1 1.5-3.6.2-7.4-1.7a27.633 27.633 0 0 0-4.4-2 46.328 46.328 0 0 0 3.2 3.6c3 3 5 5 3.9 6.5s-3.6.2-7.4-1.7a42.948 42.948 0 0 0-4.4-2.1 26.682 26.682 0 0 0 3.3 3.7c2.9 3 4.9 5 3.8 6.4s-3.6.3-7.3-1.7a41.794 41.794 0 0 0-4.5-2c.7 1 2.3 2.6 3.3 3.7 3 3 4.9 5 3.8 6.4a.904.904 0 0 1-.8.3z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fill: "#5e6c84",
                        d: "M106.7 71.1a1.097 1.097 0 0 1-.9-.5c-1-1.9-2.2-4.1-.9-5.3s3.3.2 5.5 1.7c.915.65 1.886 1.219 2.9 1.7a13.622 13.622 0 0 0-1.4-3.1c-1.3-2.3-2.5-4.4-1.2-5.6s3.4.2 5.5 1.6a11.79 11.79 0 0 0 3.1 1.8 1 1 0 1 1 1.3 1.5c-1.3 1.2-3.4-.2-5.5-1.6a19.352 19.352 0 0 0-2.9-1.7 13.087 13.087 0 0 0 1.4 3c1.3 2.3 2.5 4.5 1.2 5.7s-3.4-.2-5.5-1.7a15.8 15.8 0 0 0-3-1.7c.352.937.787 1.84 1.3 2.7a1.004 1.004 0 0 1-.4 1.3zM52.4 68.2l-.7-.2c-1.6-.7-1.2-3.1-.8-5.6.232-1.118.333-2.259.3-3.4a22.496 22.496 0 0 0-2.2 2.6c-1.5 2.1-2.9 4.1-4.6 3.4a1 1 0 0 1-.5-1.3.9.9 0 0 1 1.2-.6c.5-.2 1.6-1.8 2.3-2.7s3-4.1 4.6-3.4 1.3 3.1.9 5.7a14.802 14.802 0 0 0-.4 3.4c.83-.78 1.568-1.652 2.2-2.6 1.5-2.1 3-4.1 4.6-3.4s1.3 3.1.9 5.2a1 1 0 1 1-1.9-.3c.116-.962.183-1.93.2-2.9a11.9 11.9 0 0 0-2.2 2.6c-1.3 1.8-2.6 3.5-3.9 3.5z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_19pk7vkz _2hwx7vkz _otyr7vkz _18u07vkz _1e0c1txw _y3gn1h6o _2lx21bp4 _k48p1nn1 _1bah1h6o _1dyzqdok"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            ...$05166e313fbedae6$var$ErrorView.messages.errorTitle
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_1pfhn7od"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            ...$05166e313fbedae6$var$ErrorView.messages.error,
                            values: {
                                signUpAgainLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                        text: text,
                                        type: "inline",
                                        href: signUpUrl
                                    }),
                                contactSupportLink: (text)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                        text: text,
                                        type: "inline",
                                        href: "https://support.atlassian.com/contact/"
                                    })
                            }
                        })
                    })
                ]
            })
        ]
    });
};
var $05166e313fbedae6$export$2e2bcd8739ae039 = $05166e313fbedae6$var$ErrorView;
$05166e313fbedae6$var$ErrorView.messages = (0, $6x1qA.defineMessages)({
    errorTitle: {
        id: "WacConfirmationPage.errorTitle",
        defaultMessage: "We're not sure what went wrong"
    },
    error: {
        id: "WacConfirmationPage.error",
        defaultMessage: "Try <signUpAgainLink>signing up again</signUpAgainLink>. If this keeps happening, <contactSupportLink>contact support.</contactSupportLink>"
    }
});

});
parcelRegister("2CpWf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51ff7d9738de0ebf$export$2e2bcd8739ae039; });
/* main-container.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $at1cX = parcelRequire("at1cX");

var $bESu4 = parcelRequire("bESu4");
const $51ff7d9738de0ebf$var$containerStyle = null;
const $51ff7d9738de0ebf$export$d653589df987fd93 = ({ showHeader: showHeader = true, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _4cvr1h6o _1wpz1h6o"
        ]),
        children: [
            showHeader && /*#__PURE__*/ (0, $loA2J.jsx)((0, $at1cX.default), {}),
            children,
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bESu4.default), {})
        ]
    });
};
var $51ff7d9738de0ebf$export$2e2bcd8739ae039 = $51ff7d9738de0ebf$export$d653589df987fd93;

});
parcelRegister("at1cX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83142783fa8019a2$export$2e2bcd8739ae039; });
/* header.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $4XrxY = parcelRequire("4XrxY");

var $aO3Hl = parcelRequire("aO3Hl");

var $2xIEu = parcelRequire("2xIEu");
const $83142783fa8019a2$var$headerStyle = null;
const $83142783fa8019a2$var$h1Style = null;
const $83142783fa8019a2$export$8b251419efc915eb = /* istanbul ignore next */ ()=>{
    const intl = (0, $f6qj2.default)();
    const { products: products } = (0, $aO3Hl.useSearchParameters)();
    const product = products.length === 1 ? products[0] : "";
    const headerMessage = {
        identifier: "confirmation.header",
        text: intl.formatMessage({
            id: "confirmation.header.text",
            defaultMessage: "We're building your site ..."
        })
    };
    const bitbucketHeadingMessage = {
        identifier: "confirmation.bitbucket.header",
        text: intl.formatMessage({
            id: "confirmation.bitbucket.header.text",
            defaultMessage: "One moment, your product is starting up"
        })
    };
    const loomHeadingMessage = {
        identifier: "confirmation.loom.header",
        text: intl.formatMessage({
            id: "confirmation.loom.header.text",
            defaultMessage: "We\u2019re setting you up on Loom"
        })
    };
    const getHeadingMessage = (product)=>{
        switch(product){
            case (0, $2xIEu.ProductKey).BITBUCKET:
                return bitbucketHeadingMessage;
            case (0, $2xIEu.ProductKey).LOOM:
                return loomHeadingMessage;
            default:
                return headerMessage;
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Logo), {
                type: "logo",
                appearance: "brand",
                brand: "atlassian"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                className: (0, $esG4f.default)([
                    "_1wybviql _k48pbfng _syaz1bqd _1pfh1f4h _6rth1tcg _1dyzvkfx _vwz41ylp"
                ]),
                children: getHeadingMessage(product).text
            })
        ]
    });
};
var $83142783fa8019a2$export$2e2bcd8739ae039 = $83142783fa8019a2$export$8b251419efc915eb;

});

parcelRegister("bESu4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ca2cd4cf60a4956$export$2e2bcd8739ae039; });
//@ts-nocheck

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");
const $9ca2cd4cf60a4956$export$d7336fa50d87e946 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("script", {
                src: "//js.dmtry.com/channel.js#gid:3968;advid:997;pid:857803"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("noscript", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                    width: "0",
                    height: "0",
                    src: "//log.dmtry.com/redir/1/0/3968/857803/0/1/173/0/997/1.ver?at=v&d=PxConv",
                    alt: "Adometry Validation Dummy Tag"
                })
            })
        ]
    });
};
var $9ca2cd4cf60a4956$export$2e2bcd8739ae039 = $9ca2cd4cf60a4956$export$d7336fa50d87e946;

});



parcelRegister("gG3lv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c63052f94c020844$export$2e2bcd8739ae039; });
/* robots-view.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $2CpWf = parcelRequire("2CpWf");

var $dWbel = parcelRequire("dWbel");
parcelRequire("d2NVK");
var $kR2lN = parcelRequire("kR2lN");

var $aO3Hl = parcelRequire("aO3Hl");

var $2xIEu = parcelRequire("2xIEu");

var $1YDlO = parcelRequire("1YDlO");

var $fkFRk = parcelRequire("fkFRk");
const $c63052f94c020844$var$MessageContainer = null;
let $c63052f94c020844$var$image = "https://wac-cdn.atlassian.com/misc-assets/webp-images/construction.webp";
const $c63052f94c020844$var$RobotsView = /* istanbul ignore next */ ()=>{
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { products: products, referrer: referrer } = (0, $aO3Hl.useSearchParameters)();
    const isReferredFromVerifyEmail = referrer === "verify_email";
    const isBitbucket = products.length === 1 && products[0] === (0, $2xIEu.ProductKey).BITBUCKET; // Check if "loom" is in the products array
    if (products.includes((0, $2xIEu.ProductKey).LOOM)) $c63052f94c020844$var$image = "https://dam-cdn.atl.orangelogic.com/AssetLink/50qw66f865jv256a1c6365h05ncwhx54.svg";
    (0, $iSvIT.useEffect)(()=>{
        analyticsClient && createAnalyticsEvent({
            eventName: "robotsPageViewed",
            eventComponent: "robotsPage",
            event: "viewed"
        }).fire("signup");
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.UfoCustomTimingWrapper), {
        ufoEvent: (0, $jgJpJ.ufoEventRedirectToProduct),
        ufoCustomTimingKey: (0, $jgJpJ.UfoCustomTimingKey).ROBOTS_VIEW_DWELL_TIME,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kR2lN.DwellTimeWrapper), {
            eventData: {
                eventName: "robotsPageDwelled",
                eventComponent: "robotsPage",
                event: "dwelled",
                actionSubject: "robotsPage",
                source: "bxp-web-platform-wac-confirmation-page"
            },
            initialPollInterval: 2000,
            idleTimeout: 120000,
            nextPollIntervalCallback: (x)=>x + 2000,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fkFRk.StyledRelativePosition), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $2CpWf.default), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                            src: $c63052f94c020844$var$image,
                            height: "300px",
                            alt: ""
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1YDlO.default), {}),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            "data-testid": "robots-message",
                            className: (0, $esG4f.default)([
                                "_19pk7vkz _2hwx7vkz _otyr7vkz _18u07vkz _1e0c1txw _y3gn1h6o _2lx21bp4 _k48p1nn1 _1bah1h6o _1dyzqdok"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                ...isBitbucket ? $c63052f94c020844$var$RobotsView.messages.robotsBitbucket : $c63052f94c020844$var$RobotsView.messages.robots,
                                values: {
                                    isReferredFromVerifyEmail: isReferredFromVerifyEmail,
                                    p: (chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            children: chunks
                                        }),
                                    br: /*#__PURE__*/ (0, $loA2J.jsx)("br", {})
                                }
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $c63052f94c020844$export$2e2bcd8739ae039 = $c63052f94c020844$var$RobotsView;
$c63052f94c020844$var$RobotsView.messages = (0, $6x1qA.defineMessages)({
    robots: {
        id: "WacConfirmationPage.robots",
        defaultMessage: `<p>{ isReferredFromVerifyEmail, select, true {Great, your email address is now verified! Our robots are working on your Atlassian Cloud site.} other {Thanks for signing up! Our robots are working on your Atlassian Cloud site.} }{br}\nThis won't take more than a minute or two. You'll be taken there once it's ready.<\/p>`
    },
    robotsBitbucket: {
        id: "WacConfirmationPage.robotsBitbucket",
        defaultMessage: `<p>{ isReferredFromVerifyEmail, select, true {Great, your email address is now verified! Our robots are working on your Atlassian Cloud product.} other {Thanks for signing up! Our robots are working on your Atlassian Cloud product.} }{br}\nThis won't take more than a minute or two. You'll be taken there once it's ready.<\/p>`
    }
});

});
parcelRegister("d2NVK", function(module, exports) {
$parcel$export(module.exports, "DwellTimeWrapper", function () { return (parcelRequire("kR2lN")).DwellTimeWrapper; });
parcelRequire("kR2lN");

});
parcelRegister("kR2lN", function(module, exports) {

$parcel$export(module.exports, "DwellTimeWrapper", function () { return $a76290cb38ef5b92$export$17e1c90ba9ff9704; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $9Ub9d = parcelRequire("9Ub9d");
const $a76290cb38ef5b92$export$17e1c90ba9ff9704 = (props)=>{
    const { eventData: eventData, initialPollInterval: initialPollInterval, idleTimeout: idleTimeout, nextPollIntervalCallback: nextPollIntervalCallback, children: children } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    (0, $iSvIT.useEffect)(()=>{
        const timer = new (0, $9Ub9d.default)((payload)=>{
            const flattenAttributes = {
                ...payload["attributes"]
            };
            delete payload["attributes"];
            createAnalyticsEvent({
                ...flattenAttributes,
                ...payload,
                ...eventData
            }).fire();
        }, eventData, null, {
            initialPollInterval: initialPollInterval,
            idleTimeout: idleTimeout,
            multiplierCallback: nextPollIntervalCallback
        });
        timer.start();
        return ()=>{
            timer.stop();
            timer.destroy();
        };
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: children
    });
};

});
parcelRegister("9Ub9d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7361fdbb5ed12d90$export$2e2bcd8739ae039; });

var $3gqmq = parcelRequire("3gqmq");

var $jv6vP = parcelRequire("jv6vP");

var $9PPW1 = parcelRequire("9PPW1");
function $7361fdbb5ed12d90$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7361fdbb5ed12d90$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7361fdbb5ed12d90$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3gqmq.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7361fdbb5ed12d90$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $7361fdbb5ed12d90$var$DEFAULT_TIMING = {
    initialPollInterval: 5000,
    idleTimeout: 30000,
    multiplierCallback: (x)=>x + x
};
class $7361fdbb5ed12d90$export$2e2bcd8739ae039 {
    /**
   * Callback for sending a 'track' analytics event. This callback should either be the
   * 'sendTrackEvent' method on the AnalyticsWebClient, or a method that eventually delegates to it.
   * The data for the dwell event will be passed to this method for sending.
   *
   * @callback trackCallback
   * @param {Object} eventData - the base event data that will be added to the track event.
   */ /**
   * Creates and initialises the DwellTimeHelper.
   *
   * @param {trackCallback} trackCallback - the track callback responsible for actually sending
   * the event.
   * @param {Object} eventData - the base data that will be added to the track event.
   * Additional dwell time attributes will be appended to this data. Note that you don't need to
   * include the 'action' property, as this will be added automatically.
   * @param {?string} searchSessionId - a unique identifier for the related search session.
   * @param {?Object} timingOptions - for the purpose of debugging, you can override the default
   * timing used for measuring dwell time. The following values are possible:
   * - initialPollInterval: how long to wait before the first dwell milestone event
   * is fired (in seconds). Default = 5.
   * - pollBackoffRate: how much to multiply the last poll interval by on each dwell milestone.
   * event. Default = 2.
   * - idleTimeout: how long to wait for no user activity before pausing
   * the dwell timer (in seconds). Default = 30s.
   */ constructor(trackCallback, _eventData, _searchSessionId, timingOptions){
        /**
     * Starts the dwell timer. This method should be called upon the initial page load.
     */ (0, $3gqmq.default)(this, "start", ()=>{
            this.browserInteractionTime.startTimer();
            this.browserInteractionTime.addTimeIntervalEllapsedCallback({
                callback: (timeInMilliseconds)=>this._sendDwellEvent(this._eventData, this._searchSessionId, timeInMilliseconds, false),
                timeInMilliseconds: this._timing.initialPollInterval,
                multiplier: this._timing.multiplierCallback
            });
            if (typeof window !== "undefined") window.addEventListener("beforeunload", this._onBeforeUnload);
        });
        /**
     * Stops the dwell timer and sends the final dwell event. Call this method if you wish to
     * finalise a dwell measurement without starting a new one. When switching to a new page in a
     * single-page app, use newPage instead.
     */ (0, $3gqmq.default)(this, "stop", ()=>{
            if (this.browserInteractionTime.isRunning()) this._sendDwellEvent(this._eventData, this._searchSessionId, this.browserInteractionTime.getTimeInMilliseconds(), true);
            this.browserInteractionTime.stopTimer();
        });
        /**
     * Send the final dwell event and reinitialise the dwell timer for a new page.
     * This method should be called whenever a new page is switched to in a single-page app context.
     *
     * @param {Object} eventData - the base data that will be added to the track event.
     * @param {?string} searchSessionId - the new search session ID.
     */ (0, $3gqmq.default)(this, "newPage", (eventData, searchSessionId)=>{
            (0, $9PPW1.validateDwellBaseEvent)(eventData);
            this.stop();
            this.browserInteractionTime.reset();
            this.setEventData(eventData);
            this.setSearchSessionId(searchSessionId);
            this.start();
        });
        (0, $3gqmq.default)(this, "setEventData", (eventData)=>{
            this._eventData = eventData;
        });
        (0, $3gqmq.default)(this, "getEventData", ()=>this._eventData);
        (0, $3gqmq.default)(this, "setSearchSessionId", (searchSessionId)=>{
            this._searchSessionId = searchSessionId;
        });
        (0, $3gqmq.default)(this, "getSearchSessionId", ()=>this._searchSessionId);
        (0, $3gqmq.default)(this, "destroy", ()=>{
            this.browserInteractionTime.destroy();
            if (typeof window !== "undefined") window.removeEventListener("beforeunload", this._onBeforeUnload);
        });
        (0, $3gqmq.default)(this, "_onBeforeUnload", ()=>{
            this.stop();
            this.destroy();
        });
        (0, $3gqmq.default)(this, "_sendDwellEvent", (eventData, searchSessionId, timeInMilliseconds, isFinalDwellEvent)=>{
            const dwellAttributes = {
                dwellTime: timeInMilliseconds,
                searchReferrer: searchSessionId,
                finalDwellEvent: isFinalDwellEvent
            };
            this._trackCallback({
                action: "dwelled",
                actionSubject: eventData.actionSubject,
                actionSubjectId: eventData.actionSubjectId,
                source: eventData.source,
                containerType: eventData.containerType,
                containerId: eventData.containerId,
                objectType: eventData.objectType,
                objectId: eventData.objectId,
                attributes: $7361fdbb5ed12d90$var$_objectSpread($7361fdbb5ed12d90$var$_objectSpread({}, dwellAttributes), eventData.attributes),
                tags: eventData.tags
            });
        });
        if (!trackCallback) throw new Error("trackCallback is required for DwellTimeHelper");
        (0, $9PPW1.validateDwellBaseEvent)(_eventData);
        this._trackCallback = trackCallback;
        this._eventData = _eventData;
        this._searchSessionId = _searchSessionId;
        this._timing = $7361fdbb5ed12d90$var$_objectSpread($7361fdbb5ed12d90$var$_objectSpread({}, $7361fdbb5ed12d90$var$DEFAULT_TIMING), timingOptions);
        this.browserInteractionTime = new (0, $jv6vP.default)({
            idleTimeoutMs: this._timing.idleTimeout,
            checkCallbacksIntervalMs: 500
        });
    }
}

});
parcelRegister("jv6vP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e325f6cb8f00227c$export$2e2bcd8739ae039; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $e325f6cb8f00227c$var$__assign = function() {
    $e325f6cb8f00227c$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e325f6cb8f00227c$var$__assign.apply(this, arguments);
};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e325f6cb8f00227c$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $e325f6cb8f00227c$var$isObject_1 = $e325f6cb8f00227c$var$isObject;
var $e325f6cb8f00227c$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
/** Detect free variable `global` from Node.js. */ var $e325f6cb8f00227c$var$freeGlobal = typeof $e325f6cb8f00227c$var$commonjsGlobal == "object" && $e325f6cb8f00227c$var$commonjsGlobal && $e325f6cb8f00227c$var$commonjsGlobal.Object === Object && $e325f6cb8f00227c$var$commonjsGlobal;
var $e325f6cb8f00227c$var$_freeGlobal = $e325f6cb8f00227c$var$freeGlobal;
/** Detect free variable `self`. */ var $e325f6cb8f00227c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e325f6cb8f00227c$var$root = $e325f6cb8f00227c$var$_freeGlobal || $e325f6cb8f00227c$var$freeSelf || Function("return this")();
var $e325f6cb8f00227c$var$_root = $e325f6cb8f00227c$var$root;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $e325f6cb8f00227c$var$now = function() {
    return $e325f6cb8f00227c$var$_root.Date.now();
};
var $e325f6cb8f00227c$var$now_1 = $e325f6cb8f00227c$var$now;
/** Built-in value references. */ var $e325f6cb8f00227c$var$Symbol = $e325f6cb8f00227c$var$_root.Symbol;
var $e325f6cb8f00227c$var$_Symbol = $e325f6cb8f00227c$var$Symbol;
/** Used for built-in method references. */ var $e325f6cb8f00227c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e325f6cb8f00227c$var$hasOwnProperty = $e325f6cb8f00227c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e325f6cb8f00227c$var$nativeObjectToString = $e325f6cb8f00227c$var$objectProto.toString;
/** Built-in value references. */ var $e325f6cb8f00227c$var$symToStringTag = $e325f6cb8f00227c$var$_Symbol ? $e325f6cb8f00227c$var$_Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $e325f6cb8f00227c$var$getRawTag(value) {
    var isOwn = $e325f6cb8f00227c$var$hasOwnProperty.call(value, $e325f6cb8f00227c$var$symToStringTag), tag = value[$e325f6cb8f00227c$var$symToStringTag];
    try {
        value[$e325f6cb8f00227c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $e325f6cb8f00227c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$e325f6cb8f00227c$var$symToStringTag] = tag;
        else delete value[$e325f6cb8f00227c$var$symToStringTag];
    }
    return result;
}
var $e325f6cb8f00227c$var$_getRawTag = $e325f6cb8f00227c$var$getRawTag;
/** Used for built-in method references. */ var $e325f6cb8f00227c$var$objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e325f6cb8f00227c$var$nativeObjectToString$1 = $e325f6cb8f00227c$var$objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $e325f6cb8f00227c$var$objectToString(value) {
    return $e325f6cb8f00227c$var$nativeObjectToString$1.call(value);
}
var $e325f6cb8f00227c$var$_objectToString = $e325f6cb8f00227c$var$objectToString;
/** `Object#toString` result references. */ var $e325f6cb8f00227c$var$nullTag = "[object Null]", $e325f6cb8f00227c$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $e325f6cb8f00227c$var$symToStringTag$1 = $e325f6cb8f00227c$var$_Symbol ? $e325f6cb8f00227c$var$_Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $e325f6cb8f00227c$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $e325f6cb8f00227c$var$undefinedTag : $e325f6cb8f00227c$var$nullTag;
    return $e325f6cb8f00227c$var$symToStringTag$1 && $e325f6cb8f00227c$var$symToStringTag$1 in Object(value) ? $e325f6cb8f00227c$var$_getRawTag(value) : $e325f6cb8f00227c$var$_objectToString(value);
}
var $e325f6cb8f00227c$var$_baseGetTag = $e325f6cb8f00227c$var$baseGetTag;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $e325f6cb8f00227c$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $e325f6cb8f00227c$var$isObjectLike_1 = $e325f6cb8f00227c$var$isObjectLike;
/** `Object#toString` result references. */ var $e325f6cb8f00227c$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $e325f6cb8f00227c$var$isSymbol(value) {
    return typeof value == "symbol" || $e325f6cb8f00227c$var$isObjectLike_1(value) && $e325f6cb8f00227c$var$_baseGetTag(value) == $e325f6cb8f00227c$var$symbolTag;
}
var $e325f6cb8f00227c$var$isSymbol_1 = $e325f6cb8f00227c$var$isSymbol;
/** Used as references for various `Number` constants. */ var $e325f6cb8f00227c$var$NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */ var $e325f6cb8f00227c$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $e325f6cb8f00227c$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e325f6cb8f00227c$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e325f6cb8f00227c$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e325f6cb8f00227c$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e325f6cb8f00227c$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($e325f6cb8f00227c$var$isSymbol_1(value)) return $e325f6cb8f00227c$var$NAN;
    if ($e325f6cb8f00227c$var$isObject_1(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $e325f6cb8f00227c$var$isObject_1(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($e325f6cb8f00227c$var$reTrim, "");
    var isBinary = $e325f6cb8f00227c$var$reIsBinary.test(value);
    return isBinary || $e325f6cb8f00227c$var$reIsOctal.test(value) ? $e325f6cb8f00227c$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e325f6cb8f00227c$var$reIsBadHex.test(value) ? $e325f6cb8f00227c$var$NAN : +value;
}
var $e325f6cb8f00227c$var$toNumber_1 = $e325f6cb8f00227c$var$toNumber;
/** Error message constants. */ var $e325f6cb8f00227c$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e325f6cb8f00227c$var$nativeMax = Math.max, $e325f6cb8f00227c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $e325f6cb8f00227c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($e325f6cb8f00227c$var$FUNC_ERROR_TEXT);
    wait = $e325f6cb8f00227c$var$toNumber_1(wait) || 0;
    if ($e325f6cb8f00227c$var$isObject_1(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $e325f6cb8f00227c$var$nativeMax($e325f6cb8f00227c$var$toNumber_1(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $e325f6cb8f00227c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $e325f6cb8f00227c$var$now_1();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($e325f6cb8f00227c$var$now_1());
    }
    function debounced() {
        var time = $e325f6cb8f00227c$var$now_1(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $e325f6cb8f00227c$var$debounce_1 = $e325f6cb8f00227c$var$debounce;
/** Error message constants. */ var $e325f6cb8f00227c$var$FUNC_ERROR_TEXT$1 = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $e325f6cb8f00227c$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($e325f6cb8f00227c$var$FUNC_ERROR_TEXT$1);
    if ($e325f6cb8f00227c$var$isObject_1(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $e325f6cb8f00227c$var$debounce_1(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $e325f6cb8f00227c$var$throttle_1 = $e325f6cb8f00227c$var$throttle;
var $e325f6cb8f00227c$var$windowIdleEvents = [
    "scroll",
    "resize"
];
var $e325f6cb8f00227c$var$documentIdleEvents = [
    "wheel",
    "keydown",
    "keyup",
    "mousedown",
    "mousemove",
    "touchstart",
    "touchmove",
    "click",
    "contextmenu"
];
var $e325f6cb8f00227c$var$BrowserInteractionTime = /** @class */ function() {
    function BrowserInteractionTime(_a) {
        var _b = _a.timeIntervalEllapsedCallbacks, timeIntervalEllapsedCallbacks = _b === void 0 ? [] : _b, _c = _a.absoluteTimeEllapsedCallbacks, absoluteTimeEllapsedCallbacks = _c === void 0 ? [] : _c, _d = _a.checkCallbacksIntervalMs, checkCallbacksIntervalMs = _d === void 0 ? 100 : _d, _e = _a.browserTabInactiveCallbacks, browserTabInactiveCallbacks = _e === void 0 ? [] : _e, _f = _a.idleCallbacks, idleCallbacks = _f === void 0 ? [] : _f, _g = _a.stopTimerOnTabchange, stopTimerOnTabchange = _g === void 0 ? true : _g, _h = _a.activeCallbacks, activeCallbacks = _h === void 0 ? [] : _h, _j = _a.browserTabActiveCallbacks, browserTabActiveCallbacks = _j === void 0 ? [] : _j, _k = _a.idleTimeoutMs, idleTimeoutMs = _k === void 0 ? 3000 : _k;
        var _this = this;
        this.onBrowserTabInactive = function() {
            // if running pause timer
            if (_this.isRunning() && _this.stopTimerOnTabchange) _this.stopTimer();
            _this.browserTabInactiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserTabActive = function() {
            // if not running start timer
            if (!_this.isRunning()) _this.startTimer();
            _this.browserTabActiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserActiveChange = function() {
            if (document.visibilityState === "visible") _this.onBrowserTabActive();
            else _this.onBrowserTabInactive();
        };
        this.onTimePassed = function() {
            // check all callbacks time and if passed execute callback
            _this.absoluteTimeEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, pending = _a.pending, timeInMilliseconds = _a.timeInMilliseconds;
                if (pending && timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.absoluteTimeEllapsedCallbacks[index].pending = false;
                }
            });
            _this.timeIntervalEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, timeInMilliseconds = _a.timeInMilliseconds, multiplier = _a.multiplier;
                if (timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                }
            });
            if (_this.currentIdleTimeMs >= _this.idleTimeoutMs && _this.isRunning()) {
                _this.idle = true;
                _this.stopTimer();
                _this.idleCallbacks.forEach(function(fn) {
                    return fn(_this.getTimeInMilliseconds());
                });
            } else _this.currentIdleTimeMs += _this.checkCallbacksIntervalMs;
        };
        this.resetIdleTime = function() {
            if (_this.idle) _this.startTimer();
            _this.activeCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
            _this.idle = false;
            _this.currentIdleTimeMs = 0;
        };
        this.registerEventListeners = function() {
            var documentListenerOptions = {
                passive: true
            };
            var windowListenerOptions = $e325f6cb8f00227c$var$__assign({}, documentListenerOptions, {
                capture: true
            });
            document.addEventListener("visibilitychange", _this.onBrowserActiveChange);
            var throttleResetIdleTime = $e325f6cb8f00227c$var$throttle_1(_this.resetIdleTime, 2000, {
                leading: true,
                trailing: false
            });
            $e325f6cb8f00227c$var$windowIdleEvents.forEach(function(event) {
                window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
            });
            $e325f6cb8f00227c$var$documentIdleEvents.forEach(function(event) {
                return document.addEventListener(event, throttleResetIdleTime, documentListenerOptions);
            });
        };
        this.unregisterEventListeners = function() {
            document.removeEventListener("visibilitychange", _this.onBrowserActiveChange);
            $e325f6cb8f00227c$var$windowIdleEvents.forEach(function(event) {
                return window.removeEventListener(event, _this.resetIdleTime);
            });
            $e325f6cb8f00227c$var$documentIdleEvents.forEach(function(event) {
                return document.removeEventListener(event, _this.resetIdleTime);
            });
        };
        this.checkCallbacksOnInterval = function() {
            _this.checkCallbackIntervalId = window.setInterval(function() {
                _this.onTimePassed();
            }, _this.checkCallbacksIntervalMs);
        };
        this.startTimer = function() {
            if (!_this.checkCallbackIntervalId) _this.checkCallbacksOnInterval();
            var last = _this.times[_this.times.length - 1];
            if (last && last.stop === null) return;
            _this.times.push({
                start: performance.now(),
                stop: null
            });
            _this.running = true;
        };
        this.stopTimer = function() {
            if (!_this.times.length) return;
            _this.times[_this.times.length - 1].stop = performance.now();
            _this.running = false;
        };
        this.addTimeIntervalEllapsedCallback = function(timeIntervalEllapsedCallback) {
            _this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
        };
        this.addAbsoluteTimeEllapsedCallback = function(absoluteTimeEllapsedCallback) {
            _this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
        };
        this.addBrowserTabInactiveCallback = function(browserTabInactiveCallback) {
            _this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
        };
        this.addBrowserTabActiveCallback = function(browserTabActiveCallback) {
            _this.browserTabActiveCallbacks.push(browserTabActiveCallback);
        };
        this.addIdleCallback = function(inactiveCallback) {
            _this.idleCallbacks.push(inactiveCallback);
        };
        this.addActiveCallback = function(activeCallback) {
            _this.activeCallbacks.push(activeCallback);
        };
        this.getTimeInMilliseconds = function() {
            return _this.times.reduce(function(acc, current) {
                if (current.stop) acc = acc + (current.stop - current.start);
                else acc = acc + (performance.now() - current.start);
                return acc;
            }, 0);
        };
        this.isRunning = function() {
            return _this.running;
        };
        this.isIdle = function() {
            return _this.idle;
        };
        this.reset = function() {
            _this.times = [];
        };
        this.destroy = function() {
            _this.unregisterEventListeners();
            if (_this.checkCallbackIntervalId) window.clearInterval(_this.checkCallbackIntervalId);
        };
        this.running = false;
        this.times = [];
        this.idle = false;
        this.currentIdleTimeMs = 0;
        this.marks = {};
        this.measures = {};
        this.stopTimerOnTabchange = stopTimerOnTabchange;
        this.browserTabActiveCallbacks = browserTabActiveCallbacks;
        this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
        this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
        this.idleTimeoutMs = idleTimeoutMs;
        this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
        this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
        this.idleCallbacks = idleCallbacks;
        this.activeCallbacks = activeCallbacks;
        this.registerEventListeners();
    }
    BrowserInteractionTime.prototype.mark = function(key) {
        if (!this.marks[key]) this.marks[key] = [];
        this.marks[key].push({
            time: this.getTimeInMilliseconds()
        });
    };
    BrowserInteractionTime.prototype.getMarks = function(name) {
        if (this.marks[name].length < 1) return;
        return this.marks[name];
    };
    BrowserInteractionTime.prototype.measure = function(name, startMarkName, endMarkName) {
        var startMarks = this.marks[startMarkName];
        var startMark = startMarks[startMarks.length - 1];
        var endMarks = this.marks[endMarkName];
        var endMark = endMarks[endMarks.length - 1];
        if (!this.measures[name]) this.measures[name] = [];
        this.measures[name].push({
            name: name,
            startTime: startMark.time,
            duration: endMark.time - startMark.time
        });
    };
    BrowserInteractionTime.prototype.getMeasures = function(name) {
        if (!this.measures[name] && this.measures[name].length < 1) return;
        return this.measures[name];
    };
    return BrowserInteractionTime;
}();
var $e325f6cb8f00227c$export$2e2bcd8739ae039 = $e325f6cb8f00227c$var$BrowserInteractionTime;

});




parcelRegister("1YDlO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fabb5aa85eb4be5e$export$2e2bcd8739ae039; });
/* progress-bar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $HCrP6 = parcelRequire("HCrP6");

var $48zDN = parcelRequire("48zDN");

var $aO3Hl = parcelRequire("aO3Hl");

var $e66ZO = parcelRequire("e66ZO");

var $dkYGl = parcelRequire("dkYGl");
const $fabb5aa85eb4be5e$var$progressStyle = null;
const $fabb5aa85eb4be5e$export$c17561cb55d4db30 = ()=>{
    const { createCloudStatus: createCloudStatus } = (0, $aO3Hl.useCloudStatus)();
    const [progress, setProgress] = (0, $iSvIT.useState)(0); // components
    const progressTimeout = /*#__PURE__*/ (0, $loA2J.jsx)((0, $HCrP6.default), {
        testId: "progress-timeout",
        value: 1,
        theme: (getTokens, props)=>{
            const tokens = getTokens(props);
            return {
                ...tokens,
                bar: {
                    ...tokens.bar,
                    background: (0, $48zDN.R400)
                }
            };
        }
    });
    const progressPending = /*#__PURE__*/ (0, $loA2J.jsx)((0, $HCrP6.default), {
        testId: "progress-pending",
        value: progress
    }); // Handles the progress bar update
    (0, $iSvIT.useEffect)(()=>{
        if (createCloudStatus === "success") {
            setProgress(1);
            return;
        }
        const startTime = Date.now();
        const pivotPercentage = 0.8; // The progress bar will fill up to 80% by the pivot time
        const progressBarPivotPoint = 60000;
        const slowProgressIncrement = (1 - pivotPercentage) / (((0, $e66ZO.DEFAULT_TIMEOUT) - progressBarPivotPoint) / 100);
        const slowProgress = 0;
        const interval = setInterval(()=>{
            setProgress((0, $dkYGl.getProgressbarStatus)({
                startTime: startTime,
                pivotPercentage: pivotPercentage,
                progressBarPivotPoint: progressBarPivotPoint,
                slowProgressIncrement: slowProgressIncrement,
                slowProgress: slowProgress,
                interval: interval
            }));
        }, 100); // Update progress every 0.1 second
        return ()=>{
            setProgress(0);
            clearInterval(interval);
        };
    }, [
        createCloudStatus
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_y3gn1h6o _1e0c1txw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1wyb1j6v _2lx21bp4 _k48p1nn1 _1bah1h6o _1wpz1h6o _1bsb1osq _p12f1kdj _19pk7vkz _2hwx7vkz _otyr7vkz _18u07vkz _4cvr1h6o"
        ]),
        children: createCloudStatus === "timeout" ? progressTimeout : progressPending
    });
};
var $fabb5aa85eb4be5e$export$2e2bcd8739ae039 = $fabb5aa85eb4be5e$export$c17561cb55d4db30;

});
parcelRegister("HCrP6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0831d7312590759e$export$2e2bcd8739ae039; });

var $iv5XG = parcelRequire("iv5XG");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $5bQIS = parcelRequire("5bQIS");

var $l7z3x = parcelRequire("l7z3x");

var $7zTco = parcelRequire("7zTco");
var $0831d7312590759e$var$MIN_VALUE = 0;
var $0831d7312590759e$var$MAX_VALUE = 1;
var $0831d7312590759e$var$increasingBarAnimation = (0, $2ZUkg.keyframes)({
    from: {
        left: "-5%",
        width: "5%"
    },
    to: {
        left: "130%",
        width: " 100%"
    }
});
var $0831d7312590759e$var$decreasingBarAnimation = (0, $2ZUkg.keyframes)({
    from: {
        left: "-80%",
        width: "80%"
    },
    to: {
        left: "110%",
        width: "10%"
    }
});
var $0831d7312590759e$var$containerStyles = (0, $2ZUkg.css)({
    width: "100%",
    height: 6,
    position: "relative",
    background: "var(--ds-background-neutral, ".concat((0, $l7z3x.N40A), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    overflow: "hidden"
});
var $0831d7312590759e$var$containerAppearance = {
    default: (0, $2ZUkg.css)({
        background: "var(--ds-background-neutral, ".concat((0, $l7z3x.N40A), ")")
    }),
    success: (0, $2ZUkg.css)({
        background: "var(--ds-background-neutral, ".concat((0, $l7z3x.N40A), ")")
    }),
    inverse: (0, $2ZUkg.css)({
        background: "var(--ds-background-inverse-subtle, rgba(255, 255, 255, 0.5))"
    })
};
var $0831d7312590759e$var$barAppearance = {
    default: (0, $2ZUkg.css)({
        background: "var(--ds-background-neutral-bold, ".concat((0, $l7z3x.N500), ")")
    }),
    success: (0, $2ZUkg.css)({
        background: "var(--ds-background-success-bold, ".concat((0, $l7z3x.G300), ")")
    }),
    inverse: (0, $2ZUkg.css)({
        background: "var(--ds-surface, white)"
    })
};
var $0831d7312590759e$var$barStyles = (0, $2ZUkg.css)({
    display: "block",
    height: 6,
    position: "absolute",
    borderRadius: "var(--ds-border-radius, 3px)"
});
var $0831d7312590759e$var$determinateBarStyles = (0, $2ZUkg.css)({
    transition: "width 0.2s"
});
var $0831d7312590759e$var$increasingBarStyles = (0, $2ZUkg.css)({
    animation: "".concat($0831d7312590759e$var$increasingBarAnimation, " 2s infinite")
});
var $0831d7312590759e$var$decreasingBarStyles = (0, $2ZUkg.css)({
    animation: "".concat($0831d7312590759e$var$decreasingBarAnimation, " 2s 0.5s infinite")
});
/**
 * __Progress bar__
 *
 * A progress bar displays the status of a given process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/code)
 * - [Usage](https://atlassian.design/components/progress-bar/usage)
 */ var $0831d7312590759e$var$ProgressBar = function ProgressBar(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, ariaLabel = _ref.ariaLabel, _ref$isIndeterminate = _ref.isIndeterminate, isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate, _ref$testId = _ref.testId, testId = _ref$testId === void 0 ? "progress-bar" : _ref$testId, theme = _ref.theme, _ref$value = _ref.value, value = _ref$value === void 0 ? 0 : _ref$value;
    var valueParsed = isIndeterminate ? $0831d7312590759e$var$MIN_VALUE : Math.max($0831d7312590759e$var$MIN_VALUE, Math.min(value, $0831d7312590759e$var$MAX_VALUE));
    (0, $5bQIS.propDeprecationWarning)("@atlaskit/progress-bar", "theme", (0, $iv5XG.default)(theme) !== undefined, "https://community.developer.atlassian.com/t/theme-prop-in-atlaskit-progress-bar-is-being-deprecated/56198");
    return (0, $2ZUkg.jsx)((0, $7zTco.Theme).Provider, {
        value: theme
    }, (0, $2ZUkg.jsx)((0, $7zTco.Theme).Consumer, {
        value: value
    }, function(tokens) {
        return (0, $2ZUkg.jsx)("div", {
            css: [
                $0831d7312590759e$var$containerStyles,
                $0831d7312590759e$var$containerAppearance[appearance],
                tokens.container
            ],
            role: "progressbar",
            "aria-label": ariaLabel,
            "aria-valuemin": $0831d7312590759e$var$MIN_VALUE,
            "aria-valuenow": valueParsed,
            "aria-valuemax": $0831d7312590759e$var$MAX_VALUE,
            tabIndex: 0,
            "data-testid": testId
        }, isIndeterminate ? (0, $2ZUkg.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, (0, $2ZUkg.jsx)("span", {
            css: [
                $0831d7312590759e$var$barStyles,
                $0831d7312590759e$var$barAppearance[appearance],
                $0831d7312590759e$var$increasingBarStyles,
                tokens.bar,
                tokens.increasingBar
            ]
        }), (0, $2ZUkg.jsx)("span", {
            css: [
                $0831d7312590759e$var$barStyles,
                $0831d7312590759e$var$barAppearance[appearance],
                $0831d7312590759e$var$decreasingBarStyles,
                tokens.bar,
                tokens.decreasingBar
            ]
        })) : (0, $2ZUkg.jsx)("span", {
            style: {
                width: "".concat(Number(value) * 100, "%")
            },
            css: [
                $0831d7312590759e$var$barStyles,
                $0831d7312590759e$var$barAppearance[appearance],
                $0831d7312590759e$var$determinateBarStyles,
                tokens.bar,
                tokens.determinateBar
            ]
        }));
    }));
};
var $0831d7312590759e$export$2e2bcd8739ae039 = $0831d7312590759e$var$ProgressBar;

});
parcelRegister("iv5XG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d77fbf1cf4509dd9$export$2e2bcd8739ae039; });
function $d77fbf1cf4509dd9$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $d77fbf1cf4509dd9$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d77fbf1cf4509dd9$export$2e2bcd8739ae039(o);
}

});

parcelRegister("5bQIS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c76e07bca214f34$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "propDeprecationWarning", function () { return $3c76e07bca214f34$export$eb1decd851a5ae56; });

var $2HEce = parcelRequire("2HEce");

var $XAEGR = parcelRequire("XAEGR");
function $3c76e07bca214f34$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $2HEce.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $3c76e07bca214f34$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $XAEGR;
}

});
parcelRegister("2HEce", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f7ec714977d670a$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $1f7ec714977d670a$var$printed = {};
function $1f7ec714977d670a$export$2e2bcd8739ae039(message) {
    if ($1f7ec714977d670a$var$printed[message]) return;
    $1f7ec714977d670a$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});


parcelRegister("l7z3x", function(module, exports) {

$parcel$export(module.exports, "G300", function () { return $f60571d72bbb2fdb$export$940e1f69e873f202; });
$parcel$export(module.exports, "B200", function () { return $f60571d72bbb2fdb$export$215b7063051591f1; });
$parcel$export(module.exports, "N500", function () { return $f60571d72bbb2fdb$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N30A", function () { return $f60571d72bbb2fdb$export$920c0d5c49070351; });
$parcel$export(module.exports, "N40A", function () { return $f60571d72bbb2fdb$export$46987b49aab6d1a8; });
$parcel$export(module.exports, "skeleton", function () { return $f60571d72bbb2fdb$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $2D4tu = parcelRequire("2D4tu");
var $f60571d72bbb2fdb$export$4b84fd0e2c617bd = "#FFEBE6";
var $f60571d72bbb2fdb$export$b34b069eff244586 = "#FFBDAD";
var $f60571d72bbb2fdb$export$be802dd0d8b57f35 = "#FF8F73";
var $f60571d72bbb2fdb$export$60847d42f9da92a6 = "#FF7452";
var $f60571d72bbb2fdb$export$4a7404f376229999 = "#FF5630";
var $f60571d72bbb2fdb$export$2010d0fb4295b346 = "#DE350B";
var $f60571d72bbb2fdb$export$2837b5a1a71d5c02 = "#BF2600";
var $f60571d72bbb2fdb$export$8d9596b529bbb9cf = "#FFFAE6";
var $f60571d72bbb2fdb$export$41060a744ab0b7ae = "#FFF0B3";
var $f60571d72bbb2fdb$export$1cc05bbbf340e559 = "#FFE380";
var $f60571d72bbb2fdb$export$5aae31392d72caaa = "#FFC400";
var $f60571d72bbb2fdb$export$c6930421db9fa514 = "#FFAB00";
var $f60571d72bbb2fdb$export$59619663aa6500fb = "#FF991F";
var $f60571d72bbb2fdb$export$874739ea9e379ab6 = "#FF8B00";
var $f60571d72bbb2fdb$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $f60571d72bbb2fdb$export$69a3bf21b9686c2b = "#ABF5D1";
var $f60571d72bbb2fdb$export$afbce1382ec95f73 = "#79F2C0";
var $f60571d72bbb2fdb$export$747d86715d4175de = "#57D9A3";
var $f60571d72bbb2fdb$export$940e1f69e873f202 = "#36B37E";
var $f60571d72bbb2fdb$export$a49394138f7b8e85 = "#00875A";
var $f60571d72bbb2fdb$export$6fa04827ac68a4fb = "#006644";
var $f60571d72bbb2fdb$export$226de0355ed012f8 = "#DEEBFF";
var $f60571d72bbb2fdb$export$8c13c2ee36917869 = "#B3D4FF";
var $f60571d72bbb2fdb$export$ecfc1dff386a3e7a = "#4C9AFF";
var $f60571d72bbb2fdb$export$215b7063051591f1 = "#2684FF";
var $f60571d72bbb2fdb$export$e62e8919cca44969 = "#0065FF";
var $f60571d72bbb2fdb$export$b3de0ae08da2ce64 = "#0052CC";
var $f60571d72bbb2fdb$export$a6ee3d71bc067634 = "#0747A6";
var $f60571d72bbb2fdb$export$363e4475840015bb = "#EAE6FF";
var $f60571d72bbb2fdb$export$4b0a4417ed59760f = "#C0B6F2";
var $f60571d72bbb2fdb$export$6011520a64d9a187 = "#998DD9";
var $f60571d72bbb2fdb$export$a7175d4e9206bc80 = "#8777D9";
var $f60571d72bbb2fdb$export$b48405b95304b5a1 = "#6554C0";
var $f60571d72bbb2fdb$export$c71e4279dd54a18d = "#5243AA";
var $f60571d72bbb2fdb$export$147899de772240ec = "#403294";
var $f60571d72bbb2fdb$export$2cf711fe14c66f06 = "#E6FCFF";
var $f60571d72bbb2fdb$export$7a8f4d33f6f9772c = "#B3F5FF";
var $f60571d72bbb2fdb$export$776c9c497ef08533 = "#79E2F2";
var $f60571d72bbb2fdb$export$69cb3ca10c1e330e = "#00C7E6";
var $f60571d72bbb2fdb$export$9dc1ef0f3f48059b = "#00B8D9";
var $f60571d72bbb2fdb$export$7c835c78b6fcdef8 = "#00A3BF";
var $f60571d72bbb2fdb$export$6036577f95c3877e = "#008DA6";
var $f60571d72bbb2fdb$export$29a4f05edc054374 = "#FFFFFF";
var $f60571d72bbb2fdb$export$e655ef011c4aa1a2 = "#FAFBFC";
var $f60571d72bbb2fdb$export$9fdfb749e33cdf97 = "#F4F5F7";
var $f60571d72bbb2fdb$export$3e51e8f1440314ba = "#EBECF0";
var $f60571d72bbb2fdb$export$1ce2d1575d444ceb = "#DFE1E6";
var $f60571d72bbb2fdb$export$8754fc7e6d8b3000 = "#C1C7D0";
var $f60571d72bbb2fdb$export$c2e91cbeada39b8b = "#B3BAC5";
var $f60571d72bbb2fdb$export$5f71e19f3a7ad9de = "#A5ADBA";
var $f60571d72bbb2fdb$export$eaa8c8a70ac22806 = "#97A0AF";
var $f60571d72bbb2fdb$export$7c87d337fb91a97d = "#8993A4";
var $f60571d72bbb2fdb$export$d6447c357493214f = "#7A869A";
var $f60571d72bbb2fdb$export$f563ee71e9ee74cd = "#6B778C";
var $f60571d72bbb2fdb$export$e2ef2124cf4024b1 = "#5E6C84";
var $f60571d72bbb2fdb$export$eece5f492e429f08 = "#505F79";
var $f60571d72bbb2fdb$export$c39c0fe0f26207ae = "#42526E";
var $f60571d72bbb2fdb$export$7090862dc3038a9f = "#344563";
var $f60571d72bbb2fdb$export$ad0bacf983b7ddaa = "#253858";
var $f60571d72bbb2fdb$export$7d61b15e0da132af = "#172B4D";
var $f60571d72bbb2fdb$export$fbda843f0a27fe96 = "#091E42";
var $f60571d72bbb2fdb$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $f60571d72bbb2fdb$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $f60571d72bbb2fdb$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $f60571d72bbb2fdb$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $f60571d72bbb2fdb$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $f60571d72bbb2fdb$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $f60571d72bbb2fdb$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $f60571d72bbb2fdb$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $f60571d72bbb2fdb$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $f60571d72bbb2fdb$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $f60571d72bbb2fdb$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $f60571d72bbb2fdb$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $f60571d72bbb2fdb$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $f60571d72bbb2fdb$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $f60571d72bbb2fdb$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $f60571d72bbb2fdb$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $f60571d72bbb2fdb$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $f60571d72bbb2fdb$export$2f6319cf7d736c2a = "#E6EDFA";
var $f60571d72bbb2fdb$export$95126bc8884d6634 = "#DCE5F5";
var $f60571d72bbb2fdb$export$8338d8c35d44ff1 = "#CED9EB";
var $f60571d72bbb2fdb$export$5368d76ae4fbbda7 = "#B8C7E0";
var $f60571d72bbb2fdb$export$9f0a771d16ec8d36 = "#ABBBD6";
var $f60571d72bbb2fdb$export$abcf8c38338b4aa5 = "#9FB0CC";
var $f60571d72bbb2fdb$export$97e81faa16a182c7 = "#8C9CB8";
var $f60571d72bbb2fdb$export$bfe21c59123ecf33 = "#7988A3";
var $f60571d72bbb2fdb$export$ee82aa2ea6a1558 = "#67758F";
var $f60571d72bbb2fdb$export$682927c6ed76be02 = "#56637A";
var $f60571d72bbb2fdb$export$91fd9994c5be9757 = "#455166";
var $f60571d72bbb2fdb$export$d281fbfe3cff2df6 = "#3B475C";
var $f60571d72bbb2fdb$export$3902c91d8b98a753 = "#313D52";
var $f60571d72bbb2fdb$export$8e8133c1ba5845b5 = "#283447";
var $f60571d72bbb2fdb$export$33ff357f6620b39 = "#202B3D";
var $f60571d72bbb2fdb$export$633847cf062b69e0 = "#1B2638";
var $f60571d72bbb2fdb$export$9776a6e503bdbf76 = "#121A29";
var $f60571d72bbb2fdb$export$6c813d5160dff5db = "#0E1624";
var $f60571d72bbb2fdb$export$3d4f271a500072a = "#0D1424";
var $f60571d72bbb2fdb$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $f60571d72bbb2fdb$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $f60571d72bbb2fdb$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $f60571d72bbb2fdb$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $f60571d72bbb2fdb$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $f60571d72bbb2fdb$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $f60571d72bbb2fdb$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $f60571d72bbb2fdb$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $f60571d72bbb2fdb$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $f60571d72bbb2fdb$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $f60571d72bbb2fdb$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $f60571d72bbb2fdb$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $f60571d72bbb2fdb$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $f60571d72bbb2fdb$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $f60571d72bbb2fdb$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $f60571d72bbb2fdb$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $f60571d72bbb2fdb$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $f60571d72bbb2fdb$export$8ce1fd94bee2f412 = (0, $2D4tu.default)({
    light: "var(--ds-surface, ".concat($f60571d72bbb2fdb$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($f60571d72bbb2fdb$export$633847cf062b69e0, ")")
});
var $f60571d72bbb2fdb$export$b861914ea877b580 = (0, $2D4tu.default)({
    light: "var(--ds-background-selected, ".concat($f60571d72bbb2fdb$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($f60571d72bbb2fdb$export$8c13c2ee36917869, ")")
});
var $f60571d72bbb2fdb$export$3f1b020df94387af = (0, $2D4tu.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($f60571d72bbb2fdb$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($f60571d72bbb2fdb$export$d281fbfe3cff2df6, ")")
});
var $f60571d72bbb2fdb$export$c0183dbab98ca63e = (0, $2D4tu.default)({
    light: "var(--ds-surface-overlay, ".concat($f60571d72bbb2fdb$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($f60571d72bbb2fdb$export$8e8133c1ba5845b5, ")")
});
var $f60571d72bbb2fdb$export$6f093cfa640b7166 = (0, $2D4tu.default)({
    light: "var(--ds-text, ".concat($f60571d72bbb2fdb$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($f60571d72bbb2fdb$export$5368d76ae4fbbda7, ")")
});
var $f60571d72bbb2fdb$export$42f8e9c698766e7a = (0, $2D4tu.default)({
    light: "var(--ds-text, ".concat($f60571d72bbb2fdb$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($f60571d72bbb2fdb$export$5368d76ae4fbbda7, ")")
});
var $f60571d72bbb2fdb$export$c2d157ca1c34b6e3 = (0, $2D4tu.default)({
    light: "var(--ds-text-selected, ".concat($f60571d72bbb2fdb$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($f60571d72bbb2fdb$export$b3de0ae08da2ce64, ")")
});
var $f60571d72bbb2fdb$export$1905ba28d7cf066f = (0, $2D4tu.default)({
    light: "var(--ds-text-subtlest, ".concat($f60571d72bbb2fdb$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($f60571d72bbb2fdb$export$97e81faa16a182c7, ")")
});
var $f60571d72bbb2fdb$export$bd9002130d306d39 = (0, $2D4tu.default)({
    light: "var(--ds-text-subtlest, ".concat($f60571d72bbb2fdb$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($f60571d72bbb2fdb$export$bfe21c59123ecf33, ")")
});
var $f60571d72bbb2fdb$export$46e4a324ac90507f = (0, $2D4tu.default)({
    light: "var(--ds-text, ".concat($f60571d72bbb2fdb$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($f60571d72bbb2fdb$export$5368d76ae4fbbda7, ")")
});
var $f60571d72bbb2fdb$export$79f3f2b82beb0d36 = (0, $2D4tu.default)({
    light: "var(--ds-text-subtlest, ".concat($f60571d72bbb2fdb$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($f60571d72bbb2fdb$export$97e81faa16a182c7, ")")
});
var $f60571d72bbb2fdb$export$7bb0d5c671655cc4 = (0, $2D4tu.default)({
    light: $f60571d72bbb2fdb$export$9fdfb749e33cdf97,
    dark: $f60571d72bbb2fdb$export$8e8133c1ba5845b5
});
var $f60571d72bbb2fdb$export$9c30223ca0a664fb = (0, $2D4tu.default)({
    light: "var(--ds-link, ".concat($f60571d72bbb2fdb$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($f60571d72bbb2fdb$export$ecfc1dff386a3e7a, ")")
});
var $f60571d72bbb2fdb$export$7ed258b0728b004b = (0, $2D4tu.default)({
    light: "var(--ds-link-pressed, ".concat($f60571d72bbb2fdb$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($f60571d72bbb2fdb$export$215b7063051591f1, ")")
});
var $f60571d72bbb2fdb$export$dfa920d8decc8a59 = (0, $2D4tu.default)({
    light: "var(--ds-link-pressed, ".concat($f60571d72bbb2fdb$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($f60571d72bbb2fdb$export$ecfc1dff386a3e7a, ")")
});
var $f60571d72bbb2fdb$export$6069e6ad5c78f632 = (0, $2D4tu.default)({
    light: "var(--ds-border-focused, ".concat($f60571d72bbb2fdb$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($f60571d72bbb2fdb$export$215b7063051591f1, ")")
});
var $f60571d72bbb2fdb$export$9ad721cf3b3debe0 = (0, $2D4tu.default)({
    light: "var(--ds-background-brand-bold, ".concat($f60571d72bbb2fdb$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($f60571d72bbb2fdb$export$ecfc1dff386a3e7a, ")")
});
var $f60571d72bbb2fdb$export$2aa0182783e7e9de = (0, $2D4tu.default)({
    light: $f60571d72bbb2fdb$export$b3de0ae08da2ce64,
    dark: $f60571d72bbb2fdb$export$ecfc1dff386a3e7a
});
var $f60571d72bbb2fdb$export$8bf7dff220b82b4a = (0, $2D4tu.default)({
    light: $f60571d72bbb2fdb$export$9dc1ef0f3f48059b,
    dark: $f60571d72bbb2fdb$export$69cb3ca10c1e330e
});
var $f60571d72bbb2fdb$export$e13cce2a2d16a9d4 = (0, $2D4tu.default)({
    light: $f60571d72bbb2fdb$export$b48405b95304b5a1,
    dark: $f60571d72bbb2fdb$export$6011520a64d9a187
});
var $f60571d72bbb2fdb$export$a90204d1394caf30 = (0, $2D4tu.default)({
    light: $f60571d72bbb2fdb$export$4a7404f376229999,
    dark: $f60571d72bbb2fdb$export$4a7404f376229999
});
var $f60571d72bbb2fdb$export$594c5a8758200c32 = (0, $2D4tu.default)({
    light: $f60571d72bbb2fdb$export$c6930421db9fa514,
    dark: $f60571d72bbb2fdb$export$c6930421db9fa514
});
var $f60571d72bbb2fdb$export$955a2ebd2fb142ae = (0, $2D4tu.default)({
    light: $f60571d72bbb2fdb$export$940e1f69e873f202,
    dark: $f60571d72bbb2fdb$export$940e1f69e873f202
});
var $f60571d72bbb2fdb$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($f60571d72bbb2fdb$export$8d43898f60b96a82, ")");
};

});
parcelRegister("2D4tu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ea2b1d7dc835bee$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $4E2xI = parcelRequire("4E2xI");
// Unpack custom variants, and get correct value for the current theme
function $1ea2b1d7dc835bee$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $4E2xI.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $1ea2b1d7dc835bee$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $1ea2b1d7dc835bee$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $4E2xI.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("4E2xI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $361cded05ca80ec4$export$2e2bcd8739ae039; });

var $j1HAv = parcelRequire("j1HAv");
function $361cded05ca80ec4$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $j1HAv.CHANNEL) in props.theme) return props.theme[0, $j1HAv.CHANNEL];
        else if ("mode" in props.theme && (0, $j1HAv.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $j1HAv.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("j1HAv", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $dd9febef44a825de$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $dd9febef44a825de$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $dd9febef44a825de$export$6ba72c8346b4c57e; });

var $5bQIS = parcelRequire("5bQIS");

var $l7z3x = parcelRequire("l7z3x");
var $dd9febef44a825de$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $dd9febef44a825de$export$c93026a968943f95 = "light";
var $dd9febef44a825de$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $dd9febef44a825de$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $dd9febef44a825de$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $dd9febef44a825de$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $dd9febef44a825de$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $dd9febef44a825de$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $dd9febef44a825de$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $dd9febef44a825de$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $l7z3x.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dd9febef44a825de$export$6d8204c2cb2e06b8() / 4;
    (0, $5bQIS.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $dd9febef44a825de$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $dd9febef44a825de$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $dd9febef44a825de$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5bQIS.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $dd9febef44a825de$export$ba1d834b86d72a09 = $dd9febef44a825de$export$a1b3edb637fb4f35;
var $dd9febef44a825de$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $l7z3x.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $l7z3x.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $l7z3x.N30A), ")")
            }
        }
    };
};

});




parcelRegister("7zTco", function(module, exports) {

$parcel$export(module.exports, "Theme", function () { return $58469e9fbf4655d8$export$14faa19a0f3bbeb2; });

var $f4Jjb = parcelRequire("f4Jjb");
var $58469e9fbf4655d8$export$14faa19a0f3bbeb2 = (0, $f4Jjb.createTheme)(function(props) {
    return {
        container: {},
        bar: {},
        determinateBar: {},
        increasingBar: {},
        decreasingBar: {}
    };
});

});
parcelRegister("f4Jjb", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $af9a60089e6ab33e$export$25d302a5b900a763; });

var $esh0K = parcelRequire("esh0K");

var $iSvIT = parcelRequire("iSvIT");
var $af9a60089e6ab33e$var$_excluded = [
    "children"
];
function $af9a60089e6ab33e$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $iSvIT.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $iSvIT.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, $esh0K.default)(props, $af9a60089e6ab33e$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $iSvIT.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $iSvIT.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});
parcelRegister("esh0K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a860e03b33828130$export$2e2bcd8739ae039; });

var $imgJi = parcelRequire("imgJi");
function $a860e03b33828130$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $imgJi.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("imgJi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5d7423bcf4b1ab2$export$2e2bcd8739ae039; });
function $d5d7423bcf4b1ab2$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});






parcelRegister("fkFRk", function(module, exports) {

$parcel$export(module.exports, "StyledRelativePosition", function () { return $f5c73bb554fa53ae$export$11ed010ced21fd84; });
/* robots-view.styles.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $f5c73bb554fa53ae$export$11ed010ced21fd84 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});

});


parcelRegister("j5z4Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ead1242cd6536991$export$2e2bcd8739ae039; });
/* timeout-view.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $3FBn4 = parcelRequire("3FBn4");

var $2CpWf = parcelRequire("2CpWf");

var $dWbel = parcelRequire("dWbel");

var $1YDlO = parcelRequire("1YDlO");
const $ead1242cd6536991$var$MessageContainer = null;
const $ead1242cd6536991$var$image = "https://wac-cdn.atlassian.com/dam/jcr:504d3972-1e50-4ff8-8ba8-66520e0ade03/inbox.svg";
const $ead1242cd6536991$var$TimeoutView = ()=>{
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    (0, $iSvIT.useEffect)(()=>{
        // Confirming analyticsClient is initialized before firing event
        analyticsClient && createAnalyticsEvent({
            eventName: "timeoutPageViewed",
            eventComponent: "timeoutPage",
            event: "viewed"
        }).fire("signup");
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    // SLO "bad event" for redirect into product
    (0, $iSvIT.useEffect)(()=>{
        (0, $jgJpJ.ufoEventRedirectToProduct).failure({
            customData: {
                reactComponent: "TimeoutView",
                analyticsEvent: "timedOut",
                redirectFrom: "confirmationPage"
            }
        });
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $2CpWf.default), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                src: $ead1242cd6536991$var$image,
                height: "300px",
                alt: ""
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1YDlO.default), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_19pk7vkz _2hwx7vkz _otyr7vkz _18u07vkz _1e0c1txw _y3gn1h6o _2lx21bp4 _k48p1nn1 _1bah1h6o _1dyzqdok"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    id: "confirmation.TimeoutView.text",
                    defaultMessage: "<p>This is taking longer than expected.{br}\nDon't worry, we'll send you an email when your site is ready.</p>",
                    values: (0, $3FBn4.DEFAULT_VALUES)
                })
            })
        ]
    });
};
var $ead1242cd6536991$export$2e2bcd8739ae039 = $ead1242cd6536991$var$TimeoutView;

});

parcelRegister("5jx2H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3884957c16fd9116$export$2e2bcd8739ae039; });
/* tips-view.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $jgJpJ = parcelRequire("jgJpJ");

var $3FBn4 = parcelRequire("3FBn4");

var $dWbel = parcelRequire("dWbel");

var $2CpWf = parcelRequire("2CpWf");

var $aO3Hl = parcelRequire("aO3Hl");

var $2xIEu = parcelRequire("2xIEu");

var $1YDlO = parcelRequire("1YDlO");
parcelRequire("78RDu");
var $g0MKe = parcelRequire("g0MKe");
const $3884957c16fd9116$var$tipImages = {
    tips: "https://wac-cdn.atlassian.com/dam/jcr:db7f2385-5667-42ca-b5c7-0fea0d31de06/app-switcher-jira.svg",
    switcherJiraJsm: "https://wac-cdn.atlassian.com/misc-assets/webp-images/JiraJSMProvisioning.svg",
    switcherJsmJira: "https://wac-cdn.atlassian.com/misc-assets/webp-images/JSMJiraprovisioning.svg",
    switcherJiraConf: "https://wac-cdn.atlassian.com/misc-assets/webp-images/JiraConfluenceprovisioning.svg"
};
const $3884957c16fd9116$var$TipsView = ()=>{
    const { isClaiming: isClaiming, products: products } = (0, $aO3Hl.useSearchParameters)();
    let image;
    switch(products.join(",")){
        case `${(0, $2xIEu.ProductKey).JIRA_SOFTWARE},${(0, $2xIEu.ProductKey).JIRA_SERVICE_MANAGEMENT}`:
            image = $3884957c16fd9116$var$tipImages.switcherJiraJsm;
            break;
        case `${(0, $2xIEu.ProductKey).JIRA_SERVICE_MANAGEMENT},${(0, $2xIEu.ProductKey).JIRA_SOFTWARE}`:
            image = $3884957c16fd9116$var$tipImages.switcherJsmJira;
            break;
        case `${(0, $2xIEu.ProductKey).JIRA_SOFTWARE},${(0, $2xIEu.ProductKey).CONFLUENCE}`:
            image = $3884957c16fd9116$var$tipImages.switcherJiraConf;
            break;
        default:
            image = $3884957c16fd9116$var$tipImages.tips;
    }
    const type = (0, $aO3Hl.useTipsViewType)();
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    (0, $iSvIT.useEffect)(()=>{
        analyticsClient && createAnalyticsEvent({
            eventName: "tipsPageViewed",
            eventComponent: "tipsPage",
            event: "viewed"
        }).fire("signup");
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.UfoCustomTimingWrapper), {
        ufoEvent: (0, $jgJpJ.ufoEventRedirectToProduct),
        ufoCustomTimingKey: (0, $jgJpJ.UfoCustomTimingKey).TIPS_VIEW_DWELL_TIME,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $2CpWf.default), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx2vrvc _ca0qftgi _u5f3ftgi _n3tdftgi _19bvftgi _p12f1deq _1wyb7vkz _syaz7oqp _k48p1nn1 _1dyz8vfx _y3gn1e5h _ect4y94u _l5k1bfng _11eb1tcg _cg411bqd _17z4zwfg _d62sidpf _1d82nl7k _jw8hftgi"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _2lx21bp4 _1bah1h6o _19pkftgi _2hwxftgi _otyrftgi _18u0ftgi _1t5cglyw"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_19pkidpf _2hwxftgi _otyridpf _18u0ftgi _1ul9uuw1"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                                    src: image,
                                    height: "200px",
                                    alt: ""
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _2lx21bp4 _1bah1h6o _19pkftgi _2hwxftgi _otyrftgi _18u0ftgi _1t5cglyw"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_19pkidpf _2hwxftgi _otyridpf _18u0ftgi _1ul9uuw1"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        ...$3884957c16fd9116$var$TipsView.messages.tips,
                                        values: {
                                            isClaiming: isClaiming,
                                            type: type,
                                            h2: (...chunks)=>/*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                                    children: chunks
                                                }),
                                            menu: /*#__PURE__*/ (0, $loA2J.jsx)($3884957c16fd9116$var$MenuIcon, {}),
                                            ...(0, $3FBn4.DEFAULT_VALUES)
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $g0MKe.ProductTipList), {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $1YDlO.default), {})
            ]
        })
    });
};
var $3884957c16fd9116$export$2e2bcd8739ae039 = $3884957c16fd9116$var$TipsView;
const $3884957c16fd9116$var$tipsViewStyles = null;
const $3884957c16fd9116$var$columnStyles = null;
const $3884957c16fd9116$var$itemStyles = null;
$3884957c16fd9116$var$TipsView.messages = (0, $6x1qA.defineMessages)({
    tips: {
        id: "WacConfirmationPage.tips",
        defaultMessage: `{ isClaiming, select, 
            true {\n\n<p></p><h2>Explore all of your products</h2>\n\n}
            other {\n\n<p></p><h2>Explore all of your products</h2>\n\n} 
        } {type, select, 
            jira_bundle {Select the menu ({menu}) in the top left to switch between products. Create a project to explore your Jira products' features.} 
            jira_only_bundle {Create a project to explore your Jira products' features.} 
            other {Select the menu ({menu}) in the top left to switch between products.}
        }`
    }
});
const $3884957c16fd9116$var$MenuIcon = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        className: (0, $esG4f.default)([
            "_1e0c116y _s7n4nkob _85i51l7b"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
            height: "14",
            role: "presentation",
            viewBox: "0 0 24 24",
            width: "14",
            className: (0, $esG4f.default)([
                "_6rthidpf"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M4 5.01C4 4.451 4.443 4 5.01 4h1.98C7.549 4 8 4.443 8 5.01v1.98C8 7.549 7.557 8 6.99 8H5.01C4.451 8 4 7.557 4 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 13.549 7.557 14 6.99 14H5.01C4.451 14 4 13.557 4 12.99v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C14 7.549 13.557 8 12.99 8h-1.98C10.451 8 10 7.557 10 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C20 7.549 19.557 8 18.99 8h-1.98C16.451 8 16 7.557 16 6.99V5.01zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98C8 19.549 7.557 20 6.99 20H5.01C4.451 20 4 19.557 4 18.99v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98z",
                fill: "currentColor",
                fillRule: "evenodd"
            })
        })
    });
};

});
parcelRegister("78RDu", function(module, exports) {
$parcel$export(module.exports, "ProductTipList", function () { return (parcelRequire("g0MKe")).ProductTipList; });
parcelRequire("3bU3P");
parcelRequire("g0MKe");

});
parcelRegister("3bU3P", function(module, exports) {

$parcel$export(module.exports, "ProductTipListItem", function () { return $f00be2e51364f2ee$export$49837cbefb5a4538; });
/* product-list-item.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6x1qA = parcelRequire("6x1qA");
var $dFnC9 = parcelRequire("dFnC9");

var $3FBn4 = parcelRequire("3FBn4");

var $2xIEu = parcelRequire("2xIEu");
const $f00be2e51364f2ee$var$listItemStyle = null;
const $f00be2e51364f2ee$var$h3Style = null;
const $f00be2e51364f2ee$var$divStyle = null;
const $f00be2e51364f2ee$export$49837cbefb5a4538 = ({ productKey: productKey })=>{
    const productName = (0, $2xIEu.PRODUCT_NAMES)[productKey];
    const icuProductKey = productKey.replace("-", "_").replace(".", "_");
    return /*#__PURE__*/ (0, $loA2J.jsxs)("li", {
        className: (0, $esG4f.default)([
            "_19pkftgi _2hwxftgi _otyrftgi _18u0ftgi"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                className: (0, $esG4f.default)([
                    "_k48pbfng _1wyb1tcg _syaz1bqd _1dyznl7k _6rthftgi"
                ]),
                children: productName
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1wyb7vkz _syaz7oqp _k48p1nn1 _1dyz8vfx"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    ...$f00be2e51364f2ee$export$49837cbefb5a4538.messages.productDescription,
                    values: {
                        icuProductKey: icuProductKey,
                        ...(0, $3FBn4.DEFAULT_VALUES)
                    }
                })
            })
        ]
    });
};
$f00be2e51364f2ee$export$49837cbefb5a4538.messages = (0, $6x1qA.defineMessages)({
    productDescription: {
        id: "WacConfirmationPage.productDescription",
        defaultMessage: `{ icuProductKey, select, 
          jira_ondemand {Keep track of projects and issues}
          greenhopper_jira_ondemand {Work using agile methods like Scrum and Kanban} 
          jira_software_ondemand {Collaborate and deliver projects as one team with the #1 project management tool.} 
          com_atlassian_servicedesk_ondemand {Manage queues and SLAs for IT and business teams} 
          jira_servicedesk_ondemand {Collaborate at high-velocity, respond to business changes and deliver great customer and employee service experiences fast.} 
          jira_incident_manager_ondemand {One place to respond, resolve, and learn from every incident} 
          com_radiantminds_roadmaps_jira_ondemand {Know when you can deliver, react to change and keep everyone on the same page} 
          bonfire_jira_ondemand {Rapid bug reporting for exploratory and session-based testing} 
          confluence_ondemand {Organize your work, create documents, and discuss everything in one place.} 
          com_atlassian_confluence_plugins_confluence_questions_ondemand {Capture, learn from, and retain the collective knowledge of your organization as it grows} 
          team_calendars_confluence_ondemand {Your team's single source of truth for managing team leave, tracking Jira projects, and planning events}
          other {{br}\n}
        }`
    }
});

});

parcelRegister("g0MKe", function(module, exports) {

$parcel$export(module.exports, "ProductTipList", function () { return $39a96426740023da$export$8dde503b8d37410e; });
/* product-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $aO3Hl = parcelRequire("aO3Hl");

var $3bU3P = parcelRequire("3bU3P");
const $39a96426740023da$var$productTipListStyle = null;
const $39a96426740023da$export$8dde503b8d37410e = ()=>{
    const productKeys = (0, $aO3Hl.useProductKeys)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
        className: (0, $esG4f.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1h9didpf"
        ]),
        children: productKeys.map((productKey)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $3bU3P.ProductTipListItem), {
                productKey: productKey
            }, productKey))
    });
};

});



parcelRegister("7pLpT", function(module, exports) {

$parcel$export(module.exports, "LegacyConfirmationPageLayout", function () { return $e9a8da20d3ce8a72$export$d08e3e27767fd98e; });
$parcel$export(module.exports, "default", function () { return $e9a8da20d3ce8a72$export$2e2bcd8739ae039; });
/* view-switch.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");

var $aO3Hl = parcelRequire("aO3Hl");

var $gd3el = parcelRequire("gd3el");

var $378NJ = parcelRequire("378NJ");

var $cIEaV = parcelRequire("cIEaV");

var $gG3lv = parcelRequire("gG3lv");

var $j5z4Z = parcelRequire("j5z4Z");

var $5jx2H = parcelRequire("5jx2H");

var $bFFnD = parcelRequire("bFFnD");

var $hHiuZ = parcelRequire("hHiuZ");
const $e9a8da20d3ce8a72$var$ContainerStyle = null;
const $e9a8da20d3ce8a72$var$InnerStyle = null;
const $e9a8da20d3ce8a72$export$d08e3e27767fd98e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _4cvr1h6o _1wpz1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_4cvr1fhb _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _ca0q1wto _u5f31wto _n3td1wto _19bv1wto _k48p4jg8 _ect4bzd7 _1pfh1ul9"
            ]),
            style: {
                "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
            },
            children: children
        })
    });
}; /* istanbul ignore next */ 
const $e9a8da20d3ce8a72$var$ViewSwitch = ()=>{
    let confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gG3lv.default), {});
    const { createCloudStatus: createCloudStatus, startPerceivedProvisioningTimer: startPerceivedProvisioningTimer } = (0, $aO3Hl.useCloudStatus)();
    const { deferRedirectView: deferRedirectView } = (0, $aO3Hl.useCloudStatusRedirection)();
    const confirmationPageType = (0, $aO3Hl.useConfirmationPageType)(createCloudStatus, deferRedirectView);
    switch(confirmationPageType){
        case "user-segmentation":
            /*
          Products that can view the purple user segmentation.
          jira-servicedesk.ondemand => JSM
          The purple user seg view will be shown to users who have not viewed it with the past 365 days. 
      */ confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)((0, $hHiuZ.default), {});
            break;
        case "jira-user-segmentation":
            // view for JSW/Jira N2N users only
            confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)((0, $bFFnD.default), {});
            break;
        case "jira-template-selection":
            confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)((0, $cIEaV.default), {});
            break;
        case "tips":
            confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)((0, $5jx2H.default), {});
            break;
        case "timeout":
            confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)((0, $j5z4Z.default), {});
            break;
        case "error":
            confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gd3el.default), {});
            break;
        case "jira-animated-provisioning-screen":
            startPerceivedProvisioningTimer();
            confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)((0, $378NJ.JiraAnimatedProvisioningScreen), {});
            break;
        case "redirect":
            startPerceivedProvisioningTimer();
            confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                id: "redirectToProductContainer"
            });
            break;
        default:
            startPerceivedProvisioningTimer();
            confirmationPageView = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gG3lv.default), {});
    }
    // do not wrap legacy layout around the jira template selection
    if (confirmationPageType === "jira-template-selection" || confirmationPageType === "jira-user-segmentation") return confirmationPageView;
     // TODO: Confirm if each child component needs this confirmation page layout.
    return /*#__PURE__*/ (0, $loA2J.jsx)($e9a8da20d3ce8a72$export$d08e3e27767fd98e, {
        children: confirmationPageView
    });
};
var $e9a8da20d3ce8a72$export$2e2bcd8739ae039 = $e9a8da20d3ce8a72$var$ViewSwitch;

});
parcelRegister("378NJ", function(module, exports) {

$parcel$export(module.exports, "JiraAnimatedProvisioningScreen", function () { return $111240d795db44a8$export$dac934cd340f253b; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $iMdoL = parcelRequire("iMdoL");

var $1LPIk = parcelRequire("1LPIk");

var $aO3Hl = parcelRequire("aO3Hl");

var $dkYGl = parcelRequire("dkYGl");

var $9D5Aa = parcelRequire("9D5Aa");
const $111240d795db44a8$export$dac934cd340f253b = ({ redirectOnAnimationComplete: redirectOnAnimationComplete = true })=>{
    const { products: products, edition: edition } = (0, $aO3Hl.useSearchParameters)();
    const productKey = (0, $dkYGl.getPrimaryProduct)(products);
    const { profile: profile } = (0, $iMdoL.useUserContext)();
    const userType = profile.cohorts?.userType;
    const domainType = profile.cohorts?.domainType;
    const companyType = profile.cohorts?.companyType;
    const [waitForAttributes, setWaitForAttributes] = (0, $iSvIT.useState)(true);
    const [dataFoundationAttributes, setDataFoundationAttributes] = (0, $iSvIT.useState)({
        productKey: productKey,
        edition: edition
    });
    (0, $iSvIT.useEffect)(()=>{
        if (!profile.requestInProgress) {
            setDataFoundationAttributes((prevAttributes)=>({
                    ...prevAttributes,
                    userType: userType,
                    domainType: domainType,
                    companyType: companyType
                }));
            setWaitForAttributes(false);
        }
    }, [
        profile.requestInProgress,
        userType,
        domainType,
        companyType
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1LPIk.DataFoundationsWrapper), {
        dataFoundationsEventOption: "ProvisioningScreenViewed",
        attributes: dataFoundationAttributes,
        waitForAttributes: waitForAttributes,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9D5Aa.ControlAnimation), {
            redirectOnAnimationComplete: redirectOnAnimationComplete
        })
    });
};

});
parcelRegister("9D5Aa", function(module, exports) {

$parcel$export(module.exports, "ControlAnimation", function () { return $9d2db1c2cb5b4292$export$22264c73c1d27300; });
/* control-animation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $g9kzu = parcelRequire("g9kzu");

var $bLpA6 = parcelRequire("bLpA6");

var $9gh2a = parcelRequire("9gh2a");

var $krd0Q = parcelRequire("krd0Q");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("d2NVK");
var $kR2lN = parcelRequire("kR2lN");

var $aO3Hl = parcelRequire("aO3Hl");

var $OOa63 = parcelRequire("OOa63");

var $9iWJ8 = parcelRequire("9iWJ8");

var $d1moV = parcelRequire("d1moV");
parcelRequire("26ozz");
var $eOJAH = parcelRequire("eOJAH");











const $9d2db1c2cb5b4292$export$22264c73c1d27300 = ({ redirectOnAnimationComplete: redirectOnAnimationComplete = true })=>{
    const [currentIndex, setCurrentIndex] = (0, $iSvIT.useState)(0);
    const [loop, setLoop] = (0, $iSvIT.useState)(false);
    const [topOrTail, setTopOrTail] = (0, $iSvIT.useState)("top");
    const [override, setOverride] = (0, $iSvIT.useState)(false);
    const redirecting = (0, $iSvIT.useRef)(false);
    const [loopAnimation, setLoopAnimation] = (0, $iSvIT.useState)(null);
    const [tailAnimations, setTailAnimations] = (0, $iSvIT.useState)([]);
    const [topAnimations, setTopAnimations] = (0, $iSvIT.useState)([]);
    const provisioningComplete = (0, $iSvIT.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { createCloudStatus: createCloudStatus, perceivedProvisioningStartTime: perceivedProvisioningStartTime } = (0, $aO3Hl.useCloudStatus)();
    const { redirectUrl: redirectUrl, deferRedirectView: deferRedirectView, setDeferRedirectView: setDeferRedirectView, resolveBlockingRedirectPromises: resolveBlockingRedirectPromises } = (0, $aO3Hl.useCloudStatusRedirection)();
    const { products: products, signupId: signupId } = (0, $aO3Hl.useSearchParameters)();
    const productKey = products.length > 0 ? products[0] : undefined;
    const jiraWacDelayRedirect = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).jiraWacDelayRedirect);
    const redirectCallback = (0, $iSvIT.useCallback)(async ()=>{
        createAnalyticsEvent({
            eventType: "ui",
            action: "succeeded",
            actionSubject: "provisioning",
            actionSubjectId: "jiraAnimatedProvisioningScreen",
            source: "/ondemand/signup/confirmation",
            attributes: {
                atlasId: "ATLAS-56326"
            }
        }).fire();
        redirecting.current = true;
        createAnalyticsEvent({
            eventName: "redirectedToProduct",
            eventComponent: "confirmationPage",
            event: "redirected",
            eventType: "ui",
            action: "redirected"
        }).fire();
        (0, $OOa63.trackPerceivedProvisioningEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            productKey: productKey,
            finalProvisioningScreen: "jira-animated-provisioning-screen",
            startTimeSeconds: perceivedProvisioningStartTime,
            signupId: signupId
        }); // SLO "good event" for redirect into product
        (0, $jgJpJ.ufoEventRedirectToProduct).success({
            customData: {
                reactComponent: "JiraAnimatedProvisioningScreen",
                analyticsEvent: "redirected",
                redirectFrom: "confirmationPage",
                finalProvisioningScreen: "jira-animated-provisioning-screen"
            }
        });
        await resolveBlockingRedirectPromises();
        if (jiraWacDelayRedirect.type === "enrolled" && jiraWacDelayRedirect.value > 0) setTimeout(()=>{
            window.location.assign(redirectUrl);
        }, jiraWacDelayRedirect.value);
        else window.location.assign(redirectUrl);
    }, [
        createAnalyticsEvent,
        perceivedProvisioningStartTime,
        productKey,
        redirectUrl,
        signupId
    ]);
    const eventListener = [
        {
            eventName: "loopComplete",
            callback: ()=>{
                const lastAnimation = tailAnimations.length - 1;
                if (provisioningComplete.current) {
                    if (loop) {
                        setLoop(false);
                        setCurrentIndex(lastAnimation);
                        setTopOrTail("tail");
                    }
                }
            }
        },
        {
            eventName: "complete",
            callback: ()=>{
                const lastAnimation = tailAnimations.length - 1;
                if (provisioningComplete.current) {
                    // Stop playing animation when redirecting
                    if (redirecting.current) return;
                     // Redirect after final tail animation completes
                    if (topOrTail === "tail") {
                        if (redirectOnAnimationComplete) redirectCallback();
                    } else setTopOrTail("tail");
                } else if (currentIndex < lastAnimation) setCurrentIndex(currentIndex + 1);
                else if (currentIndex === lastAnimation) {
                    //loop on finishing up
                    setLoop(true);
                    createAnalyticsEvent({
                        eventType: "ui",
                        action: "started",
                        actionSubject: "animation",
                        actionSubjectId: "jiraAnimatedProvisioningScreenLoopAnimation",
                        source: "/ondemand/signup/confirmation",
                        attributes: {
                            atlasId: "ATLAS-56326"
                        }
                    }).fire();
                }
            }
        }
    ];
    const getAnimation = ()=>{
        if (loop) return loopAnimation;
        else if (topOrTail === "top") return topAnimations[currentIndex];
        else return tailAnimations[currentIndex];
    };
    const boldSpan = (child)=>/*#__PURE__*/ (0, $loA2J.jsx)("span", {
            className: (0, $esG4f.default)([
                "_k48pni7l"
            ]),
            children: child
        });
    const text = [
        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "jira.provisioning.preparing-workspace",
                defaultMessage: `Preparing your <tag>workspace</tag>`,
                values: {
                    tag: boldSpan
                }
            })
        }, "0"),
        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "jira.provisioning.building-timeline",
                defaultMessage: `Building your <tag>timeline</tag>...`,
                values: {
                    tag: boldSpan
                }
            })
        }, "1"),
        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "jira.provisioning.creating-board",
                defaultMessage: `Creating your <tag>board</tag>...`,
                values: {
                    tag: boldSpan
                }
            })
        }, "2"),
        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "jira.provisioning.setting-reports",
                defaultMessage: `Setting up your <tag>reports</tag>...`,
                values: {
                    tag: boldSpan
                }
            })
        }, "3"),
        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                id: "jira.provisioning.finishing-up",
                defaultMessage: `Finishing up ...`
            })
        }, "4")
    ];
    const animationsLoaded = loopAnimation && tailAnimations && topAnimations;
    (0, $iSvIT.useEffect)(()=>{
        const runSetAnimationMap = async ()=>{
            let animations;
            try {
                animations = await Promise.all([
                    (parcelRequire("gT0aR")),
                    (parcelRequire("cWOLL")),
                    (parcelRequire("6p39E")),
                    (parcelRequire("1RtZ5")),
                    (parcelRequire("j7iO9")),
                    (parcelRequire("1CYPq")),
                    (parcelRequire("lHYBA")),
                    (parcelRequire("kbBGK")),
                    (parcelRequire("ZZFqT")),
                    (parcelRequire("e43PY")),
                    (parcelRequire("79QSH"))
                ]);
            } catch (e) {
                console.error(e);
            }
            if (animations) {
                const [tail01, top01, tail02, top02, tail03, top03, tail04, top04, top05, loopAnimation, tail05] = animations;
                const topAnimations = [
                    top01,
                    top02,
                    top03,
                    top04,
                    top05
                ];
                const tailAnimations = [
                    tail01,
                    tail02,
                    tail03,
                    tail04,
                    tail05
                ];
                setTopAnimations(topAnimations);
                setTailAnimations(tailAnimations);
                setLoopAnimation(loopAnimation);
            }
        };
        runSetAnimationMap();
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        if (!redirectOnAnimationComplete) return;
        if (createCloudStatus === "success" || override) {
            provisioningComplete.current = true; // if tab inactive react-lottie 'complete' event doesn't fire
            // Redirect if tab is inactive
            if (document.hidden) redirectCallback();
            setLoop(false);
            setOverride(false);
        }
    }, [
        redirectOnAnimationComplete,
        createCloudStatus,
        override,
        redirectCallback,
        createAnalyticsEvent,
        perceivedProvisioningStartTime,
        productKey
    ]); // Prevent use-cloud-status.tsx from immediately redirecting when provisioning is finished.
    (0, $iSvIT.useEffect)(()=>{
        if (!deferRedirectView) {
            if (setDeferRedirectView) setDeferRedirectView("jira-animated-provisioning-screen");
        }
    }); // Initial analytics events
    (0, $iSvIT.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: "screen",
            name: "jiraAnimatedProvisioningScreen",
            attributes: {
                atlasId: "ATLAS-56326"
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const rotatingMessages = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_syazkrwu _y3gn1h6o _1wyb7vkz _6rthl52n"
        ]),
        children: topOrTail === "tail" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            id: "jira.provisioning.all-set",
            defaultMessage: `You're all set`
        }) : text[currentIndex]
    });
    const animations = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            animationsLoaded && /*#__PURE__*/ (0, $loA2J.jsx)((0, $d1moV.LottieAnimation), {
                options: {
                    loop: loop,
                    autoplay: true,
                    animationData: getAnimation(),
                    rendererSettings: {
                        preserveAspectRatio: "xMidYMid slice"
                    }
                },
                eventListener: eventListener
            }),
            !animationsLoaded && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3iypwq"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
                    size: "large"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.UfoCustomTimingWrapper), {
        ufoEvent: (0, $jgJpJ.ufoEventRedirectToProduct),
        ufoCustomTimingKey: (0, $jgJpJ.UfoCustomTimingKey).JIRA_ANIMATED_PROVISIONING_DWELL_TIME,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kR2lN.DwellTimeWrapper), {
            eventData: {
                action: "dwelled",
                actionSubject: "screen",
                actionSubjectId: "jiraAnimatedProvisioningScreen",
                source: "/ondemand/signup/confirmation",
                attributes: {
                    atlasId: "ATLAS-56326"
                }
            },
            initialPollInterval: 5000,
            idleTimeout: 120000,
            nextPollIntervalCallback: (x)=>x + 5000,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krd0Q.JiraBackground), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eOJAH.ModalOverlay), {
                    logo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bLpA6.JiraLogo), {
                        appearance: "brand"
                    }),
                    children: [
                        rotatingMessages,
                        animations
                    ]
                })
            })
        })
    });
};
const $9d2db1c2cb5b4292$var$textStyle = null;
const $9d2db1c2cb5b4292$var$boldStyle = null;
const $9d2db1c2cb5b4292$var$spinnerContainer = null;

});
parcelRegister("krd0Q", function(module, exports) {

$parcel$export(module.exports, "JiraBackground", function () { return $ee106c472efb9660$export$2ccb200c5de09b24; });

var $iSvIT = parcelRequire("iSvIT");

var $lJ6Pg = parcelRequire("lJ6Pg");

var $l4eiJ = parcelRequire("l4eiJ");

var $7B0iM = parcelRequire("7B0iM");

var $crk1J = parcelRequire("crk1J");
var $ee106c472efb9660$export$2ccb200c5de09b24 = function JiraBackground(_ref) {
    var children = _ref.children;
    var isDarkMode = (0, $lJ6Pg.default)().colorMode === "dark";
    var Background = isDarkMode ? (0, $l4eiJ.JiraDarkTheme) : (0, $7B0iM.JiraLightTheme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $crk1J.DesktopOnlyBackground), {
        background: Background
    }, children);
};

});
parcelRegister("lJ6Pg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd13186690631e77$export$2e2bcd8739ae039; });

var $lRb0O = parcelRequire("lRb0O");

var $ktzzK = parcelRequire("ktzzK");

var $9wtPh = parcelRequire("9wtPh");

var $aDnGA = parcelRequire("aDnGA");
function $fd13186690631e77$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fd13186690631e77$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fd13186690631e77$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lRb0O.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fd13186690631e77$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fd13186690631e77$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $9wtPh.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $fd13186690631e77$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $ktzzK.COLOR_MODE_ATTRIBUTE)) || "";
    var theme = element.getAttribute((0, $ktzzK.THEME_DATA_ATTRIBUTE)) || "";
    return $fd13186690631e77$var$_objectSpread($fd13186690631e77$var$_objectSpread({}, (0, $aDnGA.themeStringToObject)(theme)), $fd13186690631e77$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $fd13186690631e77$export$2e2bcd8739ae039 = $fd13186690631e77$var$getGlobalTheme;

});
parcelRegister("lRb0O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe9716f6174326b9$export$2e2bcd8739ae039; });

var $llC5m = parcelRequire("llC5m");
function $fe9716f6174326b9$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $llC5m.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("llC5m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8a91a21ff8f8338$export$2e2bcd8739ae039; });

var $i3sPM = parcelRequire("i3sPM");

var $glpZh = parcelRequire("glpZh");
function $f8a91a21ff8f8338$export$2e2bcd8739ae039(t) {
    var i = (0, $glpZh.default)(t, "string");
    return "symbol" == (0, $i3sPM.default)(i) ? i : i + "";
}

});
parcelRegister("i3sPM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d24edfa82403369b$export$2e2bcd8739ae039; });
function $d24edfa82403369b$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $d24edfa82403369b$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d24edfa82403369b$export$2e2bcd8739ae039(o);
}

});

parcelRegister("glpZh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be62c411c5a8b853$export$2e2bcd8739ae039; });

var $i3sPM = parcelRequire("i3sPM");
function $be62c411c5a8b853$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $i3sPM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $i3sPM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("ktzzK", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $ee821ca246a72959$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $ee821ca246a72959$export$a00eac3f8684bcd0; });
var $ee821ca246a72959$export$4ef52930e33717cd = "data-theme";
var $ee821ca246a72959$export$a00eac3f8684bcd0 = "data-color-mode";
var $ee821ca246a72959$export$2112803007239c61 = "data-contrast-mode";
var $ee821ca246a72959$export$352e418ed5b6193a = "data-custom-theme";
var $ee821ca246a72959$export$6f0c6fb8c80fcc92 = "ds";
var $ee821ca246a72959$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $ee821ca246a72959$export$dddac1532e822863 = "--".concat($ee821ca246a72959$export$6f0c6fb8c80fcc92, "-token-not-found");
var $ee821ca246a72959$export$9d7b58831ae93caa = "--".concat($ee821ca246a72959$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("9wtPh", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $6eee3d0e02407e0e$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $6eee3d0e02407e0e$export$7d43e72a58e3283f; });

var $jxLBU = parcelRequire("jxLBU");
var $6eee3d0e02407e0e$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
/**
 * Contrast preferences: The system contrast preference
 */ var $6eee3d0e02407e0e$var$themeContrastModes = [
    "more",
    "no-preference",
    "auto"
];
var $6eee3d0e02407e0e$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "light-brand-refresh",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "dark-brand-refresh",
    "legacy-light",
    "legacy-dark",
    "spacing",
    "shape",
    "typography-adg3",
    "typography-modernized",
    "typography-refreshed"
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $6eee3d0e02407e0e$var$themeOverrideIds = [];
var $6eee3d0e02407e0e$export$92ba366331403db2 = [].concat($6eee3d0e02407e0e$export$7d43e72a58e3283f, $6eee3d0e02407e0e$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $6eee3d0e02407e0e$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-legacy-light": {
        id: "legacy-light",
        displayName: "Light Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-legacy-dark": {
        id: "legacy-dark",
        displayName: "Dark Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography-adg3": {
        id: "typography-adg3",
        displayName: "ADG3 Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Atlassian Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-typography-modernized": {
        id: "typography-modernized",
        displayName: "Atlassian Typography (Modernized)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-typography-refreshed": {
        id: "typography-refreshed",
        displayName: "Atlassian Typography (Refreshed)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-light-brand-refresh": {
        id: "light-brand-refresh",
        displayName: "Light theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-dark-brand-refresh": {
        id: "dark-brand-refresh",
        displayName: "Dark theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    }
};
var $6eee3d0e02407e0e$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: undefined,
    spacing: "spacing",
    typography: function typography() {
        if ((0, $jxLBU.fg)("platform-default-typography-modernized")) return "typography-modernized";
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $6eee3d0e02407e0e$export$2e2bcd8739ae039 = $6eee3d0e02407e0e$var$themeConfig;

});

parcelRegister("aDnGA", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", function () { return $7bdfeb7287d3c582$export$f19b488f7c0547ee; });

var $i3sPM = parcelRequire("i3sPM");

var $lEgX3 = parcelRequire("lEgX3");

var $9wtPh = parcelRequire("9wtPh");
var $7bdfeb7287d3c582$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape"
];
var $7bdfeb7287d3c582$var$customThemeOptions = "UNSAFE_themeOptions";
var $7bdfeb7287d3c582$var$isThemeKind = function isThemeKind(themeKind) {
    return $7bdfeb7287d3c582$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $7bdfeb7287d3c582$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $9wtPh.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $7bdfeb7287d3c582$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $7bdfeb7287d3c582$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ").map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $lEgX3.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $7bdfeb7287d3c582$var$isColorMode(id)) themeObject[kind] = id;
        if ($7bdfeb7287d3c582$var$isThemeKind(kind) && $7bdfeb7287d3c582$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $7bdfeb7287d3c582$var$customThemeOptions) try {
            themeObject[$7bdfeb7287d3c582$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $7bdfeb7287d3c582$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, $lEgX3.default)(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $7bdfeb7287d3c582$var$isColorMode(id) || // custom theme state
        kind === $7bdfeb7287d3c582$var$customThemeOptions && (0, $i3sPM.default)(id) === "object" || // other theme states
        $7bdfeb7287d3c582$var$isThemeKind(kind) && typeof id === "string" && $7bdfeb7287d3c582$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, $i3sPM.default)(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};

});
parcelRegister("lEgX3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0411338aaf514ccc$export$2e2bcd8739ae039; });

var $h49GT = parcelRequire("h49GT");

var $gexeu = parcelRequire("gexeu");

var $f8NRF = parcelRequire("f8NRF");

var $6RCub = parcelRequire("6RCub");
function $0411338aaf514ccc$export$2e2bcd8739ae039(r, e) {
    return (0, $h49GT.default)(r) || (0, $gexeu.default)(r, e) || (0, $f8NRF.default)(r, e) || (0, $6RCub.default)();
}

});
parcelRegister("h49GT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6ca53c51c97d1cb$export$2e2bcd8739ae039; });
function $c6ca53c51c97d1cb$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("gexeu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd17bb7979460eb3$export$2e2bcd8739ae039; });
function $bd17bb7979460eb3$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("f8NRF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b05e4871dde1f69a$export$2e2bcd8739ae039; });

var $5HCHH = parcelRequire("5HCHH");
function $b05e4871dde1f69a$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5HCHH.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5HCHH.default)(r, a) : void 0;
    }
}

});
parcelRegister("5HCHH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $426efdab308ef4ec$export$2e2bcd8739ae039; });
function $426efdab308ef4ec$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("6RCub", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ff58bc78c3a9ee4$export$2e2bcd8739ae039; });
function $4ff58bc78c3a9ee4$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("l4eiJ", function(module, exports) {

$parcel$export(module.exports, "JiraDarkTheme", function () { return $f5651098b67a622d$export$24eb0206407d5744; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $iSvIT = parcelRequire("iSvIT");

var $1hoRn = parcelRequire("1hoRn");
var $9u3VS = parcelRequire("9u3VS");

var $lPRos = parcelRequire("lPRos");

var $86zeL = parcelRequire("86zeL");

var $4XzXM = parcelRequire("4XzXM");

var $gxyqS = parcelRequire("gxyqS");

var $9zWUh = parcelRequire("9zWUh");

var $jiBRo = parcelRequire("jiBRo");

var $3GfsQ = parcelRequire("3GfsQ");

var $aFJfj = parcelRequire("aFJfj");
var $f5651098b67a622d$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q",
    content: "_19bvxy5q"
};
var $f5651098b67a622d$export$24eb0206407d5744 = function JiraDarkTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $86zeL.Background), {
        testId: "testId-jira-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4XzXM.TopNav), {
        product: (0, $lPRos.Products).JIRA
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1hoRn.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $aFJfj.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $9u3VS.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1hoRn.default), {
        xcss: $f5651098b67a622d$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $9zWUh.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $gxyqS.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1hoRn.default), {
        xcss: $f5651098b67a622d$var$styles.content,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $jiBRo.Content), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $3GfsQ.DetailsPanel), null)))));
};

});
parcelRegister("1hoRn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0eeaa9a901f52e6e$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $lda32 = parcelRequire("lda32");

var $gmylQ = parcelRequire("gmylQ");

var $eoVaF = parcelRequire("eoVaF");
var $0eeaa9a901f52e6e$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $0eeaa9a901f52e6e$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        className: (0, $lda32.default)([
            $0eeaa9a901f52e6e$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $0eeaa9a901f52e6e$var$Inline = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? /*#__PURE__*/ $iSvIT.createElement($0eeaa9a901f52e6e$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $iSvIT.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $iSvIT.createElement((0, $iSvIT.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $iSvIT.createElement((0, $eoVaF.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: (0, $gmylQ.cx)(grow === "hug" && $0eeaa9a901f52e6e$var$styles.hug, grow === "fill" && $0eeaa9a901f52e6e$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$0eeaa9a901f52e6e$var$Inline.displayName = "Inline";
var $0eeaa9a901f52e6e$export$2e2bcd8739ae039 = $0eeaa9a901f52e6e$var$Inline;

});
parcelRegister("lda32", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7129b313d116d02$export$2e2bcd8739ae039; });
const $f7129b313d116d02$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $f7129b313d116d02$var$ATOMIC_GROUP_LENGTH = 5;
function $f7129b313d116d02$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $f7129b313d116d02$var$UNDERSCORE_UNICODE ? $f7129b313d116d02$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("eoVaF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7bfa792637450ab$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $lda32 = parcelRequire("lda32");
var $a7bfa792637450ab$var$rowGapMap = {
    "space.0": "_1p57ze3t",
    "space.025": "_1p57v77o",
    "space.050": "_1p571b66",
    "space.075": "_1p5712x7",
    "space.100": "_1p57u2gc",
    "space.150": "_1p57utpp",
    "space.200": "_1p57pxbi",
    "space.250": "_1p57v47k",
    "space.300": "_1p571ejb",
    "space.400": "_1p57xy5q",
    "space.500": "_1p571jfw",
    "space.600": "_1p57oahv",
    "space.800": "_1p57xncg",
    "space.1000": "_1p571epz"
};
var $a7bfa792637450ab$var$columnGapMap = {
    "space.0": "_gy1pze3t",
    "space.025": "_gy1pv77o",
    "space.050": "_gy1p1b66",
    "space.075": "_gy1p12x7",
    "space.100": "_gy1pu2gc",
    "space.150": "_gy1putpp",
    "space.200": "_gy1ppxbi",
    "space.250": "_gy1pv47k",
    "space.300": "_gy1p1ejb",
    "space.400": "_gy1pxy5q",
    "space.500": "_gy1p1jfw",
    "space.600": "_gy1poahv",
    "space.800": "_gy1pxncg",
    "space.1000": "_gy1p1epz"
};
var $a7bfa792637450ab$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    "space-between": "_1bah1yb4",
    "space-around": "_1bah1b1v",
    "space-evenly": "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $a7bfa792637450ab$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $a7bfa792637450ab$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $a7bfa792637450ab$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $a7bfa792637450ab$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $a7bfa792637450ab$var$Flex = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    return /*#__PURE__*/ $iSvIT.createElement(Component, {
        role: role,
        className: (0, $lda32.default)([
            $a7bfa792637450ab$var$styles.root,
            gap && $a7bfa792637450ab$var$columnGapMap[gap],
            columnGap && $a7bfa792637450ab$var$columnGapMap[columnGap],
            gap && $a7bfa792637450ab$var$rowGapMap[gap],
            rowGap && $a7bfa792637450ab$var$rowGapMap[rowGap],
            alignItems && $a7bfa792637450ab$var$alignItemsMap[alignItems],
            direction && $a7bfa792637450ab$var$flexDirectionMap[direction],
            justifyContent && $a7bfa792637450ab$var$justifyContentMap[justifyContent],
            wrap && $a7bfa792637450ab$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$a7bfa792637450ab$var$Flex.displayName = "Flex";
var $a7bfa792637450ab$export$2e2bcd8739ae039 = $a7bfa792637450ab$var$Flex;

});


parcelRegister("9u3VS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e79f749319abece$export$2e2bcd8739ae039; });
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $iSvIT = parcelRequire("iSvIT");


var $gmylQ = parcelRequire("gmylQ");

var $eoVaF = parcelRequire("eoVaF");
var $6e79f749319abece$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $6e79f749319abece$var$Stack = /*#__PURE__*/ (0, $iSvIT.memo)(/*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    return /*#__PURE__*/ $iSvIT.createElement((0, $eoVaF.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $gmylQ.cx)(grow === "hug" && $6e79f749319abece$var$styles.hug, grow === "fill" && $6e79f749319abece$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$6e79f749319abece$var$Stack.displayName = "Stack";
var $6e79f749319abece$export$2e2bcd8739ae039 = $6e79f749319abece$var$Stack;

});

parcelRegister("lPRos", function(module, exports) {

$parcel$export(module.exports, "Products", function () { return $fe57c73ae99041a6$export$92e44ea1079b9ec6; });
var $fe57c73ae99041a6$export$92e44ea1079b9ec6 = {
    JIRA: "jira",
    CONFLUENCE: "confluence"
};

});

parcelRegister("86zeL", function(module, exports) {

$parcel$export(module.exports, "Background", function () { return $5e6a37a251e0a798$export$668799e4797757a8; });
/* background.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $iSvIT = parcelRequire("iSvIT");

var $9u3VS = parcelRequire("9u3VS");
var $5e6a37a251e0a798$var$styles = {
    background: "_bfhkvuon _1tke1osq"
};
var $5e6a37a251e0a798$export$668799e4797757a8 = function Background(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $9u3VS.default), {
        xcss: $5e6a37a251e0a798$var$styles.background,
        testId: testId
    }, children);
};

});

parcelRegister("4XzXM", function(module, exports) {

$parcel$export(module.exports, "TopNav", function () { return $39c891a43a0b123b$export$41d0d88a6b0e456f; });
/* top-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $lRb0O = parcelRequire("lRb0O");


var $iSvIT = parcelRequire("iSvIT");

var $5UXWe = parcelRequire("5UXWe");

var $7wC8x = parcelRequire("7wC8x");

var $hibY9 = parcelRequire("hibY9");

var $fTeel = parcelRequire("fTeel");

var $3xho8 = parcelRequire("3xho8");

var $hV0NN = parcelRequire("hV0NN");

var $hUFAz = parcelRequire("hUFAz");

var $86gTc = parcelRequire("86gTc");
var $aZ4CA = parcelRequire("aZ4CA");
var $4Fru2 = parcelRequire("4Fru2");
var $dO5VB = parcelRequire("dO5VB");
var $9LNf9 = parcelRequire("9LNf9");

var $5pxzl = parcelRequire("5pxzl");
var $1hoRn = parcelRequire("1hoRn");
var $eqJ42 = parcelRequire("eqJ42");

var $crk1J = parcelRequire("crk1J");

var $lPRos = parcelRequire("lPRos");
var $39c891a43a0b123b$var$styles = {
    wrapper: "_18zrv47k _n7zl7r9e _4t3ickbl _1bsb1osq",
    search: "_195goahv _1bsb1osq",
    searchBar: "_2rkoiti9 _19it7r9e _4t3izwfg _1bsb1osq _p12fcv93 _1ul91178",
    createButton: "_2rkoiti9 _4t3izwfg _1bsbys9h _bfhk4v9p",
    createButtonText: "_2rkoiti9 _4t3ii2wt _1bsb1ady",
    chatButton: "_2rkoiti9 _19it7r9e _4t3izwfg _1bsbcae7",
    chatButtonText: "_2rkoiti9 _4t3ii2wt _1bsbzwfg"
};
var $39c891a43a0b123b$var$ProductLogos = (0, $lRb0O.default)((0, $lRb0O.default)({}, (0, $lPRos.Products).JIRA, (0, $dO5VB.JiraLogo)), (0, $lPRos.Products).CONFLUENCE, (0, $aZ4CA.ConfluenceLogo));
var $39c891a43a0b123b$var$ProductIcons = (0, $lRb0O.default)((0, $lRb0O.default)({}, (0, $lPRos.Products).JIRA, (0, $4Fru2.JiraIcon)), (0, $lPRos.Products).CONFLUENCE, (0, $86gTc.ConfluenceIcon));
var $39c891a43a0b123b$export$41d0d88a6b0e456f = function TopNav(_ref) {
    var product = _ref.product;
    var isAboveMediumScreen = (0, $crk1J.useMatchMedia)((0, $eqJ42.media).above.md);
    var Logo = $39c891a43a0b123b$var$ProductLogos[product];
    var Icon = $39c891a43a0b123b$var$ProductIcons[product];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1hoRn.default), {
        xcss: $39c891a43a0b123b$var$styles.wrapper,
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1hoRn.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUFAz))), {
        label: "Sidebar collapse",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5UXWe))), {
        label: "App switcher",
        color: "var(--ds-icon-subtle, #626F86)"
    }), isAboveMediumScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Logo, {
        appearance: "brand",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Icon, {
        appearance: "brand",
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1hoRn.default), {
        xcss: $39c891a43a0b123b$var$styles.search,
        alignInline: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1hoRn.default), {
        xcss: $39c891a43a0b123b$var$styles.searchBar,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3xho8))), {
        label: "Search",
        color: "var(--ds-icon-subtle, #626F86)",
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1hoRn.default), {
        xcss: $39c891a43a0b123b$var$styles.createButton,
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5pxzl.default), {
        xcss: $39c891a43a0b123b$var$styles.createButtonText,
        backgroundColor: "color.background.accent.blue.subtler.hovered"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1hoRn.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1hoRn.default), {
        xcss: $39c891a43a0b123b$var$styles.chatButton,
        alignBlock: "center",
        alignInline: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $9LNf9.RovoIcon), {
        size: "xsmall",
        appearance: "neutral"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5pxzl.default), {
        xcss: $39c891a43a0b123b$var$styles.chatButtonText,
        backgroundColor: "color.background.accent.gray.subtlest.hovered"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7wC8x))), {
        label: "Notifications",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fTeel))), {
        label: "Help",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hV0NN))), {
        label: "Settings",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hibY9))), {
        label: "User",
        color: "var(--ds-icon-subtle, #626F86)"
    })));
};

});
parcelRegister("5UXWe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a710c2ad5ea3773aa39998727af6369>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44f0ad334849852f$var$_react = $44f0ad334849852f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $44f0ad334849852f$var$_baseNew = $44f0ad334849852f$var$_interopRequireDefault((parcelRequire("1VEy6")));
function $44f0ad334849852f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $44f0ad334849852f$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $44f0ad334849852f$var$_react.default.createElement($44f0ad334849852f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM1 11a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm6 .5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$44f0ad334849852f$var$AppSwitcherIcon.displayName = "AppSwitcherIcon";
var $44f0ad334849852f$var$_default = module.exports.default = $44f0ad334849852f$var$AppSwitcherIcon;

});
parcelRegister("1VEy6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("e6Jgw")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("e6Jgw")).Icon; });

var $e6Jgw = parcelRequire("e6Jgw");

});
parcelRegister("e6Jgw", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $a454bcfbe30d15f1$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $a454bcfbe30d15f1$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $jxLBU = parcelRequire("jxLBU");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $a454bcfbe30d15f1$var$commonSVGStyles = (0, $2ZUkg.css)({
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    stop: {
        stopColor: "currentColor"
    }
});
var $a454bcfbe30d15f1$var$svgStyles = (0, $2ZUkg.css)({
    color: "currentColor",
    verticalAlign: "bottom"
});
var $a454bcfbe30d15f1$var$iconStyles = (0, $2ZUkg.css)({
    display: "inline-block",
    boxSizing: "border-box",
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    paddingInlineEnd: "var(--ds--button--new-icon-padding-end, 0)",
    paddingInlineStart: "var(--ds--button--new-icon-padding-start, 0)"
});
var $a454bcfbe30d15f1$var$utilityIconStyles = (0, $2ZUkg.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-150, 12px)"
});
var $a454bcfbe30d15f1$var$scaleStyles = (0, $2ZUkg.css)({
    width: "inherit",
    height: "inherit"
});
/**
 * For windows high contrast mode
 */ var $a454bcfbe30d15f1$var$baseHcmStyles = (0, $2ZUkg.css)({
    "@media screen and (forced-colors: active)": {
        color: "CanvasText",
        filter: "grayscale(1)"
    }
});
var $a454bcfbe30d15f1$var$scaleSize = (0, $2ZUkg.css)({
    width: "inherit",
    height: "inherit"
});
var $a454bcfbe30d15f1$var$sizeMap = {
    core: {
        none: (0, $2ZUkg.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $2ZUkg.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    },
    utility: {
        none: (0, $2ZUkg.css)({
            width: "var(--ds-space-150, 12px)",
            height: "var(--ds-space-150, 12px)"
        }),
        compact: (0, $2ZUkg.css)({
            width: "var(--ds-space-200, 16px)",
            height: "var(--ds-space-200, 16px)"
        }),
        spacious: (0, $2ZUkg.css)({
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)"
        })
    }
};
var $a454bcfbe30d15f1$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $a454bcfbe30d15f1$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
var $a454bcfbe30d15f1$export$f04a61298a47a40f = /*#__PURE__*/ (0, $iSvIT.memo)(function Icon(props) {
    var _props$type, _props$spacing3, _props$spacing4;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $jxLBU.fg)("platform-visual-refresh-icons")) // parse out unnecessary props
    return (0, $2ZUkg.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var baseSize = $a454bcfbe30d15f1$var$baseSizeMap[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : "core"];
    var viewBoxPadding;
    if (props.type === "utility") {
        var _props$spacing;
        viewBoxPadding = $a454bcfbe30d15f1$var$paddingMap[props.type][(_props$spacing = props.spacing) !== null && _props$spacing !== void 0 ? _props$spacing : "none"];
    } else {
        var _props$spacing2;
        viewBoxPadding = $a454bcfbe30d15f1$var$paddingMap["core"][(_props$spacing2 = props.spacing) !== null && _props$spacing2 !== void 0 ? _props$spacing2 : "none"];
    }
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return (0, $2ZUkg.jsx)("span", {
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        css: [
            $a454bcfbe30d15f1$var$iconStyles,
            $a454bcfbe30d15f1$var$baseHcmStyles,
            shouldScale && $a454bcfbe30d15f1$var$scaleStyles,
            props.type === "utility" && $a454bcfbe30d15f1$var$utilityIconStyles
        ]
    }, (0, $2ZUkg.jsx)("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        css: [
            $a454bcfbe30d15f1$var$commonSVGStyles,
            $a454bcfbe30d15f1$var$svgStyles,
            shouldScale ? $a454bcfbe30d15f1$var$scaleSize : props.type === "utility" ? $a454bcfbe30d15f1$var$sizeMap[props.type][(_props$spacing3 = props.spacing) !== null && _props$spacing3 !== void 0 ? _props$spacing3 : "none"] : $a454bcfbe30d15f1$var$sizeMap["core"][(_props$spacing4 = props.spacing) !== null && _props$spacing4 !== void 0 ? _props$spacing4 : "none"]
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $a454bcfbe30d15f1$export$2e2bcd8739ae039 = $a454bcfbe30d15f1$export$f04a61298a47a40f;

});



parcelRegister("7wC8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1e0c080c29498771abac7d6e0a3c394>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57a91ab9b365cbd1$var$_react = $57a91ab9b365cbd1$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $57a91ab9b365cbd1$var$_baseNew = $57a91ab9b365cbd1$var$_interopRequireDefault((parcelRequire("1VEy6")));
function $57a91ab9b365cbd1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $57a91ab9b365cbd1$var$NotificationIcon = (props)=>/*#__PURE__*/ $57a91ab9b365cbd1$var$_react.default.createElement($57a91ab9b365cbd1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 5a5 5 0 0 1 10 0v3.535l1.788 2.861a1.375 1.375 0 0 1-1.166 2.104h-2.459a3.251 3.251 0 0 1-6.326 0h-2.46a1.375 1.375 0 0 1-1.165-2.104L3 8.535zm3.418 8.5a1.75 1.75 0 0 0 3.164 0zM8 1.5A3.5 3.5 0 0 0 4.5 5v3.636c0 .215-.06.426-.175.608L2.603 12h10.794l-1.723-2.756a1.15 1.15 0 0 1-.174-.608V5A3.5 3.5 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$57a91ab9b365cbd1$var$NotificationIcon.displayName = "NotificationIcon";
var $57a91ab9b365cbd1$var$_default = module.exports.default = $57a91ab9b365cbd1$var$NotificationIcon;

});

parcelRegister("hibY9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aedef9bb726854d64999097926d2fc86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c96d66ea077515d7$var$_react = $c96d66ea077515d7$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $c96d66ea077515d7$var$_baseNew = $c96d66ea077515d7$var$_interopRequireDefault((parcelRequire("1VEy6")));
function $c96d66ea077515d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c96d66ea077515d7$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $c96d66ea077515d7$var$_react.default.createElement($c96d66ea077515d7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$c96d66ea077515d7$var$PersonAvatarIcon.displayName = "PersonAvatarIcon";
var $c96d66ea077515d7$var$_default = module.exports.default = $c96d66ea077515d7$var$PersonAvatarIcon;

});

parcelRegister("fTeel", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63dc429f33c9470dc156b62d0ec66db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b91707ed12daedea$var$_react = $b91707ed12daedea$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b91707ed12daedea$var$_baseNew = $b91707ed12daedea$var$_interopRequireDefault((parcelRequire("1VEy6")));
function $b91707ed12daedea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b91707ed12daedea$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $b91707ed12daedea$var$_react.default.createElement($b91707ed12daedea$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$b91707ed12daedea$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $b91707ed12daedea$var$_default = module.exports.default = $b91707ed12daedea$var$QuestionCircleIcon;

});

parcelRegister("3xho8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17c2ea3862f75cebada30b1178c22cdb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2931f11eb60dd253$var$_react = $2931f11eb60dd253$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $2931f11eb60dd253$var$_baseNew = $2931f11eb60dd253$var$_interopRequireDefault((parcelRequire("1VEy6")));
function $2931f11eb60dd253$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2931f11eb60dd253$var$SearchIcon = (props)=>/*#__PURE__*/ $2931f11eb60dd253$var$_react.default.createElement($2931f11eb60dd253$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$2931f11eb60dd253$var$SearchIcon.displayName = "SearchIcon";
var $2931f11eb60dd253$var$_default = module.exports.default = $2931f11eb60dd253$var$SearchIcon;

});

parcelRegister("hV0NN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::654979ffcf55141d2c08f198a843721e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0b861d94fac2ecc$var$_react = $d0b861d94fac2ecc$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $d0b861d94fac2ecc$var$_baseNew = $d0b861d94fac2ecc$var$_interopRequireDefault((parcelRequire("1VEy6")));
function $d0b861d94fac2ecc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0b861d94fac2ecc$var$SettingsIcon = (props)=>/*#__PURE__*/ $d0b861d94fac2ecc$var$_react.default.createElement($d0b861d94fac2ecc$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$d0b861d94fac2ecc$var$SettingsIcon.displayName = "SettingsIcon";
var $d0b861d94fac2ecc$var$_default = module.exports.default = $d0b861d94fac2ecc$var$SettingsIcon;

});

parcelRegister("hUFAz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::abc8b5d03c24733db4f330a1621745d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0a7ed5318509732$var$_react = $d0a7ed5318509732$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $d0a7ed5318509732$var$_baseNew = $d0a7ed5318509732$var$_interopRequireDefault((parcelRequire("1VEy6")));
function $d0a7ed5318509732$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0a7ed5318509732$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $d0a7ed5318509732$var$_react.default.createElement($d0a7ed5318509732$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$d0a7ed5318509732$var$SidebarCollapseIcon.displayName = "SidebarCollapseIcon";
var $d0a7ed5318509732$var$_default = module.exports.default = $d0a7ed5318509732$var$SidebarCollapseIcon;

});

parcelRegister("86gTc", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", function () { return $5e5bfc21949ab2d6$export$68f3db7f6af48bcb; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dZxqN = parcelRequire("dZxqN");

var $eKt8Z = parcelRequire("eKt8Z");

var $8Vd97 = parcelRequire("8Vd97");

var $7kz52 = parcelRequire("7kz52");
var $5e5bfc21949ab2d6$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8Vd97.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>\n    </svg>');
};
var $5e5bfc21949ab2d6$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Confluence" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eKt8Z.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eKt8Z.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eKt8Z.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dZxqN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7kz52.default), {
        appearance: appearance,
        label: label,
        svg: $5e5bfc21949ab2d6$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("dZxqN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2fae79c17f38f97$export$2e2bcd8739ae039; });

var $lEgX3 = parcelRequire("lEgX3");

var $iSvIT = parcelRequire("iSvIT");

var $jncG3 = parcelRequire("jncG3");

var $dTDl5 = parcelRequire("dTDl5");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $a2fae79c17f38f97$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $iSvIT.useState)((0, $jncG3.default)()), _useState2 = (0, $lEgX3.default)(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $iSvIT.useEffect)(function() {
        var observer = new (0, $dTDl5.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $a2fae79c17f38f97$export$2e2bcd8739ae039 = $a2fae79c17f38f97$var$useThemeObserver;

});
parcelRegister("jncG3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1a9ffc5d97c8d9b$export$2e2bcd8739ae039; });

var $lRb0O = parcelRequire("lRb0O");

var $iGPGh = parcelRequire("iGPGh");

var $jfscM = parcelRequire("jfscM");

var $jxxxL = parcelRequire("jxxxL");
function $e1a9ffc5d97c8d9b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e1a9ffc5d97c8d9b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e1a9ffc5d97c8d9b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lRb0O.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e1a9ffc5d97c8d9b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e1a9ffc5d97c8d9b$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $jfscM.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $e1a9ffc5d97c8d9b$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $iGPGh.COLOR_MODE_ATTRIBUTE)) || "";
    var theme = element.getAttribute((0, $iGPGh.THEME_DATA_ATTRIBUTE)) || "";
    return $e1a9ffc5d97c8d9b$var$_objectSpread($e1a9ffc5d97c8d9b$var$_objectSpread({}, (0, $jxxxL.themeStringToObject)(theme)), $e1a9ffc5d97c8d9b$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $e1a9ffc5d97c8d9b$export$2e2bcd8739ae039 = $e1a9ffc5d97c8d9b$var$getGlobalTheme;

});
parcelRegister("iGPGh", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $d9b43d01a3bdab4e$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $d9b43d01a3bdab4e$export$a00eac3f8684bcd0; });
var $d9b43d01a3bdab4e$export$4ef52930e33717cd = "data-theme";
var $d9b43d01a3bdab4e$export$a00eac3f8684bcd0 = "data-color-mode";
var $d9b43d01a3bdab4e$export$2112803007239c61 = "data-contrast-mode";
var $d9b43d01a3bdab4e$export$352e418ed5b6193a = "data-custom-theme";
var $d9b43d01a3bdab4e$export$2faeed762aac6741 = "light";
var $d9b43d01a3bdab4e$export$6f0c6fb8c80fcc92 = "ds";
var $d9b43d01a3bdab4e$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $d9b43d01a3bdab4e$export$dddac1532e822863 = "--".concat($d9b43d01a3bdab4e$export$6f0c6fb8c80fcc92, "-token-not-found");
var $d9b43d01a3bdab4e$export$9d7b58831ae93caa = "--".concat($d9b43d01a3bdab4e$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("jfscM", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $e0354bfa860e631d$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $e0354bfa860e631d$export$7d43e72a58e3283f; });

var $jxLBU = parcelRequire("jxLBU");
var $e0354bfa860e631d$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
var $e0354bfa860e631d$export$8ce7e340c74e86c5 = [
    "more",
    "no-preference",
    "auto"
];
var $e0354bfa860e631d$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "light-brand-refresh",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "dark-brand-refresh",
    "legacy-light",
    "legacy-dark",
    "spacing",
    "shape",
    "typography-adg3",
    "typography-modernized",
    "typography-refreshed"
];
var $e0354bfa860e631d$export$ba8a43b83ecc69f8 = [];
var $e0354bfa860e631d$export$92ba366331403db2 = [].concat($e0354bfa860e631d$export$7d43e72a58e3283f, $e0354bfa860e631d$export$ba8a43b83ecc69f8);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $e0354bfa860e631d$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-legacy-light": {
        id: "legacy-light",
        displayName: "Light Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-legacy-dark": {
        id: "legacy-dark",
        displayName: "Dark Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography-adg3": {
        id: "typography-adg3",
        displayName: "ADG3 Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Atlassian Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-typography-modernized": {
        id: "typography-modernized",
        displayName: "Atlassian Typography (Modernized)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-typography-refreshed": {
        id: "typography-refreshed",
        displayName: "Atlassian Typography (Refreshed)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-light-brand-refresh": {
        id: "light-brand-refresh",
        displayName: "Light theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-dark-brand-refresh": {
        id: "dark-brand-refresh",
        displayName: "Dark theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    }
};
var $e0354bfa860e631d$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: undefined,
    spacing: "spacing",
    typography: function typography() {
        if ((0, $jxLBU.fg)("platform-default-typography-modernized")) return "typography-modernized";
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $e0354bfa860e631d$export$2e2bcd8739ae039 = $e0354bfa860e631d$var$themeConfig;

});

parcelRegister("jxxxL", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", function () { return $e39b1e77a1e76820$export$f19b488f7c0547ee; });

var $i3sPM = parcelRequire("i3sPM");

var $lEgX3 = parcelRequire("lEgX3");

var $jfscM = parcelRequire("jfscM");
var $e39b1e77a1e76820$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape"
];
var $e39b1e77a1e76820$var$customThemeOptions = "UNSAFE_themeOptions";
var $e39b1e77a1e76820$var$isThemeKind = function isThemeKind(themeKind) {
    return $e39b1e77a1e76820$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $e39b1e77a1e76820$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $jfscM.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $e39b1e77a1e76820$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $e39b1e77a1e76820$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ").map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $lEgX3.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $e39b1e77a1e76820$var$isColorMode(id)) themeObject[kind] = id;
        if ($e39b1e77a1e76820$var$isThemeKind(kind) && $e39b1e77a1e76820$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $e39b1e77a1e76820$var$customThemeOptions) try {
            themeObject[$e39b1e77a1e76820$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $e39b1e77a1e76820$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, $lEgX3.default)(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $e39b1e77a1e76820$var$isColorMode(id) || // custom theme state
        kind === $e39b1e77a1e76820$var$customThemeOptions && (0, $i3sPM.default)(id) === "object" || // other theme states
        $e39b1e77a1e76820$var$isThemeKind(kind) && typeof id === "string" && $e39b1e77a1e76820$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, $i3sPM.default)(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};

});


parcelRegister("dTDl5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1deed5776a50784$export$2e2bcd8739ae039; });

var $gRXyc = parcelRequire("gRXyc");

var $8Euvn = parcelRequire("8Euvn");

var $lRb0O = parcelRequire("lRb0O");

var $iGPGh = parcelRequire("iGPGh");

var $jncG3 = parcelRequire("jncG3");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $a1deed5776a50784$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $gRXyc.default)(this, ThemeMutationObserver);
        (0, $lRb0O.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $8Euvn.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $jncG3.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $iGPGh.THEME_DATA_ATTRIBUTE),
                            (0, $iGPGh.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $lRb0O.default)($a1deed5776a50784$export$2e2bcd8739ae039, "observer", null);
(0, $lRb0O.default)($a1deed5776a50784$export$2e2bcd8739ae039, "callbacks", new Set());

});
parcelRegister("gRXyc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c47fca16913a003f$export$2e2bcd8739ae039; });
function $c47fca16913a003f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("8Euvn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64c9b8d20b2c2f2c$export$2e2bcd8739ae039; });

var $llC5m = parcelRequire("llC5m");
function $64c9b8d20b2c2f2c$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $llC5m.default)(o.key), o);
    }
}
function $64c9b8d20b2c2f2c$export$2e2bcd8739ae039(e, r, t) {
    return r && $64c9b8d20b2c2f2c$var$_defineProperties(e.prototype, r), t && $64c9b8d20b2c2f2c$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});



parcelRegister("eKt8Z", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", function () { return $abcbf7f6a0c59693$export$438460117ae6b7ee; });
/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $abcbf7f6a0c59693$export$438460117ae6b7ee = {
    iconColor: "inherit",
    label: "",
    size: "medium",
    textColor: "currentColor"
};
var $abcbf7f6a0c59693$export$793fba32aed8942a = {
    iconGradientStart: "inherit",
    iconGradientStop: "inherit"
};
var $abcbf7f6a0c59693$export$31d7044b7540a6d8 = $abcbf7f6a0c59693$export$438460117ae6b7ee;

});

parcelRegister("8Vd97", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearance", function () { return $67edd821f193b252$export$bbacc3980e0f3029; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $Rdfaf = parcelRequire("Rdfaf");
var $67edd821f193b252$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case "brand":
            iconGradientStart = (0, $Rdfaf.B400);
            iconGradientStop = (0, $Rdfaf.B200);
            iconColor = (0, $Rdfaf.B200);
            textColor = "var(--ds-text, ".concat((0, $Rdfaf.N800), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $Rdfaf.B400);
            break;
        case "neutral":
            iconGradientStart = (0, $Rdfaf.N600);
            iconGradientStop = (0, $Rdfaf.N100);
            iconColor = (0, $Rdfaf.N100);
            textColor = (0, $Rdfaf.N400);
            atlassianLogoTextColor = (0, $Rdfaf.N400);
            break;
        case "inverse":
            iconGradientStart = "#FFFFFF66";
            iconGradientStop = "#FFFFFF";
            iconColor = "#FFFFFF";
            textColor = "#FFFFFF";
            atlassianLogoTextColor = "#FFFFFF";
            break;
    }
    if (colorMode === "dark" && appearance === "inverse") {
        iconGradientStart = "#161A1D66";
        iconGradientStop = "#161A1D";
        iconColor = "#161A1D";
        textColor = "#161A1D";
        atlassianLogoTextColor = "#161A1D";
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $67edd821f193b252$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === "dark") switch(appearance){
        case "brand":
            iconColor = "#357DE8";
            textColor = "#E2E3E4";
            atlassianLogoTextColor = "#357DE8";
            break;
        case "neutral":
            iconColor = "#96999E";
            textColor = "#BFC1C4";
            atlassianLogoTextColor = "#96999E";
            break;
        case "inverse":
            iconColor = "#101214";
            textColor = "#101214";
            atlassianLogoTextColor = "#101214";
            break;
    }
    else switch(appearance){
        case "brand":
            iconColor = "#1868DB";
            textColor = "#101214";
            atlassianLogoTextColor = "#1868DB";
            break;
        case "neutral":
            iconColor = "#6C6F77";
            textColor = "#3B3D42";
            atlassianLogoTextColor = "#6C6F77";
            break;
        case "inverse":
            iconColor = (0, $Rdfaf.N0);
            textColor = (0, $Rdfaf.N0);
            atlassianLogoTextColor = (0, $Rdfaf.N0);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $67edd821f193b252$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $67edd821f193b252$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $67edd821f193b252$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === "dark") switch(appearance){
        case "brand":
            iconColor = "#625DF5";
            textColor = "#EFF0FF";
            break;
    }
    else switch(appearance){
        case "brand":
            iconColor = "#625DF5";
            textColor = "#252434";
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});
parcelRegister("Rdfaf", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $09ff394082a986ec$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $09ff394082a986ec$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $09ff394082a986ec$export$29a4f05edc054374; });
$parcel$export(module.exports, "N100", function () { return $09ff394082a986ec$export$d6447c357493214f; });
$parcel$export(module.exports, "N400", function () { return $09ff394082a986ec$export$eece5f492e429f08; });
$parcel$export(module.exports, "N600", function () { return $09ff394082a986ec$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $09ff394082a986ec$export$7d61b15e0da132af; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $09ff394082a986ec$export$4b84fd0e2c617bd = "#FFEBE6";
var $09ff394082a986ec$export$b34b069eff244586 = "#FFBDAD";
var $09ff394082a986ec$export$be802dd0d8b57f35 = "#FF8F73";
var $09ff394082a986ec$export$60847d42f9da92a6 = "#FF7452";
var $09ff394082a986ec$export$4a7404f376229999 = "#FF5630";
var $09ff394082a986ec$export$2010d0fb4295b346 = "#DE350B";
var $09ff394082a986ec$export$2837b5a1a71d5c02 = "#BF2600";
var $09ff394082a986ec$export$8d9596b529bbb9cf = "#FFFAE6";
var $09ff394082a986ec$export$41060a744ab0b7ae = "#FFF0B3";
var $09ff394082a986ec$export$1cc05bbbf340e559 = "#FFE380";
var $09ff394082a986ec$export$5aae31392d72caaa = "#FFC400";
var $09ff394082a986ec$export$c6930421db9fa514 = "#FFAB00";
var $09ff394082a986ec$export$59619663aa6500fb = "#FF991F";
var $09ff394082a986ec$export$874739ea9e379ab6 = "#FF8B00";
var $09ff394082a986ec$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $09ff394082a986ec$export$69a3bf21b9686c2b = "#ABF5D1";
var $09ff394082a986ec$export$afbce1382ec95f73 = "#79F2C0";
var $09ff394082a986ec$export$747d86715d4175de = "#57D9A3";
var $09ff394082a986ec$export$940e1f69e873f202 = "#36B37E";
var $09ff394082a986ec$export$a49394138f7b8e85 = "#00875A";
var $09ff394082a986ec$export$6fa04827ac68a4fb = "#006644";
var $09ff394082a986ec$export$226de0355ed012f8 = "#DEEBFF";
var $09ff394082a986ec$export$8c13c2ee36917869 = "#B3D4FF";
var $09ff394082a986ec$export$ecfc1dff386a3e7a = "#4C9AFF";
var $09ff394082a986ec$export$215b7063051591f1 = "#2684FF";
var $09ff394082a986ec$export$e62e8919cca44969 = "#0065FF";
var $09ff394082a986ec$export$b3de0ae08da2ce64 = "#0052CC";
var $09ff394082a986ec$export$a6ee3d71bc067634 = "#0747A6";
var $09ff394082a986ec$export$67f15409e87642a1 = "#669DF1";
var $09ff394082a986ec$export$f0539dbc42dbb067 = "#8FB8F6";
var $09ff394082a986ec$export$363e4475840015bb = "#EAE6FF";
var $09ff394082a986ec$export$4b0a4417ed59760f = "#C0B6F2";
var $09ff394082a986ec$export$6011520a64d9a187 = "#998DD9";
var $09ff394082a986ec$export$a7175d4e9206bc80 = "#8777D9";
var $09ff394082a986ec$export$b48405b95304b5a1 = "#6554C0";
var $09ff394082a986ec$export$c71e4279dd54a18d = "#5243AA";
var $09ff394082a986ec$export$147899de772240ec = "#403294";
var $09ff394082a986ec$export$2cf711fe14c66f06 = "#E6FCFF";
var $09ff394082a986ec$export$7a8f4d33f6f9772c = "#B3F5FF";
var $09ff394082a986ec$export$776c9c497ef08533 = "#79E2F2";
var $09ff394082a986ec$export$69cb3ca10c1e330e = "#00C7E6";
var $09ff394082a986ec$export$9dc1ef0f3f48059b = "#00B8D9";
var $09ff394082a986ec$export$7c835c78b6fcdef8 = "#00A3BF";
var $09ff394082a986ec$export$6036577f95c3877e = "#008DA6";
var $09ff394082a986ec$export$29a4f05edc054374 = "#FFFFFF";
var $09ff394082a986ec$export$e655ef011c4aa1a2 = "#FAFBFC";
var $09ff394082a986ec$export$9fdfb749e33cdf97 = "#F4F5F7";
var $09ff394082a986ec$export$3e51e8f1440314ba = "#EBECF0";
var $09ff394082a986ec$export$1ce2d1575d444ceb = "#DFE1E6";
var $09ff394082a986ec$export$8754fc7e6d8b3000 = "#C1C7D0";
var $09ff394082a986ec$export$c2e91cbeada39b8b = "#B3BAC5";
var $09ff394082a986ec$export$5f71e19f3a7ad9de = "#A5ADBA";
var $09ff394082a986ec$export$eaa8c8a70ac22806 = "#97A0AF";
var $09ff394082a986ec$export$7c87d337fb91a97d = "#8993A4";
var $09ff394082a986ec$export$d6447c357493214f = "#7A869A";
var $09ff394082a986ec$export$f563ee71e9ee74cd = "#6B778C";
var $09ff394082a986ec$export$e2ef2124cf4024b1 = "#5E6C84";
var $09ff394082a986ec$export$eece5f492e429f08 = "#505F79";
var $09ff394082a986ec$export$c39c0fe0f26207ae = "#42526E";
var $09ff394082a986ec$export$7090862dc3038a9f = "#344563";
var $09ff394082a986ec$export$ad0bacf983b7ddaa = "#253858";
var $09ff394082a986ec$export$7d61b15e0da132af = "#172B4D";
var $09ff394082a986ec$export$fbda843f0a27fe96 = "#091E42";
var $09ff394082a986ec$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $09ff394082a986ec$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $09ff394082a986ec$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $09ff394082a986ec$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $09ff394082a986ec$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $09ff394082a986ec$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $09ff394082a986ec$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $09ff394082a986ec$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $09ff394082a986ec$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $09ff394082a986ec$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $09ff394082a986ec$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $09ff394082a986ec$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $09ff394082a986ec$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $09ff394082a986ec$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $09ff394082a986ec$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $09ff394082a986ec$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $09ff394082a986ec$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $09ff394082a986ec$export$2f6319cf7d736c2a = "#E6EDFA";
var $09ff394082a986ec$export$95126bc8884d6634 = "#DCE5F5";
var $09ff394082a986ec$export$8338d8c35d44ff1 = "#CED9EB";
var $09ff394082a986ec$export$5368d76ae4fbbda7 = "#B8C7E0";
var $09ff394082a986ec$export$9f0a771d16ec8d36 = "#ABBBD6";
var $09ff394082a986ec$export$abcf8c38338b4aa5 = "#9FB0CC";
var $09ff394082a986ec$export$97e81faa16a182c7 = "#8C9CB8";
var $09ff394082a986ec$export$bfe21c59123ecf33 = "#7988A3";
var $09ff394082a986ec$export$ee82aa2ea6a1558 = "#67758F";
var $09ff394082a986ec$export$682927c6ed76be02 = "#56637A";
var $09ff394082a986ec$export$91fd9994c5be9757 = "#455166";
var $09ff394082a986ec$export$d281fbfe3cff2df6 = "#3B475C";
var $09ff394082a986ec$export$3902c91d8b98a753 = "#313D52";
var $09ff394082a986ec$export$8e8133c1ba5845b5 = "#283447";
var $09ff394082a986ec$export$33ff357f6620b39 = "#202B3D";
var $09ff394082a986ec$export$633847cf062b69e0 = "#1B2638";
var $09ff394082a986ec$export$9776a6e503bdbf76 = "#121A29";
var $09ff394082a986ec$export$6c813d5160dff5db = "#0E1624";
var $09ff394082a986ec$export$3d4f271a500072a = "#0D1424";
var $09ff394082a986ec$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $09ff394082a986ec$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $09ff394082a986ec$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $09ff394082a986ec$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $09ff394082a986ec$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $09ff394082a986ec$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $09ff394082a986ec$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $09ff394082a986ec$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $09ff394082a986ec$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $09ff394082a986ec$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $09ff394082a986ec$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $09ff394082a986ec$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $09ff394082a986ec$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $09ff394082a986ec$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $09ff394082a986ec$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $09ff394082a986ec$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $09ff394082a986ec$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $09ff394082a986ec$export$d2adc5dedf09fced = "#292A2E";
var $09ff394082a986ec$export$f51762073d2bb381 = "#94C748";
var $09ff394082a986ec$export$95e26d54def96891 = "#B3DF72";

});


parcelRegister("7kz52", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55659ce362cac2ed$export$2e2bcd8739ae039; });
/* wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7Iz7O = parcelRequire("7Iz7O");

var $lRb0O = parcelRequire("lRb0O");

var $7SYDx = parcelRequire("7SYDx");

var $iSvIT = parcelRequire("iSvIT");

var $dgjmJ = parcelRequire("dgjmJ");
var $55659ce362cac2ed$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $55659ce362cac2ed$var$CSS_VAR_COLOR = "--logo-color";
var $55659ce362cac2ed$var$CSS_VAR_FILL = "--logo-fill";
var $55659ce362cac2ed$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xsmall: "_4t3i7vkz",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $55659ce362cac2ed$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, $7SYDx.default)(_ref, $55659ce362cac2ed$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $iSvIT.createElement("span", (0, $7Iz7O.default)({
        "data-testid": testId,
        style: (0, $lRb0O.default)((0, $lRb0O.default)({}, $55659ce362cac2ed$var$CSS_VAR_COLOR, iconColor), $55659ce362cac2ed$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? "img" : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $dgjmJ.default)([
            $55659ce362cac2ed$var$styles.root,
            shouldApplyStopColor && $55659ce362cac2ed$var$styles.stop,
            size && $55659ce362cac2ed$var$styles[size]
        ])
    }));
};
var $55659ce362cac2ed$export$2e2bcd8739ae039 = $55659ce362cac2ed$var$Wrapper;

});
parcelRegister("7Iz7O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59e7e38dec0d8504$export$2e2bcd8739ae039; });
function $59e7e38dec0d8504$export$2e2bcd8739ae039() {
    return $59e7e38dec0d8504$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $59e7e38dec0d8504$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("7SYDx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bdc9cc04cfbf7c8$export$2e2bcd8739ae039; });

var $dhbRp = parcelRequire("dhbRp");
function $5bdc9cc04cfbf7c8$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $dhbRp.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("dhbRp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9aa61024e97d2702$export$2e2bcd8739ae039; });
function $9aa61024e97d2702$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("dgjmJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a7bca98a7568ad8$export$2e2bcd8739ae039; });
const $9a7bca98a7568ad8$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $9a7bca98a7568ad8$var$ATOMIC_GROUP_LENGTH = 5;
function $9a7bca98a7568ad8$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $9a7bca98a7568ad8$var$UNDERSCORE_UNICODE ? $9a7bca98a7568ad8$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});



parcelRegister("aZ4CA", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLogo", function () { return $7ff32f9befc7d91b$export$1b2e4fe6ef471556; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dZxqN = parcelRequire("dZxqN");

var $eKt8Z = parcelRequire("eKt8Z");

var $8Vd97 = parcelRequire("8Vd97");

var $7kz52 = parcelRequire("7kz52");
var $7ff32f9befc7d91b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8Vd97.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 180 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098"/>\n      <path fill="').concat(colors.textColor, '" d="M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227"/>\n    </svg>\n    ');
};
var $7ff32f9befc7d91b$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Confluence" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eKt8Z.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eKt8Z.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eKt8Z.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dZxqN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7kz52.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $7ff32f9befc7d91b$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4Fru2", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", function () { return $36604f6996b80c13$export$c4b5b1f965d8b3eb; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dZxqN = parcelRequire("dZxqN");

var $eKt8Z = parcelRequire("eKt8Z");

var $8Vd97 = parcelRequire("8Vd97");

var $7kz52 = parcelRequire("7kz52");
var $36604f6996b80c13$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8Vd97.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>\n    </svg>');
};
var $36604f6996b80c13$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eKt8Z.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eKt8Z.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eKt8Z.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dZxqN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7kz52.default), {
        appearance: appearance,
        label: label,
        svg: $36604f6996b80c13$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("dO5VB", function(module, exports) {

$parcel$export(module.exports, "JiraLogo", function () { return $a0d48b169fcfd365$export$17d3acb0b4379d02; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dZxqN = parcelRequire("dZxqN");

var $eKt8Z = parcelRequire("eKt8Z");

var $8Vd97 = parcelRequire("8Vd97");

var $7kz52 = parcelRequire("7kz52");
var $a0d48b169fcfd365$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $8Vd97.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>\n      <path fill="').concat(colors.textColor, '" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>\n    </svg>');
};
var $a0d48b169fcfd365$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eKt8Z.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eKt8Z.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eKt8Z.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dZxqN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7kz52.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $a0d48b169fcfd365$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9LNf9", function(module, exports) {

$parcel$export(module.exports, "RovoIcon", function () { return $71ceb38e2addfa29$export$e23ae35269442b4f; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dZxqN = parcelRequire("dZxqN");

var $eKt8Z = parcelRequire("eKt8Z");

var $8Vd97 = parcelRequire("8Vd97");

var $7kz52 = parcelRequire("7kz52");
var $71ceb38e2addfa29$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $8Vd97.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">\n    <g fill="'.concat(colors.iconColor, '" fill-rule="evenodd">\n      <path d="M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z"/>\n      <path d="m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z"/>\n    </g>\n  </svg>');
};
var $71ceb38e2addfa29$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Rovo" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $eKt8Z.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $eKt8Z.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $eKt8Z.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dZxqN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $7kz52.default), {
        appearance: appearance,
        svg: $71ceb38e2addfa29$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5pxzl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f0953ae2e06c136$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7Iz7O = parcelRequire("7Iz7O");

var $7SYDx = parcelRequire("7SYDx");

var $iSvIT = parcelRequire("iSvIT");

var $lda32 = parcelRequire("lda32");

var $bkPXW = parcelRequire("bkPXW");
var $3f0953ae2e06c136$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $3f0953ae2e06c136$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $3f0953ae2e06c136$var$baseStyles = null;
var $3f0953ae2e06c136$var$backgroundColorMap = {
    "color.background.accent.lime.subtlest": "_bfhkm890",
    "color.background.accent.lime.subtlest.hovered": "_bfhkd4y8",
    "color.background.accent.lime.subtlest.pressed": "_bfhk1fno",
    "color.background.accent.lime.subtler": "_bfhkz2ec",
    "color.background.accent.lime.subtler.hovered": "_bfhk1eds",
    "color.background.accent.lime.subtler.pressed": "_bfhk1hgz",
    "color.background.accent.lime.subtle": "_bfhkbq5w",
    "color.background.accent.lime.subtle.hovered": "_bfhkfoww",
    "color.background.accent.lime.subtle.pressed": "_bfhkhgj8",
    "color.background.accent.lime.bolder": "_bfhktde4",
    "color.background.accent.lime.bolder.hovered": "_bfhknzpa",
    "color.background.accent.lime.bolder.pressed": "_bfhk1b17",
    "color.background.accent.red.subtlest": "_bfhk1vk5",
    "color.background.accent.red.subtlest.hovered": "_bfhk1i6i",
    "color.background.accent.red.subtlest.pressed": "_bfhk1pbw",
    "color.background.accent.red.subtler": "_bfhk1rtt",
    "color.background.accent.red.subtler.hovered": "_bfhkrw5d",
    "color.background.accent.red.subtler.pressed": "_bfhk69rw",
    "color.background.accent.red.subtle": "_bfhkkrt9",
    "color.background.accent.red.subtle.hovered": "_bfhk1sou",
    "color.background.accent.red.subtle.pressed": "_bfhk1tf4",
    "color.background.accent.red.bolder": "_bfhkuibq",
    "color.background.accent.red.bolder.hovered": "_bfhk100f",
    "color.background.accent.red.bolder.pressed": "_bfhkprmn",
    "color.background.accent.orange.subtlest": "_bfhk1g3m",
    "color.background.accent.orange.subtlest.hovered": "_bfhkg4tm",
    "color.background.accent.orange.subtlest.pressed": "_bfhk1ya0",
    "color.background.accent.orange.subtler": "_bfhkf2vu",
    "color.background.accent.orange.subtler.hovered": "_bfhk1lml",
    "color.background.accent.orange.subtler.pressed": "_bfhkuxsx",
    "color.background.accent.orange.subtle": "_bfhk1g6e",
    "color.background.accent.orange.subtle.hovered": "_bfhk1oew",
    "color.background.accent.orange.subtle.pressed": "_bfhk1phk",
    "color.background.accent.orange.bolder": "_bfhkjgng",
    "color.background.accent.orange.bolder.hovered": "_bfhkhi52",
    "color.background.accent.orange.bolder.pressed": "_bfhkf767",
    "color.background.accent.yellow.subtlest": "_bfhk1ozg",
    "color.background.accent.yellow.subtlest.hovered": "_bfhk19g9",
    "color.background.accent.yellow.subtlest.pressed": "_bfhk31d1",
    "color.background.accent.yellow.subtler": "_bfhk3fv2",
    "color.background.accent.yellow.subtler.hovered": "_bfhklg04",
    "color.background.accent.yellow.subtler.pressed": "_bfhk1d44",
    "color.background.accent.yellow.subtle": "_bfhkry5t",
    "color.background.accent.yellow.subtle.hovered": "_bfhk17e6",
    "color.background.accent.yellow.subtle.pressed": "_bfhko0y5",
    "color.background.accent.yellow.bolder": "_bfhk1vop",
    "color.background.accent.yellow.bolder.hovered": "_bfhkkjqf",
    "color.background.accent.yellow.bolder.pressed": "_bfhk32kj",
    "color.background.accent.green.subtlest": "_bfhkn729",
    "color.background.accent.green.subtlest.hovered": "_bfhk3utz",
    "color.background.accent.green.subtlest.pressed": "_bfhkv5yf",
    "color.background.accent.green.subtler": "_bfhk1wnw",
    "color.background.accent.green.subtler.hovered": "_bfhkung8",
    "color.background.accent.green.subtler.pressed": "_bfhk1p19",
    "color.background.accent.green.subtle": "_bfhk1rsu",
    "color.background.accent.green.subtle.hovered": "_bfhk12e3",
    "color.background.accent.green.subtle.pressed": "_bfhk8h4p",
    "color.background.accent.green.bolder": "_bfhk1e5c",
    "color.background.accent.green.bolder.hovered": "_bfhka5yi",
    "color.background.accent.green.bolder.pressed": "_bfhk1azz",
    "color.background.accent.teal.subtlest": "_bfhk7xuz",
    "color.background.accent.teal.subtlest.hovered": "_bfhk108c",
    "color.background.accent.teal.subtlest.pressed": "_bfhk1j2h",
    "color.background.accent.teal.subtler": "_bfhk1a17",
    "color.background.accent.teal.subtler.hovered": "_bfhkg5py",
    "color.background.accent.teal.subtler.pressed": "_bfhkq7li",
    "color.background.accent.teal.subtle": "_bfhktdv8",
    "color.background.accent.teal.subtle.hovered": "_bfhkzh8h",
    "color.background.accent.teal.subtle.pressed": "_bfhk10ai",
    "color.background.accent.teal.bolder": "_bfhk2c8p",
    "color.background.accent.teal.bolder.hovered": "_bfhkl3ve",
    "color.background.accent.teal.bolder.pressed": "_bfhkse6l",
    "color.background.accent.blue.subtlest": "_bfhkavxe",
    "color.background.accent.blue.subtlest.hovered": "_bfhkay3p",
    "color.background.accent.blue.subtlest.pressed": "_bfhk1xmr",
    "color.background.accent.blue.subtler": "_bfhk4v9p",
    "color.background.accent.blue.subtler.hovered": "_bfhk16e6",
    "color.background.accent.blue.subtler.pressed": "_bfhk1uh7",
    "color.background.accent.blue.subtle": "_bfhk1j89",
    "color.background.accent.blue.subtle.hovered": "_bfhk1f4s",
    "color.background.accent.blue.subtle.pressed": "_bfhkqctv",
    "color.background.accent.blue.bolder": "_bfhkc8cv",
    "color.background.accent.blue.bolder.hovered": "_bfhk1cwi",
    "color.background.accent.blue.bolder.pressed": "_bfhkhcrq",
    "color.background.accent.purple.subtlest": "_bfhkp7j4",
    "color.background.accent.purple.subtlest.hovered": "_bfhkm0d5",
    "color.background.accent.purple.subtlest.pressed": "_bfhkgslw",
    "color.background.accent.purple.subtler": "_bfhk1jkz",
    "color.background.accent.purple.subtler.hovered": "_bfhk1wyu",
    "color.background.accent.purple.subtler.pressed": "_bfhk5fkp",
    "color.background.accent.purple.subtle": "_bfhkdh45",
    "color.background.accent.purple.subtle.hovered": "_bfhk1wob",
    "color.background.accent.purple.subtle.pressed": "_bfhkwz05",
    "color.background.accent.purple.bolder": "_bfhkygwo",
    "color.background.accent.purple.bolder.hovered": "_bfhkadgs",
    "color.background.accent.purple.bolder.pressed": "_bfhk1uro",
    "color.background.accent.magenta.subtlest": "_bfhk8tvm",
    "color.background.accent.magenta.subtlest.hovered": "_bfhkr3zd",
    "color.background.accent.magenta.subtlest.pressed": "_bfhk1een",
    "color.background.accent.magenta.subtler": "_bfhkv9ra",
    "color.background.accent.magenta.subtler.hovered": "_bfhk1r0p",
    "color.background.accent.magenta.subtler.pressed": "_bfhkxuzc",
    "color.background.accent.magenta.subtle": "_bfhk1mi6",
    "color.background.accent.magenta.subtle.hovered": "_bfhkrwyz",
    "color.background.accent.magenta.subtle.pressed": "_bfhk1ovh",
    "color.background.accent.magenta.bolder": "_bfhkc3uk",
    "color.background.accent.magenta.bolder.hovered": "_bfhk1ok8",
    "color.background.accent.magenta.bolder.pressed": "_bfhkwaw3",
    "color.background.accent.gray.subtlest": "_bfhk11bn",
    "color.background.accent.gray.subtlest.hovered": "_bfhk12j4",
    "color.background.accent.gray.subtlest.pressed": "_bfhk1lb4",
    "color.background.accent.gray.subtler": "_bfhk1v33",
    "color.background.accent.gray.subtler.hovered": "_bfhk1f7l",
    "color.background.accent.gray.subtler.pressed": "_bfhkd8a2",
    "color.background.accent.gray.subtle": "_bfhk1t05",
    "color.background.accent.gray.subtle.hovered": "_bfhk1a2l",
    "color.background.accent.gray.subtle.pressed": "_bfhk1z0s",
    "color.background.accent.gray.bolder": "_bfhk1t1b",
    "color.background.accent.gray.bolder.hovered": "_bfhke4nv",
    "color.background.accent.gray.bolder.pressed": "_bfhk82ra",
    "color.background.disabled": "_bfhksyzs",
    "color.background.input": "_bfhk1j9a",
    "color.background.input.hovered": "_bfhk1d5g",
    "color.background.input.pressed": "_bfhkr01l",
    "color.background.inverse.subtle": "_bfhk1vck",
    "color.background.inverse.subtle.hovered": "_bfhkmpja",
    "color.background.inverse.subtle.pressed": "_bfhk1gii",
    "color.background.neutral": "_bfhkm7j4",
    "color.background.neutral.hovered": "_bfhk15ej",
    "color.background.neutral.pressed": "_bfhkip91",
    "color.background.neutral.subtle": "_bfhksm61",
    "color.background.neutral.subtle.hovered": "_bfhk166n",
    "color.background.neutral.subtle.pressed": "_bfhk1dty",
    "color.background.neutral.bold": "_bfhkcdhy",
    "color.background.neutral.bold.hovered": "_bfhk1bsc",
    "color.background.neutral.bold.pressed": "_bfhk1b6k",
    "color.background.selected": "_bfhkfg4m",
    "color.background.selected.hovered": "_bfhki1yw",
    "color.background.selected.pressed": "_bfhk19ru",
    "color.background.selected.bold": "_bfhk1fvw",
    "color.background.selected.bold.hovered": "_bfhk18hz",
    "color.background.selected.bold.pressed": "_bfhkgr1v",
    "color.background.brand.subtlest": "_bfhk3wxy",
    "color.background.brand.subtlest.hovered": "_bfhkezq1",
    "color.background.brand.subtlest.pressed": "_bfhk2ggb",
    "color.background.brand.bold": "_bfhkb29m",
    "color.background.brand.bold.hovered": "_bfhku1se",
    "color.background.brand.bold.pressed": "_bfhkqkzo",
    "color.background.brand.boldest": "_bfhk15mt",
    "color.background.brand.boldest.hovered": "_bfhk1uwk",
    "color.background.brand.boldest.pressed": "_bfhk17jr",
    "color.background.danger": "_bfhk1gly",
    "color.background.danger.hovered": "_bfhk1yvi",
    "color.background.danger.pressed": "_bfhk1io2",
    "color.background.danger.bold": "_bfhkybec",
    "color.background.danger.bold.hovered": "_bfhks9hg",
    "color.background.danger.bold.pressed": "_bfhk9pqq",
    "color.background.warning": "_bfhk1tzq",
    "color.background.warning.hovered": "_bfhk1rd4",
    "color.background.warning.pressed": "_bfhk11dh",
    "color.background.warning.bold": "_bfhk190i",
    "color.background.warning.bold.hovered": "_bfhk1i4c",
    "color.background.warning.bold.pressed": "_bfhkrj9s",
    "color.background.success": "_bfhkmv6i",
    "color.background.success.hovered": "_bfhk1jgi",
    "color.background.success.pressed": "_bfhky4f1",
    "color.background.success.bold": "_bfhk8emd",
    "color.background.success.bold.hovered": "_bfhk1q4l",
    "color.background.success.bold.pressed": "_bfhkcrcn",
    "color.background.discovery": "_bfhk1nvp",
    "color.background.discovery.hovered": "_bfhk1xp7",
    "color.background.discovery.pressed": "_bfhkdlkp",
    "color.background.discovery.bold": "_bfhk1lri",
    "color.background.discovery.bold.hovered": "_bfhk1w72",
    "color.background.discovery.bold.pressed": "_bfhkrb53",
    "color.background.information": "_bfhk33gi",
    "color.background.information.hovered": "_bfhk1vps",
    "color.background.information.pressed": "_bfhk1s0z",
    "color.background.information.bold": "_bfhk14wj",
    "color.background.information.bold.hovered": "_bfhk1amz",
    "color.background.information.bold.pressed": "_bfhk5bth",
    "color.blanket": "_bfhk10xm",
    "color.blanket.selected": "_bfhk7wq0",
    "color.blanket.danger": "_bfhkrprw",
    "color.skeleton": "_bfhkn82g",
    "color.skeleton.subtle": "_bfhkh3tw",
    "elevation.surface": "_bfhkvuon",
    "elevation.surface.hovered": "_bfhk108i",
    "elevation.surface.pressed": "_bfhk1ji5",
    "elevation.surface.overlay": "_bfhk1bhr",
    "elevation.surface.overlay.hovered": "_bfhk16qz",
    "elevation.surface.overlay.pressed": "_bfhkvq0a",
    "elevation.surface.raised": "_bfhkhp5a",
    "elevation.surface.raised.hovered": "_bfhk1a0f",
    "elevation.surface.raised.pressed": "_bfhkf7u5",
    "elevation.surface.sunken": "_bfhkqbzx",
    "utility.elevation.surface.current": "_bfhkchd4"
};
var $3f0953ae2e06c136$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $3f0953ae2e06c136$var$setSurfaceTokenMap = {
    "elevation.surface": "_1q1lvuon",
    "elevation.surface.hovered": "_1q1l108i",
    "elevation.surface.pressed": "_1q1l1ji5",
    "elevation.surface.overlay": "_1q1l1bhr",
    "elevation.surface.overlay.hovered": "_1q1l16qz",
    "elevation.surface.overlay.pressed": "_1q1lvq0a",
    "elevation.surface.raised": "_1q1lhp5a",
    "elevation.surface.raised.hovered": "_1q1l1a0f",
    "elevation.surface.raised.pressed": "_1q1lf7u5",
    "elevation.surface.sunken": "_1q1lqbzx"
};
var $3f0953ae2e06c136$var$paddingBlockStartMap = {
    "space.0": "_1q51ze3t",
    "space.025": "_1q51v77o",
    "space.050": "_1q511b66",
    "space.075": "_1q5112x7",
    "space.100": "_1q51u2gc",
    "space.150": "_1q51utpp",
    "space.200": "_1q51pxbi",
    "space.250": "_1q51v47k",
    "space.300": "_1q511ejb",
    "space.400": "_1q51xy5q",
    "space.500": "_1q511jfw",
    "space.600": "_1q51oahv",
    "space.800": "_1q51xncg",
    "space.1000": "_1q511epz"
};
var $3f0953ae2e06c136$var$paddingBlockEndMap = {
    "space.0": "_85i5ze3t",
    "space.025": "_85i5v77o",
    "space.050": "_85i51b66",
    "space.075": "_85i512x7",
    "space.100": "_85i5u2gc",
    "space.150": "_85i5utpp",
    "space.200": "_85i5pxbi",
    "space.250": "_85i5v47k",
    "space.300": "_85i51ejb",
    "space.400": "_85i5xy5q",
    "space.500": "_85i51jfw",
    "space.600": "_85i5oahv",
    "space.800": "_85i5xncg",
    "space.1000": "_85i51epz"
};
var $3f0953ae2e06c136$var$paddingInlineStartMap = {
    "space.0": "_bozgze3t",
    "space.025": "_bozgv77o",
    "space.050": "_bozg1b66",
    "space.075": "_bozg12x7",
    "space.100": "_bozgu2gc",
    "space.150": "_bozgutpp",
    "space.200": "_bozgpxbi",
    "space.250": "_bozgv47k",
    "space.300": "_bozg1ejb",
    "space.400": "_bozgxy5q",
    "space.500": "_bozg1jfw",
    "space.600": "_bozgoahv",
    "space.800": "_bozgxncg",
    "space.1000": "_bozg1epz"
};
var $3f0953ae2e06c136$var$paddingInlineEndMap = {
    "space.0": "_y4tize3t",
    "space.025": "_y4tiv77o",
    "space.050": "_y4ti1b66",
    "space.075": "_y4ti12x7",
    "space.100": "_y4tiu2gc",
    "space.150": "_y4tiutpp",
    "space.200": "_y4tipxbi",
    "space.250": "_y4tiv47k",
    "space.300": "_y4ti1ejb",
    "space.400": "_y4tixy5q",
    "space.500": "_y4ti1jfw",
    "space.600": "_y4tioahv",
    "space.800": "_y4tixncg",
    "space.1000": "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $3f0953ae2e06c136$var$Box = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $7SYDx.default)(_ref, $3f0953ae2e06c136$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $7SYDx.default)(htmlAttributes, $3f0953ae2e06c136$var$_excluded2);
    var node = /*#__PURE__*/ $iSvIT.createElement(Component, (0, $7Iz7O.default)({
        style: style,
        ref: ref,
        className: (0, $lda32.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $3f0953ae2e06c136$var$backgroundColorMap[backgroundColor],
            backgroundColor && $3f0953ae2e06c136$var$isSurfaceToken(backgroundColor) && $3f0953ae2e06c136$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $3f0953ae2e06c136$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $3f0953ae2e06c136$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $3f0953ae2e06c136$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $3f0953ae2e06c136$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $iSvIT.createElement((0, $bkPXW.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $3f0953ae2e06c136$export$2e2bcd8739ae039 = $3f0953ae2e06c136$var$Box;
function $3f0953ae2e06c136$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $3f0953ae2e06c136$var$setSurfaceTokenMap;
}

});
parcelRegister("bkPXW", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $8409df4f5b571a4c$export$1ca2a26fecb070ae; });

var $iSvIT = parcelRequire("iSvIT");
var $8409df4f5b571a4c$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $8409df4f5b571a4c$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($8409df4f5b571a4c$export$1ca2a26fecb070ae);
};
$8409df4f5b571a4c$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("eqJ42", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $a8167337595c1aac$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $a8167337595c1aac$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: "@media all",
        xs: "@media (min-width: 30rem)",
        sm: "@media (min-width: 48rem)",
        md: "@media (min-width: 64rem)",
        lg: "@media (min-width: 90rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    only: {
        xxs: "@media (min-width: 0rem) and (max-width: 29.99rem)",
        xs: "@media (min-width: 30rem) and (max-width: 47.99rem)",
        sm: "@media (min-width: 48rem) and (max-width: 63.99rem)",
        md: "@media (min-width: 64rem) and (max-width: 89.99rem)",
        lg: "@media (min-width: 90rem) and (max-width: 110.49rem)",
        xl: "@media (min-width: 110.5rem)"
    },
    below: {
        xs: "@media not all and (min-width: 30rem)",
        sm: "@media not all and (min-width: 48rem)",
        md: "@media not all and (min-width: 64rem)",
        lg: "@media not all and (min-width: 90rem)",
        xl: "@media not all and (min-width: 110.5rem)"
    }
};

});

parcelRegister("crk1J", function(module, exports) {

$parcel$export(module.exports, "DesktopOnlyBackground", function () { return $90e78a93cf6dfe34$export$5e40b6732fa22ace; });
$parcel$export(module.exports, "useMatchMedia", function () { return $90e78a93cf6dfe34$export$dd42f485803cd57d; });

var $lEgX3 = parcelRequire("lEgX3");

var $iSvIT = parcelRequire("iSvIT");

var $2e1kT = parcelRequire("2e1kT");

var $52xdm = parcelRequire("52xdm");

var $eqJ42 = parcelRequire("eqJ42");
var $90e78a93cf6dfe34$export$5e40b6732fa22ace = function DesktopOnlyBackground(_ref) {
    var Background = _ref.background, children = _ref.children;
    var isAboveSmallScreen = $90e78a93cf6dfe34$export$dd42f485803cd57d((0, $eqJ42.media).above.sm);
    return isAboveSmallScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Background, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $52xdm.default), {
        isTinted: true
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children);
};
var $90e78a93cf6dfe34$export$dd42f485803cd57d = function useMatchMedia(mediaQuery) {
    var query = mediaQuery.replace("@media", "").trim();
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState(function() {
        return window.matchMedia(query).matches;
    }), _React$useState2 = (0, $lEgX3.default)(_React$useState, 2), matches = _React$useState2[0], setMatches = _React$useState2[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useLayoutEffect(function() {
        var screen = window.matchMedia(query);
        var unbind = (0, $2e1kT.bind)(screen, {
            type: "change",
            listener: function listener(e) {
                setMatches(e.matches);
            }
        });
        return unbind;
    }, [
        query
    ]);
    return matches;
};

});


parcelRegister("gxyqS", function(module, exports) {

$parcel$export(module.exports, "Actions", function () { return $c0aa6ffe2178729e$export$b52183d5cfb26dc9; });

var $iSvIT = parcelRequire("iSvIT");

var $cj21o = parcelRequire("cj21o");

var $lko3V = parcelRequire("lko3V");

var $lhYj7 = parcelRequire("lhYj7");

var $ctXy8 = parcelRequire("ctXy8");

var $kXKHz = parcelRequire("kXKHz");

var $1hoRn = parcelRequire("1hoRn");
var $c0aa6ffe2178729e$export$b52183d5cfb26dc9 = function Actions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1hoRn.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lko3V))), {
        label: "Lock Unlocked",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cj21o))), {
        label: "Eye Open",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kXKHz))), {
        label: "Thumbs Up",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lhYj7))), {
        label: "Share",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ctXy8))), {
        label: "Show More Horizontal",
        color: "var(--ds-icon-subtle, #626F86)"
    }));
};

});
parcelRegister("cj21o", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f58d3c8bc7fb5d3$var$_react = $8f58d3c8bc7fb5d3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $8f58d3c8bc7fb5d3$var$_baseNew = $8f58d3c8bc7fb5d3$var$_interopRequireDefault((parcelRequire("1VEy6")));
function $8f58d3c8bc7fb5d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f58d3c8bc7fb5d3$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $8f58d3c8bc7fb5d3$var$_react.default.createElement($8f58d3c8bc7fb5d3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$8f58d3c8bc7fb5d3$var$EyeOpenIcon.displayName = "EyeOpenIcon";
var $8f58d3c8bc7fb5d3$var$_default = module.exports.default = $8f58d3c8bc7fb5d3$var$EyeOpenIcon;

});

parcelRegister("lko3V", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25e57ba6be3183cfa1e359a1a5374e32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f86e2184a5a7ab16$var$_react = $f86e2184a5a7ab16$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $f86e2184a5a7ab16$var$_baseNew = $f86e2184a5a7ab16$var$_interopRequireDefault((parcelRequire("1VEy6")));
function $f86e2184a5a7ab16$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f86e2184a5a7ab16$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $f86e2184a5a7ab16$var$_react.default.createElement($f86e2184a5a7ab16$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$f86e2184a5a7ab16$var$LockUnlockedIcon.displayName = "LockUnlockedIcon";
var $f86e2184a5a7ab16$var$_default = module.exports.default = $f86e2184a5a7ab16$var$LockUnlockedIcon;

});

parcelRegister("lhYj7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccb1509d7e2270e6a953aebace8cfd49>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7f9f75134245093$var$_react = $f7f9f75134245093$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $f7f9f75134245093$var$_baseNew = $f7f9f75134245093$var$_interopRequireDefault((parcelRequire("1VEy6")));
function $f7f9f75134245093$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7f9f75134245093$var$ShareIcon = (props)=>/*#__PURE__*/ $f7f9f75134245093$var$_react.default.createElement($f7f9f75134245093$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$f7f9f75134245093$var$ShareIcon.displayName = "ShareIcon";
var $f7f9f75134245093$var$_default = module.exports.default = $f7f9f75134245093$var$ShareIcon;

});

parcelRegister("ctXy8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fb6bef909769872b46b1e0328cacf596>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $916662ca44291170$var$_react = $916662ca44291170$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $916662ca44291170$var$_baseNew = $916662ca44291170$var$_interopRequireDefault((parcelRequire("1VEy6")));
function $916662ca44291170$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $916662ca44291170$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $916662ca44291170$var$_react.default.createElement($916662ca44291170$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$916662ca44291170$var$ShowMoreHorizontalIcon.displayName = "ShowMoreHorizontalIcon";
var $916662ca44291170$var$_default = module.exports.default = $916662ca44291170$var$ShowMoreHorizontalIcon;

});

parcelRegister("kXKHz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1671a6ac4d424a875e471692b3026e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f42d8b52b8ec1034$var$_react = $f42d8b52b8ec1034$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $f42d8b52b8ec1034$var$_baseNew = $f42d8b52b8ec1034$var$_interopRequireDefault((parcelRequire("1VEy6")));
function $f42d8b52b8ec1034$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f42d8b52b8ec1034$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $f42d8b52b8ec1034$var$_react.default.createElement($f42d8b52b8ec1034$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.708 2.594a.5.5 0 0 0-.77.15L5.5 7.433V13.5h6.371c.493 0 .928-.32 1.074-.79l1.328-4.25A1.125 1.125 0 0 0 13.2 7H9.75A.75.75 0 0 1 9 6.25V3.075a.5.5 0 0 0-.175-.38zM4 13.5V8H2a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5zm.295-7 2.313-4.45a2 2 0 0 1 3.076-.596l.118.101a2 2 0 0 1 .698 1.519V5.5h2.7a2.625 2.625 0 0 1 2.505 3.408l-1.328 4.25A2.625 2.625 0 0 1 11.871 15H2a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2z" clip-rule="evenodd"/>`
    }, props));
$f42d8b52b8ec1034$var$ThumbsUpIcon.displayName = "ThumbsUpIcon";
var $f42d8b52b8ec1034$var$_default = module.exports.default = $f42d8b52b8ec1034$var$ThumbsUpIcon;

});


parcelRegister("9zWUh", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $6f95139a5b7fe850$export$2dc68d50d56fbbd; });

var $iSvIT = parcelRequire("iSvIT");

var $5pxzl = parcelRequire("5pxzl");
var $6f95139a5b7fe850$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5pxzl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($6f95139a5b7fe850$var$Image, null));
};
var $6f95139a5b7fe850$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 167,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#738496",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }));
};

});

parcelRegister("jiBRo", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $e0cd1106c92fb3e0$export$7c6e2c02157bb7d2; });

var $iSvIT = parcelRequire("iSvIT");

var $5pxzl = parcelRequire("5pxzl");
var $e0cd1106c92fb3e0$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5pxzl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($e0cd1106c92fb3e0$var$Image, null));
};
var $e0cd1106c92fb3e0$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        width: 640,
        height: 427,
        viewBox: "0 0 640 427",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 640,
        height: 20,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        y: 40,
        width: 60,
        height: 32,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 8,
        y: 53,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 68,
        y: 40,
        width: 99,
        height: 32,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 76,
        y: 53,
        width: 59,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(138 44)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M146.292 54.2929C146.105 54.4818 146 54.7368 146 55.0024C146 55.2681 146.105 55.523 146.292 55.7119L149.231 58.6769C149.449 58.8919 149.731 58.9989 150.01 58.9989C150.289 58.9989 150.566 58.8919 150.779 58.6769L153.709 55.7219C153.895 55.5329 154 55.278 154 55.0124C154 54.7469 153.895 54.492 153.709 54.3029C153.617 54.2098 153.507 54.1358 153.387 54.0853C153.266 54.0347 153.136 54.0087 153.006 54.0087C152.875 54.0087 152.745 54.0347 152.625 54.0853C152.504 54.1358 152.394 54.2098 152.303 54.3029L150.005 56.6199L147.698 54.2929C147.606 54.2001 147.496 54.1264 147.375 54.0762C147.255 54.0259 147.125 54 146.995 54C146.864 54 146.734 54.0259 146.614 54.0762C146.493 54.1264 146.384 54.2001 146.292 54.2929Z",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        y: 92,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        y: 120,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        y: 148,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        y: 200,
        width: 180,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 4,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 60,
        y: 232,
        width: 85,
        height: 20,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 64,
        y: 239,
        width: 77,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 153,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 157,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 213,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 217,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 14,
        y: 282,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#282E33",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
        cx: 27,
        cy: 295,
        r: 12,
        fill: "url(#pattern0_233_7702)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 46,
        y: 279,
        width: 591,
        height: 40,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 54,
        y: 295,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 44.2764,
        y: 385,
        width: 425.66,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 44.2764,
        y: 403,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 44.2764,
        y: 421,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 44,
        y: 356,
        width: 119,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 10,
        y: 346,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#282E33",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
        cx: 23,
        cy: 359,
        r: 12,
        fill: "url(#pattern1_233_7702)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("pattern", {
        id: "pattern0_233_7702",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("use", {
        xlinkHref: "#image0_233_7702",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("pattern", {
        id: "pattern1_233_7702",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("use", {
        xlinkHref: "#image1_233_7702",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("image", {
        id: "image0_233_7702",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgMBAQEAAAAAAAAAAAAAAwYCBAUACAf/xAAuEAACAQMCBAQGAgMAAAAAAAABAgMABAUGERITITEHQVFhFCJCcYGRMuFiobH/xAAXAQEBAQEAAAAAAAAAAAAAAAAGBwUE/8QAKREAAQMDAgQGAwAAAAAAAAAAAgEDEQAEEgVBBiExURMUInGB8JGx0f/aAAwDAQACEQMRAD8ASqjI6xozuwVFG5J7AVKlzWN0UghtkO3MPE32HYfv/lWK9uUtWCeXb91PrZlX3EbTeoXmqArlbOEMo+uQ7b/ioW2qX4wLq3Xg9Yz1H4NYWNsbrJ5C3sbCB57u4cRxRIN2ZjVrUuEvdOZy7xOUi5d3bPwsPJh5Mp81I6g0IXW7xTnP4hIpMmmW+EY/NO9tcRXUCywOHjbsRRaT9IXTR3z2xPySqSB/kP6pwplp155xhHYhei+9HLy38u6obbV1A0Tp4as8UbS0vbZp8VDKi3Q3IUJwkhSR1HEw26Uesu3z2R0dqqHK4925EskUk0X0y8tgeE/72+5rN4lBwrP0bL/a7NFIBufX2r1tpvR2ndNMz4LD2dlKw2aSNN3I9OI7nb80bUGl8HqJUGcxNnfFBsjTRAso9A3cfurGn8zY6gw1rlMVMJrO5QOjDuPVT6EHoR6irl1cQ2ltLcXUqQwRKXkkc7Kigbkk+QqVqpZSvWqCgjjy6V5R8btI22kddY+4wdktriZ0iAWMnhWXdgy9Tv1A3/dUfOh651bca913PNA8gwlvMHt4yNhwoOEOfdup28t6JVN4VbcG2JT3WgmvGBPogdq6g3VrFewmCZONW8vPf296MASQB1Jp1xOKhso1dlDXBHVj9J9BW/cuAAQaTO1ZDQkpSKxFNfgBgMlp7Tt/zpX+FurkSwROOoAXZiR7nb9VreNmFympdES2ljMUCTJNNGvTmRrvuO/XqQdj6VgYrMX2LLfBTlFbqyEBlP4NFyueyOUj5d3PvF35aKFU/fbvU+c0NwrzxhjCZjn07fVpeGsNpa+EqLlETy/P1K+N2eOjxkZt442Rgfn4v5E+9WKe8jjoL+MiRQJNvlcdx/VIsiFHZG6MpIP3p/aOAQYAkRtRF4SyyJZmv//Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("image", {
        id: "image1_233_7702",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABAADBQYHAQL/xAApEAABAwMDAwQCAwAAAAAAAAABAgMEAAUREiFBBlFxBzFCYROBkdHh/8QAFwEBAQEBAAAAAAAAAAAAAAAABgcEBf/EACkRAAEDAwIFAwUAAAAAAAAAAAECAxEABCEFEgYxUXGRIjLRQaHB4fD/2gAMAwEAAhEDEQA/AH6VKirXCXcJzUds4KjursOTTRa0tpK1GAKizTS3lpbbEqJgdzQoBJwASfquqSUnCgQfsVp9ut0a3tBEZoA8rIypXk07LiMTGi3JaS4k9xuPB4o2eJUb4DZ29Zz4/dO08BulqVPAL6RjzP4rKqVSV/thtc4tglTSxqbUe3Y/YqNpGy6l5AcQZBoPc2zlq6pl0QpJg0qs3QjeZ8hzAwlvT/J/yqzRMCfJt7inIa0pWRjChkHyKz6gwt+3W03zNbdFumrO+bfe9qT9O3zWp0qpULrV+54j2qzuv3FIy60t1KUIA98H3O/1XuR1m9anvxdQ2h6GtadTQacS7qHY+2Kn5tHQdsZ6SJ8VbhdNEbgcdcx5ojr1GY8RzHspSc+QP6qm0dc7vKuykrkANoGShofAHgnk/dA070q3Xb2qW3OfzmozxFeNXuoOPM8sDvAie2KVMyX0x2itW/AA5p6oqfAdWsuNrLmfio7jxW9ZIGK47SUqV6jFWprpJi8QIlwizFRZimxqWydSc/ogg42O9e4/RsS3OG4Xq5KfLe4U5skHjJJJOO1A+mocavT6XVuNthknQThKjkDcc131LbccvEb8LjjqFM50A5SggkbDjNFF2dyq5LZUdpzMfaqa1rVo3p6XEoG9MJiegif7zUew8h9GtB2zinaioEB1Cw44st4+KTufNStK0EkZqZupSFek1//Z"
    })));
};

});

parcelRegister("3GfsQ", function(module, exports) {

$parcel$export(module.exports, "DetailsPanel", function () { return $2ae14a3c0ca9fefc$export$e54a7f2505304e20; });
/* details-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $iSvIT = parcelRequire("iSvIT");

var $5pxzl = parcelRequire("5pxzl");
var $2ae14a3c0ca9fefc$var$styles = {
    wrapper: "_kqsw1n9t _1xi2ze3t _19bvutpp _u5f3xy5q"
};
var $2ae14a3c0ca9fefc$export$e54a7f2505304e20 = function DetailsPanel() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5pxzl.default), {
        xcss: $2ae14a3c0ca9fefc$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($2ae14a3c0ca9fefc$var$Image, null));
};
var $2ae14a3c0ca9fefc$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        width: 328,
        height: 597,
        viewBox: "0 0 328 597",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 80,
        height: 32,
        rx: 3,
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 17,
        y: 13,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#0055CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        d: "M0 52C0 47.5817 3.58172 44 8 44H320C324.418 44 328 47.5817 328 52V597H0V52Z",
        fill: "#1D2125"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        d: "M0.5 52C0.5 47.8579 3.85786 44.5 8 44.5H320C324.142 44.5 327.5 47.8579 327.5 52V596.5H0.5V52Z",
        stroke: "#A1BDD9",
        strokeOpacity: 0.08
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 77,
        width: 253,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(280 68)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M288.292 78.2929C288.105 78.4818 288 78.7368 288 79.0024C288 79.2681 288.105 79.523 288.292 79.7119L291.231 82.6769C291.449 82.8919 291.731 82.9989 292.01 82.9989C292.289 82.9989 292.566 82.8919 292.779 82.6769L295.709 79.7219C295.895 79.5329 296 79.278 296 79.0124C296 78.7469 295.895 78.492 295.709 78.3029C295.617 78.2098 295.507 78.1358 295.387 78.0853C295.266 78.0347 295.136 78.0087 295.006 78.0087C294.875 78.0087 294.745 78.0347 294.625 78.0853C294.504 78.1358 294.394 78.2098 294.303 78.3029L292.005 80.6199L289.698 78.2929C289.606 78.2001 289.496 78.1264 289.375 78.0762C289.255 78.0259 289.125 78 288.995 78C288.864 78 288.734 78.0259 288.614 78.0762C288.493 78.1264 288.384 78.2001 288.292 78.2929Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 121,
        width: 79,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 159,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 197,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 235,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 273,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 311,
        width: 110,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 349,
        width: 100,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 387,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 425,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 463,
        width: 95,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(178 112)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        d: "M190.522 131.853L190.625 131.781L195.625 127.781C196.056 127.436 196.126 126.807 195.781 126.375C195.462 125.977 194.902 125.887 194.478 126.147L194.375 126.219L190 129.72L185.625 126.219C185.227 125.901 184.66 125.936 184.304 126.282L184.219 126.375C183.901 126.773 183.936 127.34 184.282 127.696L184.375 127.781L189.375 131.781C189.707 132.046 190.166 132.071 190.522 131.853Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        d: "M190.522 126.853L190.625 126.781L195.625 122.781C196.056 122.436 196.126 121.807 195.781 121.375C195.462 120.977 194.902 120.887 194.478 121.147L194.375 121.219L190 124.72L185.625 121.219C185.227 120.901 184.66 120.936 184.304 121.282L184.219 121.375C183.901 121.773 183.936 122.34 184.282 122.696L184.375 122.781L189.375 126.781C189.707 127.046 190.166 127.071 190.522 126.853Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        d: "M190.522 121.853L190.625 121.781L195.625 117.781C196.056 117.436 196.126 116.807 195.781 116.375C195.462 115.977 194.902 115.887 194.478 116.147L194.375 116.219L190 119.72L185.625 116.219C185.227 115.901 184.66 115.936 184.304 116.282L184.219 116.375C183.901 116.773 183.936 117.34 184.282 117.696L184.375 117.781L189.375 121.781C189.707 122.046 190.166 122.071 190.522 121.853Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 210,
        y: 121,
        width: 66,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 159,
        width: 98,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 188,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 182,
        y: 195,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("g", {
        opacity: 0.8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 177,
        y: 230,
        width: 18,
        height: 18,
        rx: 9,
        stroke: "#282E33",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
        cx: 186,
        cy: 239,
        r: 8,
        fill: "url(#pattern0_233_7667)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 202,
        y: 236,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 273,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 311,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 349,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 387,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 425,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 463,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("pattern", {
        id: "pattern0_233_7667",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("use", {
        xlinkHref: "#image0_233_7667",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("image", {
        id: "image0_233_7667",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgIDAQAAAAAAAAAAAAAAAAcDBgQFCAH/xAAsEAABAwMCBQMDBQAAAAAAAAABAgMEAAURBiESEzFBUQeBkSJhcRQVMjOh/8QAFwEBAQEBAAAAAAAAAAAAAAAABwYEBf/EACkRAAEEAQIFBAIDAAAAAAAAAAECAwQRAAVREyExYYEGEnGhB0GisfD/2gAMAwEAAhEDEQA/AKVRRWXa4S7hObjt7FR3PgdzTLIkNxmlPvGkpBJOwHXDtllb7iWmxalGgO5zFSCo4SCT4FCkKQcKSUn7jFOpnRMqzx0CLDS4CASto8Sj+e9TtaQm3VBblREIaPeQMfA60YufktYlcJuEoo3ujW9VX8vOXSPRCSxxFyUhW1cvi7v68YjaK3GqLOqz3JbIyWiTw57YOCPatPSTAnM6hHRKjm0KFj/bg8j3yJlxXIbymHhSk9cKYXo9ZjOvBlvI4oqFBk468WOLf7fT/tL2rHorVc3S9wDkdQVFcUnntKGeJIO+PBxnesevQXJ8ByM11VXX9gEEjyBWatIlIiS0POdBf9EA+M6foqKLIalRmpEdYcZdQFoUOikkZBqU0QkEGjiMCCLGJj1ss/JImR0HlBaVOE9ApeRt7ppSVd/U3WMjUF1fhsOj9qju4aSkf2EbcZPffOPtVIpV9M6e5p0BLLnKyVVt7jdfeH+uzETJZcRsBe9csK9QlS1hKElSj0AGSakiR1ypTTDQytxQSKY9stsa3NBMdAC8fU4f5K9660mUlgVVk5zmWC78YxPTX9XC0Xa2ZjauMIKglWykpKiQPgitzfHJEu0TY8RPA86wtCFZ34ikgVW7Xq3ltJbuDKnCnbmN4yfyKnnawZ5ZEGMsuHop3AA9h1otf0+Y5KU57OZUT25m8v2Z0REcI93QV36VnO8iO9GcLchpbTg2KVpII+ajpqXdhF35huA5q1nJX3B8jxSzuEVUKa9HXuW1Yz5HY/FKESXxxShSsgZDHCNg2M//2Q=="
    })));
};

});

parcelRegister("aFJfj", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $7c50d49fce046825$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $iSvIT = parcelRequire("iSvIT");

var $5pxzl = parcelRequire("5pxzl");
var $eqJ42 = parcelRequire("eqJ42");

var $crk1J = parcelRequire("crk1J");
var $7c50d49fce046825$var$styles = {
    background: "_1s7z7r9e _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $7c50d49fce046825$export$1a35787d6353cf6a = function SideNav() {
    var isAboveMediumScreen = (0, $crk1J.useMatchMedia)((0, $eqJ42.media).above.md);
    return isAboveMediumScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5pxzl.default), {
        xcss: $7c50d49fce046825$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($7c50d49fce046825$var$Image, null)) : null;
};
var $7c50d49fce046825$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 296,
        height: 473,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M265.25 151.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 150.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M285.5 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 72,
        height: 9,
        x: 20,
        y: 189,
        fill: "#596773",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 278,
        height: 43,
        x: 18,
        y: 215,
        fill: "#1C2B41",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 220.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 224,
        fill: "#05C",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#1868DB",
        d: "M18 229h2.66v15.96H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 232.5,
        fill: "#05C",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M259.25 237.25v4.25h1.5v-4.25H265v-1.5h-4.25v-4.25h-1.5v4.25H255v1.5h4.25ZM279.25 236.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M279.5 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM284.25 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM289 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 263.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 267,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 275.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 306.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 310,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 318.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M20 349.5h32v32H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M39 360.5H25V359h14v1.5Zm0 5.25H25v-1.5h14v1.5ZM32 371h-7v-1.5h7v1.5Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 64,
        y: 361.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 392.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 396.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 404.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 408.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 435.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M9.667 451.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 451a1.667 1.667 0 1 1 3.333 0A1.667 1.667 0 0 1 8 451Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 451a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 451A1.667 1.667 0 1 1 24 451a1.667 1.667 0 0 1-3.333 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M10 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 451a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 447.5,
        fill: "#454F59",
        rx: 3.99
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        d: "M0 0h296v473H0z"
    }))));
};

});


parcelRegister("7B0iM", function(module, exports) {

$parcel$export(module.exports, "JiraLightTheme", function () { return $587c390c00f20edc$export$8e2414c6a082747f; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $iSvIT = parcelRequire("iSvIT");

var $1hoRn = parcelRequire("1hoRn");
var $9u3VS = parcelRequire("9u3VS");

var $lPRos = parcelRequire("lPRos");

var $86zeL = parcelRequire("86zeL");

var $4XzXM = parcelRequire("4XzXM");

var $gxyqS = parcelRequire("gxyqS");

var $hmllS = parcelRequire("hmllS");

var $9JnaO = parcelRequire("9JnaO");

var $h2MU7 = parcelRequire("h2MU7");

var $65mQT = parcelRequire("65mQT");
var $587c390c00f20edc$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q",
    content: "_19bvxy5q"
};
var $587c390c00f20edc$export$8e2414c6a082747f = function JiraLightTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $86zeL.Background), {
        testId: "testId-jira-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $4XzXM.TopNav), {
        product: (0, $lPRos.Products).JIRA
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1hoRn.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $65mQT.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $9u3VS.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1hoRn.default), {
        xcss: $587c390c00f20edc$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $hmllS.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $gxyqS.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1hoRn.default), {
        xcss: $587c390c00f20edc$var$styles.content,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $9JnaO.Content), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $h2MU7.DetailsPanel), null)))));
};

});
parcelRegister("hmllS", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $ca350dc88abdea9f$export$2dc68d50d56fbbd; });

var $iSvIT = parcelRequire("iSvIT");

var $5pxzl = parcelRequire("5pxzl");
var $ca350dc88abdea9f$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5pxzl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($ca350dc88abdea9f$var$Image, null));
};
var $ca350dc88abdea9f$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 167,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#8590A2",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }));
};

});

parcelRegister("9JnaO", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $715a4acb7a1c29ba$export$7c6e2c02157bb7d2; });

var $iSvIT = parcelRequire("iSvIT");

var $5pxzl = parcelRequire("5pxzl");
var $715a4acb7a1c29ba$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5pxzl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($715a4acb7a1c29ba$var$Image, null));
};
var $715a4acb7a1c29ba$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        width: 640,
        height: 427,
        viewBox: "0 0 640 427",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 640,
        height: 20,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        y: 40,
        width: 60,
        height: 32,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 8,
        y: 53,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 68,
        y: 40,
        width: 99,
        height: 32,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 76,
        y: 53,
        width: 59,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(138 44)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M146.292 54.2929C146.105 54.4818 146 54.7368 146 55.0024C146 55.2681 146.105 55.523 146.292 55.7119L149.231 58.6769C149.449 58.8919 149.731 58.9989 150.01 58.9989C150.289 58.9989 150.566 58.8919 150.779 58.6769L153.709 55.7219C153.895 55.5329 154 55.278 154 55.0124C154 54.7469 153.895 54.492 153.709 54.3029C153.617 54.2098 153.507 54.1358 153.387 54.0853C153.266 54.0347 153.136 54.0087 153.006 54.0087C152.875 54.0087 152.745 54.0347 152.625 54.0853C152.504 54.1358 152.394 54.2098 152.303 54.3029L150.005 56.6199L147.698 54.2929C147.606 54.2001 147.496 54.1264 147.375 54.0762C147.255 54.0259 147.125 54 146.995 54C146.864 54 146.734 54.0259 146.614 54.0762C146.493 54.1264 146.384 54.2001 146.292 54.2929Z",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        y: 92,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        y: 120,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        y: 148,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        y: 200,
        width: 180,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 4,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 60,
        y: 232,
        width: 85,
        height: 20,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 64,
        y: 239,
        width: 77,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 153,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 157,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 213,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 217,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 14,
        y: 282,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
        cx: 27,
        cy: 295,
        r: 12,
        fill: "url(#pattern0_233_6340)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 46,
        y: 279,
        width: 591,
        height: 40,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 54,
        y: 295,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 44.2764,
        y: 385,
        width: 425.66,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 44.2764,
        y: 403,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 44.2764,
        y: 421,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 44,
        y: 356,
        width: 119,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 10,
        y: 346,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
        cx: 23,
        cy: 359,
        r: 12,
        fill: "url(#pattern1_233_6340)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("pattern", {
        id: "pattern0_233_6340",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("use", {
        xlinkHref: "#image0_233_6340",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("pattern", {
        id: "pattern1_233_6340",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("use", {
        xlinkHref: "#image1_233_6340",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("image", {
        id: "image0_233_6340",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgMBAQEAAAAAAAAAAAAAAwYCBAUACAf/xAAuEAACAQMCBAQGAgMAAAAAAAABAgMABAUGERITITEHQVFhFCJCcYGRMuFiobH/xAAXAQEBAQEAAAAAAAAAAAAAAAAGBwUE/8QAKREAAQMDAgQGAwAAAAAAAAAAAgEDEQAEEgVBBiExURMUInGB8JGx0f/aAAwDAQACEQMRAD8ASqjI6xozuwVFG5J7AVKlzWN0UghtkO3MPE32HYfv/lWK9uUtWCeXb91PrZlX3EbTeoXmqArlbOEMo+uQ7b/ioW2qX4wLq3Xg9Yz1H4NYWNsbrJ5C3sbCB57u4cRxRIN2ZjVrUuEvdOZy7xOUi5d3bPwsPJh5Mp81I6g0IXW7xTnP4hIpMmmW+EY/NO9tcRXUCywOHjbsRRaT9IXTR3z2xPySqSB/kP6pwplp155xhHYhei+9HLy38u6obbV1A0Tp4as8UbS0vbZp8VDKi3Q3IUJwkhSR1HEw26Uesu3z2R0dqqHK4925EskUk0X0y8tgeE/72+5rN4lBwrP0bL/a7NFIBufX2r1tpvR2ndNMz4LD2dlKw2aSNN3I9OI7nb80bUGl8HqJUGcxNnfFBsjTRAso9A3cfurGn8zY6gw1rlMVMJrO5QOjDuPVT6EHoR6irl1cQ2ltLcXUqQwRKXkkc7Kigbkk+QqVqpZSvWqCgjjy6V5R8btI22kddY+4wdktriZ0iAWMnhWXdgy9Tv1A3/dUfOh651bca913PNA8gwlvMHt4yNhwoOEOfdup28t6JVN4VbcG2JT3WgmvGBPogdq6g3VrFewmCZONW8vPf296MASQB1Jp1xOKhso1dlDXBHVj9J9BW/cuAAQaTO1ZDQkpSKxFNfgBgMlp7Tt/zpX+FurkSwROOoAXZiR7nb9VreNmFympdES2ljMUCTJNNGvTmRrvuO/XqQdj6VgYrMX2LLfBTlFbqyEBlP4NFyueyOUj5d3PvF35aKFU/fbvU+c0NwrzxhjCZjn07fVpeGsNpa+EqLlETy/P1K+N2eOjxkZt442Rgfn4v5E+9WKe8jjoL+MiRQJNvlcdx/VIsiFHZG6MpIP3p/aOAQYAkRtRF4SyyJZmv//Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("image", {
        id: "image1_233_6340",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABAADBQYHAQL/xAApEAABAwMDAwQCAwAAAAAAAAABAgMEAAUREiFBBlFxBzFCYROBkdHh/8QAFwEBAQEBAAAAAAAAAAAAAAAABgcEBf/EACkRAAEDAwIFAwUAAAAAAAAAAAECAxEABCEFEgYxUXGRIjLRQaHB4fD/2gAMAwEAAhEDEQA/AH6VKirXCXcJzUds4KjursOTTRa0tpK1GAKizTS3lpbbEqJgdzQoBJwASfquqSUnCgQfsVp9ut0a3tBEZoA8rIypXk07LiMTGi3JaS4k9xuPB4o2eJUb4DZ29Zz4/dO08BulqVPAL6RjzP4rKqVSV/thtc4tglTSxqbUe3Y/YqNpGy6l5AcQZBoPc2zlq6pl0QpJg0qs3QjeZ8hzAwlvT/J/yqzRMCfJt7inIa0pWRjChkHyKz6gwt+3W03zNbdFumrO+bfe9qT9O3zWp0qpULrV+54j2qzuv3FIy60t1KUIA98H3O/1XuR1m9anvxdQ2h6GtadTQacS7qHY+2Kn5tHQdsZ6SJ8VbhdNEbgcdcx5ojr1GY8RzHspSc+QP6qm0dc7vKuykrkANoGShofAHgnk/dA070q3Xb2qW3OfzmozxFeNXuoOPM8sDvAie2KVMyX0x2itW/AA5p6oqfAdWsuNrLmfio7jxW9ZIGK47SUqV6jFWprpJi8QIlwizFRZimxqWydSc/ogg42O9e4/RsS3OG4Xq5KfLe4U5skHjJJJOO1A+mocavT6XVuNthknQThKjkDcc131LbccvEb8LjjqFM50A5SggkbDjNFF2dyq5LZUdpzMfaqa1rVo3p6XEoG9MJiegif7zUew8h9GtB2zinaioEB1Cw44st4+KTufNStK0EkZqZupSFek1//Z"
    })));
};

});

parcelRegister("h2MU7", function(module, exports) {

$parcel$export(module.exports, "DetailsPanel", function () { return $c6888eee8dbc8fdb$export$e54a7f2505304e20; });
/* details-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $iSvIT = parcelRequire("iSvIT");

var $5pxzl = parcelRequire("5pxzl");
var $c6888eee8dbc8fdb$var$styles = {
    wrapper: "_kqsw1n9t _1xi2ze3t _19bvutpp _u5f3xy5q"
};
var $c6888eee8dbc8fdb$export$e54a7f2505304e20 = function DetailsPanel() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5pxzl.default), {
        xcss: $c6888eee8dbc8fdb$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($c6888eee8dbc8fdb$var$Image, null));
};
var $c6888eee8dbc8fdb$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        width: 328,
        height: 597,
        viewBox: "0 0 328 597",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 80,
        height: 32,
        rx: 3,
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 17,
        y: 13,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#85B8FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        d: "M0 52C0 47.5817 3.58172 44 8 44H320C324.418 44 328 47.5817 328 52V597H0V52Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        d: "M0.5 52C0.5 47.8579 3.85786 44.5 8 44.5H320C324.142 44.5 327.5 47.8579 327.5 52V596.5H0.5V52Z",
        stroke: "#091E42",
        strokeOpacity: 0.06
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 77,
        width: 253,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(280 68)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M288.292 78.2929C288.105 78.4818 288 78.7368 288 79.0024C288 79.2681 288.105 79.523 288.292 79.7119L291.231 82.6769C291.449 82.8919 291.731 82.9989 292.01 82.9989C292.289 82.9989 292.566 82.8919 292.779 82.6769L295.709 79.7219C295.895 79.5329 296 79.278 296 79.0124C296 78.7469 295.895 78.492 295.709 78.3029C295.617 78.2098 295.507 78.1358 295.387 78.0853C295.266 78.0347 295.136 78.0087 295.006 78.0087C294.875 78.0087 294.745 78.0347 294.625 78.0853C294.504 78.1358 294.394 78.2098 294.303 78.3029L292.005 80.6199L289.698 78.2929C289.606 78.2001 289.496 78.1264 289.375 78.0762C289.255 78.0259 289.125 78 288.995 78C288.864 78 288.734 78.0259 288.614 78.0762C288.493 78.1264 288.384 78.2001 288.292 78.2929Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 121,
        width: 79,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 159,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 197,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 235,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 273,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 311,
        width: 110,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 349,
        width: 100,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 387,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 425,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 24,
        y: 463,
        width: 95,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(178 112)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        d: "M190.522 131.853L190.625 131.781L195.625 127.781C196.056 127.436 196.126 126.807 195.781 126.375C195.462 125.977 194.902 125.887 194.478 126.147L194.375 126.219L190 129.72L185.625 126.219C185.227 125.901 184.66 125.936 184.304 126.282L184.219 126.375C183.901 126.773 183.936 127.34 184.282 127.696L184.375 127.781L189.375 131.781C189.707 132.046 190.166 132.071 190.522 131.853Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        d: "M190.522 126.853L190.625 126.781L195.625 122.781C196.056 122.436 196.126 121.807 195.781 121.375C195.462 120.977 194.902 120.887 194.478 121.147L194.375 121.219L190 124.72L185.625 121.219C185.227 120.901 184.66 120.936 184.304 121.282L184.219 121.375C183.901 121.773 183.936 122.34 184.282 122.696L184.375 122.781L189.375 126.781C189.707 127.046 190.166 127.071 190.522 126.853Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        d: "M190.522 121.853L190.625 121.781L195.625 117.781C196.056 117.436 196.126 116.807 195.781 116.375C195.462 115.977 194.902 115.887 194.478 116.147L194.375 116.219L190 119.72L185.625 116.219C185.227 115.901 184.66 115.936 184.304 116.282L184.219 116.375C183.901 116.773 183.936 117.34 184.282 117.696L184.375 117.781L189.375 121.781C189.707 122.046 190.166 122.071 190.522 121.853Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 210,
        y: 121,
        width: 66,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 159,
        width: 98,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 188,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 182,
        y: 195,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("g", {
        opacity: 0.8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 177,
        y: 230,
        width: 18,
        height: 18,
        rx: 9,
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("circle", {
        cx: 186,
        cy: 239,
        r: 8,
        fill: "url(#pattern0_233_6342)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 202,
        y: 236,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 273,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 311,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 349,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 387,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 425,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        x: 178,
        y: 463,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("pattern", {
        id: "pattern0_233_6342",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("use", {
        xlinkHref: "#image0_233_6342",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("image", {
        id: "image0_233_6342",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgIDAQAAAAAAAAAAAAAAAAcDBgQFCAH/xAAsEAABAwMCBQMDBQAAAAAAAAABAgMEAAURBiESEzFBUQeBkSJhcRQVMjOh/8QAFwEBAQEBAAAAAAAAAAAAAAAABwYEBf/EACkRAAEEAQIFBAIDAAAAAAAAAAECAwQRAAVREyExYYEGEnGhB0GisfD/2gAMAwEAAhEDEQA/AKVRRWXa4S7hObjt7FR3PgdzTLIkNxmlPvGkpBJOwHXDtllb7iWmxalGgO5zFSCo4SCT4FCkKQcKSUn7jFOpnRMqzx0CLDS4CASto8Sj+e9TtaQm3VBblREIaPeQMfA60YufktYlcJuEoo3ujW9VX8vOXSPRCSxxFyUhW1cvi7v68YjaK3GqLOqz3JbIyWiTw57YOCPatPSTAnM6hHRKjm0KFj/bg8j3yJlxXIbymHhSk9cKYXo9ZjOvBlvI4oqFBk468WOLf7fT/tL2rHorVc3S9wDkdQVFcUnntKGeJIO+PBxnesevQXJ8ByM11VXX9gEEjyBWatIlIiS0POdBf9EA+M6foqKLIalRmpEdYcZdQFoUOikkZBqU0QkEGjiMCCLGJj1ss/JImR0HlBaVOE9ApeRt7ppSVd/U3WMjUF1fhsOj9qju4aSkf2EbcZPffOPtVIpV9M6e5p0BLLnKyVVt7jdfeH+uzETJZcRsBe9csK9QlS1hKElSj0AGSakiR1ypTTDQytxQSKY9stsa3NBMdAC8fU4f5K9660mUlgVVk5zmWC78YxPTX9XC0Xa2ZjauMIKglWykpKiQPgitzfHJEu0TY8RPA86wtCFZ34ikgVW7Xq3ltJbuDKnCnbmN4yfyKnnawZ5ZEGMsuHop3AA9h1otf0+Y5KU57OZUT25m8v2Z0REcI93QV36VnO8iO9GcLchpbTg2KVpII+ajpqXdhF35huA5q1nJX3B8jxSzuEVUKa9HXuW1Yz5HY/FKESXxxShSsgZDHCNg2M//2Q=="
    })));
};

});

parcelRegister("65mQT", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $46e4efac468c5e8d$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $iSvIT = parcelRequire("iSvIT");

var $5pxzl = parcelRequire("5pxzl");
var $eqJ42 = parcelRequire("eqJ42");

var $crk1J = parcelRequire("crk1J");
var $46e4efac468c5e8d$var$styles = {
    background: "_1s7z7r9e _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $46e4efac468c5e8d$export$1a35787d6353cf6a = function SideNav() {
    var isAboveMediumScreen = (0, $crk1J.useMatchMedia)((0, $eqJ42.media).above.md);
    return isAboveMediumScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5pxzl.default), {
        xcss: $46e4efac468c5e8d$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($46e4efac468c5e8d$var$Image, null)) : null;
};
var $46e4efac468c5e8d$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 296,
        height: 473,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M265.25 151.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 150.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M285.5 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 72,
        height: 9,
        x: 20,
        y: 189,
        fill: "#B3B9C4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 278,
        height: 43,
        x: 18,
        y: 215,
        fill: "#E9F2FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 220.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 224,
        fill: "#85B8FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#1868DB",
        d: "M18 229h2.66v15.96H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 232.5,
        fill: "#85B8FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M259.25 237.25v4.25h1.5v-4.25H265v-1.5h-4.25v-4.25h-1.5v4.25H255v1.5h4.25ZM279.25 236.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M279.5 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM284.25 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM289 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 263.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 267,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 275.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 306.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 310,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 318.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M20 349.5h32v32H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M39 360.5H25V359h14v1.5Zm0 5.25H25v-1.5h14v1.5ZM32 371h-7v-1.5h7v1.5Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 64,
        y: 361.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 392.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 396.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 404.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 408.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 435.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M9.667 451.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 451a1.667 1.667 0 1 1 3.335 0A1.667 1.667 0 0 1 8 451Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 451a1.667 1.667 0 1 1 3.335 0 1.667 1.667 0 0 1-3.335 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 451A1.667 1.667 0 1 1 24 451a1.667 1.667 0 0 1-3.334 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M10 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 451a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 447.5,
        fill: "#DCDFE4",
        rx: 3.99
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("path", {
        fill: "#fff",
        d: "M0 0h296v473H0z"
    }))));
};

});



parcelRegister("d1moV", function(module, exports) {

$parcel$export(module.exports, "LottieAnimation", function () { return $87647452245629ab$export$fd187eefb1144831; });
/* lottie-animation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $eVwxl = parcelRequire("eVwxl");
const $87647452245629ab$var$jiraWireFrameStyle = null;
const $87647452245629ab$export$fd187eefb1144831 = ({ options: options, eventListener: eventListener })=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1reo15vq _18m915vq _1pbykb7n"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eVwxl))), {
            options: options,
            eventListeners: eventListener
        })
    });

});

parcelRegister("26ozz", function(module, exports) {
$parcel$export(module.exports, "ModalOverlay", function () { return (parcelRequire("eOJAH")).ModalOverlay; });
parcelRequire("eOJAH");

});
parcelRegister("eOJAH", function(module, exports) {

$parcel$export(module.exports, "ModalOverlay", function () { return $bf6ebe546d5f1d79$export$8948f78d83984c69; });
/* modal-overlay.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $a6bec = parcelRequire("a6bec");
const $bf6ebe546d5f1d79$export$8948f78d83984c69 = ({ logo: logo, secondary: secondary, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _1tke1kxc _1bsbauwl _3zne1h6o _1jcr12am _9l1112am _15ct12am _p2d412am"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _2lx21bp4 _zulp1wqb _ca0q1ul9 _u5f31ul9 _n3td1ul9 _19bv1ul9 _13pgu67f _1ela1y44 _1jcr12am _9l1112am _15ct12am _p2d412am _glte1vuk _10jxoc2w"
            ]),
            children: [
                logo && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1bah1h6o",
                        secondary && "_1upzv2br"
                    ]),
                    children: logo
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1bah1h6o _ect41qje _1wyboxwj _zulp12am _p12f1osq _1vfhahaf _1twlbfng _1xd21btq _rzbyidpf _8k2zidpf _nd4uidpf _9u9nidpf _11eb1kw7 _l5k14jg8 _17z410nf _1n461kwk _if5yidpf _1gnp1k92 _7e5bidpf _iowe1h6o _1afj1h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_p12f1osq",
                                secondary && "_1ykj1e5h _srtl1e5h"
                            ]),
                            children: children
                        }),
                        secondary && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1e0cglyw _16jlkb7n _1o9zkb7n _i0dlf1ug _1sm81ule"
                            ]),
                            children: secondary
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_16jlcs5v _y063kb7n"
                    ])
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _1bah1h6o _syaz2c9p _1wyb1skh _k48p1fw0",
                        secondary && "_1upzh9n0"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $a6bec.AtlassianLogo), {
                        appearance: "neutral",
                        size: "xxsmall"
                    })
                })
            ]
        })
    });
};
// point at which JiraBackground becomes visible
const $bf6ebe546d5f1d79$var$modalBreakpoint = "@media (min-width: 801px)";
const $bf6ebe546d5f1d79$var$imageBreakpoint = "@media (min-width: 1100px)";
const $bf6ebe546d5f1d79$var$positioningFrameCss = null;
const $bf6ebe546d5f1d79$var$modalOverlayCss = null;
const $bf6ebe546d5f1d79$var$logoCss = null;
const $bf6ebe546d5f1d79$var$leftAlignLogoCss = null;
const $bf6ebe546d5f1d79$var$fontSize = {
    xs: "0.75rem",
    // 12px
    sm: "0.875rem",
    // 14px
    md: "1rem",
    // 16px
    lg: "1.25rem",
    // 20px
    xl: "2.25rem" // 36px
};
const $bf6ebe546d5f1d79$var$contentCss = null;
const $bf6ebe546d5f1d79$var$leftAlignHeadings = null;
const $bf6ebe546d5f1d79$var$primaryCss = null;
const $bf6ebe546d5f1d79$var$secondaryCss = null;
const $bf6ebe546d5f1d79$var$footerCss = null;
const $bf6ebe546d5f1d79$var$rightAlignFooterCss = null;
const $bf6ebe546d5f1d79$var$flexGrowStyle = null;

});


parcelRegister("gT0aR", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("gGYrV").then(()=>parcelRequire("alnuK"));

});

parcelRegister("cWOLL", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("aFjZp").then(()=>parcelRequire("3wfN9"));

});

parcelRegister("6p39E", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("93HEw").then(()=>parcelRequire("j8MRN"));

});

parcelRegister("1RtZ5", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("bgHSP").then(()=>parcelRequire("iXBrX"));

});

parcelRegister("j7iO9", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("jz4Fc").then(()=>parcelRequire("bzW2Q"));

});

parcelRegister("1CYPq", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("kdlH7").then(()=>parcelRequire("4Y7Sk"));

});

parcelRegister("lHYBA", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("jJfVo").then(()=>parcelRequire("6NCLK"));

});

parcelRegister("kbBGK", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("fFjTe").then(()=>parcelRequire("gv3sn"));

});

parcelRegister("ZZFqT", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("7XMft").then(()=>parcelRequire("dxDau"));

});

parcelRegister("e43PY", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("iUkan").then(()=>parcelRequire("aZ3Qq"));

});

parcelRegister("79QSH", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("5CtkU").then(()=>parcelRequire("dbeVm"));

});



parcelRegister("cIEaV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f68a4e44547015cf$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $jgJpJ = parcelRequire("jgJpJ");

var $iMdoL = parcelRequire("iMdoL");

var $1LPIk = parcelRequire("1LPIk");

var $jK7ee = parcelRequire("jK7ee");

var $aO3Hl = parcelRequire("aO3Hl");

var $f5kTP = parcelRequire("f5kTP");

var $1Y3bT = parcelRequire("1Y3bT");

var $dkYGl = parcelRequire("dkYGl");

var $43Xwa = parcelRequire("43Xwa");
const $f68a4e44547015cf$var$JiraTemplateChoiceViewManager = ()=>{
    const { skipScreen: skipScreen } = (0, $1Y3bT.useScreenManager)();
    const { loadingUserSegmentData: loadingUserSegmentData, shouldShowJiraTemplateChoiceScreen: shouldShowJiraTemplateChoiceScreen } = (0, $f5kTP.useJiraTemplateChoice)();
    const { products: products, edition: edition, jtbd: jtbd, teamType: teamType } = (0, $aO3Hl.useSearchParameters)();
    const productKey = (0, $dkYGl.getPrimaryProduct)(products);
    const { profile: profile } = (0, $iMdoL.useUserContext)();
    const userType = profile.cohorts?.userType;
    const domainType = profile.cohorts?.domainType;
    const companyType = profile.cohorts?.companyType;
    const [waitForAttributes, setWaitForAttributes] = (0, $iSvIT.useState)(true);
    const [dataFoundationAttributes, setDataFoundationAttributes] = (0, $iSvIT.useState)({
        productKey: productKey,
        edition: edition,
        teamType: teamType
    });
    (0, $iSvIT.useEffect)(()=>{
        if (!profile.requestInProgress) {
            setDataFoundationAttributes((prevAttributes)=>({
                    ...prevAttributes,
                    userType: userType,
                    domainType: domainType,
                    companyType: companyType
                }));
            setWaitForAttributes(false);
        }
    }, [
        profile.requestInProgress,
        userType,
        domainType,
        companyType
    ]);
    // Skip template choice screen if a jtbd query parameter exists (even if its an empty array)
    (0, $iSvIT.useEffect)(()=>{
        if (jtbd) skipScreen();
    }, [
        jtbd
    ]);
    (0, $iSvIT.useEffect)(()=>{
        // on first render, transition to next screen if it should not be shown.
        // for control, this screen can be hidden for users that fall into business teams
        if (!shouldShowJiraTemplateChoiceScreen && !loadingUserSegmentData) skipScreen();
    }, [
        loadingUserSegmentData,
        shouldShowJiraTemplateChoiceScreen,
        skipScreen
    ]);
    if (loadingUserSegmentData) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jK7ee.LoadingState), {});
    // do not load UI if the screen should be hidden AND the user is not in
    // Transparent Template For All treatment
    if (!shouldShowJiraTemplateChoiceScreen) return null;
    // Do not load UI if jtbd is set
    if (jtbd) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1LPIk.DataFoundationsWrapper), {
        dataFoundationsEventOption: "TemplateChoiceScreenViewed",
        attributes: dataFoundationAttributes,
        waitForAttributes: waitForAttributes,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $43Xwa.TemplateChoiceScreen), {})
    });
};
/**
 * UFO Wrapper to capture Signup's FE Performance metrics & "Product Landing" SLOs
 *   - https://go/signup-perf
 **/ const $f68a4e44547015cf$var$JiraTemplateChoiceUfoWrapper = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.UfoCustomTimingWrapper), {
        ufoEvent: (0, $jgJpJ.ufoEventRedirectToProduct),
        ufoCustomTimingKey: (0, $jgJpJ.UfoCustomTimingKey).JIRA_TEMPLATE_CHOICE_DWELL_TIME,
        children: /*#__PURE__*/ (0, $loA2J.jsx)($f68a4e44547015cf$var$JiraTemplateChoiceViewManager, {})
    });
};
var $f68a4e44547015cf$export$2e2bcd8739ae039 = $f68a4e44547015cf$var$JiraTemplateChoiceUfoWrapper;

});
parcelRegister("jK7ee", function(module, exports) {

$parcel$export(module.exports, "LoadingState", function () { return $72de5843f37e1cc1$export$62aa48085237e36f; });
/* loading-state.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $9gh2a = parcelRequire("9gh2a");

var $lvTmK = parcelRequire("lvTmK");
const $72de5843f37e1cc1$var$loadingStyle = null;
const $72de5843f37e1cc1$export$62aa48085237e36f = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": (0, $lvTmK.LOADING_STATE_TEST_ID),
        className: (0, $esG4f.default)([
            "_kqsw1n9t _152t1ssb _1e021ssb _t9ec1ooe"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
            size: "large"
        })
    });

});
parcelRegister("lvTmK", function(module, exports) {

$parcel$export(module.exports, "LOADING_STATE_TEST_ID", function () { return $5cc8f1440768206b$export$8f1fca36561eed16; });

var $loA2J = parcelRequire("loA2J");

var $8GbB2 = parcelRequire("8GbB2");
var $lkZfy = parcelRequire("lkZfy");

var $42nMG = parcelRequire("42nMG");

var $izaWL = parcelRequire("izaWL");
const $5cc8f1440768206b$var$businessImg = "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-business-card-header.webp";
const $5cc8f1440768206b$var$kanbanImg = "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-kanban-card-header.webp";
const $5cc8f1440768206b$var$scrumImg = "https://wac-cdn.atlassian.com/misc-assets/webp-images/template-choice-scrum-card-header-update.webp";
const $5cc8f1440768206b$export$561aef59779bd4c0 = 760;
const $5cc8f1440768206b$export$930fb48e549583fb = 1530;
const $5cc8f1440768206b$export$5b0488180e5f09b4 = "bxpkit-wac-confirmation-page.perceived-provisioning";
const $5cc8f1440768206b$export$c500d964fb2b6892 = `${$5cc8f1440768206b$export$5b0488180e5f09b4}.ui.onboarding-manager.template-choice.body.board`;
const $5cc8f1440768206b$export$1060f903653c3814 = `${$5cc8f1440768206b$export$c500d964fb2b6892}.header`;
const $5cc8f1440768206b$export$fc68ee436d5b9b0a = `${$5cc8f1440768206b$export$c500d964fb2b6892}.card`;
const $5cc8f1440768206b$export$8f1fca36561eed16 = `${$5cc8f1440768206b$export$5b0488180e5f09b4}.ui.loading-state`;
const $5cc8f1440768206b$var$TemplateCardStatus = {
    POPULAR: (0, $izaWL.default).statusPopular
};
const $5cc8f1440768206b$var$kanbanTemplateContent = {
    key: (0, $42nMG.TemplateKeys).KANBAN,
    cardType: "kanban",
    title: (0, $izaWL.default).kanbanCardName,
    iconSrc: $5cc8f1440768206b$var$kanbanImg,
    iconBackground: "linear-gradient(to bottom right, rgba(231, 240, 254, 1) 0%, rgba(160, 193, 244, 1) 100%)",
    summary: (0, $izaWL.default).kanbanCardSummary,
    description: (0, $izaWL.default).kanbanCardDescriptionText,
    status: $5cc8f1440768206b$var$TemplateCardStatus.POPULAR
};
const $5cc8f1440768206b$var$scrumTemplateContent = {
    key: (0, $42nMG.TemplateKeys).SCRUM,
    cardType: "scrum",
    title: (0, $izaWL.default).scrumCardName,
    iconSrc: $5cc8f1440768206b$var$scrumImg,
    iconBackground: "linear-gradient(190deg, rgba(221, 233, 253, 1) 0%, rgba(182, 208, 248, 1) 50%, rgba(125, 169, 238, 1) 100%)",
    summary: (0, $izaWL.default).scrumCardSummary,
    description: (0, $izaWL.default).scrumCardDescriptionText
};
const $5cc8f1440768206b$var$businessBlankTemplateContent = {
    key: (0, $42nMG.TemplateKeys).BUSINESS,
    cardType: "business",
    title: (0, $izaWL.default).businessCardName,
    iconSrc: $5cc8f1440768206b$var$businessImg,
    iconBackground: "linear-gradient(135deg, rgba(166, 230, 202, 1) 0%, rgba(187, 238, 216, 1) 30%, rgba(220, 249, 236, 1) 100%)",
    summary: (0, $izaWL.default).businessCardSummary,
    description: (0, $izaWL.default).businessCardDescription
};
const $5cc8f1440768206b$export$be4ae725439a22d8 = {
    [(0, $42nMG.TemplateKeys).KANBAN]: $5cc8f1440768206b$var$kanbanTemplateContent,
    [(0, $42nMG.TemplateKeys).SCRUM]: $5cc8f1440768206b$var$scrumTemplateContent,
    [(0, $42nMG.TemplateKeys).BUSINESS]: $5cc8f1440768206b$var$businessBlankTemplateContent,
    [(0, $42nMG.TemplateKeys).UNKNOWN]: undefined
};
const $5cc8f1440768206b$export$481e891875c058d1 = {
    name: (0, $42nMG.ProductKeys).JSW,
    displayName: (0, $izaWL.default).softwareBoardTitle,
    logoComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8GbB2.JiraSoftwareIcon), {
        appearance: "inverse",
        size: "xxsmall"
    }),
    templateKeys: [
        (0, $42nMG.TemplateKeys).KANBAN,
        (0, $42nMG.TemplateKeys).SCRUM
    ]
};
const $5cc8f1440768206b$export$94d7a27b13987096 = {
    name: (0, $42nMG.ProductKeys).JWM,
    displayName: (0, $izaWL.default).businessBoardTitle,
    logoComponent: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lkZfy.JiraWorkManagementIcon), {
        appearance: "inverse",
        size: "xxsmall"
    }),
    templateKeys: [
        (0, $42nMG.TemplateKeys).BUSINESS
    ]
};

});
parcelRegister("izaWL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57bb01eb4ad3f477$export$2e2bcd8739ae039; });

var $6x1qA = parcelRequire("6x1qA");
var $57bb01eb4ad3f477$export$2e2bcd8739ae039 = (0, $6x1qA.defineMessages)({
    softwareBoardTitle: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.software-board-title",
        defaultMessage: "Jira Software",
        description: "Jira software board title for template choice page while onboarding"
    },
    businessBoardTitle: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.business-board-title",
        defaultMessage: "Jira Work Management",
        description: "Jira work management board title for template choice page while onboarding"
    },
    kanbanCardName: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.kanban-card-name",
        defaultMessage: "Kanban",
        description: "Kanban card name of Template choice screen during Jira onboarding"
    },
    kanbanCardSummary: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.kanban-card-summary",
        defaultMessage: "A simple board to visualize your workflow",
        description: "Kanban card summary of Template choice screen during Jira onboarding"
    },
    kanbanCardDescriptionText: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.kanban-card-description-text",
        defaultMessage: "A flexible and efficient way to manage agile work, with a board and timeline.",
        description: "Kanban card description of Template choice screen during Jira onboarding"
    },
    scrumCardName: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.scrum-card-name",
        defaultMessage: "Scrum",
        description: "Scrum card name of Template choice screen during Jira onboarding"
    },
    scrumCardSummary: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.scrum-card-summary",
        defaultMessage: "Deliver work in short, repeatable time blocks",
        description: "Scrum card summary of Template choice screen during Jira onboarding"
    },
    scrumCardDescriptionText: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.scrum-card-description-text",
        defaultMessage: "Plan, prioritize, and schedule work using agile sprints with a backlog, board and timeline.",
        description: "Scrum card description of Template choice screen during Jira onboarding"
    },
    businessCardName: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.business-card-name",
        defaultMessage: "Business",
        description: "Business card name of Template choice screen during Jira onboarding"
    },
    businessCardSummary: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.business-card-summary",
        defaultMessage: "Collaboration for business teams",
        description: "Business card summary of Template choice screen during Jira onboarding"
    },
    businessCardDescription: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.business-card-description",
        defaultMessage: "Designed to help your business team collaborate and connect, with list and calendar views, forms, and more.",
        description: "Business card description of Template choice screen during Jira onboarding"
    },
    statusPopular: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.status-popular",
        defaultMessage: "Popular",
        description: "Label shown to indicate a Template Choice card is popular during onboarding"
    }
});

});



parcelRegister("1Y3bT", function(module, exports) {

$parcel$export(module.exports, "useScreenManager", function () { return $bf6416bad33bc546$export$42758dc8d2618de9; });
$parcel$export(module.exports, "ScreenManagerProvider", function () { return $bf6416bad33bc546$export$75a2def3a29002d3; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $jvaIB = parcelRequire("jvaIB");

var $l4l8N = parcelRequire("l4l8N");
const $bf6416bad33bc546$var$ScreenManagerContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    screensConfig: undefined,
    screenDictionary: undefined,
    activeScreen: undefined,
    screenList: [],
    prevScreen: ()=>console.warn("prevScreen not defined"),
    prevScreenExists: ()=>false,
    nextScreen: ()=>console.warn("nextScreen not defined"),
    skipScreen: ()=>console.warn("skipScreen not defined")
});
const $bf6416bad33bc546$export$42758dc8d2618de9 = ()=>{
    const context = (0, $iSvIT.useContext)($bf6416bad33bc546$var$ScreenManagerContext);
    if (context === undefined) throw new Error("`useScreenManager` must be used within a `ScreenManagerContext.Provider`");
    return context;
};
const $bf6416bad33bc546$export$75a2def3a29002d3 = ({ screensConfig: screensConfig, screenDictionary: screenDictionary, children: children })=>{
    const metadata = (0, $l4l8N.useRegisterMetadata)();
    const skippedScreens = (0, $iSvIT.useMemo)(()=>new Set(), []);
    const [screenIndex, setScreenIndex] = (0, $iSvIT.useState)(0);
    const screenList = (0, $iSvIT.useMemo)(()=>(0, $jvaIB.getConfiguredScreenList)({
            metadata: metadata,
            screensConfig: screensConfig,
            fullScreenList: Object.keys(screenDictionary)
        }), [
        screensConfig,
        screenDictionary
    ]);
    const activeScreen = (0, $iSvIT.useMemo)(()=>screenList[screenIndex], [
        screenList,
        screenIndex
    ]);
    const nextScreen = (0, $iSvIT.useCallback)(()=>{
        setScreenIndex(screenIndex + 1);
    }, [
        setScreenIndex,
        screenIndex
    ]);
    const prevScreen = (0, $iSvIT.useCallback)(()=>{
        let updatedScreenIndex = Math.max(screenIndex - 1, 0);
        let updatedScreen = screenList[updatedScreenIndex];
        // find the previous screen the users should actually see.
        while(updatedScreen && skippedScreens.has(updatedScreen)){
            skippedScreens.delete(updatedScreen);
            updatedScreenIndex = Math.max(updatedScreenIndex - 1, 0);
            updatedScreen = screenList[updatedScreenIndex];
        }
        setScreenIndex(updatedScreenIndex);
    }, [
        setScreenIndex,
        screenIndex
    ]);
    const prevScreenExists = (0, $iSvIT.useCallback)(()=>{
        if (screenIndex === 0) return false;
        let updatedScreenIndex = screenIndex - 1;
        let updatedScreen = screenList[updatedScreenIndex];
        const skippedScreensCopy = new Set(skippedScreens); // deep copy
        while(updatedScreen && skippedScreens.has(updatedScreen)){
            skippedScreensCopy.delete(updatedScreen);
            updatedScreenIndex = updatedScreenIndex - 1;
            if (updatedScreenIndex < 0) break;
            updatedScreen = screenList[updatedScreenIndex];
        }
        return updatedScreenIndex > -1;
    }, [
        setScreenIndex,
        screenIndex
    ]);
    const skipScreen = (0, $iSvIT.useCallback)(()=>{
        if (activeScreen) {
            skippedScreens.add(activeScreen);
            nextScreen();
        }
    }, [
        nextScreen
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($bf6416bad33bc546$var$ScreenManagerContext.Provider, {
        value: {
            screensConfig: screensConfig,
            screenDictionary: screenDictionary,
            activeScreen: activeScreen,
            screenList: screenList,
            nextScreen: nextScreen,
            prevScreen: prevScreen,
            prevScreenExists: prevScreenExists,
            skipScreen: skipScreen
        },
        children: children
    });
};

});
parcelRegister("jvaIB", function(module, exports) {

$parcel$export(module.exports, "TEAM_CHOICE", function () { return $c56ac2b06cb569d9$export$cff58332f2b6312a; });
$parcel$export(module.exports, "TEMPLATE_CHOICE", function () { return $c56ac2b06cb569d9$export$1f88b71abf148e1d; });
$parcel$export(module.exports, "PROVISIONING", function () { return $c56ac2b06cb569d9$export$ebba33cd31d6b30c; });
$parcel$export(module.exports, "PROVISIONING_WITH_WIZARD", function () { return $c56ac2b06cb569d9$export$6b545ee39a5dc1bf; });
$parcel$export(module.exports, "JTBD", function () { return $c56ac2b06cb569d9$export$9479b273474550a; });
$parcel$export(module.exports, "PROJECT_LANDING_SELECTOR", function () { return $c56ac2b06cb569d9$export$d5362ab05fcf9ebe; });
$parcel$export(module.exports, "getConfiguredScreenList", function () { return $c56ac2b06cb569d9$export$7a5437e9b64e31fc; });
const $c56ac2b06cb569d9$export$cff58332f2b6312a = "teamChoice";
const $c56ac2b06cb569d9$export$1f88b71abf148e1d = "templateChoice";
const $c56ac2b06cb569d9$export$ebba33cd31d6b30c = "provisioning";
const $c56ac2b06cb569d9$export$6b545ee39a5dc1bf = "provisioningWithWizard";
const $c56ac2b06cb569d9$export$9479b273474550a = "jobsToBeDone";
const $c56ac2b06cb569d9$export$d5362ab05fcf9ebe = "projectLandingSelector";
function $c56ac2b06cb569d9$export$7a5437e9b64e31fc({ metadata: metadata, screensConfig: screensConfig, fullScreenList: fullScreenList }) {
    return fullScreenList// filter on screens that exists in config.
    .filter((screen)=>screensConfig[screen])// get screens that should be shown to this user.
    .filter((screen)=>$c56ac2b06cb569d9$var$getVisibility(metadata, screensConfig[screen]?.visibility))// sort screens based on the explicit position.
    .sort((screenA, screenB)=>{
        const configA = screensConfig[screenA] ?? {
            position: {
                default: 150
            }
        };
        const configB = screensConfig[screenB] ?? {
            position: {
                default: 150
            }
        };
        return configA.position.default - configB.position.default;
    });
}
function $c56ac2b06cb569d9$var$getVisibility(metadata, visibility) {
    // if no visbility conditions are set, show the screen by default
    if (visibility == null) return true;
    // if visibility is set to true by default, show the screen
    if (visibility?.default) return true;
    const { conditionalOR: conditionalOR = [] } = visibility;
    return $c56ac2b06cb569d9$var$evaluateConditions(metadata, conditionalOR);
}
function $c56ac2b06cb569d9$var$evaluateConditions(metadata, conditions) {
    if (!conditions) return true;
    const reducedOrResults = conditions.map((OR)=>OR.conditionalAND.map(({ key: key, value: value, conditionalOR: conditionalOR })=>{
            const metadataValue = metadata?.get(key ?? "");
            // if key is undefined, set pass to true. ConditionalOr will be evaluated instead.
            let pass = key == undefined;
            // check that each value is in metadata
            if (Array.isArray(value) && Array.isArray(metadataValue)) pass = value.filter((val = false)=>metadataValue.filter((meta)=>meta == val).length > 0).length === value.length;
            else // evaluate condition against stored metadata
            pass = metadataValue == value;
            if (conditionalOR) pass = pass && $c56ac2b06cb569d9$var$evaluateConditions(metadata, conditionalOR);
            return pass;
        }).reduce(// consolidate conditions in AND clause to one boolean value.
        (conditionOne, conditionTwo)=>conditionOne && conditionTwo));
    // at least one OR condition should be true to show the screen
    return reducedOrResults.filter((res)=>res === true).length > 0;
}

});


parcelRegister("43Xwa", function(module, exports) {

$parcel$export(module.exports, "TemplateChoiceScreen", function () { return $d956a58a7cc5fd00$export$5ec3bc5c70133ad0; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");
parcelRequire("d2NVK");
var $kR2lN = parcelRequire("kR2lN");

var $9CPk0 = parcelRequire("9CPk0");

var $lozd7 = parcelRequire("lozd7");

var $f5kTP = parcelRequire("f5kTP");

var $fEXKI = parcelRequire("fEXKI");
const $d956a58a7cc5fd00$export$5ec3bc5c70133ad0 = ()=>{
    const { setTemplateChoiceError: setTemplateChoiceError } = (0, $f5kTP.useJiraTemplateChoice)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { products: products, edition: edition, jtbd: jtbd, teamType: teamType } = (0, $fEXKI.useSearchParameters)();
    const onError = (0, $iSvIT.useCallback)((error)=>{
        createAnalyticsEvent({
            actionSubject: "confirmationPageScreen",
            action: "failed",
            actionSubjectId: "TemplateChoiceScreen",
            attributes: {
                products: products,
                edition: edition,
                jtbd: jtbd,
                teamType: teamType
            }
        }).fire();
        setTemplateChoiceError(error);
    }, [
        createAnalyticsEvent,
        setTemplateChoiceError
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9CPk0.default), {
        onError: onError,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kR2lN.DwellTimeWrapper), {
            eventData: {
                action: "dwelled",
                actionSubject: "screen",
                actionSubjectId: "TemplateChoiceScreen",
                source: "/ondemand/signup/confirmation",
                attributes: {
                    atlasId: "ATLAS-58859"
                }
            },
            initialPollInterval: 5000,
            idleTimeout: 120000,
            nextPollIntervalCallback: (x)=>x + 5000,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lozd7.TemplateChoiceView), {})
        })
    });
};

});
parcelRegister("9CPk0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $850118d6b708122d$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
class $850118d6b708122d$export$2e2bcd8739ae039 extends (0, $iSvIT.Component) {
    static #_ = this.defaultProps = {
        children: null,
        onError: ()=>undefined
    };
    static getDerivedStateFromError(error) {
        return {
            caughtError: {
                error: error,
                info: {
                    componentStack: ""
                }
            }
        };
    }
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        this.setState({
            caughtError: {
                error: error,
                info: info
            }
        });
        onError(error);
    }
    render() {
        const { caughtError: caughtError } = this.state;
        const { children: children } = this.props;
        if (!caughtError) return children;
        return null;
    }
    constructor(...args){
        super(...args);
        this.state = {
            caughtError: null
        };
    }
}

});

parcelRegister("lozd7", function(module, exports) {

$parcel$export(module.exports, "TemplateChoiceView", function () { return $8dd6fc49997b9261$export$76f2b7692b316074; });
/* template-choice-view.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $8maID = parcelRequire("8maID");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $6IiXU = parcelRequire("6IiXU");

var $4LHd8 = parcelRequire("4LHd8");

var $jgJpJ = parcelRequire("jgJpJ");

var $jRcT4 = parcelRequire("jRcT4");

var $aO3Hl = parcelRequire("aO3Hl");

var $77Hlt = parcelRequire("77Hlt");

var $1Y3bT = parcelRequire("1Y3bT");

var $gh3cF = parcelRequire("gh3cF");

var $6bw3Y = parcelRequire("6bw3Y");

var $gLWQf = parcelRequire("gLWQf");

var $9GwGV = parcelRequire("9GwGV");

var $3AS1w = parcelRequire("3AS1w");
const $8dd6fc49997b9261$var$buttonWrapperStyle = null;
const $8dd6fc49997b9261$var$buttonCssOverride = null;
const $8dd6fc49997b9261$var$backButtonOverride = null;
const $8dd6fc49997b9261$var$TemplateChoiceViewBase = ()=>{
    const intl = (0, $f6qj2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { addTemplateCallback: addTemplateCallback } = (0, $aO3Hl.useGupsStatus)(); //set these on submit
    const { setTemplateChoice: setTemplateChoice, setTemplateChoiceId: setTemplateChoiceId, setTemplateChoiceName: setTemplateChoiceName, goBackToUserSegmentation: goBackToUserSegmentation, setTemplateMetadata: setTemplateMetadata } = (0, $aO3Hl.useJiraTemplateChoice)();
    const { prevScreen: prevScreen, nextScreen: nextScreen, prevScreenExists: prevScreenExists } = (0, $1Y3bT.useScreenManager)();
    const { userSegmentationContext: { selectedTeamType: contextSelectedTeamTypeState = "software-development" } } = (0, $77Hlt.useConfirmationPage)();
    const selectedTeamType = contextSelectedTeamTypeState;
    const doesPreviousScreenExist = prevScreenExists && prevScreenExists();
    const removeUrlParameter = (0, $iSvIT.useCallback)((url, paramKey)=>{
        const r = new URL(url);
        r.searchParams.delete(paramKey);
        return r.href;
    }, []); //set these on select
    const [selectedTemplate, setSelectedTemplate] = (0, $iSvIT.useState)();
    const [selectedTemplateId, setSelectedTemplateId] = (0, $iSvIT.useState)();
    const [selectedCardTitle, setSelectedCardTitle] = (0, $iSvIT.useState)();
    const [selectedTemplateMetadata, setSelectedTemplateMetadata] = (0, $iSvIT.useState)(); // get template choices based on team type
    const teamTemplateChoices = (0, $iSvIT.useMemo)(()=>(0, $3AS1w.getTeamTypeTemplateOptions)(selectedTeamType, intl.formatMessage), [
        intl.formatMessage,
        selectedTeamType
    ]); //set selected template to first template in array
    (0, $iSvIT.useEffect)(()=>{
        if (teamTemplateChoices) {
            setSelectedTemplateId(teamTemplateChoices[0]?.option.templateId);
            setSelectedTemplate(teamTemplateChoices[0]?.option.templateType);
            setSelectedTemplateMetadata(teamTemplateChoices[0]?.metadata);
            setSelectedCardTitle(teamTemplateChoices[0]?.option.title);
        }
    }, [
        teamTemplateChoices
    ]);
    const messages = {
        header: intl.formatMessage({
            id: "TransparentTemplateChoice.header.latest",
            defaultMessage: "Select a template to get started"
        }),
        subheader: intl.formatMessage({
            id: "TransparentTemplateChoice.subheader.latest",
            defaultMessage: "Your choice won't limit what you can do in Jira"
        }),
        back: intl.formatMessage({
            id: "TransparentTemplateChoice.backButton",
            defaultMessage: "Back"
        }),
        continue: intl.formatMessage({
            id: "TransparentTemplateChoice.continueButton",
            defaultMessage: "Continue"
        }),
        transparentTemplateV2subHeader: intl.formatMessage({
            id: "TransparentTemplateV2.subheader",
            defaultMessage: "You can always change this later. Selecting a template won\u2019t limit what you can do."
        })
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $gLWQf.JiraOnboardingContainer), {
            header: messages.header,
            subheader: messages.transparentTemplateV2subHeader,
            hideFooterOnMobile: true,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $9GwGV.default), {
                    setSelectedTemplate: setSelectedTemplate,
                    setSelectedTemplateId: setSelectedTemplateId,
                    setSelectedCardTitle: setSelectedCardTitle,
                    setSelectedTemplateMetadata: setSelectedTemplateMetadata,
                    selectedCardTitle: selectedCardTitle,
                    cards: teamTemplateChoices,
                    teamType: selectedTeamType
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx2vrvc _1bah1h6o _19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0q14no _u5f3gktf _n3tdgktf _19bvgktf _19itglyw _zulpv47k _1bsb13xl _13zm1n9t _1eg6idpf _13khidpf _1j30u67f _1kmxdlk8 _1ggmf6fq _1ykzdlk8 _1maef6fq _1rfm1osq _13z4eysh"
                    ]),
                    children: [
                        doesPreviousScreenExist && /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                            shouldFitContainer: true,
                            appearance: "subtle",
                            onClick: ()=>{
                                try {
                                    (0, $jgJpJ.ufoEventConfirmationPageTemplateSelectionBack).start();
                                    createAnalyticsEvent({
                                        eventType: "ui",
                                        action: "clicked",
                                        actionSubject: "button",
                                        actionSubjectId: (0, $jRcT4.TRACKING_EVENT_ACTION_SUBJECT_IDS).templateChoiceBack,
                                        attributes: {
                                            atlasTicket: "ATLAS-69623"
                                        }
                                    }).fire();
                                    const updatedUrl = removeUrlParameter(window.location.href, (0, $jRcT4.USER_SEARCH_PARAMS).teamType);
                                    history.replaceState({}, "", updatedUrl);
                                    goBackToUserSegmentation();
                                    prevScreen();
                                    (0, $jgJpJ.ufoEventConfirmationPageTemplateSelectionBack).success();
                                } catch (e) {
                                    (0, $jgJpJ.ufoEventConfirmationPageTemplateSelectionBack).failure({
                                        error: e
                                    });
                                }
                            },
                            className: (0, $esG4f.default)([
                                "_2rko1fu0 _1e0c1txw _4cvr1y6m _1bah1yb4 _ca0qgrf3 _u5f3a982 _n3tdgrf3 _19bva982 _ij3olnmy _nzz57vkz _14b511k1",
                                "_19it1prt _14w0h2mm _1m0i12gs _17gqs2wb"
                            ]),
                            children: messages.back
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                            shouldFitContainer: true,
                            appearance: "primary",
                            onClick: async ()=>{
                                try {
                                    (0, $jgJpJ.ufoEventConfirmationPageTemplateSelectionContinue).start();
                                    (0, $jgJpJ.ufoEventConfirmationPageTemplateSelectionContinue).setCustomData({
                                        teamType: selectedTeamType,
                                        template: selectedTemplate,
                                        templateId: selectedTemplateId
                                    });
                                    createAnalyticsEvent({
                                        eventType: "ui",
                                        action: "clicked",
                                        actionSubject: "button",
                                        actionSubjectId: (0, $jRcT4.TRACKING_EVENT_ACTION_SUBJECT_IDS).templateChoiceStartNow,
                                        attributes: {
                                            atlasTicket: "ATLAS-69623",
                                            template: selectedTemplate,
                                            teamType: selectedTeamType,
                                            templateId: selectedTemplateId
                                        }
                                    }).fire(); // add templateChoice to query param to maintain selection on refresh
                                    const updatedUrl = (0, $6bw3Y.getCurrentUrlWithParams)({
                                        ...(0, $4LHd8.default).checkGate("route_biz_to_kanban_revision_gate") ? {
                                            templateId: selectedTemplateId || ""
                                        } : {},
                                        templateChoice: selectedTemplate || "",
                                        jtbd: selectedTemplateMetadata?.jtbd || ""
                                    });
                                    history.replaceState({}, "", updatedUrl);
                                    if (selectedTemplateId && (0, $gh3cF.getGupsIntegrationInJiraOnboardingEnabled)()) await addTemplateCallback(selectedTemplateId);
                                    setTemplateMetadata(selectedTemplateMetadata);
                                    setTemplateChoice(selectedTemplate);
                                    setTemplateChoiceId(selectedTemplateId);
                                    setTemplateChoiceName(selectedCardTitle);
                                    nextScreen();
                                    (0, $jgJpJ.ufoEventConfirmationPageTemplateSelectionContinue).success();
                                } catch (e) {
                                    (0, $jgJpJ.ufoEventConfirmationPageTemplateSelectionContinue).failure({
                                        error: e
                                    });
                                }
                            },
                            className: (0, $esG4f.default)([
                                "_2rko1fu0 _1e0c1txw _4cvr1y6m _1bah1yb4 _ca0qgrf3 _u5f3a982 _n3tdgrf3 _19bva982 _ij3olnmy _nzz57vkz _14b511k1"
                            ]),
                            children: messages.continue
                        })
                    ]
                })
            ]
        })
    });
};
const $8dd6fc49997b9261$export$76f2b7692b316074 = (0, $8maID.default)(()=>{
    //screen analytics event here
    return /*#__PURE__*/ (0, $loA2J.jsx)($8dd6fc49997b9261$var$TemplateChoiceViewBase, {});
});

});
parcelRegister("jRcT4", function(module, exports) {

$parcel$export(module.exports, "TRACKING_EVENT_ACTION_SUBJECT_IDS", function () { return $8e01ff1d1825098b$export$ab2f7c82d3e798a3; });
$parcel$export(module.exports, "ATLAS_TICKET", function () { return $8e01ff1d1825098b$export$98d1d5709bd87e9b; });
$parcel$export(module.exports, "USER_SEARCH_PARAMS", function () { return $8e01ff1d1825098b$export$8eb15e6204fbc19; });
var $8e01ff1d1825098b$export$ab2f7c82d3e798a3;
(function(TRACKING_EVENT_ACTION_SUBJECT_IDS) {
    TRACKING_EVENT_ACTION_SUBJECT_IDS["userSegRedesignScreen"] = "userSegRedesignScreen";
    TRACKING_EVENT_ACTION_SUBJECT_IDS["teamFocusCard"] = "teamFocusCard";
    TRACKING_EVENT_ACTION_SUBJECT_IDS["teamFocusNext"] = "teamFocusNextButton";
    TRACKING_EVENT_ACTION_SUBJECT_IDS["teamFocusGetStarted"] = "teamFocusGetStartedButton";
    TRACKING_EVENT_ACTION_SUBJECT_IDS["teamFocusTeamTypeButton"] = "teamFocusTeamTypeButton";
    TRACKING_EVENT_ACTION_SUBJECT_IDS["templateChoiceCard"] = "templateChoiceCard";
    TRACKING_EVENT_ACTION_SUBJECT_IDS["templateChoiceStartNow"] = "templateChoiceStartNow";
    TRACKING_EVENT_ACTION_SUBJECT_IDS["templateChoiceBack"] = "templateChoiceBackButton";
    TRACKING_EVENT_ACTION_SUBJECT_IDS["templateChoiceNext"] = "templateChoicieNextButton";
    TRACKING_EVENT_ACTION_SUBJECT_IDS["templateChoiceTeamTypeSelect"] = "templateChoiceTeamTypeSelect";
    TRACKING_EVENT_ACTION_SUBJECT_IDS["projectNamingBack"] = "projectNamingBackButton";
    TRACKING_EVENT_ACTION_SUBJECT_IDS["projectNamingStartNow"] = "projectNamingStartNow";
    TRACKING_EVENT_ACTION_SUBJECT_IDS["workflowStyleBackClicked"] = "workflow-style-back-button-clicked";
    TRACKING_EVENT_ACTION_SUBJECT_IDS["workflowStyleGetStartedClicked"] = "workflow-style-get-started-button-clicked";
})($8e01ff1d1825098b$export$ab2f7c82d3e798a3 || ($8e01ff1d1825098b$export$ab2f7c82d3e798a3 = {}));
const $8e01ff1d1825098b$export$98d1d5709bd87e9b = "ATLAS-58859";
var $8e01ff1d1825098b$export$8eb15e6204fbc19;
(function(USER_SEARCH_PARAMS) {
    USER_SEARCH_PARAMS["teamType"] = "team_type";
    USER_SEARCH_PARAMS["templateChoice"] = "templateChoice";
})($8e01ff1d1825098b$export$8eb15e6204fbc19 || ($8e01ff1d1825098b$export$8eb15e6204fbc19 = {}));

});

parcelRegister("gLWQf", function(module, exports) {

$parcel$export(module.exports, "JiraOnboardingContainer", function () { return $b4bc885d35439556$export$37f229da8601505d; });
/* jira-onboarding-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $bLpA6 = parcelRequire("bLpA6");
var $eXoeL = parcelRequire("eXoeL");

var $5ohHq = parcelRequire("5ohHq");

var $aO3Hl = parcelRequire("aO3Hl");

var $2xIEu = parcelRequire("2xIEu");
const $b4bc885d35439556$var$list = null;
const $b4bc885d35439556$var$elevate = null;
const $b4bc885d35439556$var$container = null;
const $b4bc885d35439556$var$headerContainer = null;
const $b4bc885d35439556$var$headerFont = null;
const $b4bc885d35439556$var$subheaderFont = null;
const $b4bc885d35439556$var$maxHeightContainer = null;
const $b4bc885d35439556$var$JiraHeader = ({ header: header, subheader: subheader, hideSubHeader: hideSubHeader = false, PreHeader: PreHeader })=>{
    const searchParameters = (0, $aO3Hl.useSearchParameters)();
    const { products: products = [] } = searchParameters;
    const isJsm = products.includes((0, $2xIEu.ProductKey).JIRA_SERVICE_MANAGEMENT);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1q511ylp _zulp1f4h _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ]),
        children: [
            isJsm ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $eXoeL.JiraServiceManagementLogo), {
                appearance: "brand"
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $bLpA6.JiraLogo), {
                size: "xlarge",
                appearance: "brand"
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulp1y44 _y3gn1h6o _ca0qidpf _u5f31ylp _n3tdidpf _19bv1ylp"
                ]),
                children: [
                    PreHeader && /*#__PURE__*/ (0, $loA2J.jsx)(PreHeader, {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                        className: (0, $esG4f.default)([
                            "_k48p1fw0 _vwz4ckbl _1wyb1ylp _ect41pz4 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19q110mc _so7dzwfg"
                        ]),
                        style: {
                            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                        },
                        children: header
                    }),
                    !hideSubHeader && /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_syaz1hlo _vwz41tcg _k48p1nn1 _1wyb7vkz _ect41pz4 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _19q1gktf _so7ddlk8"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                        },
                        children: subheader
                    })
                ]
            })
        ]
    });
};
const $b4bc885d35439556$export$37f229da8601505d = ({ header: header, subheader: subheader, hideSubHeader: hideSubHeader, PreHeader: // go with experiment jsw_transparent_software_jtbd
PreHeader, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_syaz1hlo _19pk1wug _2hwx1wug _otyr1wug _18u01wug _ect41pz4 _y3gn1h6o _1e0c11p5 _2z051wug _4t3i1kxc"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_4t3i1osq _1e0c1txw _2lx21bp4 _4cvr1h6o _zulpzwfg _ca0qidpf _u5f3f6fq _n3td1ylp _19bvf6fq"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)($b4bc885d35439556$var$JiraHeader, {
                    header: header,
                    subheader: subheader,
                    hideSubHeader: hideSubHeader,
                    PreHeader: PreHeader
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_srwz12am"
                    ]),
                    children: children
                })
            ]
        })
    });
};

});

parcelRegister("9GwGV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $855e4a6400ba7f01$export$2e2bcd8739ae039; });
/* body.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $1KPYm = parcelRequire("1KPYm");

var $gFOLY = parcelRequire("gFOLY");
const $855e4a6400ba7f01$var$templateChoiceWrapper = null;
const $855e4a6400ba7f01$var$buttonWrapperStyle = null;
const $855e4a6400ba7f01$var$headerContainerStyle = null;
const $855e4a6400ba7f01$var$headerStyle = null;
const $855e4a6400ba7f01$var$iconStyle = null;
const $855e4a6400ba7f01$var$Body = ({ setSelectedTemplate: setSelectedTemplate, cards: cards, setSelectedTemplateId: setSelectedTemplateId, selectedCardTitle: selectedCardTitle, setSelectedCardTitle: setSelectedCardTitle, teamType: teamType, setSelectedTemplateMetadata: setSelectedTemplateMetadata })=>{
    const intl = (0, $f6qj2.default)();
    const identityTeamType = (0, $1KPYm.getTeamTypeForTransparentTemplateV2)(teamType, intl.formatMessage);
    const Icon = (0, $1KPYm.getIconForTransparentTemplateV2)(teamType);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1yt41ejb _p12fsgih _2rkof6fq _19it1gl9 _1e0c1txw _2lx21bp4 _4cvr1h6o _1bahitcz _bfhki0pe _srwz19bv _1rgcudc3 _1kmx1crf _1ggm1crf _1ykz1crf _1mae1crf"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx2vrvc _1bah1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1pfhj39m"
                        ]),
                        children: Icon && /*#__PURE__*/ (0, $loA2J.jsx)(Icon, {})
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                        className: (0, $esG4f.default)([
                            "_k48p1fw0 _1wyb1tcg _vwz41ul9 _1pfh19bv"
                        ]),
                        children: identityTeamType
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("fieldset", {
                role: "radiogroup",
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _1n261g80 _19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _zulputpp _pdlmxy5q _45zz1q9c _1inivrvc"
                ]),
                children: cards.map((card, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $gFOLY.default), {
                        ...card.option,
                        setSelectedTemplate: setSelectedTemplate,
                        setSelectedTemplateId: setSelectedTemplateId,
                        selectedCardTitle: selectedCardTitle,
                        setSelectedCardTitle: setSelectedCardTitle,
                        teamType: teamType,
                        templateMetadata: card.metadata,
                        setSelectedTemplateMetadata: setSelectedTemplateMetadata
                    }, index))
            })
        ]
    });
};
var $855e4a6400ba7f01$export$2e2bcd8739ae039 = $855e4a6400ba7f01$var$Body;

});
parcelRegister("gFOLY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f98d94ec6b4f1128$export$2e2bcd8739ae039; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $jRcT4 = parcelRequire("jRcT4");
const $f98d94ec6b4f1128$var$cardBorderStyle = null;
const $f98d94ec6b4f1128$var$unselectedButtonStyle = null;
const $f98d94ec6b4f1128$var$selectedButtonStyle = null;
const $f98d94ec6b4f1128$var$cardTitleStyle = null;
const $f98d94ec6b4f1128$var$subtextStyle = null;
const $f98d94ec6b4f1128$var$textContainerStyle = null;
const $f98d94ec6b4f1128$var$imgStyle = null;
const $f98d94ec6b4f1128$var$mobileImgStyle = null;
const $f98d94ec6b4f1128$var$desktopImageContainer = null;
const $f98d94ec6b4f1128$var$Card = ({ imageSrc: imageSrc, mobileImgSrc: mobileImgSrc, title: title, subtext: subtext, setSelectedTemplate: setSelectedTemplate, templateType: templateType, templateId: templateId, setSelectedTemplateId: setSelectedTemplateId, setSelectedCardTitle: setSelectedCardTitle, selectedCardTitle: selectedCardTitle, teamType: teamType, templateMetadata: templateMetadata, setSelectedTemplateMetadata: setSelectedTemplateMetadata })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
        onClick: ()=>{
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: (0, $jRcT4.TRACKING_EVENT_ACTION_SUBJECT_IDS).templateChoiceCard,
                attributes: {
                    atlasTicket: "ATLAS-61649",
                    teamType: teamType,
                    templateType: templateType,
                    templateId: templateId,
                    templateName: title
                }
            }).fire();
            setSelectedTemplate(templateType);
            setSelectedTemplateId(templateId);
            setSelectedCardTitle(title);
            setSelectedTemplateMetadata(templateMetadata);
        },
        className: (0, $esG4f.default)([
            "_19pkt94y _2hwxt94y _otyrt94y _18u0t94y _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko1x7c _19it1ehm _bfhku67f _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _p12f2lij _1ul9grxc _4cvr1h6o _80omtlke _1dbz188r _1ini1bp4 _msup1y6m _10jxglyw _19451qwj _10m4kb7n _1vdkkb7n _1wznf1ug",
            selectedCardTitle === title ? "_19itid64 _19pkidpf _2hwxidpf _otyridpf _18u0idpf" : "_1h6d11bn"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0cglyw _dm251ule _1jc2uuw1 _1945c4ae"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                    src: imageSrc,
                    alt: title,
                    className: (0, $esG4f.default)([
                        "_1e0cglyw _dm251ule _glte1osq _165t1osq _1wznidpf"
                    ])
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                src: mobileImgSrc,
                alt: title,
                className: (0, $esG4f.default)([
                    "_1bsbys9h _4t3i53f4 _dm25glyw"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_ect41qje _1yt4pxbi _1e0c1txw _2lx21bp4 _1bah1yb4 _y3gnv2br _1yagmtm4 _msup1y6m _10m4kb7n"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        className: (0, $esG4f.default)([
                            "_ect4lnmy _syaz1fxt _1wybdlk8 _k48p1fw0 _vwz4gktf _19pkidpf _2hwxidpf _otyr14y2 _18u0idpf _3p1cgktf _py5o1f4h"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_1wyb1crf _ect4lnmy _syazqlpt _k48p1nn1 _vwz4gktf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _3p1c7vkz _py5o1tcg"
                        ]),
                        children: subtext
                    })
                ]
            })
        ]
    });
};
var $f98d94ec6b4f1128$export$2e2bcd8739ae039 = $f98d94ec6b4f1128$var$Card;

});


parcelRegister("3AS1w", function(module, exports) {

$parcel$export(module.exports, "getTeamTypeTemplateOptions", function () { return $9fbbc31ef4d65caa$export$44d53e543766f145; });

var $1KPYm = parcelRequire("1KPYm");
const $9fbbc31ef4d65caa$export$baf553820dccdc1 = {
    campaignManagement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/10ppastefs72qh5685o35gu1jxnwk321.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1b77eof7q055iutk2703f1e41625p30f.webp",
        title: "Campaign management",
        subtext: "Work towards campaign launches, tracking deadlines and tasks along the way",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management"
    },
    marketingProjectManagement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/320juw1ao165rgl2q2n1b00v6ri868i2.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/td46stfve7x68r38ina7j52616n566c1.webp",
        title: "Marketing project management",
        subtext: "Manage marketing projects efficiently, visualize tasks, and see team workload",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-project-management-team-managed"
    },
    contentManagement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/26jgte23bndr258r245r1ht554o11611.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/6wus57n08s4lb1lb7l54bl877w68ir60.webp",
        title: "Content management",
        subtext: "Oversee your marketing content lifecycle from draft to delivery",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-core-simplified-content-management"
    },
    processControl: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/djkwu8yfgdb74rjb8ek207qi4uqs3ov4.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/76h2cq112s5e8gj87dvnl8bt7ij3gg04.webp",
        title: "Process control",
        subtext: "Create, monitor, and iterate on processes in one place",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-process-control-team-managed"
    },
    projectManagement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/s6ff5qxwo5vvxc86tb78fac2yp4bq421.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/rm5grquxlgb2v4s1evg165ji01c1n8a2.webp",
        title: "Project management",
        subtext: "Designed to help business teams manage work with list and calendar views",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-project-management-team-managed"
    },
    procurement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/5h6go5vn70j05m05824y8l8g0iqp8ul7.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/121o1268bn5tcrinu84vq8e0rk7x011d.webp",
        title: "Procurement",
        subtext: "Standardize purchase process on your team from request to receipt",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-procurement-team-managed"
    },
    softwareDevelopmentKanban: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/f2f8e504020478718ch0h5d335i71na5.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/3p03s867217v4d15ym6v0t71b2m7ea0j.webp",
        title: "Kanban",
        subtext: "Visualize work and maximize efficiency with a kanban board",
        templateType: "kanban",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban"
    },
    softwareDevelopmentScrum: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/84pp4vqo1lh0n35l3b0kwivtc45we78t.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/ofqct7expg2516wj6mu2y460t65p6j5t.webp",
        title: "Scrum",
        subtext: "Plan, prioritize, and schedule sprints using scrum framework",
        templateType: "scrum",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum"
    },
    softwareDevelopmentProjectManagement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/j4hv2ea8ogdr6gn073ea3q3g1djkcg6a.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/w5uk7mm5bk6uu7s3e4d31i1sg35vok30.webp",
        title: "Project management",
        subtext: "Manage and track agile work plus integrate developer tools like GitHub",
        templateType: "kanban",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban"
    },
    productManagementScrum: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/4534542j3yccx046omhjo83if71k2f7t.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/o01l42c11gbpmkks73ms74es1m2b373p.webp",
        title: "Scrum",
        subtext: "Plan, prioritize, and schedule sprints using scrum framework",
        templateType: "scrum",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum"
    },
    productManagementProjectManagement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/a612l0d7u28873d6f1ki515ndaa558e4.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/vqnwpmlpj70vmkq32bhqd2nbvd6484g1.webp",
        title: "Project management",
        subtext: "Manage and track agile work plus integrate developer tools like GitHub",
        templateType: "kanban",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban"
    },
    productManagementBusinessCollaboration: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/5st3vp7lc5s7hj3gj7hojuq134d274fa.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/vbhyn84ja67uq4s57ir1123u0303m53c.webp",
        title: "Business collaboration",
        subtext: "Designed to help business teams manage work with list and calendar views",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-project-management-team-managed"
    },
    designKanban: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/t05t6ht0t5vr8c3g1h146pc2uilcdt18.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/r8hgvtjk8b8s710ho47r8l788yi203ah.webp",
        title: "Kanban",
        subtext: "Manage design projects efficiently, visualize tasks, and see team workload",
        templateType: "kanban",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban"
    },
    designWebDesignProcess: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/pvxa3q745o62q3j85hwhqug604hsi8t8.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/oo2102b1cee7uxe6fuk06eam0qrhhf67.webp",
        title: "Web design process",
        subtext: "Build web pages plus keep designers and developers on the same page",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-web-design-process-team-managed"
    },
    designScrum: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/228vbl2f2vy163kdp43l68356k55bqy1.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/31xe035jg7g1msyvnbqo24crxt8a06kw.webp",
        title: "Scrum",
        subtext: "Plan, prioritize, and schedule sprints using scrum framework",
        templateType: "scrum",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum"
    },
    projectManagementKanban: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/t05t6ht0t5vr8c3g1h146pc2uilcdt18.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/r8hgvtjk8b8s710ho47r8l788yi203ah.webp",
        title: "Kanban",
        subtext: "Manage and track agile work plus integrate developer tools like GitHub",
        templateType: "kanban",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban"
    },
    projectManagementProjectManagement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/6w2y57obt23x1uppve31yoy7js2kd78k.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/gx3nl2pdo4843583l358b00xr63fsvb3.webp",
        title: "Project management",
        subtext: "Designed to help business teams manage work with list and calendar views",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-project-management-team-managed"
    },
    projectManagementScrum: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/53bk03d638jh563u132bcd110j1m5yf7.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/725277466h2xi7npa3xlhq1716a8tef4.webp",
        title: "Scrum",
        subtext: "Plan, prioritize, and schedule sprints using scrum framework",
        templateType: "scrum",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum"
    },
    itSupportKanban: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1ucnj43iy06p54oty4j7253127ih6g6a.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/m2804ren578556m0h7yaan6a882deye4.webp",
        title: "Kanban",
        subtext: "Visualize work and maximize efficiency with a kanban board",
        templateType: "kanban",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban"
    },
    itSupportScrum: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/rt1rn4by762bwkwf7d1ypscgeyxq65ge.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/wj11o846540c57eo1b7thxc0046cy281.webp",
        title: "Scrum",
        subtext: "Plan, prioritize, and schedule sprints using scrum framework",
        templateType: "scrum",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum"
    },
    itSupportProjectManagement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/b1c47uky8i2733clcx0x74f73s28mhv4.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/0f85kod814uielg60wx7r7757i036yp7.webp",
        title: "Project management",
        subtext: "Designed to help business teams manage work with list and calendar views",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-project-management-team-managed"
    },
    humanResourcesProjectManagement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/4534542j3yccx046omhjo83if71k2f7t.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/o01l42c11gbpmkks73ms74es1m2b373p.webp",
        title: "Project management",
        subtext: "Manage, track, and assign tasks to streamline project workflows",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-project-management-team-managed"
    },
    humanResourcesNewEmployeeOnboarding: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/w77sk23hgc4int6ve414dyp3g8kr18dv.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/jrfgj84llgwi47287cq125wj58i803i7.webp",
        title: "New employee onboarding",
        subtext: "Manage and standardize the onboarding process for all new hires",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-employee-onboarding-team-managed"
    },
    humanResourcesRecruitment: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/a612l0d7u28873d6f1ki515ndaa558e4.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/vqnwpmlpj70vmkq32bhqd2nbvd6484g1.webp",
        title: "Recruitment",
        subtext: "Track potential candidates from application to offer",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-recruitment-team-managed"
    },
    customerServiceKanban: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/0vfjckg342yo7dpig7lya7w257sl0y8j.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/7vm13w8ppnild28m1o7djja6075ixp0i.webp",
        title: "Kanban",
        subtext: "Visualize work and maximize efficiency with a kanban board",
        templateType: "kanban",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban"
    },
    customerServiceScrum: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/7cb404d3xx63w7fyen71f0k0wa5qx872.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/ru71elo3i0u4f28t46gx1tslj7c1aaqu.webp",
        title: "Scrum",
        subtext: "Plan, prioritize, and schedule sprints using scrum framework",
        templateType: "scrum",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum"
    },
    customerServiceProjectManagement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/v72j33wc0du76m468be7754522a06852.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/3267uqnx00wul5127ga7o5yq748p82yx.webp",
        title: "Project management",
        subtext: "Manage, track, and assign tasks to streamline project workflows",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-project-management-team-managed"
    },
    legalProcessControl: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1r64604wfqibw3yblds6ptf5e4ugd214.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/04a7pb68420724362a8uhtj786i41441.webp",
        title: "Process control",
        subtext: "Create, monitor, and iterate on processes in one place",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-process-control-team-managed"
    },
    legalProjectManagement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/svgfhl3b5dgx0v375752af1h0cq3guhn.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/0vw4j73qn18wc1j62e2112i084j46evu.webp",
        title: "Project management",
        subtext: "Manage, track, and assign tasks to streamline project workflows",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-project-management-team-managed"
    },
    legalIpInfringement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/42s1w8qhushh0ud8rvkbb60l53oy1y0q.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/kbawcic5d4v78w674008f0200v45vps3.webp",
        title: "IP Infringement",
        subtext: "Identify and track IP infringement claims to resolve them.",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-ip-infringement-team-managed"
    },
    financeProjectManagement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/f2f8e504020478718ch0h5d335i71na5.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/3p03s867217v4d15ym6v0t71b2m7ea0j.webp",
        title: "Project Management",
        subtext: "Manage, track, and assign tasks to streamline project workflows",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-project-management-team-managed"
    },
    financeProcurement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/xvoae7s27woi8l483jcpuln36yb2up37.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/47v3i1315mrg71nlw8q0giay0x0e46a3.webp",
        title: "Procurement",
        subtext: "Standardize purchase processes on your team from request to receipt",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-procurement-team-managed"
    },
    financeBudgetCreation: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/4es7bdkmylgnm0116x8072ys16p1m306.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/ywgw10hgch0c0m855sgmflpge3mmp7d3.webp",
        title: "Budget Creation",
        subtext: "Manage, approve, or reject budget proposals all in one place",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-budget-creation-team-managed"
    },
    salesProjectManagement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/4cu0nh41tq724v7601058vpemb307472.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/71s6di56ekra28pw0riquw7t4a07c575.webp",
        title: "Project management",
        subtext: "Manage, track, and assign tasks to streamline project workflows",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-project-management-team-managed"
    },
    salesSalesPipeline: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/12i72qppy6o120t57c486mifyu1f4m5y.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/8hhhlo7r36kbeo0ysu37ak5546kvxy7h.webp",
        title: "Sales pipeline",
        subtext: "Manage and track your customers to help close deals with ease",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-sales-pipeline-team-managed"
    },
    salesLeadTracking: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/m1w76q6ahxw23425oio25br558cdvl53.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/e8nqbp4y2kaf77602168x8gjx1175564.webp",
        title: "Lead tracking",
        subtext: "Track sales leads from opportunity through to conversion",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-lead-tracking-team-managed"
    },
    dataScienceKanban: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/1c57w6ld57uw6u6e5444bo3x4dd5h38q.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/hq5t712h2y8d21wtldwdb7w45u4h3g4t.webp",
        title: "Kanban",
        subtext: "Manage data science projects efficiently, visualize tasks, and see team workload",
        templateType: "kanban",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban"
    },
    dataScienceScrum: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/v3heq4ypf18th4023kw4ek2kniv74u54.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/238qe8r16628h6nl7pb54k8fhvf6k8q1.webp",
        title: "Scrum",
        subtext: "Plan, prioritize, and schedule sprints using scrum framework",
        templateType: "scrum",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum"
    },
    dataScienceProjectManagement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/unkrsmfsv381lyp3riu5046ypr03c2tw.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/7w1u5wl552b5t527b7saxi5lwc766hkx.webp",
        title: "Project Management",
        subtext: "Manage, track, and assign tasks to streamline project workflows",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-project-management-team-managed"
    },
    otherScrum: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/6w2y57obt23x1uppve31yoy7js2kd78k.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/gx3nl2pdo4843583l358b00xr63fsvb3.webp",
        title: "Scrum",
        subtext: "Plan, prioritize, and schedule sprints using scrum framework",
        templateType: "scrum",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum"
    },
    otherKanban: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/f2f8e504020478718ch0h5d335i71na5.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/3p03s867217v4d15ym6v0t71b2m7ea0j.webp",
        title: "Kanban",
        subtext: "Visualize work and maximize efficiency with a kanban board",
        templateType: "kanban",
        templateId: "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban"
    },
    otherProjectManagement: {
        imageSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/53bk03d638jh563u132bcd110j1m5yf7.webp",
        mobileImgSrc: "https://dam-cdn.atl.orangelogic.com/AssetLink/725277466h2xi7npa3xlhq1716a8tef4.webp",
        title: "Project management",
        subtext: "Manage, track, and assign tasks to streamline project workflows",
        templateType: undefined,
        templateId: "com.atlassian.jira-core-project-templates:jira-work-management-project-management-team-managed"
    }
};
function $9fbbc31ef4d65caa$export$44d53e543766f145(teamType, formatMessage) {
    const defaultTemplateOptions = [
        {
            option: {
                ...$9fbbc31ef4d65caa$export$baf553820dccdc1.softwareDevelopmentKanban,
                title: formatMessage({
                    id: "TransparentTemplateV2.softwareDevelopment.kanban.title",
                    defaultMessage: "Kanban"
                }),
                subtext: formatMessage({
                    id: "TransparentTemplateV2.softwareDevelopment.kanban.subtext",
                    defaultMessage: "Visualize work and maximize efficiency with a kanban board"
                }),
                templateType: "kanban"
            }
        },
        {
            option: {
                ...$9fbbc31ef4d65caa$export$baf553820dccdc1.softwareDevelopmentScrum,
                title: formatMessage({
                    id: "TransparentTemplateV2.scrum.title",
                    defaultMessage: "Scrum"
                }),
                subtext: formatMessage({
                    id: "TransparentTemplateV2.scrum.subtext",
                    defaultMessage: "Plan, prioritize, and schedule sprints using scrum framework"
                }),
                templateType: "scrum"
            }
        },
        {
            option: {
                ...$9fbbc31ef4d65caa$export$baf553820dccdc1.softwareDevelopmentProjectManagement,
                title: formatMessage({
                    id: "TransparentTemplateV2.softwareDevelopment.projectManagement.title",
                    defaultMessage: "Project management"
                }),
                subtext: formatMessage({
                    id: "TransparentTemplateV2.softwareDevelopment.projectManagement.subtext",
                    defaultMessage: "Manage and track agile work plus integrate developer tools like GitHub"
                }),
                templateType: "business"
            }
        }
    ];
    switch(teamType){
        case 0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE:
            return [
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.softwareDevelopmentKanban,
                        title: formatMessage({
                            id: "TransparentTemplateV2.softwareDevelopment.kanban.title",
                            defaultMessage: "Kanban"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.softwareDevelopment.kanban.subtext",
                            defaultMessage: "Visualize work and maximize efficiency with a kanban board"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.softwareDevelopmentScrum,
                        title: formatMessage({
                            id: "TransparentTemplateV2.scrum.title",
                            defaultMessage: "Scrum"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.scrum.subtext",
                            defaultMessage: "Plan, prioritize, and schedule sprints using scrum framework"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.softwareDevelopmentProjectManagement,
                        title: formatMessage({
                            id: "TransparentTemplateV2.softwareDevelopment.projectManagement.title",
                            defaultMessage: "Project management"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.softwareDevelopment.projectManagement.subtext",
                            defaultMessage: "Manage and track agile work plus integrate developer tools like GitHub"
                        })
                    }
                }
            ];
        case 0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT:
            return [
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.productManagementScrum,
                        title: formatMessage({
                            id: "TransparentTemplateV2.scrum.title",
                            defaultMessage: "Scrum"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.scrum.subtext",
                            defaultMessage: "Plan, prioritize, and schedule sprints using scrum framework"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.productManagementProjectManagement,
                        title: formatMessage({
                            id: "TransparentTemplateV2.productManagement.projectManagement.title",
                            defaultMessage: "Project management"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.productManagement.projectManagement.subtext",
                            defaultMessage: "Manage and track agile work plus integrate developer tools like GitHub"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.productManagementBusinessCollaboration,
                        title: formatMessage({
                            id: "TransparentTemplateV2.productManagement.businessCollaboration.title",
                            defaultMessage: "Business collaboration"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.productManagement.businessCollaboration.subtext",
                            defaultMessage: "Designed to help business teams manage work with list and calendar views"
                        })
                    }
                }
            ];
        case 0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_MARKETING:
            return [
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.campaignManagement,
                        title: formatMessage({
                            id: "TransparentTemplate.marketing.campaignManagement.title",
                            defaultMessage: "Campaign management"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplate.marketing.campaignManagement.subtext",
                            defaultMessage: "Work towards campaign launches, tracking deadlines and tasks along the way"
                        }),
                        templateType: "campaign management"
                    },
                    metadata: {
                        jtbd: "1,5"
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.marketingProjectManagement,
                        title: formatMessage({
                            id: "TransparentTemplate.marketing.marketingProjectManagement.title",
                            defaultMessage: "Marketing project management"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplate.marketing.marketingProjectManagement.subtext",
                            defaultMessage: "Manage marketing projects efficiently, visualize tasks, and see team workload"
                        }),
                        templateType: "project management"
                    },
                    metadata: {
                        jtbd: "4,5"
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.contentManagement,
                        title: formatMessage({
                            id: "TransparentTemplate.marketing.contentManagement.title",
                            defaultMessage: "Content management"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplate.marketing.contentManagement.subtext",
                            defaultMessage: "Oversee your marketing content lifecycle from draft to delivery"
                        }),
                        templateType: "content management"
                    },
                    metadata: {
                        jtbd: "2,6,5"
                    }
                }
            ];
        case 0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_DESIGN:
            return [
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.designKanban,
                        title: formatMessage({
                            id: "TransparentTemplateV2.design.kanban.title",
                            defaultMessage: "Kanban"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.design.kanban.subtext",
                            defaultMessage: "Manage design projects efficiently, visualize tasks, and see team workload"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.designWebDesignProcess,
                        title: formatMessage({
                            id: "TransparentTemplateV2.design.webDesignProcess.title",
                            defaultMessage: "Web design process"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.design.webDesignProcess.subtext",
                            defaultMessage: "Build web pages plus keep designers and developers on the same page"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.designScrum,
                        title: formatMessage({
                            id: "TransparentTemplateV2.scrum.title",
                            defaultMessage: "Scrum"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.scrum.subtext",
                            defaultMessage: "Plan, prioritize, and schedule sprints using scrum framework"
                        })
                    }
                }
            ];
        case 0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT:
            return [
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.projectManagementKanban,
                        title: formatMessage({
                            id: "TransparentTemplateV2.projectManagement.kanban.title",
                            defaultMessage: "Kanban"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.projectManagement.kanban.subtext",
                            defaultMessage: "Manage and track agile work plus integrate developer tools like GitHub"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.projectManagementProjectManagement,
                        title: formatMessage({
                            id: "TransparentTemplateV2.projectManagement.projectManagement.title",
                            defaultMessage: "Project management"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.projectManagement.projectManagement.subtext",
                            defaultMessage: "Designed to help business teams manage work with list and calendar views"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.projectManagementScrum,
                        title: formatMessage({
                            id: "TransparentTemplateV2.scrum.title",
                            defaultMessage: "Scrum"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.scrum.subtext",
                            defaultMessage: "Plan, prioritize, and schedule sprints using scrum framework"
                        })
                    }
                }
            ];
        case 0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS:
            return [
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.processControl,
                        title: formatMessage({
                            id: "TransparentTemplate.operations.processControl.title",
                            defaultMessage: "Process control"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplate.operations.processControl.subtext",
                            defaultMessage: "Create, monitor, and iterate on processes in one place"
                        }),
                        templateType: "process control"
                    },
                    metadata: {
                        jtbd: "3,2"
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.projectManagement,
                        title: formatMessage({
                            id: "TransparentTemplate.operations.projectManagement.title",
                            defaultMessage: "Project management"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplate.operations.projectManagement.subtext",
                            defaultMessage: "Designed to help business teams manage work with list and calendar views"
                        }),
                        templateType: "project management"
                    },
                    metadata: {
                        jtbd: "5,2"
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.procurement,
                        title: formatMessage({
                            id: "TransparentTemplate.operations.procurement.title",
                            defaultMessage: "Procurement"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplate.operations.procurement.subtext",
                            defaultMessage: "Standardize purchase process on your team from request to receipt"
                        }),
                        templateType: "procurement"
                    },
                    metadata: {
                        jtbd: "7,2"
                    }
                }
            ];
        case 0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT:
            return [
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.itSupportKanban,
                        title: formatMessage({
                            id: "TransparentTemplateV2.itSupport.kanban.title",
                            defaultMessage: "Kanban"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.itSupport.kanban.subtext",
                            defaultMessage: "Visualize work and maximize efficiency with a kanban board"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.itSupportScrum,
                        title: formatMessage({
                            id: "TransparentTemplateV2.scrum.title",
                            defaultMessage: "Scrum"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.scrum.subtext",
                            defaultMessage: "Plan, prioritize, and schedule sprints using scrum framework"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.itSupportProjectManagement,
                        title: formatMessage({
                            id: "TransparentTemplateV2.itSupport.projectManagement.title",
                            defaultMessage: "Project management"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.itSupport.projectManagement.subtext",
                            defaultMessage: "Designed to help business teams manage work with list and calendar views"
                        })
                    }
                }
            ];
        case 0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_HR:
            return [
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.humanResourcesProjectManagement,
                        title: formatMessage({
                            id: "TransparentTemplateV2.humanResources.projectManagement.title",
                            defaultMessage: "Project management"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.humanResources.projectManagement.subtext",
                            defaultMessage: "Manage, track, and assign tasks to streamline project workflows"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.humanResourcesNewEmployeeOnboarding,
                        title: formatMessage({
                            id: "TransparentTemplateV2.humanResources.newEmployeeOnboarding.title",
                            defaultMessage: "New employee onboarding"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.humanResources.newEmployeeOnboarding.subtext",
                            defaultMessage: "Manage and standardize the onboarding process for all new hires"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.humanResourcesRecruitment,
                        title: formatMessage({
                            id: "TransparentTemplateV2.humanResources.recruitment.title",
                            defaultMessage: "Recruitment"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.humanResources.recruitment.subtext",
                            defaultMessage: "Track potential candidates from application to offer"
                        })
                    }
                }
            ];
        case 0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE:
            return [
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.customerServiceKanban,
                        title: formatMessage({
                            id: "TransparentTemplateV2.customerService.kanban.title",
                            defaultMessage: "Kanban"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.customerService.kanban.subtext",
                            defaultMessage: "Visualize work and maximize efficiency with a kanban board"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.customerServiceScrum,
                        title: formatMessage({
                            id: "TransparentTemplateV2.scrum.title",
                            defaultMessage: "Scrum"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.scrum.subtext",
                            defaultMessage: "Plan, prioritize, and schedule sprints using scrum framework"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.customerServiceProjectManagement,
                        title: formatMessage({
                            id: "TransparentTemplateV2.customerService.projectManagement.title",
                            defaultMessage: "Project management"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.customerService.projectManagement.subtext",
                            defaultMessage: "Manage, track, and assign tasks to streamline project workflows"
                        })
                    }
                }
            ];
        case 0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_LEGAL:
            return [
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.legalProcessControl,
                        title: formatMessage({
                            id: "TransparentTemplateV2.legal.processControl.title",
                            defaultMessage: "Process control"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.legal.processControl.subtext",
                            defaultMessage: "Create, monitor, and iterate on processes in one place"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.legalProjectManagement,
                        title: formatMessage({
                            id: "TransparentTemplateV2.legal.projectManagement.title",
                            defaultMessage: "Project management"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.legal.projectManagement.subtext",
                            defaultMessage: "Manage, track, and assign tasks to streamline project workflows"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.legalIpInfringement,
                        title: formatMessage({
                            id: "TransparentTemplateV2.legal.ipInfringement.title",
                            defaultMessage: "IP Infringement"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.legal.ipInfringement.subtext",
                            defaultMessage: "Identify and track IP infringement claims to resolve them."
                        })
                    }
                }
            ];
        case 0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_FINANCE:
            return [
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.financeProjectManagement,
                        title: formatMessage({
                            id: "TransparentTemplateV2.finance.projectManagement.title",
                            defaultMessage: "Project Management"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.finance.projectManagement.subtext",
                            defaultMessage: "Manage, track, and assign tasks to streamline project workflows"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.financeProcurement,
                        title: formatMessage({
                            id: "TransparentTemplateV2.finance.procurement.title",
                            defaultMessage: "Procurement"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.finance.procurement.subtext",
                            defaultMessage: "Standardize purchase processes on your team from request to receipt"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.financeBudgetCreation,
                        title: formatMessage({
                            id: "TransparentTemplateV2.finance.budgetCreation.title",
                            defaultMessage: "Budget Creation"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.finance.budgetCreation.subtext",
                            defaultMessage: "Manage, approve, or reject budget proposals all in one place"
                        })
                    }
                }
            ];
        case 0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_SALES:
            return [
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.salesProjectManagement,
                        title: formatMessage({
                            id: "TransparentTemplateV2.sales.projectManagement.title",
                            defaultMessage: "Project management"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.sales.projectManagement.subtext",
                            defaultMessage: "Manage, track, and assign tasks to streamline project workflows"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.salesSalesPipeline,
                        title: formatMessage({
                            id: "TransparentTemplateV2.sales.salesPipeline.title",
                            defaultMessage: "Sales pipeline"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.sales.salesPipeline.subtext",
                            defaultMessage: "Manage and track your customers to help close deals with ease"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.salesLeadTracking,
                        title: formatMessage({
                            id: "TransparentTemplateV2.sales.leadTracking.title",
                            defaultMessage: "Lead tracking"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.sales.leadTracking.subtext",
                            defaultMessage: "Track sales leads from opportunity through to conversion"
                        })
                    }
                }
            ];
        case 0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE:
            return [
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.dataScienceKanban,
                        title: formatMessage({
                            id: "TransparentTemplateV2.dataScience.kanban.title",
                            defaultMessage: "Kanban"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.dataScience.kanban.subtext",
                            defaultMessage: "Manage data science projects efficiently, visualize tasks, and see team workload"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.dataScienceScrum,
                        title: formatMessage({
                            id: "TransparentTemplateV2.scrum.title",
                            defaultMessage: "Scrum"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.scrum.subtext",
                            defaultMessage: "Plan, prioritize, and schedule sprints using scrum framework"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.dataScienceProjectManagement,
                        title: formatMessage({
                            id: "TransparentTemplateV2.dataScience.projectManagement.title",
                            defaultMessage: "Project Management"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.dataScience.projectManagement.subtext",
                            defaultMessage: "Manage, track, and assign tasks to streamline project workflows"
                        })
                    }
                }
            ];
        case 0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL:
            return [
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.otherScrum,
                        title: formatMessage({
                            id: "TransparentTemplateV2.scrum.title",
                            defaultMessage: "Scrum"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.scrum.subtext",
                            defaultMessage: "Plan, prioritize, and schedule sprints using scrum framework"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.otherKanban,
                        title: formatMessage({
                            id: "TransparentTemplateV2.other.kanban.title",
                            defaultMessage: "Kanban"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.other.kanban.subtext",
                            defaultMessage: "Visualize work and maximize efficiency with a kanban board"
                        })
                    }
                },
                {
                    option: {
                        ...$9fbbc31ef4d65caa$export$baf553820dccdc1.otherProjectManagement,
                        title: formatMessage({
                            id: "TransparentTemplateV2.other.projectManagement.title",
                            defaultMessage: "Project management"
                        }),
                        subtext: formatMessage({
                            id: "TransparentTemplateV2.other.projectManagement.subtext",
                            defaultMessage: "Manage, track, and assign tasks to streamline project workflows"
                        })
                    }
                }
            ];
        default:
            return defaultTemplateOptions;
    }
}

});




parcelRegister("bFFnD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50a3ba7fff8b8ed1$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $jgJpJ = parcelRequire("jgJpJ");

var $icO1N = parcelRequire("icO1N");

var $kF7gk = parcelRequire("kF7gk");
const $50a3ba7fff8b8ed1$var$UserSegmentation = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.UfoCustomTimingWrapper), {
        ufoEvent: (0, $jgJpJ.ufoEventRedirectToProduct),
        ufoCustomTimingKey: (0, $jgJpJ.UfoCustomTimingKey).JIRA_USER_SEGMENTATION_DWELL_TIME,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "user-segmentation",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $icO1N.UserSegmentationProvider), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kF7gk.default), {})
            })
        })
    });
};
var $50a3ba7fff8b8ed1$export$2e2bcd8739ae039 = $50a3ba7fff8b8ed1$var$UserSegmentation;

});
parcelRegister("icO1N", function(module, exports) {

$parcel$export(module.exports, "UserSegmentationProvider", function () { return $70125589f355efb5$export$1ea49ab4628de83e; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $70125589f355efb5$export$8a5ed23208f525f6 = "v1";
const $70125589f355efb5$export$9826580eca38d62 = "v2";
const $70125589f355efb5$var$UserSegmentationContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    userSegView: undefined,
    setUserSegView: ()=>{
        throw new Error("Missing provider");
    }
});
const $70125589f355efb5$export$4e0f15a9f4dea54b = ()=>{
    const context = (0, $iSvIT.useContext)($70125589f355efb5$var$UserSegmentationContext);
    if (context === undefined) throw new Error("`useUserSegmentation` must be used within a `UserSegmentationContext.Provider`");
    return context;
};
const $70125589f355efb5$export$1ea49ab4628de83e = ({ children: children })=>{
    const [userSegView, setUserSegView] = (0, $iSvIT.useState)();
    return /*#__PURE__*/ (0, $loA2J.jsx)($70125589f355efb5$var$UserSegmentationContext.Provider, {
        value: {
            userSegView: userSegView,
            setUserSegView: setUserSegView
        },
        children: children
    });
};

});

parcelRegister("kF7gk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82779f1148ac4e5f$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $iMdoL = parcelRequire("iMdoL");

var $gkhN4 = parcelRequire("gkhN4");

var $1LPIk = parcelRequire("1LPIk");

var $aO3Hl = parcelRequire("aO3Hl");

var $77Hlt = parcelRequire("77Hlt");

var $1Y3bT = parcelRequire("1Y3bT");

var $dkYGl = parcelRequire("dkYGl");

var $1KPYm = parcelRequire("1KPYm");

var $jRcT4 = parcelRequire("jRcT4");

var $gkGzt = parcelRequire("gkGzt");
const $82779f1148ac4e5f$var$ViewManager = ()=>{
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const { nextScreen: nextScreen } = (0, $1Y3bT.useScreenManager)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { userSegmentationContext: { closeUserSegmentationUI: closeUserSegmentationUI, setSelectedTeamType: setSelectedTeamType } } = (0, $77Hlt.useConfirmationPage)();
    const searchParameters = new URLSearchParams(window.location.search);
    const paramsTeamType = searchParameters.get((0, $jRcT4.USER_SEARCH_PARAMS).teamType) ?? "";
    const { products: products, edition: edition } = (0, $aO3Hl.useSearchParameters)();
    const productKey = (0, $dkYGl.getPrimaryProduct)(products);
    const { profile: profile } = (0, $iMdoL.useUserContext)();
    const userType = profile.cohorts?.userType;
    const domainType = profile.cohorts?.domainType;
    const companyType = profile.cohorts?.companyType;
    const [waitForAttributes, setWaitForAttributes] = (0, $iSvIT.useState)(true);
    const [dataFoundationAttributes, setDataFoundationAttributes] = (0, $iSvIT.useState)({
        productKey: productKey,
        edition: edition
    });
    (0, $iSvIT.useEffect)(()=>{
        if (!profile.requestInProgress) {
            setDataFoundationAttributes((prevAttributes)=>({
                    ...prevAttributes,
                    userType: userType,
                    domainType: domainType,
                    companyType: companyType
                }));
            setWaitForAttributes(false);
        }
    }, [
        profile.requestInProgress,
        userType,
        domainType,
        companyType
    ]);
    (0, $iSvIT.useEffect)(()=>{
        // Suppress purple user segmentation view during N2E Flow.
        stargateClient.postUserSegmentationViewAttempt();
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        // If team type is set as a query parameter, the user has refreshed the page.
        // Add the selected team type to state and close the user segmentation UI.
        if ((0, $1KPYm.USER_SEGMENTATION_TEAM_TYPES).includes(paramsTeamType)) {
            setSelectedTeamType(paramsTeamType);
            closeUserSegmentationUI();
            nextScreen();
            return;
        }
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: (0, $jRcT4.TRACKING_EVENT_ACTION_SUBJECT_IDS).userSegRedesignScreen,
            attributes: {
                atlasTicket: (0, $jRcT4.ATLAS_TICKET)
            }
        }).fire();
    }, [
        paramsTeamType
    ]);
    return (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPES).includes(paramsTeamType) ? null : /*#__PURE__*/ (0, $loA2J.jsx)((0, $1LPIk.DataFoundationsWrapper), {
        dataFoundationsEventOption: "TeamChoiceScreenViewed",
        attributes: dataFoundationAttributes,
        waitForAttributes: waitForAttributes,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gkGzt.default), {})
    });
};
var $82779f1148ac4e5f$export$2e2bcd8739ae039 = $82779f1148ac4e5f$var$ViewManager;

});
parcelRegister("gkGzt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $662cb6577d578916$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $dy6pe = parcelRequire("dy6pe");

var $gLWQf = parcelRequire("gLWQf");

var $aO3Hl = parcelRequire("aO3Hl");

var $2xIEu = parcelRequire("2xIEu");
const $662cb6577d578916$var$TeamFocusView = ()=>{
    const intl = (0, $f6qj2.default)();
    const searchParameters = (0, $aO3Hl.useSearchParameters)();
    const { products: products = [] } = searchParameters;
    const isJsm = products.includes((0, $2xIEu.ProductKey).JIRA_SERVICE_MANAGEMENT);
    const messages = isJsm ? {
        teamFocus: intl.formatMessage({
            id: "UserSeg.teamTypeSelection.header",
            defaultMessage: "What kind of work do you do?"
        }),
        personalizeJira: intl.formatMessage({
            id: "UserSeg.teamTypeSelection.jsm.subHeader",
            defaultMessage: "This helps us personalize your experience"
        })
    } : {
        teamFocus: intl.formatMessage({
            id: "UserSeg.teamTypeSelection.header",
            defaultMessage: "What kind of work do you do?"
        }),
        personalizeJira: intl.formatMessage({
            id: "UserSeg.teamTypeSelection.transparentTemplateForAll.subHeader",
            defaultMessage: "This helps us suggest templates that help your team do their best work."
        })
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gLWQf.JiraOnboardingContainer), {
        header: messages.teamFocus,
        subheader: messages.personalizeJira,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dy6pe.CardsGrid), {})
    });
};
var $662cb6577d578916$export$2e2bcd8739ae039 = $662cb6577d578916$var$TeamFocusView;

});
parcelRegister("dy6pe", function(module, exports) {

$parcel$export(module.exports, "CardsGrid", function () { return $5e6b1f0703d681d3$export$4e3eac493083c27f; });
/* cards-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $1KPYm = parcelRequire("1KPYm");

var $9PfCv = parcelRequire("9PfCv");

var $sIwfY = parcelRequire("sIwfY");
const $5e6b1f0703d681d3$var$gridContainer = null;
const $5e6b1f0703d681d3$export$4e3eac493083c27f = ()=>{
    const intl = (0, $f6qj2.default)();
    const cardsMap = (0, $iSvIT.useMemo)(()=>[
            {
                card: intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.softwareDevelopment",
                    defaultMessage: "Software development"
                }),
                Icon: (0, $sIwfY.SoftwareDevelopmentIcon2),
                teamType: (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE)
            },
            {
                card: intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.productManagement",
                    defaultMessage: "Product management"
                }),
                Icon: (0, $sIwfY.ProductManagementIcon),
                teamType: (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT)
            },
            {
                card: intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.marketing",
                    defaultMessage: "Marketing"
                }),
                Icon: (0, $sIwfY.MarketingIcon2),
                teamType: (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_MARKETING)
            },
            {
                card: intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.design",
                    defaultMessage: "Design"
                }),
                Icon: (0, $sIwfY.DesignIcon2),
                teamType: (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_DESIGN)
            },
            {
                card: intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.projectManagement",
                    defaultMessage: "Project management"
                }),
                Icon: (0, $sIwfY.ProjectManagementIcon),
                teamType: (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT)
            },
            {
                card: intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.operations",
                    defaultMessage: "Operations"
                }),
                Icon: (0, $sIwfY.OperationsIcon2),
                teamType: (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_OPERATIONS)
            },
            {
                card: intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.itSupport",
                    defaultMessage: "IT support"
                }),
                Icon: (0, $sIwfY.ITSupportIcon2),
                teamType: (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT)
            },
            {
                card: intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.humanResources",
                    defaultMessage: "Human resources"
                }),
                Icon: (0, $sIwfY.HumanResourcesIcon),
                teamType: (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_HR)
            },
            {
                card: intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.customerService",
                    defaultMessage: "Customer service"
                }),
                Icon: (0, $sIwfY.CustomerServiceIcon2),
                teamType: (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_CUSTOMER_SERVICE)
            },
            {
                card: intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.legal",
                    defaultMessage: "Legal"
                }),
                Icon: (0, $sIwfY.LegalIcon2),
                teamType: (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_LEGAL)
            },
            {
                card: intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.finance",
                    defaultMessage: "Finance"
                }),
                Icon: (0, $sIwfY.FinanceIcon2),
                teamType: (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_FINANCE)
            },
            {
                card: intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.sales",
                    defaultMessage: "Sales"
                }),
                Icon: (0, $sIwfY.SalesIcon2),
                teamType: (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_SALES)
            },
            {
                card: intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.dataScience",
                    defaultMessage: "Data science"
                }),
                Icon: (0, $sIwfY.DataScienceIcon),
                teamType: (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_DATA_SCIENCE)
            },
            {
                card: intl.formatMessage({
                    id: "UserSeg.teamTypeSelection.otherOrPersonal",
                    defaultMessage: "Other"
                }),
                Icon: (0, $sIwfY.OtherIcon),
                teamType: (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL)
            }
        ], []);
    const [cardSelected, setCardSelected] = (0, $iSvIT.useState)(false);
    const onCardClick = ()=>{
        setCardSelected(true);
    };
    const afterCardClick = ()=>{
        setCardSelected(false);
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1h6o _zulputpp _99s6pxbi _nv391wug _1bv01wug _1waft94y _181n11p5 _1j8bwxkt"
        ]),
        children: cardsMap.map((cardObject, index)=>{
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9PfCv.UserSegCard), {
                    idx: index,
                    ...cardObject,
                    onClick: onCardClick,
                    afterClick: afterCardClick,
                    disabled: cardSelected
                })
            }, index);
        })
    });
};

});
parcelRegister("9PfCv", function(module, exports) {

$parcel$export(module.exports, "UserSegCard", function () { return $36cda420e7277ba5$export$4028956054dba973; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $g9kzu = parcelRequire("g9kzu");

var $3cmdt = parcelRequire("3cmdt");

var $jgJpJ = parcelRequire("jgJpJ");

var $gkhN4 = parcelRequire("gkhN4");

var $5ohHq = parcelRequire("5ohHq");

var $77Hlt = parcelRequire("77Hlt");

var $1Y3bT = parcelRequire("1Y3bT");

var $dmKCp = parcelRequire("dmKCp");

var $jRcT4 = parcelRequire("jRcT4");

var $aO3Hl = parcelRequire("aO3Hl");

var $5VIPX = parcelRequire("5VIPX");

var $1KPYm = parcelRequire("1KPYm");

var $gh3cF = parcelRequire("gh3cF");

var $6bw3Y = parcelRequire("6bw3Y");
const $36cda420e7277ba5$var$buttonStyle = null;
const $36cda420e7277ba5$var$iconWrapper = null;
const $36cda420e7277ba5$var$arrowIconWrapper = null;
const $36cda420e7277ba5$var$cardHeaderText = null;
const $36cda420e7277ba5$export$4028956054dba973 = ({ card: card, Icon: Icon, teamType: teamType, onClick: onClick, afterClick: afterClick, disabled: disabled })=>{
    const { userSegmentationContext: { closeUserSegmentationUI: closeUserSegmentationUI, setSelectedTeamType: setSelectedTeamType } } = (0, $77Hlt.useConfirmationPage)();
    const { addTeamTypeCallback: addTeamTypeCallback } = (0, $aO3Hl.useGupsStatus)();
    const { nextScreen: nextScreen } = (0, $1Y3bT.useScreenManager)();
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const [isHovering, setIsHovering] = (0, $iSvIT.useState)(false);
    const { fireTeamTypeProcessedEvent: fireTeamTypeProcessedEvent } = (0, $5VIPX.useUserSegmentationEvents)();
    const onClickHandler = async ()=>{
        try {
            (0, $jgJpJ.ufoEventConfirmationPageTeamTypeSelection).start();
            (0, $jgJpJ.ufoEventConfirmationPageTeamTypeSelection).setCustomData({
                teamType: teamType
            });
            onClick?.();
            if ((0, $gh3cF.getGupsIntegrationInJiraOnboardingEnabled)()) addTeamTypeCallback(teamType);
            if (teamType == undefined) {
                (0, $jgJpJ.ufoEventConfirmationPageTeamTypeSelection).failure({
                    error: new Error("teamType is undefined")
                });
                return;
            }
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: (0, $jRcT4.TRACKING_EVENT_ACTION_SUBJECT_IDS).teamFocusTeamTypeButton,
                attributes: {
                    atlasTicket: "ATLAS-69623",
                    teamType: teamType
                }
            }).fire(); // map the selected team type to the value
            // downstream consumers are expecting.
            const teamTypeFromIdentity = (0, $1KPYm.getIdentityTeamType)(teamType);
            await (0, $dmKCp.updateUserProfile)({
                selectedTeamType: teamTypeFromIdentity,
                stargateClient: stargateClient
            });
            setSelectedTeamType(teamType);
            fireTeamTypeProcessedEvent(teamType); // add team_type to query param to maintain selection on refresh
            const updatedUrl = (0, $6bw3Y.getCurrentUrlWithParams)({
                team_type: teamType || ""
            });
            history.replaceState({}, "", updatedUrl);
            closeUserSegmentationUI(); // TODO: remove closeUserSegmentationUI once confirmation page rearch is productionized.
            nextScreen();
            (0, $jgJpJ.ufoEventConfirmationPageTeamTypeSelection).success();
        } catch (e) {
            (0, $jgJpJ.ufoEventConfirmationPageTeamTypeSelection).failure({
                error: e
            });
        } finally{
            afterClick?.();
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
        "data-testid": "team-type-button",
        onMouseEnter: ()=>setIsHovering(true),
        onMouseLeave: ()=>setIsHovering(false),
        onFocus: ()=>setIsHovering(true),
        onBlur: ()=>setIsHovering(false),
        onClick: onClickHandler,
        disabled: disabled,
        className: (0, $esG4f.default)([
            "_80omtlke _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1y6m _ca0q7vkz _u5f37vkz _n3td7vkz _19bv7vkz _zulpu2gc _4t3ivbgk _2rkoftgi _bfhkcd5j _19it14i9 _19pkt94y _2hwxt94y _otyrt94y _18u0t94y _vchhusvi _kqswh2mm _1ul9qxjr _jbnuidpf _1897idpf _1axsidpf _1uwgidpf _bfw71ttf"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1ylp _1bsb1ylp _bfhkglyw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)(Icon, {
                    label: "",
                    primaryColor: "#FFF",
                    size: "large"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_syaz1hlo _ect41pz4 _1wybf6fq _k48p1fw0 _vwz41f4h _y3gn1e5h"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                },
                children: card
            }),
            isHovering && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                "data-testid": "arrow-icon",
                className: (0, $esG4f.default)([
                    "_ahbq1wug _1pfh14y2"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3cmdt))), {
                    label: "arrow-right",
                    size: "medium"
                })
            })
        ]
    });
};

});
parcelRegister("3cmdt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2543b9c45eebfb2f$var$_react = $2543b9c45eebfb2f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $2543b9c45eebfb2f$var$_arrowRight = $2543b9c45eebfb2f$var$_interopRequireDefault((parcelRequire("1U6T0")));
function $2543b9c45eebfb2f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2543b9c45eebfb2f$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $2543b9c45eebfb2f$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $2543b9c45eebfb2f$var$_arrowRight.default
    }));
$2543b9c45eebfb2f$var$ArrowRightIcon.displayName = "ArrowRightIcon";
var $2543b9c45eebfb2f$var$_default = module.exports.default = $2543b9c45eebfb2f$var$ArrowRightIcon;

});
parcelRegister("1U6T0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $16305ce039613543$var$_react = $16305ce039613543$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $16305ce039613543$var$_baseNew = $16305ce039613543$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $16305ce039613543$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $16305ce039613543$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $16305ce039613543$var$_react.default.createElement($16305ce039613543$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$16305ce039613543$var$ArrowRightIcon.displayName = "ArrowRightIcon";
var $16305ce039613543$var$_default = module.exports.default = $16305ce039613543$var$ArrowRightIcon;

});


parcelRegister("5VIPX", function(module, exports) {

$parcel$export(module.exports, "useUserSegmentationEvents", function () { return $e76a19601f337845$export$ce69758f969f3685; });

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $97qSZ = parcelRequire("97qSZ");
const $e76a19601f337845$export$ce69758f969f3685 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const fireTeamTypeProcessedEvent = (0, $iSvIT.useCallback)((teamType, additionalAttributes = {})=>{
        const eventData = {
            eventType: "track",
            action: "processed",
            actionSubject: "teamType",
            attributes: (0, $97qSZ.GASv3).enrichEventData({
                teamType: teamType,
                ...additionalAttributes
            })
        };
        createAnalyticsEvent(eventData).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireTeamTypeProcessedEvent: fireTeamTypeProcessedEvent
    };
};

});






parcelRegister("hHiuZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72b00580d25d9cf5$export$2e2bcd8739ae039; });
/* user-segmentation-view.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $jgJpJ = parcelRequire("jgJpJ");
parcelRequire("d2NVK");
var $kR2lN = parcelRequire("kR2lN");

var $aO3Hl = parcelRequire("aO3Hl");

var $1Y3bT = parcelRequire("1Y3bT");

var $2xIEu = parcelRequire("2xIEu");
const $72b00580d25d9cf5$var$UserSegmentationView = ()=>{
    const { products: products, requestId: requestId, onDemandUrl: onDemandUrl, cloudId: cloudId, n2n: n2n } = (0, $aO3Hl.useSearchParameters)();
    const { nextScreen: nextScreen } = (0, $1Y3bT.useScreenManager)();
    const listenForUserSegmentationPage = (0, $iSvIT.useCallback)((event)=>{
        let data;
        try {
            data = JSON.parse(event.data);
            if (data.source !== "user-segmentation-ui") data = null;
        } catch (e) {
            data = null;
        }
        if (!data) return;
        if (!data.message) return;
        if (data.message === "finished") nextScreen();
    }, [
        nextScreen
    ]);
    // url is relative to WAC
    const iframeURL = window.IS_STORYBOOK ? "/iframe.html?args=&id=templates-wac-confirmation-page--user-segmentation-story-component&viewMode=story" : `/signup/account/setup?products=${products}&cloudId=${cloudId}&features=&requestId=${requestId}&ondemandurl=${onDemandUrl}&platform=web-platform${n2n ? "&n2n=true" : ""}`;
    (0, $iSvIT.useEffect)(()=>{
        const isProductJPD = products.length === 1 && products.includes((0, $2xIEu.ProductKey).JIRA_PRODUCT_DISCOVERY);
        const isProductJSM = products.length === 1 && products.includes((0, $2xIEu.ProductKey).JIRA_SERVICE_MANAGEMENT);
        if (isProductJPD || isProductJSM) {
            window.addEventListener("message", listenForUserSegmentationPage, false);
            return ()=>{
                window.removeEventListener("message", listenForUserSegmentationPage, false);
            };
        }
        return;
    }, [
        listenForUserSegmentationPage,
        products
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jgJpJ.UfoCustomTimingWrapper), {
        ufoEvent: (0, $jgJpJ.ufoEventRedirectToProduct),
        ufoCustomTimingKey: (0, $jgJpJ.UfoCustomTimingKey).USER_SEGMENTATION_DWELL_TIME,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kR2lN.DwellTimeWrapper), {
            eventData: {
                eventName: "userSegmentationPageDwelled",
                eventComponent: "userSegmentationPage",
                event: "dwelled",
                actionSubject: "userSegmentationPage",
                source: "wac-confirmation-page"
            },
            initialPollInterval: 5000,
            idleTimeout: 120000,
            nextPollIntervalCallback: (x)=>x + 5000,
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _kqsw1n9t _4t3i1kxc _1bsbauwl _1pby18b4 _152tidpf _1e02idpf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("iframe", {
                    title: "User Segmentation",
                    "data-testid": "user-seg-iframe",
                    frameBorder: "0",
                    height: "100%",
                    width: "100%",
                    src: iframeURL
                })
            })
        })
    });
};
const $72b00580d25d9cf5$var$IframeContainer = null;
var $72b00580d25d9cf5$export$2e2bcd8739ae039 = $72b00580d25d9cf5$var$UserSegmentationView;

});



parcelRegister("fHG2S", function(module, exports) {

$parcel$export(module.exports, "ProductViewSwitch", function () { return $69114953da1c77ce$export$72c36fa8dba79b32; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $l4l8N = parcelRequire("l4l8N");

var $2xIEu = parcelRequire("2xIEu");

var $jOWu2 = parcelRequire("jOWu2");

var $aldmM = parcelRequire("aldmM");

var $7pLpT = parcelRequire("7pLpT");
const { JIRA_SOFTWARE: $69114953da1c77ce$var$JIRA_SOFTWARE, JIRA_PRODUCT_DISCOVERY: $69114953da1c77ce$var$JIRA_PRODUCT_DISCOVERY, JIRA_SERVICE_MANAGEMENT: $69114953da1c77ce$var$JIRA_SERVICE_MANAGEMENT, LOOM: $69114953da1c77ce$var$LOOM } = (0, $2xIEu.ProductKey);
const $69114953da1c77ce$export$72c36fa8dba79b32 = ()=>{
    const metadata = (0, $l4l8N.useRegisterMetadata)();
    const orderedProductsKeys = (0, $iSvIT.useMemo)(()=>{
        const items = metadata?.get((0, $l4l8N.queryParam).products) ?? [];
        return items.sort().join(",");
    }, [
        metadata
    ]);
    const LegacyViewSwitch = /*#__PURE__*/ (0, $loA2J.jsx)((0, $7pLpT.default), {});
    switch(orderedProductsKeys){
        case $69114953da1c77ce$var$JIRA_SOFTWARE:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aldmM.JiraProvisioningUI), {});
        case $69114953da1c77ce$var$JIRA_PRODUCT_DISCOVERY:
        case $69114953da1c77ce$var$JIRA_SERVICE_MANAGEMENT:
        case $69114953da1c77ce$var$LOOM:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jOWu2.DefaultProvisioningUI), {});
        default:
            return LegacyViewSwitch;
    }
};

});
parcelRegister("jOWu2", function(module, exports) {

$parcel$export(module.exports, "DefaultProvisioningUI", function () { return $5ff187ecd655e521$export$6cb1cd3f14b166ad; });

var $loA2J = parcelRequire("loA2J");

var $gyY7b = parcelRequire("gyY7b");

var $kll8J = parcelRequire("kll8J");

var $8WD5n = parcelRequire("8WD5n");

var $dJLyV = parcelRequire("dJLyV");

var $gG3lv = parcelRequire("gG3lv");

var $5b4r7 = parcelRequire("5b4r7");
const $5ff187ecd655e521$export$6cb1cd3f14b166ad = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5b4r7.BaseProvisioningUI), {
        screenConfig: (0, $kll8J.defaultScreenConfig),
        screenDictionary: (0, $8WD5n.defaultScreenDictionary),
        screenFallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gyY7b.PerceivedProvisioningStartTimer), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJLyV.ProductRedirector), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gG3lv.default), {})
            })
        })
    });
};

});
parcelRegister("kll8J", function(module, exports) {

$parcel$export(module.exports, "defaultScreenConfig", function () { return $f24678e9f7dd54f0$export$455059caef3b89a3; });

var $l4l8N = parcelRequire("l4l8N");

var $2xIEu = parcelRequire("2xIEu");

var $jvaIB = parcelRequire("jvaIB");
const $f24678e9f7dd54f0$export$455059caef3b89a3 = {
    [(0, $jvaIB.TEAM_CHOICE)]: {
        position: {
            default: 100
        },
        onMount: ()=>undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: (0, $l4l8N.user).isN2n,
                            value: true
                        },
                        {
                            key: (0, $l4l8N.queryParam).templateId,
                            value: undefined
                        },
                        {
                            key: (0, $l4l8N.queryParam).products,
                            value: [
                                (0, $2xIEu.ProductKey).JIRA_SERVICE_MANAGEMENT
                            ]
                        }
                    ]
                },
                {
                    conditionalAND: [
                        {
                            key: (0, $l4l8N.user).isExistingJsmUser,
                            value: false
                        },
                        {
                            key: (0, $l4l8N.queryParam).templateId,
                            value: undefined
                        },
                        {
                            key: (0, $l4l8N.queryParam).products,
                            value: [
                                (0, $2xIEu.ProductKey).JIRA_SERVICE_MANAGEMENT
                            ]
                        }
                    ]
                }
            ]
        }
    },
    [(0, $jvaIB.PROVISIONING)]: {
        position: {
            default: 400
        },
        onMount: ()=>undefined,
        visibility: {
            default: true
        }
    }
};

});

parcelRegister("8WD5n", function(module, exports) {

$parcel$export(module.exports, "defaultScreenDictionary", function () { return $b28d557c84e1be81$export$342dd17b1ee963f2; });

var $loA2J = parcelRequire("loA2J");

var $dJLyV = parcelRequire("dJLyV");

var $gG3lv = parcelRequire("gG3lv");

var $bFFnD = parcelRequire("bFFnD");

var $7pLpT = parcelRequire("7pLpT");

var $gyY7b = parcelRequire("gyY7b");

var $jvaIB = parcelRequire("jvaIB");
const $b28d557c84e1be81$export$b427f3931717d69c = {
    [(0, $jvaIB.TEAM_CHOICE)]: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bFFnD.default), {})
};
const $b28d557c84e1be81$export$1638c2ed0cb353d3 = {
    [(0, $jvaIB.PROVISIONING)]: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gyY7b.PerceivedProvisioningStartTimer), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJLyV.ProductRedirector), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7pLpT.LegacyConfirmationPageLayout), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gG3lv.default), {})
            })
        })
    })
};
const $b28d557c84e1be81$export$342dd17b1ee963f2 = {
    ...$b28d557c84e1be81$export$b427f3931717d69c,
    ...$b28d557c84e1be81$export$1638c2ed0cb353d3
};

});
parcelRegister("dJLyV", function(module, exports) {

$parcel$export(module.exports, "ProductRedirector", function () { return $721313de38961b54$export$658e6bc3e0434598; });

var $iSvIT = parcelRequire("iSvIT");

var $aO3Hl = parcelRequire("aO3Hl");
const $721313de38961b54$export$658e6bc3e0434598 = ({ children: children })=>{
    const { createCloudStatus: createCloudStatus } = (0, $aO3Hl.useCloudStatus)();
    const { setWaitingForProvisioning: setWaitingForProvisioning } = (0, $aO3Hl.useCloudStatusRedirection)();
    // check if create cloud status is a success on first render
    const [shouldRedirect] = (0, $iSvIT.useState)(createCloudStatus === "success");
    // inform cloud status the user is waiting for provisioning to complete.
    (0, $iSvIT.useEffect)(()=>{
        setWaitingForProvisioning(true);
    }, []);
    // Do not show children. A redirect to product is imminent
    // This redirect will happen in use-cloud-status.tsx
    if (shouldRedirect === true) return null;
    return children;
};

});


parcelRegister("5b4r7", function(module, exports) {

$parcel$export(module.exports, "BaseProvisioningUI", function () { return $23e4fe1de71f8253$export$5dbcf3b6a7e78094; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $aO3Hl = parcelRequire("aO3Hl");

var $1Y3bT = parcelRequire("1Y3bT");

var $jvaIB = parcelRequire("jvaIB");

var $d71IS = parcelRequire("d71IS");

var $gd3el = parcelRequire("gd3el");

var $gG3lv = parcelRequire("gG3lv");

var $j6PI4 = parcelRequire("j6PI4");

var $j5z4Z = parcelRequire("j5z4Z");
const $23e4fe1de71f8253$var$baseLoadingScreen = /*#__PURE__*/ (0, $loA2J.jsx)((0, $gG3lv.default), {});
const $23e4fe1de71f8253$var$baseScreenDictionary = {
    [(0, $jvaIB.PROVISIONING)]: $23e4fe1de71f8253$var$baseLoadingScreen
};
const $23e4fe1de71f8253$var$baseScreenConfig = {
    [(0, $jvaIB.PROVISIONING)]: {
        position: {
            default: 100
        },
        onMount: ()=>console.log("loading default provisioning UI"),
        visibility: {
            default: true
        }
    }
};
const $23e4fe1de71f8253$export$5dbcf3b6a7e78094 = ({ screenDictionary: screenDictionary = $23e4fe1de71f8253$var$baseScreenDictionary, screenConfig: screenConfig = $23e4fe1de71f8253$var$baseScreenConfig, screenFallback: screenFallback = $23e4fe1de71f8253$var$baseLoadingScreen })=>{
    const { createCloudStatus: createCloudStatus } = (0, $aO3Hl.useCloudStatus)();
    // override the current screen based on cloud status error or timeout.
    const getScreenOverride = (0, $iSvIT.useCallback)(()=>{
        switch(createCloudStatus){
            case "error":
                return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gd3el.default), {});
            case "error-unrecoverable":
                return /*#__PURE__*/ (0, $loA2J.jsx)((0, $d71IS.AsyncArchitectureErrorView), {
                    errorType: "un-recoverable"
                });
            case "timeout":
                return /*#__PURE__*/ (0, $loA2J.jsx)((0, $j5z4Z.default), {});
            case "timeout-recoverable":
                return /*#__PURE__*/ (0, $loA2J.jsx)((0, $d71IS.AsyncArchitectureErrorView), {
                    errorType: "recoverable"
                });
        }
        return undefined;
    }, [
        createCloudStatus
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1Y3bT.ScreenManagerProvider), {
        screenDictionary: screenDictionary,
        screensConfig: screenConfig,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $j6PI4.ScreenManagerView), {
            screenOverride: getScreenOverride(),
            screenFallback: screenFallback
        })
    });
};

});
parcelRegister("d71IS", function(module, exports) {

$parcel$export(module.exports, "AsyncArchitectureErrorView", function () { return $f923e120089ab052$export$85944cc06f9151ae; });
/* async-architecture-error-view.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $91nJf = parcelRequire("91nJf");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $gLWQf = parcelRequire("gLWQf");

var $aO3Hl = parcelRequire("aO3Hl");

var $2F5jk = parcelRequire("2F5jk");

var $4W7la = parcelRequire("4W7la");
const $f923e120089ab052$var$mainContainer = null;
const $f923e120089ab052$var$preHeaderContainer = null;
const $f923e120089ab052$var$support = null;
const $f923e120089ab052$var$link = null;
const $f923e120089ab052$var$UnRecoverablePreheader = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _ca0q7vkz _u5f3idpf _n3tdzwfg _19bvidpf"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4W7la.ErrorSvg), {})
    });
};
const $f923e120089ab052$var$RecoverablePreheader = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _ca0q7vkz _u5f3idpf _n3tdzwfg _19bvidpf"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $2F5jk.CoffeeSvg), {})
    });
};
const $f923e120089ab052$export$85944cc06f9151ae = ({ errorType: errorType })=>{
    const { isProduction: isProduction } = (0, $aO3Hl.useCloudStatus)();
    const intl = (0, $f6qj2.default)();
    const isRecoverable = errorType === "recoverable";
    const homeUrl = isProduction ? "https://home.atlassian.com" : "https://home.stg.atlassian.com";
    const params = new URLSearchParams();
    params.append("bundle", "jira-service-management");
    const signupUrl = (0, $3FBn4.useLocalizedHref)(`/try/cloud/signup?${params}`); // conditionally define based on error type
    const PreHeader = isRecoverable ? $f923e120089ab052$var$RecoverablePreheader : $f923e120089ab052$var$UnRecoverablePreheader;
    const url = isRecoverable ? homeUrl : signupUrl; // header text
    const unrecoverableHeaderText = intl.formatMessage({
        id: "asyncArch.errorMessage.unRecoverable.header",
        defaultMessage: "Something went wrong"
    });
    const recoverableHeaderText = intl.formatMessage({
        id: "asyncArch.errorMessage.recoverable.header",
        defaultMessage: "Your site needs a little extra time"
    }); // subheader text
    const recoverableSubheaderText = intl.formatMessage({
        id: "asyncArch.errorMessage.recoverable.subheader",
        defaultMessage: "Grab a cup of coffee while we prepare your site."
    }); // cta text
    const unrecoverableCtaText = intl.formatMessage({
        id: "asyncArch.errorMessage.unRecoverable.cta",
        defaultMessage: "Try signing up again"
    });
    const recoverableCtaText = intl.formatMessage({
        id: "asyncArch.errorMessage.recoverable.cta",
        defaultMessage: "Take me home"
    }); // support text
    const persistText = intl.formatMessage({
        id: "asyncArch.errorMessage.persist",
        defaultMessage: "If this persists, please "
    });
    const supportText = intl.formatMessage({
        id: "asyncArch.errorMessage.support",
        defaultMessage: "contact support"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $gLWQf.JiraOnboardingContainer), {
            header: isRecoverable ? recoverableHeaderText : unrecoverableHeaderText,
            subheader: recoverableSubheaderText,
            PreHeader: PreHeader,
            hideSubHeader: !isRecoverable,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                    onClick: ()=>{
                        window.location.assign(url);
                    },
                    children: isRecoverable ? recoverableCtaText : unrecoverableCtaText
                }),
                !isRecoverable && /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                    className: (0, $esG4f.default)([
                        "_ect4bzd7"
                    ]),
                    style: {
                        "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                    },
                    children: [
                        persistText,
                        /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                            href: "https://support.atlassian.com/contact/",
                            className: (0, $esG4f.default)([
                                "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz17la"
                            ]),
                            style: {
                                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                            },
                            children: supportText
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("2F5jk", function(module, exports) {

$parcel$export(module.exports, "CoffeeSvg", function () { return $f3efc9284e3e6258$export$b1bef69bf9b84f0; });

var $loA2J = parcelRequire("loA2J");
const $f3efc9284e3e6258$export$b1bef69bf9b84f0 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "179",
        height: "214",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M126 78H9l22 135h96l23-135h-24Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M126 121H9l8 51h125l8-51h-24Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M126 121H16l8 51h110l9-51h-17Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M158 86H0l6-33h148l4 33Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M150 78H9l1 8h138l2-8Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M93 134h5l4 2 2 3 1 1v2h1v3h1l1 1c0 1 0 0 0 0v-2a9 9 0 0 0 0-2l-2-4-4-4-2-1-1-1h-3 1a16 16 0 0 0-12 2l-5 5-2 6 1-1v-2l1-1-1 4v4l-1-2v-1l2 8 7 6-2-1 3 1h-1l6 2a15 15 0 0 0 14-9l1-5c0-2 0-2-1 0v-1l-2 6v1l-3 2-3 3h-3l-1 1h-4v-1l-6-3c-2-2-4-5-4-8-1-3 0-6 2-9 2-2 4-4 6-4h1a7 7 0 0 1 2-1h1Zm-13 15v1-3 2Zm6 9h1c-2 0-3-1-4-3l-3-4h1l1 2v1l1 1 3 3Zm18-3h-1 1Zm-13-22c0 1-1 1 0 0Zm-2 27h1-1Zm10-26v1-1Zm5 3c0 1-1 0 0 0Zm3 8Zm-13 16h-2 2Zm-11-25 1-1-1 1Zm1 22-1-1 1 1Zm-5-9v1-1Zm4-13-1 1 1-1Zm-3 4c0-1 1-1 0 0Zm8-7c-1 0 0-1 0 0Zm5-1c1 0 0 0 0 0ZM155 7l-4-4-5-3h-3a23 23 0 0 0-9 1l-1 1h-1v2l-1 1v2a8 8 0 0 0 4 6l6 2a72 72 0 0 0 20 2h2a61 61 0 0 0 12-3l4-1h-3l-11 2a56 56 0 0 1-28-3l-1-2-1-1h-1V4h1l1-1 9-1h-1l7 4c2 2 2 5 1 8l-6 7-4 2-5 2c-13 6-27 9-40 10h8l4-1h2l-7 1a125 125 0 0 1-6 1H84h9-3l-3-1h-7l-15-2c-3 0-5-1-6-3v-5l5-4 5-2-2 1-3 1 5-2 5-1-2 1 6-2 14-3a72 72 0 0 1 27 1l9 4a33 33 0 0 1 16 18 30 30 0 0 1 1 8v4a44 44 0 0 0 1-4v1l-1-10-5-9-1-1v-1h-1l-2-2-2-2c-1-2-4-4-7-5l-8-3-6-1h-4l-4-1h1-5l-10 1-7 2-14 3-7 2-4 2-3 4v5c0 2 2 3 3 4l4 1 5 1a120 120 0 0 0 53-3l16-5 3-1 4-2 6-4 1-1 2-3 2-4a10 10 0 0 0 0-6ZM83 37h-5v-1c5 0 16 2 5 1ZM64 19h3l-8 4-2 4 1 4 4 3 5 1 4 1h5-6l-3-1-5-1-4-2-2-4 2-4 3-3 3-2Zm68 0Zm22-6v2h-1l1-2Zm-78 3 4-1-4 1Zm57-13-1 1 1-1Zm10 12h2-2Zm30 0 1-1-1 1Zm-79-2-6 2 5-2h1Zm36 16 5-2-5 2Zm-70-5-2 2 1-2h1Zm22 12h-2l1-1 1 1Zm47-7-5 2 4-2h1Zm-16 4c2-1 3 0 0 0Zm34-12h-2 2Zm6-14h-1V6l1 1Z",
                fill: "#101214"
            })
        ]
    });
};

});

parcelRegister("4W7la", function(module, exports) {

$parcel$export(module.exports, "ErrorSvg", function () { return $111ec444bf9a046b$export$bb92a7e2c63b6630; });

var $loA2J = parcelRequire("loA2J");
const $111ec444bf9a046b$export$bb92a7e2c63b6630 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "165",
        height: "215",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m0 214 .1.2H165v-.2L82.6 58.5 0 214Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M82.8 114.2V171M86.7 188.7a4.7 4.7 0 0 0 0-1.8 3.4 3.4 0 0 0-3-2.8 5.3 5.3 0 0 0-1.6 0 3.4 3.4 0 0 0-3 2.9 4.7 4.7 0 0 0 0 1.7 3.4 3.4 0 0 0 3 2.9 4.6 4.6 0 0 0 1.6 0 3.4 3.4 0 0 0 3-3Z",
                stroke: "#fff",
                strokeWidth: "7.1",
                strokeMiterlimit: "10"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m111.4 54.6.1-.8s1-.9.8-1.7l1.2-1.5s.3-.7.2-1.2l-.5-.6c-.4-.4-1-.4-1.2.4h-.1c-.1.9-1.1 1.2-1.5 2h.1-.1c0 .6-.7.6-.5 1.4l-.1-.2c-1 1.5-2.4 3.4-3.2 5.1.3 0 1-.5 1-.5.4 1-.8 1-1.1 1.7l-.2-.2.2-.6a8 8 0 0 0-2.3 3.4c.2.1 0-.4.5-.1l-.3.7c-.3-.2-.1-.3-.2-.3-.6 0-5.6 7-3.1 6.2l.1.1c.4-.4.7-.7 1.3-1l-.1-.1-.1-.1c-.4-.3-.2-.3-.2-.4 1.2 1 1.1-1.4 1.3-1.5.6.4.3-.4.6-.3l.1.2c.5.1.6-2.4 1-1.4 2.6-1.2 3.5-6 6.1-7.5 0 0 0-.1 0 0l.2-1.2Zm-4.1 4.7-.2.3-.2-.1c-.2-.6 1.6-.3.6-.1l-.2-.1Zm-1.7 2.6h-.2c-.2-1 1.2-1.4 1.4-2.3.7.8-.2 1.1-.4 1.4 0 .5-.5.7-.8.9Zm-3 4.2h.1Zm8-11.5c.2.2 0 .3-.3 0 .1 0 0-.2.4 0Zm-5.8 7.8c.4.3.3.6-.2.2l.2-.2Zm6.7-9.8c-.3-.3.1 0 .3 0 0 0 0 .1-.2 0Zm.6-1.3c-.2-.1-.3-.3-.2-.3l.2.3Zm1.2-2c-.2 0-.2-.2 0 0 0 0 .2.2 0 0Zm-9.9 13.8c-.5-.5 0-.4 0-.6.6.4 0 .3 0 .5Zm5-7.3c-.5-.4 0-.4 0-.5l.2.1c0 .2 0 .3-.2.4Zm-3.7 4.9c-.1-.2.1-.2.1-.2.3.2.2.4 0 .2Zm1.5-2c.3.2 0 .2 0 .2l-.1-.3Zm2.3-2.7s0 .2-.2.3l-.2-.2.2-.2.2.1Zm-1 .7-.1-.1c-.1-.3.4 0 .2.1Zm1.6-2.1c-.1.2-.7-.6 0 0Zm.5-1.2v-.2c.1 0 .5.4 0 .2ZM57.1 24.9l-.7-.5s-.4-1.2-1.2-1.3l-.8-1.8s-.6-.6-1-.6l-.8.2c-.4.3-.7.8 0 1.3l-.2.1c.8.5.7 1.5 1.2 2.2l.2-.1h-.2c.6.3.3 1 1.1 1l-.2.1c1 1.4 2 3.6 3.3 5v-1.2c1 0 .6 1.2 1 1.7l-.2.2a1 1 0 0 0-.5-.5c.3 1 1.4 2.9 2.2 3.5.1-.1-.4-.2.1-.6l.5.6c-.4.2-.3 0-.4 0-.1.6 4 8 4.4 5.4l.2-.1c-.3-.5-.4-.9-.4-1.6h-.2l-.2.1c-.4.3-.3 0-.4 0 1.3-.8-.8-1.5-.8-1.7.5-.5-.3-.4 0-.7h.1c.4-.4-1.8-1.5-.8-1.5 0-2.9-4-5.7-4.3-8.7l-.1.1v-.1c-.4 0-1-.6-1-.6h.1Zm2.6 5.6.2.3-.2.2c-.6 0 .4-1.7.2-.6l-.2.1Zm1.6 2.6v.2c-1-.3-.8-1.7-1.5-2.2 1-.3 1 .6 1 1 .5.1.5.6.5 1Zm2.6 4.4h.2-.1Zm-7-12c.2 0 .2.2-.2.3 0 0-.2 0 .2-.2Zm4.7 8.5c.3-.2.5 0 0 .3V34Zm-6.3-10c-.3.1 0-.1.3-.3l-.2.2Zm-.9-1H54c.1-.1.5-.2.4 0Zm-1.2-2c-.2.2-.3.2-.1 0 .1 0 .3 0 0 .1Zm8.4 14.6c-.6.3-.3-.2-.5-.2.6-.4.3.1.4.1v.1ZM57 28.1c-.5.4-.3-.2-.5-.2l.2-.1c.2 0 .4 0 .3.3Zm3 5.4c-.3 0-.1-.2-.2-.2.3-.2.5 0 .2.2Zm-1.3-2.2c.3-.2.2 0 .3 0l-.3.1Zm-1.5-3.2.2.3-.2.1-.2-.3.2-.1Zm.3 1.2h-.2c-.2 0 .3-.3.2 0ZM56.2 27c.2.2-.8.4 0 0Zm-.9-1h-.1c0-.1.5-.3.1 0ZM51.6 57h-.9s-1-.8-1.7-.5l-1.7-1.1s-.8-.2-1.2 0c-.3.1-.5.3-.6.5-.3.5-.2 1 .6 1.2v.1c1 0 1.4 1 2.2 1.3 0-.1.1-.2 0-.1v.1c.7 0 .7.6 1.5.3l-.2.2c1.7.7 3.8 2 5.6 2.6 0-.3-.7-1-.7-1 1-.5 1.2.7 1.9 1l-.1.2a1 1 0 0 0-.7-.1c.8.8 2.7 1.8 3.8 1.9 0-.2-.4 0-.2-.6.2.2.5.2.7.3-.2.4-.2.2-.3.2.2.6 7.8 4.9 6.7 2.5l.1-.2c-.4-.3-.8-.6-1.1-1.2l-.2.2H65c-.2.5-.3.3-.4.3.8-1.4-1.5-1-1.7-1.1.3-.7-.4-.2-.4-.6l.2-.1c0-.5-2.4-.3-1.5-.9-1.6-2.5-6.6-2.9-8.5-5.3h-1.1Zm5.3 3.7.3.2-.1.2c-.5.2-.6-1.6-.2-.6v.2Zm2.8 1.4.1.2c-1 .3-1.6-1-2.6-1.1.8-.9 1.2 0 1.5.2.5 0 .7.4 1 .7Zm4.6 2.5h.1Zm-12.6-6.8c.1-.2.3 0 0 .3 0 0-.2 0 0-.3Zm8.7 5c.1-.4.5-.3.2.2l-.2-.2Zm-10.9-5.6c-.2.3 0 0 0-.3v.3Zm-1.4-.4c0 .2-.2.2-.2.2l.2-.2Zm-2-1c-.1.2-.2.2-.1 0 0-.1.2-.2 0 0Zm15.1 8.4c-.3.6-.3 0-.5 0 .3-.6.3 0 .5 0Zm-8-4.2c-.3.5-.3 0-.5 0l.1-.2c.2 0 .3 0 .4.2Zm5.5 3.1c-.2.2-.2 0-.2 0 .1-.4.4-.3.2 0ZM56.4 62c.2-.3.2-.1.2-.1l-.2.2v-.1Zm-3-2h.3l-.1.3-.3-.2v-.2Zm.9.8-.1.2c-.3.1 0-.4 0-.2Zm-2.4-1.3c.2.1-.5.8 0 0Zm-1.3-.4h-.1c-.2 0 .3-.5.1 0ZM100.9 19.8l-1-2.5s-1-4.5-2-6.1l-1.7-6.8s-.9-2.7-1.5-3.4c-.3-.5-.7-.8-1-.8-.5 0-.6 1.1.3 3.7v.2c1 2.8 1.2 5.7 2 8.5.2 0 .4 0 .3.1h-.2c1 1.9.7 3.2 1.8 4.8l-.3-.1 1.6 5.6 1 3.9-2.5-.4-4.5-.6c.6.3 3.5 1 3.5 1-2.3.6-4.7-.8-7-1.1v-.2c1 .1 2 .2 2.3.1a79.8 79.8 0 0 0-8.2-1.6l-2.6-.4-2.4-.4 1.2 3.5.5 1.3.3.6c0-.1 0-.4-.2-.7-.2-.5-.3-1 0-1.2l.3 1 .3.6.4 1.3c-.3 0-.4-.4-.5-.5.1 1.6 9.3 30.5 8.6 23l.2.2c-.5-1.8-1-3.3-1.2-5.3-.1-.2 0-.3-.3-.2 0 0-.1-.2-.2-.1-.4.2-.4-.5-.5-.7 1.5-.2-1.8-5.8-2-6.6.6-.4-.5-1.6-.4-2.2l.3.2c.3-.6-3.3-7.3-1.8-5.6l-.7-3.4c-.5-1.6-.3-1.5-.4-1.8l.6.1 2.6.4 5.5.9 5.4.8 2.7.5 4.3.8-.5-2.3a138.1 138.1 0 0 1-1-4.7v.1-.4c-.5-.8-1.4-3.1-1.4-3.1Zm-11.5 7-1.3-.2.1-.3c1.3-.2 3.8 1.9 1.3.7l-.1-.2Zm-7.6.3.1.6c-.4-.7-.9-1.7-1.2-2.8 2.5.5 4.7 1.2 7 1.3-.7.5-1.6.5-2.5.3l-2.2-.6c-.4 0-.8 0-1.4-.2l.2 1.4Zm5.6 17.3h.1v.1Zm13.3-23c.3.1.4 1-.1.5 0-.1-.3-.4.1-.5Zm-18.2 8.7c.4-.1.8.9.3 1l-.3-1Zm15.8-16c-.5-.2 0-.3.2-.4 0 0 0 .3-.2.3Zm-1.6-4.7c-.2 0-.4-.3-.4-.4 0-.4.6.2.4.4Zm-2.2-7.8c-.2 0-.3 0-.1-.2.2 0 .4.2.1.3ZM83.2 35c-.7 0-.5-1.1-.8-1.6.7 0 .5 1 .7 1.3l.1.3Zm17.7-7.3-.2-.4s.1-.1 0-.2l.3.1.3.6-.4-.1Zm-21.4-3.3-.4-.8.7.2c.1.1 0 .2-.2.2.2.4.2.7-.1.4Zm9.7 1c0 .4-.4.2-.5.2l.4-.3.1.1ZM101 28l-.9-.1v-.3l.7.1.2.3Zm-3.5-1v-.2c.7-.1.6.5 0 .3Zm2.9-2.3v.2c.2.8-1-.1 0-.2Zm-1.5-4.3-.1-.3c-.2-.6.6 0 .1.3Z",
                fill: "#1E1F21"
            })
        ]
    });
};

});


parcelRegister("j6PI4", function(module, exports) {

$parcel$export(module.exports, "ScreenManagerView", function () { return $2d883546ffeeefb9$export$dfcfc90f7d7b94ba; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $dWbel = parcelRequire("dWbel");

var $77Hlt = parcelRequire("77Hlt");

var $1Y3bT = parcelRequire("1Y3bT");
const $2d883546ffeeefb9$export$dfcfc90f7d7b94ba = ({ screenOverride: screenOverride, screenFallback: screenFallback })=>{
    const confirmationPageContext = (0, $77Hlt.useConfirmationPage)();
    const { activeScreen: activeScreen, screensConfig: screensConfig, screenDictionary: screenDictionary, screenList: screenList } = (0, $1Y3bT.useScreenManager)();
    (0, $iSvIT.useEffect)(()=>{
        if (screensConfig && activeScreen) screensConfig[activeScreen]?.onMount(confirmationPageContext);
    }, [
        activeScreen
    ]);
    if (screenOverride) return screenOverride;
    return activeScreen && screenDictionary ? /*#__PURE__*/ (0, $loA2J.jsx)($2d883546ffeeefb9$export$94f808a216e0376b, {
        actionSubjectId: activeScreen,
        containerId: "ScreenManagerView",
        attributes: {
            screens: screenList
        },
        children: screenDictionary[activeScreen]
    }) : /*#__PURE__*/ (0, $loA2J.jsx)($2d883546ffeeefb9$export$94f808a216e0376b, {
        actionSubjectId: "screenFallback",
        containerId: "ScreenManagerView",
        attributes: {
            screens: screenList
        },
        children: screenFallback
    });
};
const $2d883546ffeeefb9$export$94f808a216e0376b = ({ actionSubjectId: actionSubjectId, containerId: containerId, attributes: attributes, children: children })=>{
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    (0, $iSvIT.useEffect)(()=>{
        if (!analyticsClient) return;
        createAnalyticsEvent({
            eventType: "ui",
            action: "viewed",
            actionSubject: "ui",
            actionSubjectId: actionSubjectId,
            containerId: containerId,
            attributes: attributes
        }).fire();
    }, [
        analyticsClient,
        actionSubjectId
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: children
    });
};

});



parcelRegister("aldmM", function(module, exports) {

$parcel$export(module.exports, "JiraProvisioningUI", function () { return $7cb5fcacd2ef483a$export$8a969a90ef987233; });

var $loA2J = parcelRequire("loA2J");

var $j5EHP = parcelRequire("j5EHP");

var $3xWYn = parcelRequire("3xWYn");

var $gyY7b = parcelRequire("gyY7b");

var $ayLXV = parcelRequire("ayLXV");

var $7xKCg = parcelRequire("7xKCg");

var $378NJ = parcelRequire("378NJ");

var $dJLyV = parcelRequire("dJLyV");

var $5b4r7 = parcelRequire("5b4r7");
const $7cb5fcacd2ef483a$export$8a969a90ef987233 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $3xWYn.TenantAwareStatsigClientUpdaterProvider), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $j5EHP.AnalyticsClientUpdater), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5b4r7.BaseProvisioningUI), {
                screenConfig: (0, $ayLXV.jiraScreenConfig),
                screenDictionary: (0, $7xKCg.jiraScreenDictionary),
                screenFallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gyY7b.PerceivedProvisioningStartTimer), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJLyV.ProductRedirector), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $378NJ.JiraAnimatedProvisioningScreen), {})
                    })
                })
            })
        ]
    });

});
parcelRegister("j5EHP", function(module, exports) {

$parcel$export(module.exports, "AnalyticsClientUpdater", function () { return $c8352fe5ebb01232$export$a68144d241c080ee; });

var $iSvIT = parcelRequire("iSvIT");

var $ftAF8 = parcelRequire("ftAF8");

var $jFQmg = parcelRequire("jFQmg");

var $gAJUc = parcelRequire("gAJUc");

var $aO3Hl = parcelRequire("aO3Hl");
const $c8352fe5ebb01232$export$a68144d241c080ee = ()=>{
    const { cloudId: cloudId } = (0, $aO3Hl.useCloudStatus)();
    const analyticsClient = (0, $jFQmg.useAnalyticsClient)();
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jiraAddSignupIdToEvents)) {
            if (!analyticsClient || !cloudId) return;
            analyticsClient.setTenantInfo((0, $ftAF8.tenantType).CLOUD_ID, cloudId);
        }
    }, [
        analyticsClient,
        cloudId
    ]);
    return null;
};

});

parcelRegister("ayLXV", function(module, exports) {

$parcel$export(module.exports, "jiraScreenConfig", function () { return $0a7f99c2f12bd492$export$942cb09e8f704789; });

var $l4l8N = parcelRequire("l4l8N");

var $jvaIB = parcelRequire("jvaIB");
const $0a7f99c2f12bd492$export$942cb09e8f704789 = {
    [(0, $jvaIB.TEAM_CHOICE)]: {
        position: {
            default: 100
        },
        onMount: ()=>undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: (0, $l4l8N.queryParam).templateId,
                            value: undefined
                        },
                        {
                            key: (0, $l4l8N.queryParam).products,
                            value: [
                                "jira-software.ondemand"
                            ]
                        },
                        {
                            conditionalOR: [
                                {
                                    conditionalAND: [
                                        {
                                            key: (0, $l4l8N.user).isN2n,
                                            value: true
                                        }
                                    ]
                                },
                                {
                                    conditionalAND: [
                                        {
                                            key: (0, $l4l8N.user).isExistingJiraUser,
                                            value: false
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            conditionalOR: [
                                {
                                    conditionalAND: [
                                        {
                                            key: (0, $l4l8N.localStorageData).team,
                                            value: undefined
                                        }
                                    ]
                                },
                                {
                                    conditionalAND: [
                                        {
                                            key: (0, $l4l8N.localStorageData).team,
                                            value: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    [(0, $jvaIB.JTBD)]: {
        position: {
            default: 190
        },
        onMount: ()=>undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: (0, $l4l8N.user).isN2n,
                            value: true
                        },
                        {
                            key: (0, $l4l8N.queryParam).jtbd,
                            value: undefined
                        },
                        {
                            conditionalOR: [
                                {
                                    conditionalAND: [
                                        {
                                            key: (0, $l4l8N.queryParam).products,
                                            value: [
                                                "jira-software.ondemand"
                                            ]
                                        }
                                    ]
                                },
                                {
                                    conditionalAND: [
                                        {
                                            key: (0, $l4l8N.queryParam).products,
                                            value: [
                                                "jira-core.ondemand"
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            key: (0, $l4l8N.queryParam).templateId,
                            value: undefined
                        }
                    ]
                }
            ]
        }
    },
    [(0, $jvaIB.TEMPLATE_CHOICE)]: {
        position: {
            default: 200
        },
        onMount: ()=>undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: (0, $l4l8N.queryParam).templateId,
                            value: undefined
                        },
                        {
                            key: (0, $l4l8N.queryParam).templateChoice,
                            value: undefined
                        },
                        {
                            key: (0, $l4l8N.queryParam).jtbd,
                            value: undefined
                        },
                        {
                            key: (0, $l4l8N.queryParam).products,
                            value: [
                                "jira-software.ondemand"
                            ]
                        }
                    ]
                }
            ]
        }
    },
    [(0, $jvaIB.PROVISIONING)]: {
        position: {
            default: 300
        },
        onMount: ()=>undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: (0, $l4l8N.user).isMobile,
                            value: true
                        }
                    ]
                }
            ]
        }
    },
    [(0, $jvaIB.PROVISIONING_WITH_WIZARD)]: {
        position: {
            default: 300
        },
        onMount: ()=>undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: (0, $l4l8N.user).isMobile,
                            value: false
                        }
                    ]
                }
            ]
        }
    }
};

});

parcelRegister("7xKCg", function(module, exports) {

$parcel$export(module.exports, "jiraScreenDictionary", function () { return $453a8e1315c63218$export$92b7b11bf85e51fa; });

var $loA2J = parcelRequire("loA2J");

var $378NJ = parcelRequire("378NJ");

var $cIEaV = parcelRequire("cIEaV");

var $bEOLZ = parcelRequire("bEOLZ");

var $bvLdd = parcelRequire("bvLdd");

var $dJLyV = parcelRequire("dJLyV");

var $cO3jF = parcelRequire("cO3jF");

var $bFFnD = parcelRequire("bFFnD");

var $gyY7b = parcelRequire("gyY7b");

var $jvaIB = parcelRequire("jvaIB");
const $453a8e1315c63218$export$b427f3931717d69c = {
    [(0, $jvaIB.TEAM_CHOICE)]: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bFFnD.default), {})
};
const $453a8e1315c63218$export$fad079d1a8093adf = {
    [(0, $jvaIB.TEMPLATE_CHOICE)]: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cIEaV.default), {})
};
const $453a8e1315c63218$export$1638c2ed0cb353d3 = {
    [(0, $jvaIB.PROVISIONING)]: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gyY7b.PerceivedProvisioningStartTimer), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJLyV.ProductRedirector), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $378NJ.JiraAnimatedProvisioningScreen), {})
        })
    })
};
const $453a8e1315c63218$export$845e4f444ac9aa0f = {
    [(0, $jvaIB.PROVISIONING_WITH_WIZARD)]: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bvLdd.JiraProvisioningWithOnboardingWizard), {})
};
const $453a8e1315c63218$export$e7864947fe8dfe95 = {
    [(0, $jvaIB.JTBD)]: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bEOLZ.default), {})
};
const $453a8e1315c63218$export$52705fe2150f48a8 = {
    [(0, $jvaIB.PROJECT_LANDING_SELECTOR)]: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cO3jF.default), {})
};
const $453a8e1315c63218$export$92b7b11bf85e51fa = {
    ...$453a8e1315c63218$export$b427f3931717d69c,
    ...$453a8e1315c63218$export$fad079d1a8093adf,
    ...$453a8e1315c63218$export$1638c2ed0cb353d3,
    ...$453a8e1315c63218$export$845e4f444ac9aa0f,
    ...$453a8e1315c63218$export$e7864947fe8dfe95,
    ...$453a8e1315c63218$export$52705fe2150f48a8
};

});
parcelRegister("bEOLZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1dbada4adbfc59b6$export$2e2bcd8739ae039; });
/* jtbd-view.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $9gh2a = parcelRequire("9gh2a");

var $1LPIk = parcelRequire("1LPIk");

var $gLWQf = parcelRequire("gLWQf");

var $aO3Hl = parcelRequire("aO3Hl");

var $1Y3bT = parcelRequire("1Y3bT");

var $dkYGl = parcelRequire("dkYGl");

var $6bw3Y = parcelRequire("6bw3Y");

var $awme5 = parcelRequire("awme5");

var $bUOuY = parcelRequire("bUOuY");

var $887Jf = parcelRequire("887Jf");
const $1dbada4adbfc59b6$var$spinnerStyles = null;
const $1dbada4adbfc59b6$var$JtbdView = ()=>{
    const [isLoading, setIsLoading] = (0, $iSvIT.useState)(true);
    const { skipScreen: skipScreen } = (0, $1Y3bT.useScreenManager)();
    const intl = (0, $f6qj2.default)();
    const { teamType: teamType, teamTypeCheckboxes: teamTypeCheckboxes, isSoftwareTeamType: isSoftwareTeamType } = (0, $6bw3Y.useGetTeamTypeData)();
    const [checkboxes, setCheckboxes] = (0, $iSvIT.useState)(teamTypeCheckboxes);
    const handleCheckboxChange = (checkboxes)=>{
        setCheckboxes(checkboxes);
    };
    const { products: products, edition: edition } = (0, $aO3Hl.useSearchParameters)();
    const productKey = (0, $dkYGl.getPrimaryProduct)(products);
    const dataFoundationAttributes = {
        productKey: productKey,
        edition: edition,
        teamType: teamType
    };
    (0, $iSvIT.useEffect)(()=>{
        const canViewScreen = teamType && (0, $6bw3Y.isEligibleTeamTypeToViewJtbdScreen)(teamType);
        if (canViewScreen) setIsLoading(false);
        else skipScreen();
    }, [
        skipScreen,
        teamType
    ]);
    if (checkboxes === undefined || teamType === undefined) {
        skipScreen();
        return;
    }
    const countTrue = ()=>{
        let count = 0;
        checkboxes.forEach((checkbox)=>{
            if (checkbox.isChecked) count++;
        });
        return count;
    };
    const numSelected = countTrue();
    if (isLoading) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        role: "progressbar",
        "aria-label": "loading",
        className: (0, $esG4f.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _1tke1kxc"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9gh2a.default), {
            size: "xlarge"
        })
    });
    const view = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $gLWQf.JiraOnboardingContainer), {
        header: intl.formatMessage({
            id: (0, $887Jf.messages).header.id,
            defaultMessage: (0, $887Jf.messages).header.defaultMessage
        }),
        subheader: intl.formatMessage({
            id: (0, $887Jf.messages).subHeader.id,
            defaultMessage: (0, $887Jf.messages).subHeader.defaultMessage
        }),
        hideSubHeader: isSoftwareTeamType,
        hideFooterOnMobile: true,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bUOuY.default), {
                checkboxes: checkboxes,
                handleCheckboxChange: handleCheckboxChange,
                // handleErrorChange={handleErrorChange}
                numSelected: numSelected,
                header: intl.formatMessage({
                    id: (0, $887Jf.messages).chooseOptions.id,
                    defaultMessage: (0, $887Jf.messages).chooseOptions.defaultMessage
                }),
                disableSelectionLimit: isSoftwareTeamType
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $awme5.default), {
                checkboxes: checkboxes,
                teamType: teamType
            })
        ]
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1LPIk.DataFoundationsWrapper), {
        dataFoundationsEventOption: "JTBDScreenViewed",
        attributes: dataFoundationAttributes,
        children: view
    });
};
var $1dbada4adbfc59b6$export$2e2bcd8739ae039 = $1dbada4adbfc59b6$var$JtbdView;

});
parcelRegister("awme5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6541d86bccee4a17$export$2e2bcd8739ae039; });
/* buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $5ohHq = parcelRequire("5ohHq");

var $jRcT4 = parcelRequire("jRcT4");

var $aO3Hl = parcelRequire("aO3Hl");

var $1Y3bT = parcelRequire("1Y3bT");

var $gh3cF = parcelRequire("gh3cF");

var $6bw3Y = parcelRequire("6bw3Y");

var $887Jf = parcelRequire("887Jf");
const $6541d86bccee4a17$var$buttonWrapperStyle = null;
const $6541d86bccee4a17$var$Buttons = ({ checkboxes: checkboxes, teamType: teamType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { prevScreen: prevScreen, nextScreen: nextScreen } = (0, $1Y3bT.useScreenManager)();
    const intl = (0, $f6qj2.default)();
    const { addJtbdCallback: addJtbdCallback } = (0, $aO3Hl.useGupsStatus)();
    const removeUrlParameter = (0, $iSvIT.useCallback)((url, paramKey)=>{
        const r = new URL(url);
        r.searchParams.delete(paramKey);
        return r.href;
    }, []); // Don't render the back button if team is set in localStorage
    const teamSetFromLocalStorage = (0, $6bw3Y.useEligibleTeamTypeForJtbdLocalStorage)();
    const BackButton = /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
        variant: "secondary",
        size: "small",
        color: "black",
        onClick: ()=>{
            const updatedUrl = removeUrlParameter(window.location.href, (0, $jRcT4.USER_SEARCH_PARAMS).teamType);
            history.replaceState({}, "", updatedUrl);
            prevScreen();
        },
        children: intl.formatMessage({
            id: (0, $887Jf.messages).backButton.id,
            defaultMessage: (0, $887Jf.messages).backButton.defaultMessage
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx2vrvc _1bah1h6o _19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0q14no _u5f3gktf _n3tdgktf _19bvgktf _19itglyw _zulpv47k _1bsb13xl _13zm1n9t _1eg6idpf _13khidpf _1j30cd5j _1kmxdlk8 _1ggmf6fq _1ykzdlk8 _1maef6fq _1rfm1osq _13z4eysh"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
        },
        children: [
            !teamSetFromLocalStorage ? BackButton : "",
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                variant: "primary",
                size: "small",
                color: "blue",
                onClick: async ()=>{
                    const checkedCheckboxVals = checkboxes.filter((checkbox)=>checkbox.isChecked);
                    const checkedBoxes = checkedCheckboxVals.map((checkbox)=>checkbox.index);
                    const { template: template, persona: persona } = (0, $6bw3Y.mapJTBDtoTemplateChoice)(checkboxes, teamType);
                    const jtbd = checkedBoxes.length > 0 ? checkedBoxes.join(",") : "0";
                    const jtbdVals = checkedCheckboxVals.length > 0 ? checkedCheckboxVals.map((checkbox)=>checkbox.value).join(",") : "NONE";
                    createAnalyticsEvent({
                        actionSubject: "button",
                        action: "clicked",
                        actionSubjectId: "jtbdContinue",
                        attributes: {
                            jtbd: jtbd,
                            jtbdVals: jtbdVals,
                            templateId: template,
                            teamType: teamType
                        }
                    }).fire();
                    if ((0, $gh3cF.getGupsIntegrationInJiraOnboardingEnabled)()) await addJtbdCallback(checkboxes, template);
                    const updatedUrl = (0, $6bw3Y.getCurrentUrlWithParams)({
                        jtbdTemplateOverride: template ?? "",
                        jtbd: checkedBoxes.length > 0 ? checkedBoxes.join() : "0",
                        jtbdPersona: persona ?? ""
                    });
                    history.replaceState({}, "", updatedUrl);
                    nextScreen();
                },
                children: intl.formatMessage({
                    id: (0, $887Jf.messages).continueButton.id,
                    defaultMessage: (0, $887Jf.messages).continueButton.defaultMessage
                })
            })
        ]
    });
};
var $6541d86bccee4a17$export$2e2bcd8739ae039 = $6541d86bccee4a17$var$Buttons;

});

parcelRegister("bUOuY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08a9d65ebb112f79$export$2e2bcd8739ae039; });
/* checkbox-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $gLorn = parcelRequire("gLorn");

var $ksNxv = parcelRequire("ksNxv");
const $08a9d65ebb112f79$var$headerStyles = null;
const $08a9d65ebb112f79$var$gridWrapperStyle = null;
const $08a9d65ebb112f79$var$CheckboxGrid = ({ checkboxes: checkboxes, handleCheckboxChange: handleCheckboxChange, header: header, numSelected: // errorState,
// handleErrorChange,
numSelected, disableSelectionLimit: disableSelectionLimit = false })=>{
    const handleClick = (i)=>{
        const newCheckboxArr = [
            ...checkboxes
        ];
        if (i >= 0 && i < checkboxes.length) {
            const updatedObject = {
                ...checkboxes[i]
            };
            updatedObject.isChecked = !updatedObject.isChecked;
            newCheckboxArr[i] = updatedObject;
            if (updatedObject.isChecked && (disableSelectionLimit || numSelected < (0, $gLorn.MAX_SELECTABLE)) || !updatedObject.isChecked) // handleErrorChange(false, "");
            handleCheckboxChange(newCheckboxArr);
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            !disableSelectionLimit && header && /*#__PURE__*/ (0, $loA2J.jsx)("h5", {
                className: (0, $esG4f.default)([
                    "_ect41td8 _k48p1fw0 _syazqlpt _1wyb1k92 _vwz41m1q _19pk19bv _2hwxidpf _otyr1tcg _18u0idpf"
                ]),
                children: header
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c11p5 _19pkidpf _2hwx1wug _otyridpf _18u01wug _19itglyw _zulp1k8s _p12f1an8 _yv0efsjm _19d7glyw"
                ]),
                children: checkboxes.map((checkbox, i)=>{
                    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $ksNxv.default), {
                        name: checkbox.name,
                        id: checkbox.id,
                        isChecked: checkbox.isChecked,
                        handleClick: ()=>{
                            handleClick(i);
                        },
                        isDisabled: !disableSelectionLimit && numSelected === (0, $gLorn.MAX_SELECTABLE) && !checkbox.isChecked
                    }, checkbox.name);
                })
            })
        ]
    });
};
var $08a9d65ebb112f79$export$2e2bcd8739ae039 = $08a9d65ebb112f79$var$CheckboxGrid;

});
parcelRegister("ksNxv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d61019f1aba50f09$export$2e2bcd8739ae039; });
/* jtbdCheckbox.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $7nbgg = parcelRequire("7nbgg");
const $d61019f1aba50f09$var$wrapperStyles = null;
const $d61019f1aba50f09$var$labelStyles = null;
const $d61019f1aba50f09$var$JtbdCheckbox = ({ name: name, id: id, isChecked: isChecked, handleClick: handleClick, isDisabled: isDisabled })=>{
    const intl = (0, $f6qj2.default)();
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        onClick: (e)=>{
            e.preventDefault();
            handleClick();
        },
        onKeyDown: (e)=>{
            if (e.key === "Enter") handleClick();
        },
        className: (0, $esG4f.default)([
            "_ca0q8jkm _u5f37vkz _n3td8jkm _19bv7vkz _19it1rq2 _2rkoftgi _1ul91kdj _80omtlke _1e0c1txw _4cvr1h6o _4cvx1ism _1eq11h6o _1vzltlke _wdod1e5h _szsuidpf _1raa1wug _12vridpf _4e0g1y44 _1wnttlke _12ultlke",
            isChecked === true && "_1h6d1ism"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7nbgg.default), {
            value: name,
            id: id,
            name: name,
            label: /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                htmlFor: id,
                onClick: (e)=>e.stopPropagation(),
                onKeyDown: (e)=>e.stopPropagation(),
                className: (0, $esG4f.default)([
                    "_ect41td8 _k48pni7l _syazqlpt _1wyb1j6v _vwz4qgp8 _y3gn1e5h"
                ]),
                children: intl.formatMessage({
                    id: id,
                    defaultMessage: name
                })
            }),
            isChecked: isChecked,
            isDisabled: isDisabled,
            onClick: (e)=>{
                e.stopPropagation();
                handleClick();
            }
        })
    });
};
var $d61019f1aba50f09$export$2e2bcd8739ae039 = $d61019f1aba50f09$var$JtbdCheckbox;

});



parcelRegister("bvLdd", function(module, exports) {

$parcel$export(module.exports, "JiraProvisioningWithOnboardingWizard", function () { return $ce7e434a38d4a4d0$export$eb4241c108d2f930; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $fxdfZ = parcelRequire("fxdfZ");

var $jgJpJ = parcelRequire("jgJpJ");

var $OOa63 = parcelRequire("OOa63");

var $9iWJ8 = parcelRequire("9iWJ8");

var $gAJUc = parcelRequire("gAJUc");

var $aO3Hl = parcelRequire("aO3Hl");

var $378NJ = parcelRequire("378NJ");

var $kbfAN = parcelRequire("kbfAN");

var $hrj1e = parcelRequire("hrj1e");

var $4Ii1l = parcelRequire("4Ii1l");

var $b6UCt = parcelRequire("b6UCt");
const $ce7e434a38d4a4d0$export$eb4241c108d2f930 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const createRedirectUrlWithWizard = (0, $4Ii1l.useCreateRedirectUrlWithWizard)();
    const { createCloudStatus: createCloudStatus, startPerceivedProvisioningTimer: startPerceivedProvisioningTimer, perceivedProvisioningStartTime: perceivedProvisioningStartTime } = (0, $aO3Hl.useCloudStatus)();
    const { setWaitingForProvisioning: setWaitingForProvisioning, redirectUrl: redirectUrl, addBlockingRedirectPromise: addBlockingRedirectPromise, resolveBlockingRedirectPromises: resolveBlockingRedirectPromises, createRedirectUrl: createRedirectUrl } = (0, $aO3Hl.useCloudStatusRedirection)();
    const { products: products, signupId: signupId } = (0, $aO3Hl.useSearchParameters)();
    const productKey = products.length > 0 ? products[0] : undefined;
    const provisioningEventFired = (0, $iSvIT.useRef)(false);
    const [siteProvisionedOnMount] = (0, $iSvIT.useState)(createCloudStatus === "success");
    const { userEligibleForWizardExperiment: userEligibleForWizardExperiment } = (0, $hrj1e.useShowOnboardingWizardScreen)();
    const { userEligibleForWizardForScrumExperiment: userEligibleForWizardForScrumExperiment } = (0, $hrj1e.useShowOnboardingWizardScreenForScrum)();
    const { userEligibleForWizardForDevKanbanExperiment: userEligibleForWizardForDevKanbanExperiment } = (0, $hrj1e.useShowOnboardingWizardScreenForKanban)();
    const { userEligibleForWizardForRouteBizExperiment: userEligibleForWizardForRouteBizExperiment } = (0, $hrj1e.useShowOnboardingWizardScreenForRouteBiz)();
    const { userEligibleForSampleProject: userEligibleForSampleProject } = (0, $hrj1e.useEligibleForSampleProject)();
    const { updatedStatsigClientWithCloudId: updatedStatsigClientWithCloudId } = (0, $aO3Hl.useTenantAwareStatsigClientUpdater)();
    const createSampleProjectRequestInitialized = (0, $iSvIT.useRef)(false);
    const { createSampleProject: createSampleProject } = (0, $aO3Hl.useCreateSampleProject)();
    const isSampleProjectVariation = (0, $iSvIT.useMemo)(()=>{
        if (!userEligibleForSampleProject) return false;
        const sampleProjectExperiment = (0, $9iWJ8.getExperimentWithExposures)((0, $9iWJ8.experiments).jfindMatureExampleProjectExperiment);
        return sampleProjectExperiment.type === "enrolled" && sampleProjectExperiment.value;
    }, [
        userEligibleForSampleProject
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (isSampleProjectVariation && createCloudStatus === "success" && createSampleProjectRequestInitialized.current === false) {
            createSampleProjectRequestInitialized.current = true;
            const sampleProjectPromise = createSampleProject();
            addBlockingRedirectPromise(sampleProjectPromise);
        }
    }, [
        isSampleProjectVariation,
        userEligibleForSampleProject,
        createCloudStatus,
        addBlockingRedirectPromise,
        createSampleProject
    ]);
    (0, $iSvIT.useEffect)(()=>{
        setWaitingForProvisioning(true);
    }, [
        setWaitingForProvisioning
    ]);
    (0, $iSvIT.useEffect)(()=>{
        startPerceivedProvisioningTimer();
    }, [
        startPerceivedProvisioningTimer
    ]);
    const isEnrolledAndEnabled = (experiment)=>{
        return experiment.type === "enrolled" && experiment.value;
    };
    const checkExperimentEligibility = (isEligible, experimentKey)=>{
        if (!isEligible) return false;
        const experiment = (0, $9iWJ8.getExperimentWithExposures)((0, $9iWJ8.experiments)[experimentKey]);
        return isEnrolledAndEnabled(experiment);
    };
    const trackProvisioningEventIfNeeded = (isWizardVariation)=>{
        if (isWizardVariation && !provisioningEventFired.current) {
            (0, $OOa63.trackPerceivedProvisioningEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                productKey: productKey,
                finalProvisioningScreen: "jira-onboarding-wizard",
                startTimeSeconds: perceivedProvisioningStartTime,
                signupId: signupId
            });
            provisioningEventFired.current = true;
        }
    };
    const getIsWizardVariation = ()=>{
        if (!updatedStatsigClientWithCloudId) return {
            isWizardVariation: false,
            withSampleData: false
        };
        const experimentChecks = [
            {
                isEligible: userEligibleForWizardForRouteBizExperiment,
                experimentKey: "jiraProjectOnboardingWizardForRouteBiz"
            },
            {
                isEligible: userEligibleForWizardForScrumExperiment,
                experimentKey: "jiraProjectOnboardingWizardForScrum"
            },
            {
                isEligible: userEligibleForWizardExperiment,
                experimentKey: "jiraProjectOnboardingWizardTenant"
            },
            {
                isEligible: userEligibleForWizardForDevKanbanExperiment,
                experimentKey: "jiraProjectOnboardingWizardDevKanban"
            }
        ];
        let isWizardVariation = false;
        let withSampleData = false;
        experimentChecks.forEach(({ isEligible: isEligible, experimentKey: experimentKey })=>{
            if (checkExperimentEligibility(isEligible, experimentKey)) {
                isWizardVariation = true;
                if (experimentKey === "jiraProjectOnboardingWizardForScrum") {
                    if (checkExperimentEligibility(true, "jiraProjectOnboardingWizardForScrumWithSampleData")) withSampleData = true;
                }
            }
        });
        trackProvisioningEventIfNeeded(isWizardVariation);
        return {
            isWizardVariation: isWizardVariation,
            withSampleData: withSampleData
        };
    };
    const onComplete = async (taskId, onRedirect)=>{
        const productUrl = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jiraOnboardingMultipleProjectRequestsBugfix) ? createRedirectUrl() : redirectUrl;
        if (productUrl) {
            await resolveBlockingRedirectPromises();
            if ((0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jiraOnboardingWizardMetricImprovements) && onRedirect) try {
                onRedirect();
            } catch (error) {
            // NO-OP, prevent redirect from failing
            }
            createAnalyticsEvent({
                eventName: "redirectedToProduct",
                eventComponent: "confirmationPage",
                event: "redirected",
                eventType: "ui",
                action: "redirected",
                attributes: {
                    reactComponent: "JiraProvisioningWithOnboardingWizard"
                }
            }).fire();
            // SLO "good event" for redirect into product
            (0, $jgJpJ.ufoEventRedirectToProduct).success({
                customData: {
                    analyticsEvent: "redirected",
                    redirectFrom: "confirmationPage",
                    reactComponent: "JiraProvisioningWithOnboardingWizard",
                    finalProvisioningScreen: "jira-onboarding-wizard"
                }
            });
            window.location.assign(createRedirectUrlWithWizard(productUrl, taskId));
        }
    };
    const handleOnError = (0, $iSvIT.useCallback)((error)=>{
        createAnalyticsEvent({
            eventType: "operational",
            actionSubject: `${(0, $kbfAN.ANALYTICS_PREFIX)}Screen`,
            action: "failed",
            attributes: {
                error: error.message
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const { isWizardVariation: isWizardVariation, withSampleData: withSampleData } = getIsWizardVariation();
    // This acts like ProductRedirector to avoid showing JiraAnimatedProvisioningScreen if site is ready
    if (siteProvisionedOnMount && !isWizardVariation) return null;
    // Handles both cases where site is still provisioning and we show wizard
    // or show wizard immediately when site provisioned on mount
    if (isWizardVariation) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fxdfZ.default), {
        fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $378NJ.JiraAnimatedProvisioningScreen), {}),
        onError: handleOnError,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $b6UCt.WelcomeModal), {
            onComplete: onComplete,
            withSampleData: withSampleData
        })
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $378NJ.JiraAnimatedProvisioningScreen), {});
};

});
parcelRegister("kbfAN", function(module, exports) {

$parcel$export(module.exports, "WIZARD_PAGE_ONBOARDING_PROJECT_DETAILS_SOURCE_NAME", function () { return $0b106e68f09e5698$export$99bbefa3015017ea; });
$parcel$export(module.exports, "WIZARD_PAGE_ONBOARDING_WORK_TYPES_SOURCE_NAME", function () { return $0b106e68f09e5698$export$be407c0fdbddac79; });
$parcel$export(module.exports, "WIZARD_PAGE_ONBOARDING_BOARD_COLUMNS_SOURCE_NAME", function () { return $0b106e68f09e5698$export$c5f8b87cec810bb6; });
$parcel$export(module.exports, "MIN_COLUMNS_LEN", function () { return $0b106e68f09e5698$export$ae94ecc32a05ffc0; });
$parcel$export(module.exports, "MAX_COLUMNS_LEN", function () { return $0b106e68f09e5698$export$79573477ed0fb167; });
$parcel$export(module.exports, "MAX_INPUT_LENGTH", function () { return $0b106e68f09e5698$export$23d199eb60c714e7; });
$parcel$export(module.exports, "ANALYTICS_PREFIX", function () { return $0b106e68f09e5698$export$2b4fb785c0f568cb; });
// Wizard modal pages
const $0b106e68f09e5698$export$99bbefa3015017ea = "onboardingProjectDetails";
const $0b106e68f09e5698$export$be407c0fdbddac79 = "onboardingWorkTypes";
const $0b106e68f09e5698$export$c5f8b87cec810bb6 = "onboardingBoardColumns";
const $0b106e68f09e5698$export$ae94ecc32a05ffc0 = 3;
const $0b106e68f09e5698$export$79573477ed0fb167 = 5;
const $0b106e68f09e5698$export$23d199eb60c714e7 = 30;
const $0b106e68f09e5698$export$2b4fb785c0f568cb = "onboardingWizard";

});

parcelRegister("hrj1e", function(module, exports) {

$parcel$export(module.exports, "useWizardConfiguration", function () { return $cc3cb019f33067bd$export$700353f36f462a26; });
$parcel$export(module.exports, "useShowOnboardingWizardScreen", function () { return $cc3cb019f33067bd$export$bbd711cd06d457cc; });
$parcel$export(module.exports, "useShowOnboardingWizardScreenForScrum", function () { return $cc3cb019f33067bd$export$d8ecc2f8e00c8255; });
$parcel$export(module.exports, "useShowOnboardingWizardScreenForKanban", function () { return $cc3cb019f33067bd$export$a94972d691c14664; });
$parcel$export(module.exports, "useShowOnboardingWizardScreenForRouteBiz", function () { return $cc3cb019f33067bd$export$aca879ddefff992c; });
$parcel$export(module.exports, "useEligibleForSampleProject", function () { return $cc3cb019f33067bd$export$61bad4d24ad4efcb; });
$parcel$export(module.exports, "useEligibleForSimplifiedLandingViewWithBasicTasks", function () { return $cc3cb019f33067bd$export$d006b56948c1c6fb; });

var $4LHd8 = parcelRequire("4LHd8");

var $77Hlt = parcelRequire("77Hlt");

var $oqKC2 = parcelRequire("oqKC2");

var $l4l8N = parcelRequire("l4l8N");

var $42nMG = parcelRequire("42nMG");

var $1KPYm = parcelRequire("1KPYm");

var $6bw3Y = parcelRequire("6bw3Y");

var $c6FEA = parcelRequire("c6FEA");
const $cc3cb019f33067bd$export$700353f36f462a26 = ()=>{
    const { userSegmentationContext: { selectedTeamType: selectedTeamType = "" } } = (0, $77Hlt.useConfirmationPage)();
    const metadata = (0, $l4l8N.useRegisterMetadata)();
    const templateChoice = metadata?.get((0, $l4l8N.queryParam).templateChoice) ?? (0, $6bw3Y.getJtbdTemplateOverrideQueryParam)();
    const templateId = metadata?.get((0, $l4l8N.queryParam).templateId) ?? (0, $6bw3Y.getJtbdTemplateOverrideQueryParam)();
    const teamType = selectedTeamType ?? (0, $c6FEA.USER_SEGMENTATION_TEAM_TYPE_UNKNOWN);
    return {
        teamType: teamType,
        wizardConfiguration: (0, $c6FEA.wizardConfigurations)[teamType] || (0, $c6FEA.defaultWizardConfiguration),
        projectDetails: templateChoice === "kanban" || (0, $4LHd8.default).checkGate("route_biz_to_kanban_revision_gate") && templateId?.toString().startsWith("com.atlassian.jira-core-project-templates:") ? (0, $c6FEA.KANBAN_PROJECT_DEFAULTS) : (0, $c6FEA.SCRUM_PROJECT_DEFAULTS)
    };
};
const $cc3cb019f33067bd$export$bbd711cd06d457cc = ()=>{
    const metadata = (0, $l4l8N.useRegisterMetadata)();
    const { userSegmentationContext: { selectedTeamType: selectedTeamType = "" } } = (0, $77Hlt.useConfirmationPage)();
    const templateChoice = metadata?.get((0, $l4l8N.queryParam).templateChoice) ?? (0, $6bw3Y.getJtbdTemplateOverrideQueryParam)();
    // Targeting Check: Non-software team types who choose Kanban and are enrolled in the experiment
    if (selectedTeamType === (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE) || templateChoice !== "kanban") return {
        userEligibleForWizardExperiment: false
    };
    return {
        // we only want to show the screen if the user is in the variant
        // we skip the screen if the user is in the control group
        userEligibleForWizardExperiment: true
    };
};
const $cc3cb019f33067bd$export$d8ecc2f8e00c8255 = ()=>{
    const metadata = (0, $l4l8N.useRegisterMetadata)();
    const templateChoice = metadata?.get((0, $l4l8N.queryParam).templateChoice) ?? (0, $6bw3Y.getJtbdTemplateOverrideQueryParam)();
    if (templateChoice === "scrum") return {
        userEligibleForWizardForScrumExperiment: true
    };
    return {
        userEligibleForWizardForScrumExperiment: false
    };
};
const $cc3cb019f33067bd$export$a94972d691c14664 = ()=>{
    const { userSegmentationContext: { selectedTeamType: selectedTeamType = "" } } = (0, $77Hlt.useConfirmationPage)();
    const metadata = (0, $l4l8N.useRegisterMetadata)();
    const templateChoice = metadata?.get((0, $l4l8N.queryParam).templateChoice) ?? (0, $6bw3Y.getJtbdTemplateOverrideQueryParam)();
    if (selectedTeamType === (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE) && templateChoice === "kanban") return {
        userEligibleForWizardForDevKanbanExperiment: true
    };
    return {
        userEligibleForWizardForDevKanbanExperiment: false
    };
};
const $cc3cb019f33067bd$export$aca879ddefff992c = ()=>{
    const metadata = (0, $l4l8N.useRegisterMetadata)();
    const templateId = metadata?.get((0, $l4l8N.queryParam).templateId) ?? (0, $6bw3Y.getJtbdTemplateOverrideQueryParam)();
    if (templateId?.toString().startsWith("com.atlassian.jira-core-project-templates:")) return {
        userEligibleForWizardForRouteBizExperiment: true
    };
    return {
        userEligibleForWizardForRouteBizExperiment: false
    };
};
const $cc3cb019f33067bd$export$61bad4d24ad4efcb = ()=>{
    const templateId = (0, $oqKC2.useRecommendedTemplate)();
    const enrollmentPreconditionsMet = [
        (0, $42nMG.KANBAN_TEAM_MANAGED_KEY),
        (0, $42nMG.BLANK_TEMPLATE_TEAM_MANAGED_KEY),
        (0, $42nMG.CAMPAIGN_MANAGEMENT_KEY),
        (0, $42nMG.CONTENT_MANAGEMENT_KEY),
        (0, $42nMG.PROCESS_CONTROL_KEY),
        (0, $42nMG.PROJECT_MANAGEMENT_KEY),
        (0, $42nMG.PROCUREMENT_KEY),
        (0, $42nMG.DESIGN_WEB_DESIGN_PROCESS_KEY),
        (0, $42nMG.HUMAN_RESOURCES_NEW_EMPLOYEE_ONBOARDING_KEY),
        (0, $42nMG.HUMAN_RESOURCES_RECRUITMENT_KEY),
        (0, $42nMG.LEGAL_IP_INFRINGEMENT_KEY),
        (0, $42nMG.FINANCE_BUDGET_CREATION_KEY),
        (0, $42nMG.SALES_SALES_PIPELINE_KEY),
        (0, $42nMG.SALES_LEAD_TRACKING_KEY)
    ].includes(templateId);
    if (enrollmentPreconditionsMet) return {
        userEligibleForSampleProject: true
    };
    return {
        userEligibleForSampleProject: false
    };
};
const $cc3cb019f33067bd$export$d006b56948c1c6fb = ()=>{
    const metadata = (0, $l4l8N.useRegisterMetadata)();
    const { userSegmentationContext: { selectedTeamType: selectedTeamType = "" } } = (0, $77Hlt.useConfirmationPage)();
    const templateChoice = metadata?.get((0, $l4l8N.queryParam).templateChoice) ?? (0, $6bw3Y.getJtbdTemplateOverrideQueryParam)();
    // Targeting Check: Non-software team types who choose Kanban and are enrolled in the experiment
    if (selectedTeamType === (0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE) || templateChoice !== "kanban") return {
        userEligibleForSimplifiedLandingView: false
    };
    return {
        userEligibleForSimplifiedLandingView: true
    };
};

});
parcelRegister("c6FEA", function(module, exports) {

$parcel$export(module.exports, "USER_SEGMENTATION_TEAM_TYPE_UNKNOWN", function () { return $a52902e3aed324f7$export$591e824a63ba52fe; });
$parcel$export(module.exports, "wizardConfigurations", function () { return $a52902e3aed324f7$export$950f91ba0026771f; });
$parcel$export(module.exports, "defaultWizardConfiguration", function () { return $a52902e3aed324f7$export$593fe9b53e2cbedc; });
$parcel$export(module.exports, "KANBAN_PROJECT_DEFAULTS", function () { return $a52902e3aed324f7$export$b692da97c4cabbb3; });
$parcel$export(module.exports, "SCRUM_PROJECT_DEFAULTS", function () { return $a52902e3aed324f7$export$95b4357c6b4c7c6; });

var $1KPYm = parcelRequire("1KPYm");

var $bemVX = parcelRequire("bemVX");

var $epeEl = parcelRequire("epeEl");
const $a52902e3aed324f7$export$591e824a63ba52fe = "unknown";
const $a52902e3aed324f7$var$featureIssueType = {
    name: (0, $epeEl.default).featureIssueTypeName,
    description: (0, $epeEl.default).featureIssueTypeDescription,
    icon: "Feature",
    avatarId: 10314,
    id: "1"
};
const $a52902e3aed324f7$var$taskIssueType = {
    name: (0, $epeEl.default).taskIssueTypeName,
    description: (0, $epeEl.default).taskIssueTypeDescription,
    icon: "Task",
    avatarId: 10318,
    id: "14"
};
const $a52902e3aed324f7$var$storyIssueType = {
    name: (0, $epeEl.default).storyIssueTypeName,
    description: (0, $epeEl.default).storyIssueTypeDescription,
    icon: "Story",
    avatarId: 10315,
    id: "3"
};
const $a52902e3aed324f7$var$bugIssueType = {
    name: (0, $epeEl.default).bugIssueTypeName,
    description: (0, $epeEl.default).bugIssueTypeDescription,
    icon: "Bug",
    avatarId: 10303,
    id: "4"
};
const $a52902e3aed324f7$var$assetIssueType = {
    name: (0, $epeEl.default).assetIssueTypeName,
    description: (0, $epeEl.default).assetIssueTypeDescription,
    icon: "Asset",
    avatarId: 10309,
    id: "5"
};
const $a52902e3aed324f7$var$contactIssueType = {
    name: (0, $epeEl.default).contactIssueTypeName,
    description: (0, $epeEl.default).contactIssueTypeDescription,
    icon: "Contact",
    avatarId: 10322,
    id: "6"
};
const $a52902e3aed324f7$var$requestIssueType = {
    name: (0, $epeEl.default).requestIssueTypeName,
    description: (0, $epeEl.default).requestIssueTypeDescription,
    icon: "Request",
    avatarId: 10311,
    id: "7"
};
const $a52902e3aed324f7$var$researchItemIssueType = {
    name: (0, $epeEl.default).researchItemIssueTypeName,
    description: (0, $epeEl.default).researchItemIssueTypeDescription,
    icon: "ResearchItem",
    avatarId: 10320,
    id: "8"
};
const $a52902e3aed324f7$var$incidentIssueType = {
    name: (0, $epeEl.default).incidentIssueTypeName,
    description: (0, $epeEl.default).incidentIssueTypeDescription,
    icon: "Incident",
    avatarId: 10304,
    id: "9"
};
const $a52902e3aed324f7$var$serviceRequestIssueType = {
    name: (0, $epeEl.default).serviceRequestIssueTypeName,
    description: (0, $epeEl.default).serviceRequestIssueTypeDescription,
    icon: "ServiceRequest",
    avatarId: 10308,
    id: "10"
};
const $a52902e3aed324f7$var$supportIssueType = {
    name: (0, $epeEl.default).supportIssueTypeName,
    description: (0, $epeEl.default).supportIssueTypeDescription,
    icon: "Support",
    avatarId: 10306,
    id: "11"
};
const $a52902e3aed324f7$var$campaignIssueType = {
    name: (0, $epeEl.default).campaignIssueTypeName,
    description: (0, $epeEl.default).campaignIssueTypeDescription,
    icon: "Campaign",
    avatarId: 10313,
    id: "12"
};
const $a52902e3aed324f7$var$candidateIssueType = {
    name: (0, $epeEl.default).candidateIssueTypeName,
    description: (0, $epeEl.default).candidateIssueTypeDescription,
    icon: "Candidate",
    avatarId: 10322,
    id: "13"
};
const $a52902e3aed324f7$var$projectManagementWizardConfiguration = {
    issueTypes: [
        {
            ...$a52902e3aed324f7$var$featureIssueType,
            isPreSelected: true
        },
        {
            ...$a52902e3aed324f7$var$taskIssueType,
            isPreSelected: true
        },
        {
            ...$a52902e3aed324f7$var$storyIssueType,
            isPreSelected: false
        },
        {
            ...$a52902e3aed324f7$var$bugIssueType,
            isPreSelected: false
        },
        {
            ...$a52902e3aed324f7$var$assetIssueType,
            isPreSelected: false
        }
    ],
    columns: [
        (0, $epeEl.default).ideaColumnName,
        (0, $epeEl.default).todoColumnName,
        (0, $epeEl.default).inProgressColumnName,
        (0, $epeEl.default).inReviewColumnName,
        (0, $epeEl.default).doneColumnName
    ]
};
const $a52902e3aed324f7$var$productManagementWizardConfiguration = {
    issueTypes: [
        {
            ...$a52902e3aed324f7$var$featureIssueType,
            isPreSelected: true
        },
        {
            ...$a52902e3aed324f7$var$taskIssueType,
            isPreSelected: true
        },
        {
            ...$a52902e3aed324f7$var$storyIssueType,
            isPreSelected: false
        },
        {
            ...$a52902e3aed324f7$var$bugIssueType,
            isPreSelected: false
        }
    ],
    columns: [
        (0, $epeEl.default).ideaColumnName,
        (0, $epeEl.default).todoColumnName,
        (0, $epeEl.default).inProgressColumnName,
        (0, $epeEl.default).testingColumnName,
        (0, $epeEl.default).doneColumnName
    ]
};
const $a52902e3aed324f7$var$otherPersonalWizardConfiguration = {
    issueTypes: [
        {
            ...$a52902e3aed324f7$var$taskIssueType,
            isPreSelected: true
        },
        {
            ...$a52902e3aed324f7$var$assetIssueType,
            isPreSelected: false
        },
        {
            ...$a52902e3aed324f7$var$contactIssueType,
            isPreSelected: false
        },
        {
            ...$a52902e3aed324f7$var$requestIssueType,
            isPreSelected: false
        }
    ],
    columns: [
        (0, $epeEl.default).todoColumnName,
        (0, $epeEl.default).inProgressColumnName,
        (0, $epeEl.default).doneColumnName
    ]
};
const $a52902e3aed324f7$var$designWizardConfiguration = {
    issueTypes: [
        {
            ...$a52902e3aed324f7$var$taskIssueType,
            isPreSelected: true
        },
        {
            ...$a52902e3aed324f7$var$assetIssueType,
            isPreSelected: true
        },
        {
            ...$a52902e3aed324f7$var$requestIssueType,
            isPreSelected: false
        },
        {
            ...$a52902e3aed324f7$var$researchItemIssueType,
            isPreSelected: false
        }
    ],
    columns: [
        (0, $epeEl.default).todoColumnName,
        (0, $epeEl.default).inDesignColumnName,
        (0, $epeEl.default).userTestingColumnName,
        (0, $epeEl.default).approvedColumnName,
        (0, $epeEl.default).liveColumnName
    ]
};
const $a52902e3aed324f7$var$itSupportWizardConfiguration = {
    issueTypes: [
        {
            ...$a52902e3aed324f7$var$taskIssueType,
            isPreSelected: true
        },
        {
            ...$a52902e3aed324f7$var$incidentIssueType,
            isPreSelected: true
        },
        {
            ...$a52902e3aed324f7$var$serviceRequestIssueType,
            isPreSelected: true
        },
        {
            ...$a52902e3aed324f7$var$supportIssueType,
            isPreSelected: false
        }
    ],
    columns: [
        (0, $epeEl.default).todoColumnName,
        (0, $epeEl.default).inProgressColumnName,
        (0, $epeEl.default).waitingForCustomerColumnName,
        (0, $epeEl.default).resolvedColumnName
    ]
};
const $a52902e3aed324f7$var$softwareDevelopmentWizardConfiguration = {
    issueTypes: [
        {
            ...$a52902e3aed324f7$var$taskIssueType,
            isPreSelected: true
        },
        {
            ...$a52902e3aed324f7$var$storyIssueType,
            isPreSelected: true
        },
        {
            ...$a52902e3aed324f7$var$featureIssueType,
            isPreSelected: false
        },
        {
            ...$a52902e3aed324f7$var$requestIssueType,
            isPreSelected: false
        },
        {
            ...$a52902e3aed324f7$var$bugIssueType,
            isPreSelected: false
        }
    ],
    columns: [
        (0, $epeEl.default).todoColumnName,
        (0, $epeEl.default).inProgressColumnName,
        (0, $epeEl.default).inReviewColumnName,
        (0, $epeEl.default).doneColumnName
    ]
};
const $a52902e3aed324f7$export$51e0494cd82a2349 = {
    issueTypes: [
        {
            ...$a52902e3aed324f7$var$featureIssueType,
            isPreSelected: true
        },
        {
            ...$a52902e3aed324f7$var$taskIssueType,
            isPreSelected: true
        },
        {
            ...$a52902e3aed324f7$var$storyIssueType,
            isPreSelected: false
        },
        {
            ...$a52902e3aed324f7$var$bugIssueType,
            isPreSelected: false
        },
        {
            ...$a52902e3aed324f7$var$requestIssueType,
            isPreSelected: false
        }
    ],
    columns: [
        (0, $epeEl.default).todoColumnName,
        (0, $epeEl.default).inProgressColumnName,
        (0, $epeEl.default).inReviewColumnName,
        (0, $epeEl.default).doneColumnName
    ]
};
const $a52902e3aed324f7$export$950f91ba0026771f = {
    [(0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_PROJECT_MANAGEMENT)]: $a52902e3aed324f7$var$projectManagementWizardConfiguration,
    "Project Management": $a52902e3aed324f7$var$projectManagementWizardConfiguration,
    [(0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT)]: $a52902e3aed324f7$var$productManagementWizardConfiguration,
    "Product Management": $a52902e3aed324f7$var$productManagementWizardConfiguration,
    [(0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_OTHER_PERSONAL)]: $a52902e3aed324f7$var$otherPersonalWizardConfiguration,
    "Other or Personal": $a52902e3aed324f7$var$otherPersonalWizardConfiguration,
    [(0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_DESIGN)]: $a52902e3aed324f7$var$designWizardConfiguration,
    "Design": $a52902e3aed324f7$var$designWizardConfiguration,
    [(0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_IT_SUPPORT)]: $a52902e3aed324f7$var$itSupportWizardConfiguration,
    "IT Support": $a52902e3aed324f7$var$itSupportWizardConfiguration,
    [$a52902e3aed324f7$export$591e824a63ba52fe]: $a52902e3aed324f7$export$51e0494cd82a2349,
    "Software Development": $a52902e3aed324f7$var$softwareDevelopmentWizardConfiguration,
    [(0, $1KPYm.USER_SEGMENTATION_TEAM_TYPE_SOFTWARE)]: $a52902e3aed324f7$var$softwareDevelopmentWizardConfiguration,
    "": $a52902e3aed324f7$export$51e0494cd82a2349
};
const $a52902e3aed324f7$export$593fe9b53e2cbedc = {
    issueTypes: [
        {
            ...$a52902e3aed324f7$var$taskIssueType,
            isPreSelected: true
        },
        {
            ...$a52902e3aed324f7$var$requestIssueType,
            isPreSelected: false
        },
        {
            ...$a52902e3aed324f7$var$campaignIssueType,
            isPreSelected: false
        },
        {
            ...$a52902e3aed324f7$var$candidateIssueType,
            isPreSelected: false
        },
        {
            ...$a52902e3aed324f7$var$assetIssueType,
            isPreSelected: false
        }
    ],
    columns: [
        (0, $epeEl.default).todoColumnName,
        (0, $epeEl.default).inProgressColumnName,
        (0, $epeEl.default).doneColumnName
    ]
};
const $a52902e3aed324f7$export$b692da97c4cabbb3 = {
    projectKey: "KAN",
    template: "KANBAN",
    defaultProjectName: (0, $bemVX.default).defaultProjectName
};
const $a52902e3aed324f7$export$95b4357c6b4c7c6 = {
    projectKey: "SCRUM",
    template: "SCRUM",
    defaultProjectName: (0, $bemVX.default).defaultScrumProjectName
};

});
parcelRegister("bemVX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66e065f2b7e9b81b$export$2e2bcd8739ae039; });

var $6x1qA = parcelRequire("6x1qA");
var $66e065f2b7e9b81b$export$2e2bcd8739ae039 = (0, $6x1qA.defineMessages)({
    defaultProjectName: {
        id: "onboarding.wizard.defaultProjectName",
        defaultMessage: "My Kanban Project",
        description: "Default name for a new project if none is provided"
    },
    defaultScrumProjectName: {
        id: "onboarding.wizard.defaultScrumProjectName",
        defaultMessage: "My Scrum Project",
        description: "Default name for a new scrum project if none is provided"
    }
});

});

parcelRegister("epeEl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc2ac8c396ffbff3$export$2e2bcd8739ae039; });

var $6x1qA = parcelRequire("6x1qA");
var $dc2ac8c396ffbff3$export$2e2bcd8739ae039 = (0, $6x1qA.defineMessages)({
    featureIssueTypeName: {
        id: "software-onboarding-modals.utils.wizard.feature-issue-type-name",
        defaultMessage: "Feature",
        description: "The name of the feature issue type"
    },
    featureIssueTypeDescription: {
        id: "software-onboarding-modals.utils.wizard.feature-issue-type-description",
        defaultMessage: "A broad piece of functionality.",
        description: "The description of the feature issue type"
    },
    taskIssueTypeName: {
        id: "software-onboarding-modals.utils.wizard.task-issue-type-name",
        defaultMessage: "Task",
        description: "The name of the task issue type"
    },
    taskIssueTypeDescription: {
        id: "software-onboarding-modals.utils.wizard.task-issue-type-description",
        defaultMessage: "A small piece of work.",
        description: "The description of the task issue type"
    },
    storyIssueTypeName: {
        id: "software-onboarding-modals.utils.wizard.story-issue-type-name",
        defaultMessage: "Story",
        description: "The name of the story issue type"
    },
    storyIssueTypeDescription: {
        id: "software-onboarding-modals.utils.wizard.story-issue-type-description",
        defaultMessage: "A requirement expressed from the user\u2019s perspective.",
        description: "The description of the story issue type"
    },
    bugIssueTypeName: {
        id: "software-onboarding-modals.utils.wizard.bug-issue-type-name",
        defaultMessage: "Bug",
        description: "The name of the bug issue type"
    },
    bugIssueTypeDescription: {
        id: "software-onboarding-modals.utils.wizard.bug-issue-type-description",
        defaultMessage: "A problem that needs fixing.",
        description: "The description of the bug issue type"
    },
    assetIssueTypeName: {
        id: "software-onboarding-modals.utils.wizard.asset-issue-type-name",
        defaultMessage: "Asset",
        description: "The name of the asset issue type"
    },
    assetIssueTypeDescription: {
        id: "software-onboarding-modals.utils.wizard.asset-issue-type-description",
        defaultMessage: "A file, image, or video.",
        description: "The description of the asset issue type"
    },
    contactIssueTypeName: {
        id: "software-onboarding-modals.utils.wizard.contact-issue-type-name",
        defaultMessage: "Contact",
        description: "The name of the contact issue type"
    },
    contactIssueTypeDescription: {
        id: "software-onboarding-modals.utils.wizard.contact-issue-type-description",
        defaultMessage: "A relevant point of contact.",
        description: "The description of the contact issue type"
    },
    requestIssueTypeName: {
        id: "software-onboarding-modals.utils.wizard.request-issue-type-name",
        defaultMessage: "Request",
        description: "The name of the request issue type"
    },
    requestIssueTypeDescription: {
        id: "software-onboarding-modals.utils.wizard.request-issue-type-description",
        defaultMessage: "An ask for assistance.",
        description: "The description of the request issue type"
    },
    researchItemIssueTypeName: {
        id: "software-onboarding-modals.utils.wizard.research-item-issue-type-name",
        defaultMessage: "Research Item",
        description: "The name of the research item issue type"
    },
    researchItemIssueTypeDescription: {
        id: "software-onboarding-modals.utils.wizard.research-item-issue-type-description",
        defaultMessage: "A sample of data or supporting information.",
        description: "The description of the research item issue type"
    },
    incidentIssueTypeName: {
        id: "software-onboarding-modals.utils.wizard.incident-issue-type-name",
        defaultMessage: "Incident",
        description: "The name of the incident item issue type"
    },
    incidentIssueTypeDescription: {
        id: "software-onboarding-modals.utils.wizard.incident-issue-type-description",
        defaultMessage: "An IT-related event requiring attention.",
        description: "The description of the incident item issue type"
    },
    serviceRequestIssueTypeName: {
        id: "software-onboarding-modals.utils.wizard.service-request-issue-type-name",
        defaultMessage: "Service Request",
        description: "The name of the service request issue type"
    },
    serviceRequestIssueTypeDescription: {
        id: "software-onboarding-modals.utils.wizard.service-request-issue-type-description",
        defaultMessage: "An ask for assistance from a customer service team.",
        description: "The description of the service request item issue type"
    },
    supportIssueTypeName: {
        id: "software-onboarding-modals.utils.wizard.support-issue-type-name",
        defaultMessage: "Support",
        description: "The name of the support issue type"
    },
    supportIssueTypeDescription: {
        id: "software-onboarding-modals.utils.wizard.support-issue-type-description",
        defaultMessage: "A request for help for customer support issues.",
        description: "The description of the support issue type"
    },
    campaignIssueTypeName: {
        id: "software-onboarding-modals.utils.wizard.campaign-issue-type-name",
        defaultMessage: "Campaign",
        description: "The name of the support issue type"
    },
    campaignIssueTypeDescription: {
        id: "software-onboarding-modals.utils.wizard.campaign-issue-type-description",
        defaultMessage: "A marketing strategy with a defined goal.",
        description: "The description of the campaign issue type"
    },
    candidateIssueTypeName: {
        id: "software-onboarding-modals.utils.wizard.candidate-issue-type-name",
        defaultMessage: "Candidate",
        description: "The name of the candidate issue type"
    },
    candidateIssueTypeDescription: {
        id: "software-onboarding-modals.utils.wizard.candidate-issue-type-description",
        defaultMessage: "A person in consideration for a role.",
        description: "The description of the candidate issue type"
    },
    ideaColumnName: {
        id: "software-onboarding-modals.utils.wizard.idea-column-name",
        defaultMessage: "Idea",
        description: "Idea column name"
    },
    todoColumnName: {
        id: "software-onboarding-modals.utils.wizard.todo-column-name",
        defaultMessage: "To Do",
        description: "To Do column name"
    },
    inProgressColumnName: {
        id: "software-onboarding-modals.utils.wizard.in-progress-column-name",
        defaultMessage: "In Progress",
        description: "In Progress column name"
    },
    inReviewColumnName: {
        id: "software-onboarding-modals.utils.wizard.in-review-column-name",
        defaultMessage: "In Review",
        description: "In Review column name"
    },
    doneColumnName: {
        id: "software-onboarding-modals.utils.wizard.done-column-name",
        defaultMessage: "Done",
        description: "Done column name"
    },
    testingColumnName: {
        id: "software-onboarding-modals.utils.wizard.testing-column-name",
        defaultMessage: "Testing",
        description: "Testing column name"
    },
    inDesignColumnName: {
        id: "software-onboarding-modals.utils.wizard.in-design-column-name",
        defaultMessage: "In Design",
        description: "In Design column name"
    },
    userTestingColumnName: {
        id: "software-onboarding-modals.utils.wizard.user-testing-column-name",
        defaultMessage: "User Testing",
        description: "User Testing column name"
    },
    approvedColumnName: {
        id: "software-onboarding-modals.utils.wizard.approved-column-name",
        defaultMessage: "Approved",
        description: "Approved column name"
    },
    liveColumnName: {
        id: "software-onboarding-modals.utils.wizard.live-column-name",
        defaultMessage: "Live",
        description: "Live column name"
    },
    waitingForCustomerColumnName: {
        id: "software-onboarding-modals.utils.wizard.waiting-for-customer-column-name",
        defaultMessage: "Waiting for Customer",
        description: "Waiting for customer column name"
    },
    resolvedColumnName: {
        id: "software-onboarding-modals.utils.wizard.resolved-column-name",
        defaultMessage: "Resolved",
        description: "Resolved column name"
    }
});

});



parcelRegister("4Ii1l", function(module, exports) {

$parcel$export(module.exports, "useCreateRedirectUrlWithWizard", function () { return $ccd59172b6fb45b6$export$269c6d18db56aae5; });

var $iSvIT = parcelRequire("iSvIT");
const $ccd59172b6fb45b6$export$269c6d18db56aae5 = ()=>(0, $iSvIT.useCallback)((redirectUrl, taskId)=>{
        if (!redirectUrl) return "";
        const url = new URL(redirectUrl);
        const continueParam = url.searchParams.get("continue");
        if (continueParam) {
            const continueUrl = new URL(continueParam);
            continueUrl.searchParams.append("wizard", "true");
            if (taskId) continueUrl.searchParams.append("projectCreateTaskId", taskId);
            url.searchParams.set("continue", continueUrl.toString());
        } else {
            url.searchParams.append("wizard", "true");
            if (taskId) url.searchParams.append("projectCreateTaskId", taskId);
        }
        return url.toString();
    }, []);

});

parcelRegister("b6UCt", function(module, exports) {

$parcel$export(module.exports, "WelcomeModal", function () { return $13431d02d798e9b1$export$9d12d42929c3fcf; });
/* eslint-disable complexity */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $4LHd8 = parcelRequire("4LHd8");

var $8KELJ = parcelRequire("8KELJ");
var $bh8PA = parcelRequire("bh8PA");

var $krd0Q = parcelRequire("krd0Q");

var $jgJpJ = parcelRequire("jgJpJ");

var $gkhN4 = parcelRequire("gkhN4");

var $aO3Hl = parcelRequire("aO3Hl");

var $9iWJ8 = parcelRequire("9iWJ8");

var $gAJUc = parcelRequire("gAJUc");

var $1KPYm = parcelRequire("1KPYm");

var $kbfAN = parcelRequire("kbfAN");

var $hrj1e = parcelRequire("hrj1e");

var $gyy4U = parcelRequire("gyy4U");
const $13431d02d798e9b1$export$9d12d42929c3fcf = ({ onComplete: onComplete, withSampleData: withSampleData })=>{
    const [projectConfig, setProjectConfig] = (0, $iSvIT.useState)(null);
    const isCreateRequestInProgress = (0, $iSvIT.useRef)(false);
    const { userEligibleForWizardForRouteBizExperiment: userEligibleForWizardForRouteBizExperiment } = (0, $hrj1e.useShowOnboardingWizardScreenForRouteBiz)();
    const { userEligibleForWizardForDevKanbanExperiment: userEligibleForWizardForDevKanbanExperiment } = (0, $hrj1e.useShowOnboardingWizardScreenForKanban)();
    const { userEligibleForSimplifiedLandingView: userEligibleForSimplifiedLandingView } = (0, $hrj1e.useEligibleForSimplifiedLandingViewWithBasicTasks)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { createCloudStatus: createCloudStatus, cloudId: cloudId } = (0, $aO3Hl.useCloudStatus)();
    const { deferRedirectView: deferRedirectView, setDeferRedirectView: setDeferRedirectView } = (0, $aO3Hl.useCloudStatusRedirection)();
    const { signupId: signupId } = (0, $aO3Hl.useSearchParameters)();
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const { teamType: teamType, projectDetails: projectDetails } = (0, $hrj1e.useWizardConfiguration)();
    (0, $iSvIT.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: "screen",
            name: `${(0, $kbfAN.ANALYTICS_PREFIX)}Screen`,
            attributes: {
                teamType: teamType,
                template: projectDetails.template
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        projectDetails.template,
        teamType
    ]);
    // Prevent use-cloud-status.tsx from immediately redirecting when provisioning is finished.
    (0, $iSvIT.useEffect)(()=>{
        if (!deferRedirectView) {
            if (setDeferRedirectView) setDeferRedirectView("jira-onboarding-wizard");
        }
    });
    const handleComplete = (config)=>{
        setProjectConfig(config);
        (0, $jgJpJ.ufoEventOnboardingWizardProjectCreationIncludingProvisioning).start();
        if ((0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jiraAddSignupIdToEvents)) (0, $jgJpJ.ufoEventOnboardingWizardProjectCreationIncludingProvisioning).setCustomData({
            signupId: signupId
        });
    };
    const isSimplifiedLandingViewWithBasicTasks = (0, $iSvIT.useCallback)(()=>{
        if (!userEligibleForSimplifiedLandingView) return false;
        const simplifiedListViewWithBasicTasksExperimentConfig = (0, $9iWJ8.getExperimentWithExposures)((0, $9iWJ8.experiments).jfindSimplifiedListViewWithBasicTasks);
        return simplifiedListViewWithBasicTasksExperimentConfig.type === "enrolled" && simplifiedListViewWithBasicTasksExperimentConfig.value;
    }, [
        userEligibleForSimplifiedLandingView
    ]);
    const isWizardRouteBizExperiment = (0, $iSvIT.useCallback)(()=>{
        const wizardRouteBizExperimentConfig = (0, $9iWJ8.getExperiment)((0, $9iWJ8.experiments).jiraProjectOnboardingWizardForRouteBiz);
        return userEligibleForWizardForRouteBizExperiment && wizardRouteBizExperimentConfig.type === "enrolled" && wizardRouteBizExperimentConfig.value;
    }, [
        userEligibleForWizardForRouteBizExperiment
    ]);
    const isWizardDevKanbanExperiment = (0, $iSvIT.useCallback)(()=>{
        const wizardDevKanbanExperimentConfig = (0, $9iWJ8.getExperiment)((0, $9iWJ8.experiments).jiraProjectOnboardingWizardDevKanban);
        return userEligibleForWizardForDevKanbanExperiment && wizardDevKanbanExperimentConfig.type === "enrolled" && wizardDevKanbanExperimentConfig.value;
    }, [
        userEligibleForWizardForDevKanbanExperiment
    ]);
    const isAllowExtraFieldsExperiment = (0, $iSvIT.useCallback)(()=>{
        const allowExtraFieldsExperimentConfig = (0, $9iWJ8.getExperimentWithExposures)((0, $9iWJ8.experiments).jiraProjectOnboardingExtraFieldsForWizards);
        return allowExtraFieldsExperimentConfig.type === "enrolled" && allowExtraFieldsExperimentConfig.value;
    }, []);
    const createProject = (0, $iSvIT.useCallback)(async ()=>{
        if (projectConfig && cloudId) {
            (0, $jgJpJ.ufoEventOnboardingWizardProjectCreation).start();
            if ((0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jiraAddSignupIdToEvents)) (0, $jgJpJ.ufoEventOnboardingWizardProjectCreation).setCustomData({
                signupId: signupId
            });
            (0, $jgJpJ.ufoEventOnboardingWizardProjectCreationIncludingProvisioning).startSubstep((0, $jgJpJ.UfoCustomTimingKey).ONBOARDING_WIZARD_PROJECT_CREATE_API_CALL);
            try {
                isCreateRequestInProgress.current = true;
                const isWizardDevKanbanExperimentEnabled = isWizardDevKanbanExperiment();
                const isWizardRouteBizExperimentEnabled = isWizardRouteBizExperiment();
                const isAllowExtraFieldsExperimentEnabled = isAllowExtraFieldsExperiment();
                const isSimplifiedLandingViewWithBasicTasksEnabled = isSimplifiedLandingViewWithBasicTasks();
                const projectPayload = {
                    projectName: projectConfig.projectName,
                    issueTypes: projectConfig.issueTypes,
                    statusNames: projectConfig.columns,
                    projectKey: projectDetails.projectKey,
                    template: projectDetails.template,
                    cloudId: cloudId,
                    teamType: (0, $1KPYm.getProductQueryParamTeamType)(teamType),
                    ...isWizardDevKanbanExperimentEnabled || isSimplifiedLandingViewWithBasicTasksEnabled || (0, $4LHd8.default).checkGate("jira_onboarding_wizard_small_refactor") ? {
                        isSampleDataIncluded: isWizardDevKanbanExperimentEnabled || isSimplifiedLandingViewWithBasicTasksEnabled || withSampleData
                    } : {},
                    ...isAllowExtraFieldsExperimentEnabled || isWizardRouteBizExperimentEnabled || isSimplifiedLandingViewWithBasicTasksEnabled || (0, $4LHd8.default).checkGate("jira_onboarding_wizard_small_refactor") ? {
                        customDetail: {
                            ...isAllowExtraFieldsExperimentEnabled || isWizardRouteBizExperimentEnabled ? {
                                enableExtraFields: true
                            } : {},
                            ...isSimplifiedLandingViewWithBasicTasksEnabled ? {
                                sampleDataVersion: "GENERIC"
                            } : {},
                            ...withSampleData ? {
                                sampleDataVersion: "WIZARD"
                            } : {}
                        }
                    } : {}
                };
                const { taskId: taskId } = await stargateClient.wizardProjectCreate(projectPayload);
                (0, $jgJpJ.ufoEventOnboardingWizardProjectCreation).success({
                    customData: {
                        template: projectDetails.template
                    }
                });
                if ((0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jiraOnboardingWizardMetricImprovements)) {
                    const onRedirect = ()=>{
                        (0, $jgJpJ.ufoEventOnboardingWizardProjectCreationIncludingProvisioning).success({
                            customData: {
                                template: projectDetails.template
                            }
                        });
                    };
                    onComplete(taskId, onRedirect);
                } else {
                    (0, $jgJpJ.ufoEventOnboardingWizardProjectCreationIncludingProvisioning).success({
                        customData: {
                            template: projectDetails.template
                        }
                    });
                    onComplete(taskId);
                }
            } catch (error) {
                (0, $jgJpJ.ufoEventOnboardingWizardProjectCreation).failure({
                    customData: {
                        template: projectDetails.template
                    },
                    error: error
                });
                if ((0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jiraOnboardingWizardMetricImprovements)) {
                    const onRedirect = ()=>{
                        (0, $jgJpJ.ufoEventOnboardingWizardProjectCreationIncludingProvisioning).failure({
                            customData: {
                                template: projectDetails.template
                            },
                            error: error
                        });
                    };
                    onComplete(undefined, onRedirect);
                } else {
                    (0, $jgJpJ.ufoEventOnboardingWizardProjectCreationIncludingProvisioning).failure({
                        customData: {
                            template: projectDetails.template
                        },
                        error: error
                    });
                    onComplete();
                }
            } finally{
                if ((0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).jiraOnboardingMultipleProjectRequestsBugfix)) // skip updating isCreateRequestInProgress ref.
                return;
                isCreateRequestInProgress.current = false;
            }
        }
    }, [
        projectConfig,
        cloudId,
        signupId,
        isWizardDevKanbanExperiment,
        isWizardRouteBizExperiment,
        isAllowExtraFieldsExperiment,
        isSimplifiedLandingViewWithBasicTasks,
        projectDetails.projectKey,
        projectDetails.template,
        teamType,
        withSampleData,
        stargateClient,
        onComplete
    ]);
    (0, $iSvIT.useEffect)(()=>{
        // Only trigger creating project once the site is ready
        const canCreateProject = projectConfig && createCloudStatus === "success" && cloudId;
        if (canCreateProject && !isCreateRequestInProgress.current) createProject();
    }, [
        createCloudStatus,
        cloudId,
        createProject,
        projectConfig
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (createCloudStatus === "success") createAnalyticsEvent({
            eventType: "ui",
            action: "succeeded",
            actionSubject: "provisioning",
            actionSubjectId: "jiraAnimatedProvisioningScreen",
            source: "/ondemand/signup/confirmation",
            attributes: {
                atlasId: "ATLAS-56326",
                reactComponent: "WelcomeModal",
                template: projectDetails.template,
                teamType: teamType
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        createCloudStatus,
        projectDetails.template,
        teamType
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $krd0Q.JiraBackground), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bh8PA.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8KELJ.default), {
                    shouldCloseOnOverlayClick: false,
                    shouldCloseOnEscapePress: false,
                    width: "1140px",
                    height: "626px",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gyy4U.WelcomeModalPageSwitcher), {
                        onComplete: handleComplete
                    })
                })
            })
        ]
    });
};

});
parcelRegister("gyy4U", function(module, exports) {

$parcel$export(module.exports, "WelcomeModalPageSwitcher", function () { return $00daaa7e47c0d8f3$export$dad05f21707542e3; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $hFDGT = parcelRequire("hFDGT");
var $j7TVc = parcelRequire("j7TVc");

var $bZyGC = parcelRequire("bZyGC");

var $kbfAN = parcelRequire("kbfAN");

var $hrj1e = parcelRequire("hrj1e");

var $lJGae = parcelRequire("lJGae");

var $kmspH = parcelRequire("kmspH");

var $dmnHD = parcelRequire("dmnHD");
const $00daaa7e47c0d8f3$var$WIZARD_PAGES = [
    (0, $kbfAN.WIZARD_PAGE_ONBOARDING_PROJECT_DETAILS_SOURCE_NAME),
    (0, $kbfAN.WIZARD_PAGE_ONBOARDING_WORK_TYPES_SOURCE_NAME),
    (0, $kbfAN.WIZARD_PAGE_ONBOARDING_BOARD_COLUMNS_SOURCE_NAME)
];
const $00daaa7e47c0d8f3$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { teamType: teamType } = (0, $hrj1e.useWizardConfiguration)();
    const fireAnalyticsEvent = (0, $iSvIT.useCallback)((eventData)=>{
        createAnalyticsEvent(eventData).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent,
        teamType: teamType
    };
};
const $00daaa7e47c0d8f3$export$dad05f21707542e3 = ({ onComplete: onComplete })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { wizardConfiguration: wizardConfiguration, projectDetails: { template: template, defaultProjectName: defaultProjectName } } = (0, $hrj1e.useWizardConfiguration)();
    const defaultColumns = wizardConfiguration.columns.map((defaultColumnName)=>formatMessage({
            id: defaultColumnName.id,
            defaultMessage: defaultColumnName.defaultMessage
        }));
    const defaultIssueTypes = wizardConfiguration.issueTypes;
    const [currentPage, setCurrentPage] = (0, $iSvIT.useState)(0);
    const [projectName, setProjectName] = (0, $iSvIT.useState)(undefined);
    const [columnNames, setColumnNames] = (0, $iSvIT.useState)(defaultColumns);
    const [selectedIssueTypes, setSelectedIssueTypes] = (0, $iSvIT.useState)(defaultIssueTypes?.filter((issue)=>issue.isPreSelected) || []);
    const analytics = $00daaa7e47c0d8f3$export$e955abb82869dc84();
    const { fireAnalyticsEvent: fireAnalyticsEvent, teamType: teamType } = analytics;
    const onToggleIssueType = (0, $iSvIT.useCallback)((issueType)=>{
        setSelectedIssueTypes((prevTypes)=>prevTypes.includes(issueType) ? prevTypes.filter((type)=>type !== issueType) : [
                ...prevTypes,
                issueType
            ]);
        fireAnalyticsEvent({
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: `${(0, $kbfAN.ANALYTICS_PREFIX)}WorkTypesButton`,
            eventType: "ui",
            attributes: {
                issueTypeClicked: issueType,
                selectedIssueTypes: selectedIssueTypes,
                teamType: teamType,
                template: template
            }
        });
    }, [
        setSelectedIssueTypes,
        fireAnalyticsEvent,
        selectedIssueTypes,
        teamType,
        template
    ]);
    const onFinishHandler = (0, $iSvIT.useCallback)(()=>{
        const hasChangedDefaultIssueTypeConfiguration = !(defaultIssueTypes.length === selectedIssueTypes.length && defaultIssueTypes.every((defaultType)=>selectedIssueTypes.some((selectedType)=>selectedType.id === defaultType.id)));
        const selectedIssuesInPriorityOrder = defaultIssueTypes.map((defaultType)=>selectedIssueTypes.find((selectedType)=>selectedType.id === defaultType.id)).filter((issueType)=>issueType !== undefined);
        fireAnalyticsEvent({
            action: "completed",
            actionSubject: `${(0, $kbfAN.ANALYTICS_PREFIX)}Setup`,
            eventType: "track",
            attributes: {
                totalSelected: selectedIssueTypes.length,
                totalColumns: columnNames.length,
                defaultIssueTypes: defaultIssueTypes,
                selectedIssueTypes: selectedIssuesInPriorityOrder,
                hasChangedDefaultIssueTypeConfiguration: hasChangedDefaultIssueTypeConfiguration,
                hasChangedDefaultProjectName: projectName !== undefined,
                teamType: teamType,
                template: template
            }
        });
        onComplete({
            projectName: projectName === undefined ? formatMessage(defaultProjectName) : projectName,
            issueTypes: selectedIssuesInPriorityOrder.map(({ icon: icon, avatarId: avatarId })=>({
                    name: icon,
                    avatarId: avatarId
                })),
            columns: columnNames
        });
    }, [
        defaultIssueTypes,
        selectedIssueTypes,
        fireAnalyticsEvent,
        columnNames,
        projectName,
        teamType,
        template,
        onComplete,
        formatMessage,
        defaultProjectName
    ]);
    const setNextWizardPage = (0, $iSvIT.useCallback)(()=>{
        if ($00daaa7e47c0d8f3$var$WIZARD_PAGES[currentPage] === (0, $kbfAN.WIZARD_PAGE_ONBOARDING_BOARD_COLUMNS_SOURCE_NAME)) {
            fireAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: `${(0, $kbfAN.ANALYTICS_PREFIX)}FinishButton`,
                eventType: "ui",
                attributes: {
                    teamType: teamType,
                    template: template
                }
            });
            onFinishHandler();
        } else {
            fireAnalyticsEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: `${(0, $kbfAN.ANALYTICS_PREFIX)}NextButton`,
                eventType: "ui",
                attributes: {
                    currentPageBeforeNextClick: $00daaa7e47c0d8f3$var$WIZARD_PAGES[currentPage],
                    teamType: teamType,
                    template: template
                }
            });
            setCurrentPage(currentPage + 1);
        }
    }, [
        currentPage,
        fireAnalyticsEvent,
        onFinishHandler,
        setCurrentPage,
        teamType,
        template
    ]);
    const defaultProjectNameFormatted = formatMessage(defaultProjectName);
    const handleProjectNameChange = (0, $iSvIT.useCallback)((newProjectName)=>{
        setProjectName(newProjectName);
    }, [
        setProjectName
    ]);
    const wizardPage = $00daaa7e47c0d8f3$var$WIZARD_PAGES[currentPage] || $00daaa7e47c0d8f3$var$WIZARD_PAGES[0];
    switch(wizardPage){
        case 0, $kbfAN.WIZARD_PAGE_ONBOARDING_PROJECT_DETAILS_SOURCE_NAME:
        default:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hFDGT.default), {
                gap: "space.0",
                xcss: $00daaa7e47c0d8f3$var$gridStyles,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kmspH.PageProjectDetails), {
                    onClickNext: setNextWizardPage,
                    currentProjectName: projectName,
                    onProjectNameChange: handleProjectNameChange,
                    defaultProjectName: defaultProjectNameFormatted
                })
            });
        case 0, $kbfAN.WIZARD_PAGE_ONBOARDING_WORK_TYPES_SOURCE_NAME:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hFDGT.default), {
                gap: "space.0",
                xcss: $00daaa7e47c0d8f3$var$gridStyles,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dmnHD.PageWorkTypes), {
                    defaultIssueTypes: defaultIssueTypes,
                    projectName: projectName ?? defaultProjectNameFormatted,
                    onClickNext: setNextWizardPage,
                    selectedIssueTypes: selectedIssueTypes,
                    onToggleIssueType: onToggleIssueType
                })
            });
        case 0, $kbfAN.WIZARD_PAGE_ONBOARDING_BOARD_COLUMNS_SOURCE_NAME:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hFDGT.default), {
                gap: "space.0",
                xcss: $00daaa7e47c0d8f3$var$gridStyles,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $lJGae.PageBoardColumns), {
                    onClickNext: setNextWizardPage,
                    projectName: projectName ?? defaultProjectNameFormatted,
                    columnNames: columnNames,
                    setColumnNames: setColumnNames
                })
            });
    }
};
const $00daaa7e47c0d8f3$var$gridStyles = (0, $j7TVc.xcss)({
    width: "100%",
    height: "100%",
    gridTemplateColumns: "100%",
    [(0, $bZyGC.media).above.sm]: {
        gridTemplateColumns: "50% 50%"
    }
});

});
parcelRegister("lJGae", function(module, exports) {

$parcel$export(module.exports, "PageBoardColumns", function () { return $52698afef47bcc59$export$21fc80e7d2faa4c1; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $kbfAN = parcelRequire("kbfAN");

var $dWmS4 = parcelRequire("dWmS4");

var $hgNMu = parcelRequire("hgNMu");

var $hrj1e = parcelRequire("hrj1e");

var $dWAap = parcelRequire("dWAap");

var $aTFJ4 = parcelRequire("aTFJ4");
const $52698afef47bcc59$export$21fc80e7d2faa4c1 = ({ projectName: projectName, onClickNext: onClickNext, columnNames: columnNames, setColumnNames: setColumnNames })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { teamType: teamType, projectDetails: { template: template } } = (0, $hrj1e.useWizardConfiguration)();
    (0, $iSvIT.useEffect)(()=>{
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: `${(0, $kbfAN.ANALYTICS_PREFIX)}BoardColumns`,
            attributes: {
                teamType: teamType,
                template: template
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        teamType,
        template
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dWmS4.LeftHandSideWrapper), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dWAap.LeftHandSidePageBoardColumns), {
                    onClickNext: onClickNext,
                    columnNames: columnNames,
                    setColumnNames: setColumnNames
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $hgNMu.RightHandSideWrapper), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aTFJ4.RightHandSidePageBoardColumns), {
                    projectName: projectName,
                    columnNames: columnNames
                })
            })
        ]
    });
};

});
parcelRegister("dWmS4", function(module, exports) {

$parcel$export(module.exports, "LeftHandSideWrapper", function () { return $0bb412ba6eddd5ca$export$3e91eecd8bf3ee96; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $257fv = parcelRequire("257fv");
var $jXVyf = parcelRequire("jXVyf");
var $j7TVc = parcelRequire("j7TVc");

var $bZyGC = parcelRequire("bZyGC");
const $0bb412ba6eddd5ca$export$3e91eecd8bf3ee96 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
        xcss: $0bb412ba6eddd5ca$var$wrapperStyles,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jXVyf.default), {
            spread: "space-between",
            xcss: $0bb412ba6eddd5ca$var$stackStyles,
            children: children
        })
    });
};
const $0bb412ba6eddd5ca$var$wrapperStyles = (0, $j7TVc.xcss)({
    backgroundColor: "elevation.surface",
    padding: "space.300",
    [(0, $bZyGC.media).above.sm]: {
        padding: "space.800"
    }
});
const $0bb412ba6eddd5ca$var$stackStyles = (0, $j7TVc.xcss)({
    height: "100%"
});

});

parcelRegister("hgNMu", function(module, exports) {

$parcel$export(module.exports, "RightHandSideWrapper", function () { return $666daaf1e898433e$export$4c25a25f2b141c52; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $257fv = parcelRequire("257fv");
var $j7TVc = parcelRequire("j7TVc");

var $bZyGC = parcelRequire("bZyGC");
const $666daaf1e898433e$export$4c25a25f2b141c52 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
        xcss: $666daaf1e898433e$var$rightHandSideStyles,
        children: children
    });
};
const $666daaf1e898433e$var$rightHandSideStyles = (0, $j7TVc.xcss)({
    display: "none",
    [(0, $bZyGC.media).above.sm]: {
        display: "block"
    }
});

});

parcelRegister("dWAap", function(module, exports) {

$parcel$export(module.exports, "LeftHandSidePageBoardColumns", function () { return $5b8661fba6f15896$export$93f9a40ffff2308e; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $3XfGP = parcelRequire("3XfGP");

var $kzsvd = parcelRequire("kzsvd");

var $gf1F9 = parcelRequire("gf1F9");

var $257fv = parcelRequire("257fv");
var $1Lr0O = parcelRequire("1Lr0O");
var $jXVyf = parcelRequire("jXVyf");
var $j7TVc = parcelRequire("j7TVc");

var $2hxsc = parcelRequire("2hxsc");

var $cBSOl = parcelRequire("cBSOl");
const $5b8661fba6f15896$export$93f9a40ffff2308e = ({ onClickNext: onClickNext, columnNames: columnNames, setColumnNames: setColumnNames })=>{
    const [emptyInputIndexes, setEmptyInputIndexes] = (0, $iSvIT.useState)([]);
    const [dupeIndexes, setDupeIndexes] = (0, $iSvIT.useState)([]);
    const [exceededInputLengthIndexes, setExceededInputLengthIndexes] = (0, $iSvIT.useState)([]);
    const [isSubmitting, setIsSubmitting] = (0, $iSvIT.useState)(false);
    const onClickNextWrapper = ({ columnNames: columnNames })=>{
        onClickNext({
            columnNames: columnNames
        });
        setIsSubmitting(true);
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                        size: "xlarge",
                        as: "h1",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            ...(0, $2hxsc.default).title
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        xcss: $5b8661fba6f15896$var$subtextStyles,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            ...(0, $2hxsc.default).subtitle
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $cBSOl.ColumnInputs), {
                        columnNames: columnNames,
                        setColumnNames: setColumnNames,
                        emptyInputIndexes: emptyInputIndexes,
                        setEmptyInputIndexes: setEmptyInputIndexes,
                        dupeIndexes: dupeIndexes,
                        setDupeIndexes: setDupeIndexes,
                        exceededInputLengthIndexes: exceededInputLengthIndexes,
                        setExceededInputLengthIndexes: setExceededInputLengthIndexes
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kzsvd.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1Lr0O.default), {
                    justifyContent: "space-between",
                    alignItems: "center",
                    xcss: $5b8661fba6f15896$var$footerStyles,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            ...(0, $2hxsc.default).step
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $3XfGP.default), {
                            appearance: "primary",
                            onClick: ()=>{
                                (0, $cBSOl.onClickFinishButton)({
                                    onClickNext: onClickNextWrapper,
                                    columnNames: columnNames,
                                    setEmptyInputIndexes: setEmptyInputIndexes,
                                    setDupeIndexes: setDupeIndexes,
                                    setExceededInputLengthIndexes: setExceededInputLengthIndexes
                                });
                            },
                            isLoading: isSubmitting,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                ...(0, $2hxsc.default).finishButtonCta
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $5b8661fba6f15896$var$subtextStyles = (0, $j7TVc.xcss)({
    fontSize: "font.body.medium",
    color: "color.text.subtle"
});
const $5b8661fba6f15896$var$footerStyles = (0, $j7TVc.xcss)({
    width: "100%",
    color: "color.text.subtlest"
});

});
parcelRegister("2hxsc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4813f258b49e896$export$2e2bcd8739ae039; });

var $6x1qA = parcelRequire("6x1qA");
var $b4813f258b49e896$export$2e2bcd8739ae039 = (0, $6x1qA.defineMessages)({
    title: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.title",
        defaultMessage: "How do you track work?",
        description: "Title for a modal about setting up the board columns"
    },
    subtitle: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.subtitle",
        defaultMessage: "As you complete work, it moves through these statuses.",
        description: "Subtitle for a modal about setting up the board columns"
    },
    statusInputPlaceholder: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.column-input-placeholder",
        defaultMessage: "Name of status",
        description: "Placeholder for text input fields for naming statuses in onboarding wizard modal"
    },
    addStatusButton: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.add-column-button",
        defaultMessage: "Add status",
        description: "Button text for adding a status input in onboarding wizard modal"
    },
    step: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.step",
        defaultMessage: "Step 3 of 3",
        description: "Current step of the onboarding wizard displayed in bottom left corner of the modal"
    },
    deleteTooltip: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.deleteTooltip",
        defaultMessage: "Minimum 3 statuses",
        description: "Tooltip text that appears when user hovers over disabled delete button when there are only three column statuses"
    },
    maxColumnsText: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.max-columns-text",
        defaultMessage: "Don't worry, you can change these later.",
        description: "Text that appears instead of the add status button when the maximum number of columns are added"
    },
    emptyInputErrorMessage: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.empty-input-error-message",
        defaultMessage: "Enter a name for this status",
        description: "Error text that appears if status name input is empty when finish button is pressed"
    },
    duplicateStatusErrorMessage: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.duplicate-status-error-message",
        defaultMessage: "Statuses can't share the same name",
        description: "Error text that appears if there are duplicate status name in inputs when finish button is pressed"
    },
    inputLengthErrorMessage: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.input-length-error-message",
        defaultMessage: "Status name can't exceed 30 characters",
        description: "Error text that appears if the status name is over 30 characters when finish button is pressed"
    },
    nextButtonCta: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.next-button-cta",
        defaultMessage: "Next",
        description: "CTA for the next button"
    },
    finishButtonCta: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.finish-button-cta",
        defaultMessage: "Finish",
        description: "CTA for the finish button"
    },
    deleteColumnButtonLabel: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.delete-column-button-label",
        defaultMessage: "Delete column {columnNumber}"
    },
    columnInputLabel: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-board-columns.left-hand-side.column-input-label",
        defaultMessage: "Column {columnNumber} name"
    }
});

});

parcelRegister("cBSOl", function(module, exports) {

$parcel$export(module.exports, "onClickFinishButton", function () { return $4e1aa72fe91f6c86$export$f7c51b887e331a97; });
$parcel$export(module.exports, "ColumnInputs", function () { return $4e1aa72fe91f6c86$export$3d040ec13e8bf956; });
/* utils.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $6IiXU = parcelRequire("6IiXU");

var $hGQlB = parcelRequire("hGQlB");

var $ayjUl = parcelRequire("ayjUl");

var $i3sQU = parcelRequire("i3sQU");

var $257fv = parcelRequire("257fv");
var $1Lr0O = parcelRequire("1Lr0O");
var $jXVyf = parcelRequire("jXVyf");
var $j7TVc = parcelRequire("j7TVc");

var $7OGW4 = parcelRequire("7OGW4");

var $iSjV6 = parcelRequire("iSjV6");

var $kbfAN = parcelRequire("kbfAN");

var $hrj1e = parcelRequire("hrj1e");

var $2hxsc = parcelRequire("2hxsc");
const $4e1aa72fe91f6c86$export$d5a8001d4b9a6d19 = ({ newValue: newValue, columnKey: columnKey, columnNames: columnNames, setColumnNames: setColumnNames })=>{
    const newColumnNames = [
        ...columnNames
    ];
    newColumnNames[columnKey] = newValue;
    setColumnNames(newColumnNames);
};
const $4e1aa72fe91f6c86$export$530274b7c26f7525 = ({ columnNames: columnNames, setColumnNames: setColumnNames })=>{
    const newColumnNames = [
        ...columnNames
    ];
    newColumnNames.splice(columnNames.length - 1, 0, "");
    setColumnNames(newColumnNames);
};
const $4e1aa72fe91f6c86$export$5ee6263354ad76d2 = (columnName)=>{
    return columnName.trim().replace(/\s+/g, " ");
};
const $4e1aa72fe91f6c86$export$3ffa1a3018c1c179 = (columnNames)=>{
    const emptyInputIndexes = [];
    columnNames.forEach((columnName, i)=>columnName === "" && emptyInputIndexes.push(i));
    return emptyInputIndexes;
};
const $4e1aa72fe91f6c86$export$e2b8c6d7d57cabc5 = (columnNames)=>{
    const dupeIndexes = [];
    const indexMap = new Map();
    columnNames.forEach((columnName)=>{
        indexMap.set(columnName, (indexMap.get(columnName) || 0) + 1);
    });
    columnNames.forEach((columnName, i)=>{
        const columnNameCount = indexMap.get(columnName);
        if (columnName !== "" && columnNameCount !== undefined && columnNameCount > 1) dupeIndexes.push(i);
    });
    return dupeIndexes;
};
const $4e1aa72fe91f6c86$export$d39c62d378ff9016 = (columnNames, dupeIndexes)=>{
    const exceededIndexes = [];
    columnNames.forEach((columnName, i)=>columnName.length > (0, $kbfAN.MAX_INPUT_LENGTH) && !dupeIndexes.includes(i) && exceededIndexes.push(i));
    return exceededIndexes;
};
const $4e1aa72fe91f6c86$export$f7c51b887e331a97 = ({ onClickNext: onClickNext, columnNames: columnNames, setEmptyInputIndexes: setEmptyInputIndexes, setDupeIndexes: setDupeIndexes, setExceededInputLengthIndexes: setExceededInputLengthIndexes })=>{
    const newColumnNames = columnNames.map((columnName)=>$4e1aa72fe91f6c86$export$5ee6263354ad76d2(columnName));
    const emptyInputIndexes = $4e1aa72fe91f6c86$export$3ffa1a3018c1c179(newColumnNames);
    const dupeIndexes = $4e1aa72fe91f6c86$export$e2b8c6d7d57cabc5(newColumnNames);
    const exceededIndexes = $4e1aa72fe91f6c86$export$d39c62d378ff9016(newColumnNames, dupeIndexes);
    if (emptyInputIndexes.length > 0) setEmptyInputIndexes(emptyInputIndexes);
    else setEmptyInputIndexes([]);
    if (dupeIndexes.length > 0) setDupeIndexes(dupeIndexes);
    else setDupeIndexes([]);
    if (exceededIndexes.length > 0) setExceededInputLengthIndexes(exceededIndexes);
    else setExceededInputLengthIndexes([]);
    if (emptyInputIndexes.length > 0 || dupeIndexes.length > 0 || exceededIndexes.length > 0) return;
    onClickNext({
        columnNames: newColumnNames
    });
};
const $4e1aa72fe91f6c86$export$c8d6cc7db1973a10 = ({ columnNames: columnNames, setColumnNames: setColumnNames, index: index, emptyInputIndexes: emptyInputIndexes, setEmptyInputIndexes: setEmptyInputIndexes, setDupeIndexes: setDupeIndexes, setExceededInputLengthIndexes: setExceededInputLengthIndexes })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { teamType: teamType } = (0, $hrj1e.useWizardConfiguration)();
    const isMinColumnLen = columnNames.length <= (0, $kbfAN.MIN_COLUMNS_LEN);
    const buttonLabel = formatMessage((0, $2hxsc.default).deleteColumnButtonLabel, {
        columnNumber: index + 1
    });
    const handleDelete = ()=>{
        if (isMinColumnLen) return;
        const newColumnNames = [
            ...columnNames
        ];
        newColumnNames.splice(index, 1);
        const updatedEmptyInputIndexes = emptyInputIndexes.filter((emptyIndex)=>newColumnNames[emptyIndex] === "");
        setEmptyInputIndexes(updatedEmptyInputIndexes);
        const newDupeIndexes = $4e1aa72fe91f6c86$export$e2b8c6d7d57cabc5(newColumnNames);
        setDupeIndexes(newDupeIndexes);
        setExceededInputLengthIndexes($4e1aa72fe91f6c86$export$d39c62d378ff9016(newColumnNames, newDupeIndexes));
        setColumnNames(newColumnNames);
        createAnalyticsEvent({
            action: "clicked",
            actionSubject: "button",
            actionSubjectId: `${(0, $kbfAN.ANALYTICS_PREFIX)}DeleteBoardColumn`,
            eventType: "ui",
            attributes: {
                teamType: teamType
            }
        }).fire();
    };
    const handleKeyDown = (e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleDelete();
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSjV6.default), {
        content: columnNames.length === (0, $kbfAN.MIN_COLUMNS_LEN) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
            ...(0, $2hxsc.default).deleteTooltip
        }) : "",
        position: "right-end",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
            isDisabled: isMinColumnLen,
            "aria-label": buttonLabel,
            onClick: handleDelete,
            onKeyDown: handleKeyDown,
            className: (0, $esG4f.default)([
                "_1ul91a70 _4t3ickbl _bfhkc1q8 _19itzgxb _2rkocf72 _1e0c1txw _4cvr1h6o _1bah1h6o _irr3glas"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i3sQU))), {
                label: ""
            })
        })
    });
};
const $4e1aa72fe91f6c86$var$ColumnInputErrorMessage = ({ hasEmptyInput: hasEmptyInput, hasDupeInput: hasDupeInput, hasExceededInput: hasExceededInput })=>{
    const getErrorMessage = ()=>{
        switch(true){
            case hasDupeInput:
                return (0, $2hxsc.default).duplicateStatusErrorMessage;
            case hasExceededInput:
                return (0, $2hxsc.default).inputLengthErrorMessage;
            case hasEmptyInput:
                return (0, $2hxsc.default).emptyInputErrorMessage;
            default:
                return null;
        }
    };
    const errorMessage = getErrorMessage();
    return errorMessage ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $jXVyf.default), {
        space: "space.050",
        xcss: $4e1aa72fe91f6c86$var$bottomPadding,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hGQlB.ErrorMessage), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                ...errorMessage
            })
        })
    }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_4t3iu2gc"
        ])
    });
};
const $4e1aa72fe91f6c86$export$3d040ec13e8bf956 = ({ columnNames: columnNames, setColumnNames: setColumnNames, emptyInputIndexes: emptyInputIndexes, setEmptyInputIndexes: setEmptyInputIndexes, dupeIndexes: dupeIndexes, setDupeIndexes: setDupeIndexes, exceededInputLengthIndexes: exceededInputLengthIndexes, setExceededInputLengthIndexes: setExceededInputLengthIndexes })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { teamType: teamType } = (0, $hrj1e.useWizardConfiguration)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $257fv.default), {
        xcss: $4e1aa72fe91f6c86$var$columnInputWrapperStyles,
        children: [
            columnNames.map((columnName, index)=>{
                return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1bsb1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1Lr0O.default), {
                            direction: "row",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OGW4.default), {
                                    width: "100%",
                                    value: columnName,
                                    placeholder: formatMessage((0, $2hxsc.default).statusInputPlaceholder),
                                    isInvalid: emptyInputIndexes.includes(index) || dupeIndexes.includes(index) || exceededInputLengthIndexes.includes(index),
                                    onChange: (e)=>{
                                        $4e1aa72fe91f6c86$export$d5a8001d4b9a6d19({
                                            newValue: e.currentTarget.value,
                                            columnKey: index,
                                            columnNames: columnNames,
                                            setColumnNames: setColumnNames
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1bsbutpp"
                                    ])
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)($4e1aa72fe91f6c86$export$c8d6cc7db1973a10, {
                                    columnNames: columnNames,
                                    setColumnNames: setColumnNames,
                                    index: index,
                                    emptyInputIndexes: emptyInputIndexes,
                                    setEmptyInputIndexes: setEmptyInputIndexes,
                                    setDupeIndexes: setDupeIndexes,
                                    setExceededInputLengthIndexes: setExceededInputLengthIndexes
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($4e1aa72fe91f6c86$var$ColumnInputErrorMessage, {
                            hasEmptyInput: emptyInputIndexes.includes(index),
                            hasDupeInput: dupeIndexes.includes(index),
                            hasExceededInput: exceededInputLengthIndexes.includes(index)
                        })
                    ]
                }, index);
            }),
            columnNames.length === (0, $kbfAN.MAX_COLUMNS_LEN) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                xcss: $4e1aa72fe91f6c86$var$maxColumnsTextStyles,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                    ...(0, $2hxsc.default).maxColumnsText
                })
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                xcss: $4e1aa72fe91f6c86$var$addColumnButtonPadding,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                    appearance: "subtle",
                    iconBefore: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ayjUl))), {
                        label: ""
                    }),
                    onClick: ()=>{
                        const secondLastIndex = columnNames.length - 1;
                        const lastIndex = columnNames.length;
                        if (emptyInputIndexes.includes(secondLastIndex)) {
                            const newEmptyInputIndexes = emptyInputIndexes.filter((emptyIndex)=>emptyIndex !== secondLastIndex);
                            newEmptyInputIndexes.push(lastIndex);
                            setEmptyInputIndexes(newEmptyInputIndexes);
                        }
                        if (dupeIndexes.includes(secondLastIndex)) {
                            const newDupeIndexes = dupeIndexes.filter((dupeIndex)=>dupeIndex !== secondLastIndex);
                            newDupeIndexes.push(lastIndex);
                            setDupeIndexes(newDupeIndexes);
                        }
                        if (exceededInputLengthIndexes.includes(secondLastIndex)) {
                            const newExceededInputLengthIndexes = exceededInputLengthIndexes.filter((exceededInputLengthIndex)=>exceededInputLengthIndex !== secondLastIndex);
                            newExceededInputLengthIndexes.push(lastIndex);
                            setExceededInputLengthIndexes(newExceededInputLengthIndexes);
                        }
                        $4e1aa72fe91f6c86$export$530274b7c26f7525({
                            columnNames: columnNames,
                            setColumnNames: setColumnNames
                        });
                        createAnalyticsEvent({
                            action: "clicked",
                            actionSubject: "button",
                            actionSubjectId: `${(0, $kbfAN.ANALYTICS_PREFIX)}AddBoardColumn`,
                            eventType: "ui",
                            attributes: {
                                teamType: teamType
                            }
                        }).fire();
                    },
                    isDisabled: columnNames.length >= (0, $kbfAN.MAX_COLUMNS_LEN),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        ...(0, $2hxsc.default).addStatusButton
                    })
                })
            })
        ]
    });
};
const $4e1aa72fe91f6c86$var$maxColumnsTextStyles = (0, $j7TVc.xcss)({
    color: "color.text.subtlest"
});
const $4e1aa72fe91f6c86$var$addColumnButtonPadding = (0, $j7TVc.xcss)({
    paddingInlineStart: "space.050",
    paddingBlockEnd: "space.050"
});
const $4e1aa72fe91f6c86$var$inputWidthStyle = null;
const $4e1aa72fe91f6c86$var$horizontalSpacing = null;
const $4e1aa72fe91f6c86$var$verticalSpacing = null;
const $4e1aa72fe91f6c86$var$bottomPadding = (0, $j7TVc.xcss)({
    paddingBlockEnd: "space.050"
});
const $4e1aa72fe91f6c86$var$deleteButtonStyles = null;
const $4e1aa72fe91f6c86$var$columnInputWrapperStyles = (0, $j7TVc.xcss)({
    maxWidth: "460px",
    minWidth: "250px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    paddingBlockStart: "space.150"
});

});


parcelRegister("aTFJ4", function(module, exports) {

$parcel$export(module.exports, "RightHandSidePageBoardColumns", function () { return $f366464c60b3ea44$export$576dc3e63ed20720; });

var $loA2J = parcelRequire("loA2J");

var $1Lr0O = parcelRequire("1Lr0O");
var $j7TVc = parcelRequire("j7TVc");

var $8USnA = parcelRequire("8USnA");

var $6Qct2 = parcelRequire("6Qct2");

var $2VjDh = parcelRequire("2VjDh");
const $f366464c60b3ea44$export$576dc3e63ed20720 = ({ projectName: projectName, columnNames: columnNames })=>{
    const injections = {
        additionalObject: (0, $2VjDh.ColumnHighlight),
        svgBody: (0, $8USnA.BoardColumnsSvg)({
            columnNames: columnNames
        })
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1Lr0O.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $f366464c60b3ea44$var$containerStyles,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6Qct2.ProjectSvg), {
            projectName: projectName,
            activeView: "board",
            injections: injections
        })
    });
};
const $f366464c60b3ea44$var$containerStyles = (0, $j7TVc.xcss)({
    height: "100%",
    backgroundColor: "elevation.surface"
});

});
parcelRegister("8USnA", function(module, exports) {

$parcel$export(module.exports, "BoardColumnsSvg", function () { return $988ed609811e697e$export$d8c0e51094505c67; });

var $loA2J = parcelRequire("loA2J");

var $257fv = parcelRequire("257fv");
var $1Lr0O = parcelRequire("1Lr0O");
var $j7TVc = parcelRequire("j7TVc");

var $kwHar = parcelRequire("kwHar");

var $kbfAN = parcelRequire("kbfAN");
const $988ed609811e697e$var$GREEN = "#82B536";
const $988ed609811e697e$var$BLUE = "#1868DB";
const $988ed609811e697e$var$ORANGE = "#FFA900";
const $988ed609811e697e$var$SquiggleBlue = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "64",
        height: "14",
        viewBox: "0 0 64 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M63.9947 6.70862C52.9658 9.28601 44.8283 2.69108 33.6895 8.10094C33.1695 5.78395 31.8253 2.88238 29.8131 2.83986C31.4913 2.89301 34.1756 8.94588 31.4786 4.89114C29.8934 1.80359 22.9649 5.57673 28.2744 2.89306C24.6093 3.46168 21.2487 7.21878 18.7715 10.5614C14.6499 15.3229 17.7781 6.10813 14.7979 1.47414C10.5748 -4.96667 -2.24221 11.7837 0.340646 11.7943C1.98505 9.69524 4.19167 8.38792 5.10476 6.0603C21.181 -7.71943 9.58144 17.7834 19.1562 13.5108C34.797 -4.20142 26.8921 11.8315 36.0737 10.7368C41.4254 4.3172 64.1807 14.3823 63.9989 6.70862H63.9947Z",
            fill: "#091E42",
            fillOpacity: "0.31"
        })
    });
const $988ed609811e697e$var$SquiggleGreen = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "64",
        height: "14",
        viewBox: "0 0 64 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M0.447341 5.46691C1.1146 5.92415 1.83039 6.12598 2.56438 6.25373C3.30443 6.38149 4.07481 6.4151 4.96651 6.4151C5.18489 6.3008 5.22736 6.34115 5.16063 6.08563C5.20916 6.02512 5.28801 5.91744 5.23342 5.82331C5.04537 5.22487 5.58525 5.29887 5.79149 5.19129C5.95527 6.19989 7.22914 5.7427 8.41201 4.9022C9.59488 4.06842 10.7777 2.96566 11.1296 2.85807C11.5785 3.66495 12.4156 2.32005 12.9372 2.58901C12.919 2.63608 12.8038 2.88488 12.7917 2.93194C13.0464 3.18073 14.4295 2.33363 15.6124 2.55552C16.1947 2.65638 16.7164 2.96554 16.9105 3.24122C17.1289 3.49674 17.0682 3.59098 16.6132 3.51701L16.7588 3.79937C16.8013 3.90023 16.8438 4.00779 16.8862 4.11538L17.0136 4.42466C17.05 4.53897 17.0864 4.65328 17.1228 4.76759L17.238 5.11052C17.2684 5.23155 17.2987 5.35934 17.329 5.48037C17.3351 5.52072 17.3836 5.64842 17.42 5.76273L17.5413 6.10566C17.6263 6.32755 17.7355 6.54285 17.8628 6.74458C18.3845 7.54473 19.3126 8.05567 20.2832 7.99515C20.7685 7.96825 21.2598 7.82036 21.6966 7.5245C22.0059 7.30261 22.3153 7.08745 22.6247 6.85883C23.0796 6.50246 23.5891 6.24701 24.0805 5.91753C24.3353 5.77633 24.5961 5.65523 24.857 5.51403L25.2512 5.30554L25.6577 5.13744C26.7374 4.63986 27.9081 4.32381 29.1153 4.10192C31.5296 3.66486 34.1076 3.82626 36.4915 4.29694C38.8876 4.78107 41.1017 5.54761 42.9518 6.48898L42.9154 6.36126C42.97 6.41505 43.1702 6.40835 43.1884 6.55628C44.0377 6.38818 46.1365 6.63689 46.1365 6.63689C46.8887 6.68395 47.6469 6.71768 48.4052 6.74458C48.4052 6.74458 49.3333 7.07394 50.4919 7.30256C51.6444 7.55135 53.0335 7.63878 53.8403 7.32275C55.7814 7.61188 57.7772 7.72618 59.7789 7.47739C59.7789 7.47739 60.3916 7.29589 61.0771 7.02693C61.7504 6.7109 62.4904 6.31425 62.7574 5.91753C63.097 5.4603 63.2426 5.01646 63.188 4.68699C63.1334 4.35078 62.8726 4.12209 62.3995 4.10192C61.9324 4.09519 61.2469 4.25658 60.24 4.61968C60.2096 4.58606 60.1186 4.56594 60.0944 4.50542C59.051 5.01645 57.8985 5.00291 56.7823 4.9155C55.6541 4.78774 54.5379 4.54571 53.355 4.44485C53.3672 4.64657 53.2701 4.78784 53.2095 4.68025L53.258 4.43812C51.6202 4.7138 50.7527 3.73207 49.1513 4.2431C49.1513 4.2431 49.3758 3.96746 49.3818 3.96074C46.8705 3.49006 43.9224 2.58906 40.8287 1.80235C37.7351 1.02909 34.4291 0.410515 31.4082 0.659304L31.4386 0.692957L31.4264 0.726446C31.7055 0.854202 32.5062 0.995518 33.2098 1.17707C33.5677 1.25775 33.9014 1.33161 34.144 1.40558C34.3866 1.47282 34.5504 1.51327 34.5504 1.51327C34.0469 1.74861 33.5435 1.85623 33.0339 1.88312C32.5304 1.89657 32.0148 1.8494 31.4932 1.77543C30.4559 1.61406 29.3579 1.42579 28.3146 1.61406L28.2842 1.29805C28.7392 1.23754 29.1638 1.15005 29.5217 1.04919C29.8735 0.955049 30.1586 0.88117 30.3164 0.800482C28.6664 0.67945 26.0519 0.948391 23.6923 2.12509C23.1039 2.42095 22.5215 2.71677 21.9999 3.09331C21.733 3.27486 21.4661 3.443 21.2173 3.63127C20.9747 3.83299 20.7381 4.02807 20.5076 4.22307L20.3378 4.37098C20.2832 4.41804 20.3499 4.371 20.3256 4.3979L20.2832 4.45831C20.2528 4.49865 20.2104 4.5391 20.1619 4.566C20.0709 4.62652 19.9495 4.64658 19.8343 4.62641C19.7736 4.74072 19.8768 4.73396 19.9495 4.76086C20.0284 4.78775 20.083 4.86173 20.1376 5.27862C19.9435 5.29879 19.7372 5.27194 19.5613 5.15763C19.3793 5.05677 19.2702 4.84832 19.1974 4.63987C19.6099 4.41125 19.5371 4.64658 19.622 4.62641C19.6341 4.57262 19.6341 4.49203 19.628 4.3979C19.6402 4.3979 19.6038 4.29702 19.5735 4.20961C19.5431 4.12219 19.5128 4.02795 19.4825 3.92709C19.4218 3.73209 19.3066 3.51022 19.2034 3.27488C19.1003 3.03954 18.9669 2.77738 18.7909 2.51514C18.706 2.38066 18.615 2.2461 18.524 2.09817C18.4149 1.96369 18.2996 1.82257 18.1783 1.68137C17.9538 1.38551 17.6263 1.13675 17.2987 0.867788C16.9408 0.639171 16.5586 0.403739 16.1219 0.269258C15.2666 -0.0333226 14.3446 -0.0535209 13.5014 0.0742355C12.6582 0.208716 11.8878 0.477703 11.1478 0.77356C9.66767 1.37872 8.33922 2.15199 7.08355 2.7975C5.83396 3.44973 4.68141 3.97428 3.71692 4.22307C2.75242 4.47186 2.0063 4.47184 1.44217 4.37771C0.884093 4.27685 0.483737 4.12879 0.295691 4.2431C0.119777 4.33051 0.15011 4.67346 0.677852 5.27862L0.435206 5.44672L0.447341 5.46691Z",
            fill: "#091E42",
            fillOpacity: "0.31"
        })
    });
const $988ed609811e697e$var$SquiggleOrange = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "64",
        height: "14",
        viewBox: "0 0 64 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M0.765963 6.17706C1.14511 6.3765 1.5549 6.3549 1.94172 6.27944C2.723 6.11235 3.4813 5.75126 4.32769 5.38473C4.53833 5.19607 4.57663 5.21768 4.50769 5.02903C4.55365 4.95896 4.63024 4.83499 4.57663 4.77031C4.38897 4.32832 4.9328 4.16113 5.13961 3.99943C5.20472 4.40908 5.54174 4.38758 6.00515 4.19353C6.13919 4.13963 6.18898 4.11272 6.31536 4.09655C6.45324 4.0696 6.59877 4.03717 6.75196 4.00483C7.05069 3.9617 7.38388 3.8971 7.69026 3.94561C8.00048 3.98334 8.29537 4.10722 8.52516 4.3875C8.75878 4.6624 8.92729 5.07205 9.05751 5.46553C9.18772 5.8644 9.28347 6.23631 9.38687 6.53816C9.48262 6.84 9.58219 7.03952 9.63198 7.1581C9.56687 7.3198 9.58219 7.56766 9.72773 7.74014C9.789 7.84795 9.89241 7.89114 9.99581 7.95043C10.1069 7.98816 10.2294 8.00438 10.352 7.99899C10.6048 7.97204 10.846 7.85336 11.0528 7.76173C11.2367 7.65392 11.409 7.58934 11.5392 7.59473C11.5239 7.64863 11.3592 7.90731 11.3401 7.95043C11.4818 8.0205 11.9873 7.73479 12.5618 7.2335C13.1363 6.72683 13.8026 6.03152 14.3809 5.36315C15.549 4.04257 16.4529 2.93757 15.8822 4.12339C16.3227 3.7892 16.7861 3.42817 17.2495 3.01852C17.3644 2.91611 17.4831 2.81366 17.6018 2.71125L17.6822 2.64111L17.7205 2.61426C17.7435 2.59809 17.7703 2.57649 17.7933 2.5711H17.8737C17.8737 2.5711 17.8929 2.58189 17.9159 2.58189L18.0116 2.5711C18.138 2.54954 18.2567 2.5711 18.3831 2.5711C18.8695 2.60344 19.3099 2.73275 19.6201 3.05616C19.9418 3.35801 20.2023 3.87544 20.5201 4.65161C20.681 5.03431 20.8572 5.47639 21.1214 5.95072C21.3818 6.41966 21.7916 6.9532 22.3163 7.21732C22.4465 7.27122 22.5767 7.33592 22.707 7.37365C22.8333 7.4006 22.9636 7.42223 23.0938 7.4384C23.3312 7.4384 23.584 7.43833 23.7946 7.37365C23.9019 7.3467 24.0168 7.32519 24.1202 7.28746L24.4189 7.16889C24.6257 7.09343 24.798 6.98562 24.9857 6.88859C26.4142 6.04774 27.5976 4.89418 28.7696 3.71374L29.501 2.95378L29.8725 2.75428C30.0142 2.67343 30.1406 2.65737 30.2747 2.60347C30.3436 2.57113 30.4011 2.5657 30.4585 2.5657L30.6308 2.54412C30.6883 2.53334 30.7228 2.56031 30.7725 2.56031C30.8185 2.5657 30.8683 2.56034 30.8989 2.59268C31.0483 2.63041 31.1823 2.79205 31.3662 3.06155C31.7262 3.59518 32.136 4.68943 32.9287 5.41171C33.1317 5.5788 33.3309 5.75132 33.553 5.84834C33.6602 5.90224 33.7713 5.96142 33.8785 6.00454L34.2155 6.09087L34.43 6.13929C34.5028 6.15007 34.5717 6.19321 34.6407 6.15548L35.039 6.03691L35.51 5.90216C38.0147 5.1691 40.4773 5.23917 42.5569 5.63265L42.4956 5.54106C42.5607 5.5734 42.7675 5.53025 42.8173 5.64344C43.2309 5.48713 43.9892 5.40086 44.6441 5.34157C45.299 5.27688 45.8505 5.27156 45.8505 5.27156L48.2135 5.10983C48.2135 5.10983 49.2284 5.28231 50.4578 5.37933C51.6872 5.47097 53.131 5.471 53.9544 5.14759C56.011 5.23384 58.0944 5.22839 60.1625 4.81874C60.1625 4.81874 60.3234 4.77564 60.5761 4.70557C60.8251 4.61394 61.1659 4.47381 61.5259 4.31749C61.8859 4.1504 62.2689 4.00488 62.5945 3.79467C62.92 3.57906 63.1996 3.37419 63.3643 3.2017C63.7779 2.77049 64 2.37159 64 2.09131C64 1.81102 63.7702 1.64933 63.2685 1.69784C63.0196 1.72479 62.7017 1.80023 62.3072 1.94576C61.9166 2.09668 61.4264 2.20997 60.8557 2.44174C60.8251 2.42018 60.7255 2.41472 60.7064 2.3716C59.5038 2.89983 58.2514 3.02379 56.9991 3.02918C56.3748 3.04535 55.7391 2.96996 55.1072 2.96457C54.4714 2.94301 53.828 2.88366 53.1769 2.90522C53.2076 3.06153 53.1195 3.18557 53.0429 3.10472L53.0735 2.91061C51.3157 3.23402 50.2433 2.51715 48.6003 3.06155C48.6003 3.06155 48.7956 2.81902 48.7995 2.81363C47.4131 2.73817 45.9041 2.59799 44.3033 2.51175C42.7062 2.40934 41.0211 2.37699 39.3054 2.50096C38.8764 2.54408 38.4475 2.5872 38.0147 2.63032C37.5858 2.68422 37.153 2.78673 36.7241 2.86758L36.0807 2.99694L35.4411 3.19091L34.8053 3.39041L34.5296 3.4766C34.5602 3.4766 34.5143 3.48738 34.5104 3.4766C34.499 3.4766 34.5104 3.47659 34.4836 3.46581L34.3879 3.44963C34.319 3.44963 34.2768 3.39579 34.2194 3.37962C34.1045 3.34728 34.0202 3.2448 33.9168 3.18012C33.7292 2.99686 33.53 2.69506 33.3002 2.28541C33.0666 1.88654 32.8177 1.34216 32.3619 0.824705C32.2662 0.695342 32.1168 0.58746 31.9943 0.474268C31.8679 0.355685 31.7223 0.280229 31.5768 0.210157C31.2819 0.037673 30.9947 0.0323407 30.7151 0C30.7266 0.00539012 30.7419 0.0215921 30.7572 0.0323723L30.7381 0.0592177C30.8415 0.0969485 30.9908 0.150871 31.1708 0.215552C31.347 0.269454 31.5653 0.442043 31.7798 0.592966C32.2087 0.970275 32.5266 1.54696 32.7411 2.0159C32.9632 2.50101 33.1164 2.87837 33.2504 3.14248C33.3845 3.38504 33.4726 3.53594 33.4726 3.52516C33.0475 3.33112 32.6951 2.78135 32.3274 2.19921C32.1321 1.91354 31.9406 1.60089 31.6726 1.36911C31.4198 1.11039 31.1057 0.975576 30.7955 0.905504C30.4891 0.856993 30.1713 0.857014 29.8802 0.927086C29.5662 0.964816 29.3172 1.0834 28.9993 1.19659L28.8653 1.25055C28.8232 1.2775 28.7849 1.3152 28.7427 1.35293L28.5398 1.52545L28.1989 1.8218C27.973 2.02662 27.7547 2.23153 27.5364 2.44174L27.4444 2.22066C27.8198 1.8703 28.153 1.48224 28.4249 1.16422L28.4747 1.105L28.5627 1.00788C28.6202 0.948593 28.6661 0.873226 28.7274 0.835496C28.8423 0.765424 28.9572 0.68991 29.0185 0.646789C29.1564 0.549766 29.2713 0.46354 29.3555 0.393469C29.2406 0.44198 29.1257 0.485106 29.0032 0.533617C28.9304 0.565958 28.8576 0.598262 28.7849 0.630602L28.647 0.695347C28.601 0.727688 28.5627 0.770788 28.5206 0.808519C28.31 1.00256 28.0917 1.20193 27.8619 1.41214C27.4483 1.78945 27.0002 2.18841 26.5291 2.58189C26.0619 2.97537 25.5678 3.38495 25.07 3.72453C24.5797 4.0695 24.0589 4.39288 23.6261 4.51147C23.4231 4.55998 23.2278 4.59775 23.1244 4.56002C23.0172 4.52768 22.9636 4.50069 22.8563 4.37671C22.7529 4.25813 22.6189 4.02097 22.4733 3.71374C22.3278 3.41189 22.1784 3.06159 21.9946 2.68967C21.6461 1.95661 21.1176 1.16432 20.4972 0.727719C19.8767 0.280339 19.2601 0.188602 18.7852 0.215552C18.8082 0.264063 18.9001 0.285698 19.0303 0.291088C19.1606 0.307258 19.3367 0.339557 19.5167 0.382678C19.6967 0.441969 19.8844 0.539007 20.0261 0.66837C20.1678 0.813904 20.2674 0.980961 20.2827 1.16961C19.8346 0.824647 19.3367 0.706106 18.881 0.673766L18.5401 0.662975L18.2146 0.700742C18.1074 0.711523 17.9963 0.716823 17.8967 0.743774C17.7742 0.770725 17.6516 0.792359 17.5329 0.819309C17.5137 0.716897 17.5444 0.646862 17.6056 0.587571C17.6363 0.56062 17.6746 0.533596 17.7167 0.512035C17.7512 0.490475 17.778 0.479647 17.8125 0.463477C17.9427 0.404186 18.0959 0.409618 18.1418 0.371887C18.0959 0.366497 18.0154 0.344921 17.9159 0.355701C17.8661 0.355701 17.8086 0.361101 17.7474 0.366492C17.6554 0.377272 17.5559 0.393479 17.4486 0.404259C17.3912 0.409649 17.3337 0.420456 17.2686 0.431236L17.1729 0.442027C17.1422 0.458197 17.1193 0.490475 17.0925 0.512035C16.9852 0.619838 16.8703 0.733104 16.7478 0.857077C16.6022 0.99722 16.4376 1.15347 16.2614 1.32595C15.5682 1.99972 14.6452 2.90526 13.5767 3.88626C13.0443 4.38215 12.4699 4.86722 11.8801 5.33078C11.7345 5.43858 11.5852 5.54104 11.4358 5.64884C11.2903 5.74047 11.1448 5.83211 10.9954 5.92374L10.7886 6.02073L10.6852 6.07468L10.6469 6.08547C10.5894 6.10703 10.5703 6.10705 10.5435 6.10166C10.486 6.10166 10.4516 6.02619 10.4362 5.95611L10.3213 5.4171C10.2677 5.15299 10.1988 4.83487 10.1069 4.50607C10.015 4.17188 9.88092 3.81077 9.70475 3.45502C9.60134 3.28254 9.50177 3.1047 9.38304 2.94838C9.25666 2.80285 9.1341 2.63574 8.9924 2.52794C8.42942 2.03744 7.83197 1.90813 7.35324 1.90813C6.84771 1.89195 6.43409 1.98891 5.98983 2.10749C5.92089 2.13444 5.8328 2.12913 5.75238 2.18303L5.53408 2.31238L5.25067 2.49556C5.07067 2.61954 4.89833 2.73821 4.73748 2.86219C4.08641 3.3473 3.50428 3.80542 2.96427 4.17195C2.4281 4.53848 1.93023 4.81872 1.54724 4.93731C1.35958 4.9966 1.20256 5.00744 1.11065 4.99666C1.02256 4.99127 0.968943 4.96964 0.903836 4.92652C0.796601 4.85105 0.666387 4.57084 0.589791 4.32289C0.501705 4.08033 0.451918 3.87554 0.386811 3.81085C0.325534 3.74078 0.271917 3.79461 0.222129 3.99943C0.172342 4.20964 0.126384 4.57079 0.19915 5.08825C0.134043 5.0559 0.061277 5.01819 0 4.96968C0.114894 5.51947 0.390641 6.00999 0.773622 6.19864L0.765963 6.17706Z",
            fill: "#091E42",
            fillOpacity: "0.31"
        })
    });
const $988ed609811e697e$var$Square = ({ color: color })=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
            width: "12",
            height: "12",
            fill: color
        })
    });
const $988ed609811e697e$var$GreyRectangle = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "17",
        height: "4",
        viewBox: "0 0 17 4",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M0.199219 0H16.1992V4H0.199219V0Z",
            fill: "#DCDFE4"
        })
    });
const $988ed609811e697e$var$IssueBlock = ({ color: color })=>{
    let SquiggleSvg;
    switch(color){
        case $988ed609811e697e$var$GREEN:
            SquiggleSvg = $988ed609811e697e$var$SquiggleGreen;
            break;
        case $988ed609811e697e$var$ORANGE:
            SquiggleSvg = $988ed609811e697e$var$SquiggleOrange;
            break;
        default:
            SquiggleSvg = $988ed609811e697e$var$SquiggleBlue;
    }
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
        xcss: $988ed609811e697e$var$issueBlockStyles,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1Lr0O.default), {
            direction: "column",
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)(SquiggleSvg, {}),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1Lr0O.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    xcss: $988ed609811e697e$var$issueIconMargin,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$Square, {
                            color: color
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$GreyRectangle, {})
                    ]
                })
            ]
        })
    });
};
const $988ed609811e697e$var$ColumnTitle = ({ title: title })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
        xcss: $988ed609811e697e$var$truncatedHeadingStyles,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
            xcss: $988ed609811e697e$var$columnTitleStyles,
            children: title.toUpperCase()
        })
    });
const $988ed609811e697e$var$VerticalLine = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
        xcss: $988ed609811e697e$var$verticalLineContainerStyles,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
            xcss: $988ed609811e697e$var$verticalLineStyles
        })
    });
const $988ed609811e697e$export$d8c0e51094505c67 = ({ columnNames: columnNames })=>columnNames.length >= (0, $kbfAN.MIN_COLUMNS_LEN) && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $257fv.default), {
        xcss: $988ed609811e697e$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $257fv.default), {
                xcss: $988ed609811e697e$var$columnStyles,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$ColumnTitle, {
                        title: columnNames[0]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$IssueBlock, {
                        color: $988ed609811e697e$var$BLUE
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$IssueBlock, {
                        color: $988ed609811e697e$var$ORANGE
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$VerticalLine, {}),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $257fv.default), {
                xcss: $988ed609811e697e$var$columnStyles,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$ColumnTitle, {
                        title: columnNames[1]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$IssueBlock, {
                        color: $988ed609811e697e$var$GREEN
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$IssueBlock, {
                        color: $988ed609811e697e$var$BLUE
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$VerticalLine, {}),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $257fv.default), {
                xcss: $988ed609811e697e$var$columnStyles,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$ColumnTitle, {
                        title: columnNames[2]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$IssueBlock, {
                        color: $988ed609811e697e$var$BLUE
                    })
                ]
            }),
            columnNames.length > (0, $kbfAN.MIN_COLUMNS_LEN) && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$VerticalLine, {}),
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $257fv.default), {
                        xcss: $988ed609811e697e$var$columnStyles,
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$ColumnTitle, {
                                title: columnNames[3]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$IssueBlock, {
                                color: $988ed609811e697e$var$GREEN
                            })
                        ]
                    })
                ]
            }),
            columnNames.length === (0, $kbfAN.MAX_COLUMNS_LEN) && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$VerticalLine, {}),
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $257fv.default), {
                        xcss: $988ed609811e697e$var$columnStyles,
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$ColumnTitle, {
                                title: columnNames[4]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)($988ed609811e697e$var$IssueBlock, {
                                color: $988ed609811e697e$var$GREEN
                            })
                        ]
                    })
                ]
            })
        ]
    });
const $988ed609811e697e$var$truncatedHeadingStyles = (0, $j7TVc.xcss)({
    width: "100%",
    maxWidth: "125.333px",
    minWidth: "72px",
    height: "16px",
    marginBlockEnd: "space.100",
    display: "flex"
});
const $988ed609811e697e$var$columnTitleStyles = (0, $j7TVc.xcss)({
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "12px",
    color: "color.text.subtle",
    minHeight: "20px",
    backgroundColor: "color.background.neutral",
    paddingInlineStart: "space.050",
    paddingInlineEnd: "space.050",
    borderRadius: "border.radius.050"
});
const $988ed609811e697e$var$issueBlockStyles = (0, $j7TVc.xcss)({
    maxWidth: "125.333px",
    minWidth: "72px",
    width: "100%",
    height: "60px",
    backgroundColor: "color.background.input.hovered",
    padding: "space.100",
    marginBlockEnd: "space.100",
    borderRadius: "border.radius.050"
});
const $988ed609811e697e$var$containerStyles = (0, $j7TVc.xcss)({
    width: "394px",
    height: "223px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "stretch"
});
const $988ed609811e697e$var$columnStyles = (0, $j7TVc.xcss)({
    flex: "1 1 125.333px",
    maxWidth: "125.333px",
    minWidth: "72px",
    height: "100%",
    display: "flex",
    flexDirection: "column"
});
const $988ed609811e697e$var$verticalLineContainerStyles = (0, $j7TVc.xcss)({
    height: "223px",
    width: "9px",
    paddingInlineStart: "space.050",
    paddingInlineEnd: "space.050",
    flexShrink: "0"
});
const $988ed609811e697e$var$verticalLineStyles = (0, $j7TVc.xcss)({
    height: "100%",
    borderInlineStart: `1px solid ${(0, $kwHar.default)("color.background.neutral")}`
});
const $988ed609811e697e$var$issueIconMargin = (0, $j7TVc.xcss)({
    marginBlockStart: "space.200"
});

});

parcelRegister("6Qct2", function(module, exports) {

$parcel$export(module.exports, "ProjectSvg", function () { return $0d8ec14194102134$export$d2631480a7cfad95; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");

var $257fv = parcelRequire("257fv");
var $6fxse = parcelRequire("6fxse");
var $agt8L = parcelRequire("agt8L");
var $j7TVc = parcelRequire("j7TVc");

var $kwHar = parcelRequire("kwHar");

var $lMCos = parcelRequire("lMCos");
const $0d8ec14194102134$var$tabNavList = [
    "board",
    "list",
    "timeline",
    "backlog"
];
const $0d8ec14194102134$export$d2631480a7cfad95 = ({ projectName: projectName, activeView: activeView, injections: injections })=>{
    const additionalObject = injections.additionalObject;
    const viewSvg = injections.svgBody;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "570",
        height: "416",
        viewBox: "0 0 570 416",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                clipPath: "url(#clip0_2056_22194)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        x: "212.766",
                        y: "20.3813",
                        width: "279.448",
                        height: "381.336",
                        transform: "rotate(-1.95711 212.766 20.3813)",
                        fill: "#FFA900"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "264",
                        height: "416",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M263.999 18.6309V400.19L225.789 401.496L212.766 20.3816L263.999 18.6309Z",
                        fill: "#09326C"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                width: "442",
                height: "331",
                transform: "translate(32 48)",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                x: "362",
                y: "76",
                width: "24",
                height: "16",
                fill: "#F1F2F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                x: "394",
                y: "76",
                width: "24",
                height: "16",
                fill: "#F1F2F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                x: "426",
                y: "76",
                width: "24",
                height: "16",
                fill: "#F1F2F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("foreignObject", {
                width: 150,
                height: 24,
                x: 56,
                y: 66,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                    xcss: $0d8ec14194102134$var$truncatedHeadingStyles,
                    children: projectName
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("foreignObject", {
                width: 220,
                height: 24,
                x: 56,
                y: 98,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6fxse.default), {
                    space: "space.200",
                    children: $0d8ec14194102134$var$tabNavList.map((nav)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $agt8L.default), {
                            color: nav === activeView ? "color.text" : "color.text.disabled",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                                xcss: $0d8ec14194102134$var$smallHeadingStyles,
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    ...(0, $lMCos.messages)[nav]
                                })
                            })
                        }, nav))
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("foreignObject", {
                width: 394,
                height: 223,
                x: 56,
                y: 132,
                children: viewSvg
            }),
            additionalObject
        ]
    });
};
const $0d8ec14194102134$var$smallHeadingStyles = (0, $j7TVc.xcss)({
    font: (0, $kwHar.default)("font.heading.xxsmall")
});
const $0d8ec14194102134$var$truncatedHeadingStyles = (0, $j7TVc.xcss)({
    width: "150px",
    height: "24px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    font: (0, $kwHar.default)("font.heading.small")
});

});
parcelRegister("lMCos", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $2758e5692da9c7ff$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $2758e5692da9c7ff$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    board: {
        id: "software-onboarding-modals.welcome-modal.wizards.right-hand-side.assets.board",
        defaultMessage: "Board",
        description: "Board tag on tab nav of svg in welcome wizards"
    },
    list: {
        id: "software-onboarding-modals.welcome-modal.wizards.right-hand-side.assets.list",
        defaultMessage: "List",
        description: "List tag on tab nav of svg in welcome wizards"
    },
    timeline: {
        id: "software-onboarding-modals.welcome-modal.wizards.right-hand-side.assets.timeline",
        defaultMessage: "Timeline",
        description: "Timeline tag on tab nav of svg in welcome wizards"
    },
    backlog: {
        id: "software-onboarding-modals.welcome-modal.wizards.right-hand-side.assets.backlog",
        defaultMessage: "Backlog",
        description: "Backlog tag on tab nav of svg in welcome wizards"
    }
});

});


parcelRegister("2VjDh", function(module, exports) {

$parcel$export(module.exports, "ColumnHighlight", function () { return $eb360345fa0b340f$export$71b903ec7baf8454; });

var $loA2J = parcelRequire("loA2J");
const $eb360345fa0b340f$export$71b903ec7baf8454 = /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
    transform: "translate(0 111)",
    children: [
        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M45.851 51.7403C46.1991 52.1264 37.5584 62.5931 32.8869 65.5867C33.2869 67.6696 32.2938 70.7258 30.1281 72.6693C31.0476 82.1743 38.4673 68.6973 40.7035 64.4331C37.6491 65.5887 43.8988 61.0488 44.0992 59.5144C43.6673 60.0082 52.2027 50.0358 47.9367 50.697C48.0177 50.1863 45.1567 51.5259 45.8491 51.7301L45.851 51.7403Z",
            fill: "#101214"
        }),
        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M16.1279 39.4332C14.3771 41.7816 11.7702 42.5246 8.73204 42.6129C2.35221 50.3699 19.0068 45.3171 23.028 44.0392C23.028 44.0392 30.1376 41.9468 29.5669 42.541C30.8121 43.1552 42.4358 42.187 39.0269 38.7542C37.0509 38.7228 33.6103 40.2264 32.6329 39.0867C29.8602 37.1014 20.6744 40.5616 16.1197 39.4453L16.1279 39.4332Z",
            fill: "#101214"
        }),
        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M19.0264 3.89086C13.4167 6.99094 24.8454 12.6867 28.1617 16.0215C28.1617 16.0215 31.4108 19.6641 32.9233 20.0795C32.4526 19.5483 44.7158 31.7839 41.0433 22.755C40.8191 22.6295 36.5803 18.3868 36.5803 18.3868C32.7046 11.2616 25.4345 6.75824 19.0163 3.89282L19.0264 3.89086Z",
            fill: "#101214"
        })
    ]
});

});



parcelRegister("kmspH", function(module, exports) {

$parcel$export(module.exports, "PageProjectDetails", function () { return $ee3d1adeeaf58464$export$82c51293e656c1d0; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $kbfAN = parcelRequire("kbfAN");

var $dWmS4 = parcelRequire("dWmS4");

var $hgNMu = parcelRequire("hgNMu");

var $hrj1e = parcelRequire("hrj1e");

var $bzdYo = parcelRequire("bzdYo");

var $10q7q = parcelRequire("10q7q");
const $ee3d1adeeaf58464$export$82c51293e656c1d0 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { teamType: teamType, projectDetails: { template: template } } = (0, $hrj1e.useWizardConfiguration)();
    (0, $iSvIT.useEffect)(()=>{
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: `${(0, $kbfAN.ANALYTICS_PREFIX)}ProjectDetails`,
            attributes: {
                teamType: teamType,
                template: template
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        template,
        teamType
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dWmS4.LeftHandSideWrapper), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bzdYo.LeftHandSidePageProjectDetails), {
                    ...props
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $hgNMu.RightHandSideWrapper), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $10q7q.RightHandSidePageProjectDetails), {
                    projectName: props.currentProjectName !== undefined ? props.currentProjectName : props.defaultProjectName
                })
            })
        ]
    });
};

});
parcelRegister("bzdYo", function(module, exports) {

$parcel$export(module.exports, "LeftHandSidePageProjectDetails", function () { return $d6fba09fcf2348d7$export$1e593b7e809d8526; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $6IiXU = parcelRequire("6IiXU");

var $6oKbD = parcelRequire("6oKbD");
var $hGQlB = parcelRequire("hGQlB");
var $26kkA = parcelRequire("26kkA");
var $kzsvd = parcelRequire("kzsvd");
var $gsk9h = parcelRequire("gsk9h");

var $gf1F9 = parcelRequire("gf1F9");

var $257fv = parcelRequire("257fv");
var $1Lr0O = parcelRequire("1Lr0O");
var $jXVyf = parcelRequire("jXVyf");
var $agt8L = parcelRequire("agt8L");
var $j7TVc = parcelRequire("j7TVc");

var $7OGW4 = parcelRequire("7OGW4");

var $adCEi = parcelRequire("adCEi");

var $acVcb = parcelRequire("acVcb");
const $d6fba09fcf2348d7$export$1e593b7e809d8526 = ({ onClickNext: onClickNext, currentProjectName: currentProjectName, onProjectNameChange: onProjectNameChange, defaultProjectName: defaultProjectName })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const handleOnSubmit = ()=>{
        onClickNext();
    };
    const validateProjectName = (0, $iSvIT.useCallback)((value1)=>{
        // If the project name is undefined, we don't need to validate it since we use the default project name
        if (value1 === undefined) return;
        const trimmedValueLength = value1?.trim().length ?? 0;
        if (trimmedValueLength < (0, $adCEi.JIRA_MIN_PROJECT_NAME_LENGTH)) return formatMessage((0, $acVcb.default).projectNameMinCharacterLengthError, {
            _minCharacters: (0, $adCEi.JIRA_MIN_PROJECT_NAME_LENGTH),
            get minCharacters () {
                return this["_minCharacters"];
            },
            set minCharacters (value){
                this["_minCharacters"] = value;
            }
        });
        if (trimmedValueLength > (0, $adCEi.JIRA_MAX_PROJECT_NAME_LENGTH)) return formatMessage((0, $acVcb.default).projectNameMaxCharacterLengthError, {
            maxCharacters: (0, $adCEi.JIRA_MAX_PROJECT_NAME_LENGTH)
        });
    }, [
        formatMessage
    ]);
    const handleProjectNameChanged = (0, $iSvIT.useCallback)((onChange)=>(e)=>{
            onProjectNameChange(e.currentTarget.value);
            onChange(e);
        }, [
        onProjectNameChange
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1Lr0O.default), {
        xcss: $d6fba09fcf2348d7$var$containerStyles,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6oKbD.default), {
            onSubmit: handleOnSubmit,
            children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $loA2J.jsx)("form", {
                    ...formProps,
                    noValidate: true,
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                        spread: "space-between",
                        xcss: $d6fba09fcf2348d7$var$containerStyles,
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                                        space: "space.150",
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                                                size: "xxlarge",
                                                children: formatMessage((0, $acVcb.default).title)
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                                                xcss: $d6fba09fcf2348d7$var$subtextStyles,
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                                    ...(0, $acVcb.default).bodyLineOne
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $gsk9h.default), {
                                        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                                            space: "space.300",
                                            children: [
                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $26kkA.default), {
                                                    name: (0, $adCEi.PROJECT_NAME_TEXT_FIELD),
                                                    label: formatMessage((0, $acVcb.default).projectFormField),
                                                    validate: validateProjectName,
                                                    children: ({ fieldProps: fieldProps, error: error, meta: meta })=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OGW4.default), {
                                                                    ...fieldProps,
                                                                    autoComplete: "off",
                                                                    defaultValue: defaultProjectName,
                                                                    value: currentProjectName,
                                                                    onChange: handleProjectNameChanged(fieldProps.onChange)
                                                                }),
                                                                fieldProps.isInvalid && meta.touched && /*#__PURE__*/ (0, $loA2J.jsx)((0, $hGQlB.ErrorMessage), {
                                                                    children: error
                                                                })
                                                            ]
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                                                    xcss: $d6fba09fcf2348d7$var$projectExampleStyles,
                                                    space: "space.100",
                                                    children: [
                                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $agt8L.default), {
                                                            color: "color.text.subtlest",
                                                            as: "strong",
                                                            children: formatMessage((0, $acVcb.default).projectExampleHeading)
                                                        }),
                                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $agt8L.default), {
                                                            color: "color.text.subtlest",
                                                            as: "p",
                                                            children: formatMessage((0, $acVcb.default).projectExamples)
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kzsvd.default), {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6IiXU.default), {
                                    type: "submit",
                                    appearance: "primary",
                                    children: formatMessage((0, $acVcb.default).getStartedBtn)
                                })
                            })
                        ]
                    })
                })
        })
    });
};
const $d6fba09fcf2348d7$var$containerStyles = (0, $j7TVc.xcss)({
    height: "100%"
});
const $d6fba09fcf2348d7$var$subtextStyles = (0, $j7TVc.xcss)({
    fontSize: "font.body.medium",
    color: "color.text.subtle"
});
const $d6fba09fcf2348d7$var$projectExampleStyles = (0, $j7TVc.xcss)({
    backgroundColor: "color.background.input.hovered",
    borderRadius: "border.radius.100",
    padding: "space.100"
});

});
parcelRegister("adCEi", function(module, exports) {

$parcel$export(module.exports, "PROJECT_NAME_TEXT_FIELD", function () { return $05eb32a12049a79e$export$cf1c76ae53135501; });
$parcel$export(module.exports, "JIRA_MIN_PROJECT_NAME_LENGTH", function () { return $05eb32a12049a79e$export$fccd8398ac81f07b; });
$parcel$export(module.exports, "JIRA_MAX_PROJECT_NAME_LENGTH", function () { return $05eb32a12049a79e$export$80e9f1c4b157a4b9; });
const $05eb32a12049a79e$export$cf1c76ae53135501 = "project-name-text-field";
const $05eb32a12049a79e$export$fccd8398ac81f07b = 2;
const $05eb32a12049a79e$export$80e9f1c4b157a4b9 = 80;

});

parcelRegister("acVcb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13ea71ef4ed714d7$export$2e2bcd8739ae039; });

var $6x1qA = parcelRequire("6x1qA");
var $13ea71ef4ed714d7$export$2e2bcd8739ae039 = (0, $6x1qA.defineMessages)({
    title: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.title",
        defaultMessage: "Name your first project",
        description: "Title for page one of the modal. This modal is introduced to admins of a TMP project, to explain the hierarchy of Epics and Issues when they first land on the Board."
    },
    bodyLineOne: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.body-line-one",
        defaultMessage: "Projects bring your work to life, helping your team track progress, stay organized, and manage tasks.",
        description: "The main text content within page one of the modal. This modal is introduced to admins of a TMP project, to explain the hierarchy of Epics and Issues when they first land on the Board."
    },
    getStartedBtn: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.get-started-btn",
        defaultMessage: "Get started",
        description: "Button to create issues and get started"
    },
    projectNamePlaceholder: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.project-name-placeholder",
        defaultMessage: "e.g. {projectName}",
        description: 'Short form of "example" followed by the project name to be used as the placeholder text'
    },
    projectFormField: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.project-form-field",
        defaultMessage: "Name your project",
        description: "The label for the project name field within the project name and icon form."
    },
    projectNameMinCharacterLengthError: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.min-character-length-error",
        defaultMessage: "Too short (min. {minCharacters} {minCharacters, plural, one {character} other {characters}})",
        description: "Error that shows when the user has not typed enough characters for their project or space name."
    },
    projectNameMaxCharacterLengthError: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.max-character-length-error",
        defaultMessage: "Too long (max. {maxCharacters} {maxCharacters, plural, one {character} other {characters}})",
        description: "Error that shows when the user has typed too many characters for their project or space name."
    },
    projectExampleHeading: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-one.project-example-heading",
        defaultMessage: "Example project names:",
        description: "Title of a section that contains examples of what to name Jira projects."
    },
    projectExamples: {
        id: "onboarding-wizard.welcome-modal.left-hand-side.page-oneproject-examples",
        defaultMessage: "Team Astro, Visual upgrade, Bug tracking, Product launch",
        description: "Some examples of Jira project names that customer can use to help them name their project."
    }
});

});


parcelRegister("10q7q", function(module, exports) {

$parcel$export(module.exports, "RightHandSidePageProjectDetails", function () { return $c7e83f25b7df16da$export$d8e94b72deee7913; });

var $loA2J = parcelRequire("loA2J");

var $1Lr0O = parcelRequire("1Lr0O");
var $j7TVc = parcelRequire("j7TVc");

var $32FfR = parcelRequire("32FfR");

var $6Qct2 = parcelRequire("6Qct2");

var $68XDU = parcelRequire("68XDU");
const $c7e83f25b7df16da$export$d8e94b72deee7913 = ({ projectName: projectName })=>{
    const injections = {
        additionalObject: (0, $68XDU.HeaderArrow),
        svgBody: (0, $32FfR.BoardSvgStatic)
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1Lr0O.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $c7e83f25b7df16da$var$containerStyles,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6Qct2.ProjectSvg), {
            projectName: projectName,
            activeView: "board",
            injections: injections
        })
    });
};
const $c7e83f25b7df16da$var$containerStyles = (0, $j7TVc.xcss)({
    height: "100%",
    backgroundColor: "elevation.surface"
});

});
parcelRegister("32FfR", function(module, exports) {

$parcel$export(module.exports, "BoardSvgStatic", function () { return $812c02f28d867eb3$export$7787fe29d9c4706c; });

var $loA2J = parcelRequire("loA2J");
const $812c02f28d867eb3$export$7787fe29d9c4706c = /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
    width: "394",
    height: "223",
    viewBox: "0 0 394 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    children: [
        /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
            clipPath: "url(#clip0_2248_14874)",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                    y: "8",
                    width: "44",
                    height: "16",
                    rx: "3",
                    fill: "#091E42",
                    fillOpacity: "0.06"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M7.13281 20V13.5869H4.80713V12.2495H11.0806V13.5869H8.75488V20H7.13281ZM15.6353 20.1987C14.869 20.1987 14.2065 20.034 13.6479 19.7046C13.0894 19.3716 12.6579 18.9007 12.3535 18.292C12.0527 17.6833 11.9023 16.9618 11.9023 16.1274V16.1167C11.9023 15.2788 12.0545 14.5573 12.3589 13.9521C12.6668 13.3434 13.1001 12.8743 13.6587 12.5449C14.2173 12.2155 14.8761 12.0508 15.6353 12.0508C16.3979 12.0508 17.0568 12.2155 17.6118 12.5449C18.1704 12.8743 18.6019 13.3434 18.9062 13.9521C19.2106 14.5609 19.3628 15.2824 19.3628 16.1167V16.1274C19.3628 16.9618 19.2106 17.6833 18.9062 18.292C18.6055 18.9007 18.1758 19.3716 17.6172 19.7046C17.0586 20.034 16.3979 20.1987 15.6353 20.1987ZM15.6353 18.8237C16.0542 18.8237 16.4194 18.7127 16.731 18.4907C17.0425 18.2687 17.2824 17.9554 17.4507 17.5508C17.6226 17.1462 17.7085 16.6717 17.7085 16.1274V16.1167C17.7085 15.5688 17.6226 15.0944 17.4507 14.6934C17.2824 14.2887 17.0425 13.9772 16.731 13.7588C16.4194 13.5368 16.0542 13.4258 15.6353 13.4258C15.2163 13.4258 14.8511 13.5368 14.5396 13.7588C14.228 13.9772 13.9863 14.2887 13.8145 14.6934C13.6426 15.0944 13.5566 15.5688 13.5566 16.1167V16.1274C13.5566 16.6717 13.6408 17.1462 13.8091 17.5508C13.981 17.9554 14.2209 18.2687 14.5288 18.4907C14.8403 18.7127 15.2091 18.8237 15.6353 18.8237ZM23.7402 20V12.2495H26.791C27.5609 12.2495 28.2161 12.3999 28.7568 12.7007C29.2975 12.9979 29.7111 13.4312 29.9976 14.0005C30.284 14.5698 30.4272 15.2591 30.4272 16.0684V16.0791C30.4272 16.9134 30.284 17.6224 29.9976 18.2061C29.7147 18.7897 29.3029 19.2355 28.7622 19.5435C28.2215 19.8478 27.5645 20 26.791 20H23.7402ZM25.3623 18.6626H26.5332C27.013 18.6626 27.4194 18.5641 27.7524 18.3672C28.0854 18.1702 28.3379 17.882 28.5098 17.5024C28.6852 17.1193 28.7729 16.6538 28.7729 16.106V16.0952C28.7729 15.5617 28.6834 15.1087 28.5044 14.7363C28.3289 14.3604 28.0729 14.0757 27.7363 13.8823C27.4033 13.6854 27.0023 13.5869 26.5332 13.5869H25.3623V18.6626ZM35.3579 20.1987C34.5916 20.1987 33.9292 20.034 33.3706 19.7046C32.812 19.3716 32.3805 18.9007 32.0762 18.292C31.7754 17.6833 31.625 16.9618 31.625 16.1274V16.1167C31.625 15.2788 31.7772 14.5573 32.0815 13.9521C32.3895 13.3434 32.8228 12.8743 33.3813 12.5449C33.9399 12.2155 34.5988 12.0508 35.3579 12.0508C36.1206 12.0508 36.7795 12.2155 37.3345 12.5449C37.8931 12.8743 38.3245 13.3434 38.6289 13.9521C38.9333 14.5609 39.0854 15.2824 39.0854 16.1167V16.1274C39.0854 16.9618 38.9333 17.6833 38.6289 18.292C38.3281 18.9007 37.8984 19.3716 37.3398 19.7046C36.7812 20.034 36.1206 20.1987 35.3579 20.1987ZM35.3579 18.8237C35.7769 18.8237 36.1421 18.7127 36.4536 18.4907C36.7651 18.2687 37.005 17.9554 37.1733 17.5508C37.3452 17.1462 37.4312 16.6717 37.4312 16.1274V16.1167C37.4312 15.5688 37.3452 15.0944 37.1733 14.6934C37.005 14.2887 36.7651 13.9772 36.4536 13.7588C36.1421 13.5368 35.7769 13.4258 35.3579 13.4258C34.939 13.4258 34.5737 13.5368 34.2622 13.7588C33.9507 13.9772 33.709 14.2887 33.5371 14.6934C33.3652 15.0944 33.2793 15.5688 33.2793 16.1167V16.1274C33.2793 16.6717 33.3634 17.1462 33.5317 17.5508C33.7036 17.9554 33.9435 18.2687 34.2515 18.4907C34.563 18.7127 34.9318 18.8237 35.3579 18.8237Z",
                    fill: "#44546F"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                    y: "32",
                    width: "125.333",
                    height: "60",
                    rx: "4",
                    fill: "#F8F8F8"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M71.9947 46.7086C60.9658 49.286 52.8283 42.6911 41.6895 48.1009C41.1695 45.7839 39.8253 42.8824 37.8131 42.8399C39.4913 42.893 42.1756 48.9459 39.4786 44.8911C37.8934 41.8036 30.9649 45.5767 36.2744 42.8931C32.6093 43.4617 29.2487 47.2188 26.7715 50.5614C22.6499 55.3229 25.7781 46.1081 22.7979 41.4741C18.5748 35.0333 5.75779 51.7837 8.34065 51.7943C9.98505 49.6952 12.1917 48.3879 13.1048 46.0603C29.181 32.2806 17.5814 57.7834 27.1562 53.5108C42.797 35.7986 34.8921 51.8315 44.0737 50.7368C49.4254 44.3172 72.1807 54.3823 71.9989 46.7086H71.9947Z",
                    fill: "#091E42",
                    fillOpacity: "0.31"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                    x: "8",
                    y: "69",
                    width: "12",
                    height: "12",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M101.333 73H117.333V77H101.333V73Z",
                    fill: "#DCDFE4"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                    y: "100",
                    width: "125.333",
                    height: "60",
                    rx: "4",
                    fill: "#F8F8F8"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M8.76596 117.177C9.14511 117.376 9.5549 117.355 9.94172 117.279C10.723 117.112 11.4813 116.751 12.3277 116.385C12.5383 116.196 12.5766 116.218 12.5077 116.029C12.5536 115.959 12.6302 115.835 12.5766 115.77C12.389 115.328 12.9328 115.161 13.1396 114.999C13.2047 115.409 13.5417 115.388 14.0051 115.194C14.1392 115.14 14.189 115.113 14.3154 115.097C14.4532 115.07 14.5988 115.037 14.752 115.005C15.0507 114.962 15.3839 114.897 15.6903 114.946C16.0005 114.983 16.2954 115.107 16.5252 115.388C16.7588 115.662 16.9273 116.072 17.0575 116.466C17.1877 116.864 17.2835 117.236 17.3869 117.538C17.4826 117.84 17.5822 118.04 17.632 118.158C17.5669 118.32 17.5822 118.568 17.7277 118.74C17.789 118.848 17.8924 118.891 17.9958 118.95C18.1069 118.988 18.2294 119.004 18.352 118.999C18.6048 118.972 18.846 118.853 19.0528 118.762C19.2367 118.654 19.409 118.589 19.5392 118.595C19.5239 118.649 19.3592 118.907 19.3401 118.95C19.4818 119.021 19.9873 118.735 20.5618 118.234C21.1363 117.727 21.8026 117.032 22.3809 116.363C23.549 115.043 24.4529 113.938 23.8822 115.123C24.3227 114.789 24.7861 114.428 25.2495 114.019C25.3644 113.916 25.4831 113.814 25.6018 113.711L25.6822 113.641L25.7205 113.614C25.7435 113.598 25.7703 113.576 25.7933 113.571H25.8737C25.8737 113.571 25.8929 113.582 25.9159 113.582L26.0116 113.571C26.138 113.55 26.2567 113.571 26.3831 113.571C26.8695 113.603 27.3099 113.733 27.6201 114.056C27.9418 114.358 28.2023 114.875 28.5201 115.652C28.681 116.034 28.8572 116.476 29.1214 116.951C29.3818 117.42 29.7916 117.953 30.3163 118.217C30.4465 118.271 30.5767 118.336 30.707 118.374C30.8333 118.401 30.9636 118.422 31.0938 118.438C31.3312 118.438 31.584 118.438 31.7946 118.374C31.9019 118.347 32.0168 118.325 32.1202 118.287L32.4189 118.169C32.6257 118.093 32.798 117.986 32.9857 117.889C34.4142 117.048 35.5976 115.894 36.7696 114.714L37.501 113.954L37.8725 113.754C38.0142 113.673 38.1406 113.657 38.2747 113.603C38.3436 113.571 38.4011 113.566 38.4585 113.566L38.6308 113.544C38.6883 113.533 38.7228 113.56 38.7725 113.56C38.8185 113.566 38.8683 113.56 38.8989 113.593C39.0483 113.63 39.1823 113.792 39.3662 114.062C39.7262 114.595 40.136 115.689 40.9287 116.412C41.1317 116.579 41.3309 116.751 41.553 116.848C41.6602 116.902 41.7713 116.961 41.8785 117.005L42.2155 117.091L42.43 117.139C42.5028 117.15 42.5717 117.193 42.6407 117.155L43.039 117.037L43.51 116.902C46.0147 116.169 48.4773 116.239 50.5569 116.633L50.4956 116.541C50.5607 116.573 50.7675 116.53 50.8173 116.643C51.2309 116.487 51.9892 116.401 52.6441 116.342C53.299 116.277 53.8505 116.272 53.8505 116.272L56.2135 116.11C56.2135 116.11 57.2284 116.282 58.4578 116.379C59.6872 116.471 61.131 116.471 61.9544 116.148C64.011 116.234 66.0944 116.228 68.1625 115.819C68.1625 115.819 68.3234 115.776 68.5761 115.706C68.8251 115.614 69.1659 115.474 69.5259 115.317C69.8859 115.15 70.2689 115.005 70.5945 114.795C70.92 114.579 71.1996 114.374 71.3643 114.202C71.7779 113.77 72 113.372 72 113.091C72 112.811 71.7702 112.649 71.2685 112.698C71.0196 112.725 70.7017 112.8 70.3072 112.946C69.9166 113.097 69.4264 113.21 68.8557 113.442C68.8251 113.42 68.7255 113.415 68.7064 113.372C67.5038 113.9 66.2514 114.024 64.9991 114.029C64.3748 114.045 63.7391 113.97 63.1072 113.965C62.4714 113.943 61.828 113.884 61.1769 113.905C61.2076 114.062 61.1195 114.186 61.0429 114.105L61.0735 113.911C59.3157 114.234 58.2433 113.517 56.6003 114.062C56.6003 114.062 56.7956 113.819 56.7995 113.814C55.4131 113.738 53.9041 113.598 52.3033 113.512C50.7062 113.409 49.0211 113.377 47.3054 113.501C46.8764 113.544 46.4475 113.587 46.0147 113.63C45.5858 113.684 45.153 113.787 44.7241 113.868L44.0807 113.997L43.4411 114.191L42.8053 114.39L42.5296 114.477C42.5602 114.477 42.5143 114.487 42.5104 114.477C42.499 114.477 42.5104 114.477 42.4836 114.466L42.3879 114.45C42.319 114.45 42.2768 114.396 42.2194 114.38C42.1045 114.347 42.0202 114.245 41.9168 114.18C41.7292 113.997 41.53 113.695 41.3002 113.285C41.0666 112.887 40.8177 112.342 40.3619 111.825C40.2662 111.695 40.1168 111.587 39.9943 111.474C39.8679 111.356 39.7223 111.28 39.5768 111.21C39.2819 111.038 38.9947 111.032 38.7151 111C38.7266 111.005 38.7419 111.022 38.7572 111.032L38.7381 111.059C38.8415 111.097 38.9908 111.151 39.1708 111.216C39.347 111.269 39.5653 111.442 39.7798 111.593C40.2087 111.97 40.5266 112.547 40.7411 113.016C40.9632 113.501 41.1164 113.878 41.2504 114.142C41.3845 114.385 41.4726 114.536 41.4726 114.525C41.0475 114.331 40.6951 113.781 40.3274 113.199C40.1321 112.914 39.9406 112.601 39.6726 112.369C39.4198 112.11 39.1057 111.976 38.7955 111.906C38.4891 111.857 38.1713 111.857 37.8802 111.927C37.5662 111.965 37.3172 112.083 36.9993 112.197L36.8653 112.251C36.8232 112.277 36.7849 112.315 36.7427 112.353L36.5398 112.525L36.1989 112.822C35.973 113.027 35.7547 113.232 35.5364 113.442L35.4444 113.221C35.8198 112.87 36.153 112.482 36.4249 112.164L36.4747 112.105L36.5627 112.008C36.6202 111.949 36.6661 111.873 36.7274 111.835C36.8423 111.765 36.9572 111.69 37.0185 111.647C37.1564 111.55 37.2713 111.464 37.3555 111.393C37.2406 111.442 37.1257 111.485 37.0032 111.534C36.9304 111.566 36.8576 111.598 36.7849 111.631L36.647 111.695C36.601 111.728 36.5627 111.771 36.5206 111.809C36.31 112.003 36.0917 112.202 35.8619 112.412C35.4483 112.789 35.0002 113.188 34.5291 113.582C34.0619 113.975 33.5678 114.385 33.07 114.725C32.5797 115.069 32.0589 115.393 31.6261 115.511C31.4231 115.56 31.2278 115.598 31.1244 115.56C31.0172 115.528 30.9636 115.501 30.8563 115.377C30.7529 115.258 30.6189 115.021 30.4733 114.714C30.3278 114.412 30.1784 114.062 29.9946 113.69C29.6461 112.957 29.1176 112.164 28.4972 111.728C27.8767 111.28 27.2601 111.189 26.7852 111.216C26.8082 111.264 26.9001 111.286 27.0303 111.291C27.1606 111.307 27.3367 111.34 27.5167 111.383C27.6967 111.442 27.8844 111.539 28.0261 111.668C28.1678 111.814 28.2674 111.981 28.2827 112.17C27.8346 111.825 27.3367 111.706 26.881 111.674L26.5401 111.663L26.2146 111.701C26.1074 111.712 25.9963 111.717 25.8967 111.744C25.7742 111.771 25.6516 111.792 25.5329 111.819C25.5137 111.717 25.5444 111.647 25.6056 111.588C25.6363 111.561 25.6746 111.534 25.7167 111.512C25.7512 111.49 25.778 111.48 25.8125 111.463C25.9427 111.404 26.0959 111.41 26.1418 111.372C26.0959 111.366 26.0154 111.345 25.9159 111.356C25.8661 111.356 25.8086 111.361 25.7474 111.366C25.6554 111.377 25.5559 111.393 25.4486 111.404C25.3912 111.41 25.3337 111.42 25.2686 111.431L25.1729 111.442C25.1422 111.458 25.1193 111.49 25.0925 111.512C24.9852 111.62 24.8703 111.733 24.7478 111.857C24.6022 111.997 24.4376 112.153 24.2614 112.326C23.5682 113 22.6452 113.905 21.5767 114.886C21.0443 115.382 20.4699 115.867 19.8801 116.331C19.7345 116.439 19.5852 116.541 19.4358 116.649C19.2903 116.74 19.1448 116.832 18.9954 116.924L18.7886 117.021L18.6852 117.075L18.6469 117.085C18.5894 117.107 18.5703 117.107 18.5435 117.102C18.486 117.102 18.4516 117.026 18.4362 116.956L18.3213 116.417C18.2677 116.153 18.1988 115.835 18.1069 115.506C18.015 115.172 17.8809 114.811 17.7047 114.455C17.6013 114.283 17.5018 114.105 17.383 113.948C17.2567 113.803 17.1341 113.636 16.9924 113.528C16.4294 113.037 15.832 112.908 15.3532 112.908C14.8477 112.892 14.4341 112.989 13.9898 113.107C13.9209 113.134 13.8328 113.129 13.7524 113.183L13.5341 113.312L13.2507 113.496C13.0707 113.62 12.8983 113.738 12.7375 113.862C12.0864 114.347 11.5043 114.805 10.9643 115.172C10.4281 115.538 9.93023 115.819 9.54724 115.937C9.35958 115.997 9.20256 116.007 9.11065 115.997C9.02256 115.991 8.96894 115.97 8.90384 115.927C8.7966 115.851 8.66639 115.571 8.58979 115.323C8.50171 115.08 8.45192 114.876 8.38681 114.811C8.32553 114.741 8.27192 114.795 8.22213 114.999C8.17234 115.21 8.12638 115.571 8.19915 116.088C8.13404 116.056 8.06128 116.018 8 115.97C8.11489 116.519 8.39064 117.01 8.77362 117.199L8.76596 117.177Z",
                    fill: "#091E42",
                    fillOpacity: "0.31"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                    x: "8",
                    y: "137",
                    width: "12",
                    height: "12",
                    fill: "#FFA900"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M101.333 141H117.333V145H101.333V141Z",
                    fill: "#DCDFE4"
                })
            ]
        }),
        /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
            x: "129.333",
            width: "1",
            height: "223",
            fill: "#F0F1F2"
        }),
        /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
            clipPath: "url(#clip1_2248_14874)",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                    x: "134.333",
                    y: "8",
                    width: "85",
                    height: "16",
                    rx: "3",
                    fill: "#091E42",
                    fillOpacity: "0.06"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M139.665 20V12.2495H141.287V20H139.665ZM143.167 20V12.2495H144.521L148.511 17.7603L147.378 17.1855H148.184V12.2495H149.736V20H148.393L144.392 14.4678L145.531 15.0425H144.719V20H143.167ZM155.268 17.5562V16.2886H157.256C157.721 16.2886 158.083 16.1704 158.341 15.9341C158.602 15.6942 158.733 15.354 158.733 14.9136V14.9028C158.733 14.4624 158.602 14.124 158.341 13.8877C158.083 13.6514 157.721 13.5332 157.256 13.5332H155.268V12.2495H157.653C158.197 12.2495 158.674 12.3605 159.082 12.5825C159.49 12.8009 159.807 13.1089 160.032 13.5063C160.262 13.9038 160.376 14.3675 160.376 14.8975V14.9082C160.376 15.4417 160.262 15.9072 160.032 16.3047C159.807 16.7021 159.49 17.0101 159.082 17.2285C158.674 17.4469 158.197 17.5562 157.653 17.5562H155.268ZM154.457 20V12.2495H156.079V20H154.457ZM161.869 20V12.2495H165.097C165.685 12.2495 166.184 12.3498 166.596 12.5503C167.011 12.7472 167.326 13.0301 167.541 13.3989C167.76 13.7677 167.869 14.2064 167.869 14.7148V14.7256C167.869 15.2233 167.745 15.6709 167.498 16.0684C167.255 16.4622 166.911 16.7469 166.467 16.9224L168.1 20H166.263L164.818 17.1641C164.807 17.1641 164.795 17.1641 164.781 17.1641C164.766 17.1641 164.754 17.1641 164.743 17.1641H163.491V20H161.869ZM163.491 15.9824H164.92C165.325 15.9824 165.64 15.875 165.865 15.6602C166.095 15.4417 166.209 15.141 166.209 14.7578V14.7471C166.209 14.3711 166.093 14.0721 165.86 13.8501C165.627 13.6281 165.307 13.5171 164.899 13.5171H163.491V15.9824ZM172.896 20.1987C172.13 20.1987 171.468 20.034 170.909 19.7046C170.35 19.3716 169.919 18.9007 169.615 18.292C169.314 17.6833 169.163 16.9618 169.163 16.1274V16.1167C169.163 15.2788 169.316 14.5573 169.62 13.9521C169.928 13.3434 170.361 12.8743 170.92 12.5449C171.478 12.2155 172.137 12.0508 172.896 12.0508C173.659 12.0508 174.318 12.2155 174.873 12.5449C175.431 12.8743 175.863 13.3434 176.167 13.9521C176.472 14.5609 176.624 15.2824 176.624 16.1167V16.1274C176.624 16.9618 176.472 17.6833 176.167 18.292C175.866 18.9007 175.437 19.3716 174.878 19.7046C174.32 20.034 173.659 20.1987 172.896 20.1987ZM172.896 18.8237C173.315 18.8237 173.68 18.7127 173.992 18.4907C174.303 18.2687 174.543 17.9554 174.712 17.5508C174.884 17.1462 174.969 16.6717 174.969 16.1274V16.1167C174.969 15.5688 174.884 15.0944 174.712 14.6934C174.543 14.2887 174.303 13.9772 173.992 13.7588C173.68 13.5368 173.315 13.4258 172.896 13.4258C172.477 13.4258 172.112 13.5368 171.801 13.7588C171.489 13.9772 171.247 14.2887 171.075 14.6934C170.904 15.0944 170.818 15.5688 170.818 16.1167V16.1274C170.818 16.6717 170.902 17.1462 171.07 17.5508C171.242 17.9554 171.482 18.2687 171.79 18.4907C172.101 18.7127 172.47 18.8237 172.896 18.8237ZM181.538 20.1987C180.962 20.1987 180.444 20.1056 179.986 19.9194C179.528 19.7297 179.137 19.4593 178.815 19.1084C178.497 18.7539 178.251 18.326 178.079 17.8247C177.907 17.3198 177.822 16.7523 177.822 16.1221V16.1113C177.822 15.2806 177.972 14.5627 178.273 13.9575C178.573 13.3488 179 12.8797 179.551 12.5503C180.102 12.2173 180.752 12.0508 181.501 12.0508C182.113 12.0508 182.661 12.16 183.144 12.3784C183.628 12.5968 184.022 12.9012 184.326 13.2915C184.634 13.6818 184.825 14.1348 184.901 14.6504L184.911 14.7041H183.3L183.289 14.6504C183.182 14.2637 182.971 13.9629 182.656 13.748C182.34 13.5332 181.955 13.4258 181.501 13.4258C181.085 13.4258 180.726 13.535 180.421 13.7534C180.12 13.9683 179.888 14.2762 179.723 14.6772C179.558 15.0747 179.476 15.5474 179.476 16.0952V16.106C179.476 16.5249 179.524 16.9027 179.621 17.2393C179.718 17.5723 179.857 17.8569 180.04 18.0933C180.222 18.3296 180.443 18.5104 180.7 18.6357C180.958 18.7611 181.247 18.8237 181.565 18.8237C181.92 18.8237 182.233 18.7557 182.505 18.6196C182.777 18.4836 182.99 18.2938 183.144 18.0503C183.298 17.8068 183.381 17.5221 183.391 17.1963L183.397 17.0513H181.721V15.8696H184.976V16.8525C184.976 17.3646 184.897 17.8265 184.74 18.2383C184.582 18.6501 184.353 19.0028 184.052 19.2964C183.751 19.5864 183.388 19.8102 182.962 19.9678C182.539 20.1217 182.065 20.1987 181.538 20.1987ZM186.533 20V12.2495H189.761C190.349 12.2495 190.848 12.3498 191.26 12.5503C191.675 12.7472 191.99 13.0301 192.205 13.3989C192.424 13.7677 192.533 14.2064 192.533 14.7148V14.7256C192.533 15.2233 192.409 15.6709 192.162 16.0684C191.919 16.4622 191.575 16.7469 191.131 16.9224L192.764 20H190.927L189.482 17.1641C189.471 17.1641 189.459 17.1641 189.445 17.1641C189.43 17.1641 189.418 17.1641 189.407 17.1641H188.156V20H186.533ZM188.156 15.9824H189.584C189.989 15.9824 190.304 15.875 190.53 15.6602C190.759 15.4417 190.873 15.141 190.873 14.7578V14.7471C190.873 14.3711 190.757 14.0721 190.524 13.8501C190.291 13.6281 189.971 13.5171 189.563 13.5171H188.156V15.9824ZM194.171 20V12.2495H199.306V13.5869H195.793V15.4561H199.107V16.7021H195.793V18.6626H199.306V20H194.171ZM203.785 20.1987C203.17 20.1987 202.634 20.1056 202.179 19.9194C201.725 19.7332 201.367 19.4718 201.105 19.1353C200.847 18.7951 200.702 18.3958 200.67 17.9375L200.665 17.8516H202.228L202.233 17.9053C202.255 18.0986 202.333 18.2687 202.469 18.4155C202.609 18.5588 202.795 18.6715 203.028 18.7539C203.261 18.8363 203.528 18.8774 203.828 18.8774C204.118 18.8774 204.373 18.8345 204.591 18.7485C204.809 18.6626 204.98 18.5444 205.101 18.394C205.227 18.2401 205.289 18.0646 205.289 17.8677V17.8623C205.289 17.6081 205.185 17.404 204.978 17.25C204.774 17.096 204.43 16.9689 203.947 16.8687L203.13 16.7021C202.324 16.5374 201.739 16.2671 201.374 15.8911C201.009 15.5151 200.826 15.0335 200.826 14.4463V14.4409C200.826 13.9611 200.953 13.5422 201.207 13.1841C201.462 12.826 201.811 12.5485 202.255 12.3516C202.699 12.151 203.207 12.0508 203.78 12.0508C204.382 12.0508 204.897 12.1493 205.327 12.3462C205.76 12.5396 206.099 12.8063 206.342 13.1465C206.586 13.4831 206.723 13.868 206.756 14.3013L206.761 14.3711H205.236L205.225 14.3066C205.193 14.1204 205.114 13.9575 204.989 13.8179C204.867 13.6782 204.702 13.569 204.494 13.4902C204.29 13.4079 204.052 13.3667 203.78 13.3667C203.515 13.3667 203.282 13.4061 203.082 13.4849C202.881 13.5636 202.726 13.6746 202.615 13.8179C202.503 13.9575 202.448 14.124 202.448 14.3174V14.3228C202.448 14.5734 202.548 14.7793 202.749 14.9404C202.953 15.098 203.282 15.2233 203.737 15.3164L204.559 15.4829C205.107 15.5939 205.552 15.7443 205.896 15.9341C206.244 16.1239 206.5 16.362 206.664 16.6484C206.829 16.9349 206.911 17.2804 206.911 17.6851V17.6904C206.911 18.2025 206.784 18.6465 206.53 19.0225C206.279 19.3949 205.92 19.6849 205.45 19.8926C204.985 20.0967 204.43 20.1987 203.785 20.1987ZM211.219 20.1987C210.603 20.1987 210.068 20.1056 209.613 19.9194C209.158 19.7332 208.8 19.4718 208.539 19.1353C208.281 18.7951 208.136 18.3958 208.104 17.9375L208.098 17.8516H209.661L209.667 17.9053C209.688 18.0986 209.767 18.2687 209.903 18.4155C210.043 18.5588 210.229 18.6715 210.462 18.7539C210.694 18.8363 210.961 18.8774 211.262 18.8774C211.552 18.8774 211.806 18.8345 212.025 18.7485C212.243 18.6626 212.413 18.5444 212.535 18.394C212.66 18.2401 212.723 18.0646 212.723 17.8677V17.8623C212.723 17.6081 212.619 17.404 212.411 17.25C212.207 17.096 211.864 16.9689 211.38 16.8687L210.564 16.7021C209.758 16.5374 209.173 16.2671 208.807 15.8911C208.442 15.5151 208.26 15.0335 208.26 14.4463V14.4409C208.26 13.9611 208.387 13.5422 208.641 13.1841C208.895 12.826 209.244 12.5485 209.688 12.3516C210.132 12.151 210.641 12.0508 211.214 12.0508C211.815 12.0508 212.331 12.1493 212.76 12.3462C213.194 12.5396 213.532 12.8063 213.776 13.1465C214.019 13.4831 214.157 13.868 214.189 14.3013L214.195 14.3711H212.669L212.658 14.3066C212.626 14.1204 212.547 13.9575 212.422 13.8179C212.3 13.6782 212.136 13.569 211.928 13.4902C211.724 13.4079 211.486 13.3667 211.214 13.3667C210.949 13.3667 210.716 13.4061 210.515 13.4849C210.315 13.5636 210.159 13.6746 210.048 13.8179C209.937 13.9575 209.882 14.124 209.882 14.3174V14.3228C209.882 14.5734 209.982 14.7793 210.182 14.9404C210.386 15.098 210.716 15.2233 211.171 15.3164L211.992 15.4829C212.54 15.5939 212.986 15.7443 213.33 15.9341C213.677 16.1239 213.933 16.362 214.098 16.6484C214.263 16.9349 214.345 17.2804 214.345 17.6851V17.6904C214.345 18.2025 214.218 18.6465 213.964 19.0225C213.713 19.3949 213.353 19.6849 212.884 19.8926C212.419 20.0967 211.864 20.1987 211.219 20.1987Z",
                    fill: "#44546F"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                    x: "134.333",
                    y: "32",
                    width: "125.333",
                    height: "60",
                    rx: "4",
                    fill: "#F8F8F8"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M142.581 48.4669C143.249 48.9241 143.964 49.126 144.698 49.2537C145.438 49.3815 146.209 49.4151 147.101 49.4151C147.319 49.3008 147.361 49.3411 147.295 49.0856C147.343 49.0251 147.422 48.9174 147.367 48.8233C147.179 48.2249 147.719 48.2989 147.926 48.1913C148.089 49.1999 149.363 48.7427 150.546 47.9022C151.729 47.0684 152.912 45.9657 153.264 45.8581C153.712 46.665 154.55 45.3201 155.071 45.589C155.053 45.6361 154.938 45.8849 154.926 45.9319C155.18 46.1807 156.564 45.3336 157.746 45.5555C158.329 45.6564 158.85 45.9655 159.045 46.2412C159.263 46.4967 159.202 46.591 158.747 46.517L158.893 46.7994C158.935 46.9002 158.978 47.0078 159.02 47.1154L159.148 47.4247C159.184 47.539 159.22 47.6533 159.257 47.7676L159.372 48.1105C159.402 48.2316 159.433 48.3593 159.463 48.4804C159.469 48.5207 159.518 48.6484 159.554 48.7627L159.675 49.1057C159.76 49.3276 159.869 49.5429 159.997 49.7446C160.519 50.5447 161.447 51.0557 162.417 50.9952C162.902 50.9683 163.394 50.8204 163.831 50.5245C164.14 50.3026 164.449 50.0874 164.759 49.8588C165.214 49.5025 165.723 49.247 166.215 48.9175C166.469 48.7763 166.73 48.6552 166.991 48.514L167.385 48.3055L167.792 48.1374C168.871 47.6399 170.042 47.3238 171.249 47.1019C173.664 46.6649 176.242 46.8263 178.626 47.2969C181.022 47.7811 183.236 48.5476 185.086 49.489L185.049 49.3613C185.104 49.4151 185.304 49.4084 185.322 49.5563C186.172 49.3882 188.271 49.6369 188.271 49.6369C189.023 49.684 189.781 49.7177 190.539 49.7446C190.539 49.7446 191.467 50.0739 192.626 50.3026C193.778 50.5513 195.168 50.6388 195.974 50.3227C197.915 50.6119 199.911 50.7262 201.913 50.4774C201.913 50.4774 202.526 50.2959 203.211 50.0269C203.884 49.7109 204.624 49.3143 204.891 48.9175C205.231 48.4603 205.377 48.0165 205.322 47.687C205.267 47.3508 205.007 47.1221 204.533 47.1019C204.066 47.0952 203.381 47.2566 202.374 47.6197C202.344 47.5861 202.253 47.5659 202.228 47.5054C201.185 48.0164 200.033 48.0029 198.916 47.9155C197.788 47.7877 196.672 47.5457 195.489 47.4448C195.501 47.6466 195.404 47.7878 195.343 47.6803L195.392 47.4381C193.754 47.7138 192.887 46.7321 191.285 47.2431C191.285 47.2431 191.51 46.9675 191.516 46.9607C189.005 46.4901 186.056 45.5891 182.963 44.8024C179.869 44.0291 176.563 43.4105 173.542 43.6593L173.573 43.693L173.56 43.7264C173.839 43.8542 174.64 43.9955 175.344 44.1771C175.702 44.2578 176.035 44.3316 176.278 44.4056C176.521 44.4728 176.684 44.5133 176.684 44.5133C176.181 44.7486 175.678 44.8562 175.168 44.8831C174.664 44.8966 174.149 44.8494 173.627 44.7754C172.59 44.6141 171.492 44.4258 170.449 44.6141L170.418 44.2981C170.873 44.2375 171.298 44.15 171.656 44.0492C172.008 43.955 172.293 43.8812 172.45 43.8005C170.8 43.6794 168.186 43.9484 165.826 45.1251C165.238 45.421 164.656 45.7168 164.134 46.0933C163.867 46.2749 163.6 46.443 163.351 46.6313C163.109 46.833 162.872 47.0281 162.642 47.2231L162.472 47.371C162.417 47.418 162.484 47.371 162.46 47.3979L162.417 47.4583C162.387 47.4987 162.344 47.5391 162.296 47.566C162.205 47.6265 162.084 47.6466 161.968 47.6264C161.908 47.7407 162.011 47.734 162.084 47.7609C162.162 47.7878 162.217 47.8617 162.272 48.2786C162.078 48.2988 161.871 48.2719 161.695 48.1576C161.513 48.0568 161.404 47.8483 161.331 47.6399C161.744 47.4113 161.671 47.6466 161.756 47.6264C161.768 47.5726 161.768 47.492 161.762 47.3979C161.774 47.3979 161.738 47.297 161.707 47.2096C161.677 47.1222 161.647 47.0279 161.617 46.9271C161.556 46.7321 161.441 46.5102 161.337 46.2749C161.234 46.0395 161.101 45.7774 160.925 45.5151C160.84 45.3807 160.749 45.2461 160.658 45.0982C160.549 44.9637 160.434 44.8226 160.312 44.6814C160.088 44.3855 159.76 44.1367 159.433 43.8678C159.075 43.6392 158.693 43.4037 158.256 43.2693C157.401 42.9667 156.479 42.9465 155.635 43.0742C154.792 43.2087 154.022 43.4777 153.282 43.7736C151.802 44.3787 150.473 45.152 149.218 45.7975C147.968 46.4497 146.815 46.9743 145.851 47.2231C144.886 47.4719 144.14 47.4718 143.576 47.3777C143.018 47.2768 142.618 47.1288 142.43 47.2431C142.254 47.3305 142.284 47.6735 142.812 48.2786L142.569 48.4467L142.581 48.4669Z",
                    fill: "#091E42",
                    fillOpacity: "0.31"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                    x: "142.333",
                    y: "69",
                    width: "12",
                    height: "12",
                    fill: "#82B536"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M235.667 73H251.667V77H235.667V73Z",
                    fill: "#DCDFE4"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                    x: "134.333",
                    y: "100",
                    width: "125.333",
                    height: "60",
                    rx: "4",
                    fill: "#F8F8F8"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M204.862 117.693C199.566 116.176 203.645 106.31 191.901 111.49C191.901 111.49 192.026 111.198 192.026 111.193C187.049 112.772 180.323 120.588 175.209 116.306C174.995 116.987 176.386 118.048 177.057 118.087C174.089 118.744 174.609 115.163 173.645 113.079C174.324 113.113 174.409 114.928 174.813 115.345C174.093 105.945 160.466 112.556 163.301 112.532C162.71 112.83 160.275 114.481 161.408 113.315C154.57 116.498 149.483 121.735 145.822 111.572C144.822 110.377 140.437 110.597 143.276 111.486L143.08 111.654C146.39 112.172 145.217 114.337 146.884 116.363C145.746 120.233 152.549 118.999 154.357 118.567C153.144 120.381 160.542 114.841 159.271 116.426C179.572 104.486 166.709 127.957 187.334 116.997L187.236 116.963C191.319 113.286 199.912 108.442 201.125 117.424C201.499 119.359 206.955 119.493 204.853 117.693H204.862Z",
                    fill: "#091E42",
                    fillOpacity: "0.31"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                    x: "142.333",
                    y: "137",
                    width: "12",
                    height: "12",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M235.667 141H251.667V145H235.667V141Z",
                    fill: "#DCDFE4"
                })
            ]
        }),
        /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
            x: "263.667",
            width: "1",
            height: "223",
            fill: "#F0F1F2"
        }),
        /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
            clipPath: "url(#clip2_2248_14874)",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                    x: "268.667",
                    y: "8",
                    width: "41",
                    height: "16",
                    rx: "3",
                    fill: "#091E42",
                    fillOpacity: "0.06"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M274.015 20V12.2495H277.066C277.836 12.2495 278.491 12.3999 279.031 12.7007C279.572 12.9979 279.986 13.4312 280.272 14.0005C280.559 14.5698 280.702 15.2591 280.702 16.0684V16.0791C280.702 16.9134 280.559 17.6224 280.272 18.2061C279.989 18.7897 279.578 19.2355 279.037 19.5435C278.496 19.8478 277.839 20 277.066 20H274.015ZM275.637 18.6626H276.808C277.288 18.6626 277.694 18.5641 278.027 18.3672C278.36 18.1702 278.613 17.882 278.784 17.5024C278.96 17.1193 279.048 16.6538 279.048 16.106V16.0952C279.048 15.5617 278.958 15.1087 278.779 14.7363C278.604 14.3604 278.348 14.0757 278.011 13.8823C277.678 13.6854 277.277 13.5869 276.808 13.5869H275.637V18.6626ZM285.633 20.1987C284.866 20.1987 284.204 20.034 283.645 19.7046C283.087 19.3716 282.655 18.9007 282.351 18.292C282.05 17.6833 281.9 16.9618 281.9 16.1274V16.1167C281.9 15.2788 282.052 14.5573 282.356 13.9521C282.664 13.3434 283.097 12.8743 283.656 12.5449C284.215 12.2155 284.873 12.0508 285.633 12.0508C286.395 12.0508 287.054 12.2155 287.609 12.5449C288.168 12.8743 288.599 13.3434 288.904 13.9521C289.208 14.5609 289.36 15.2824 289.36 16.1167V16.1274C289.36 16.9618 289.208 17.6833 288.904 18.292C288.603 18.9007 288.173 19.3716 287.615 19.7046C287.056 20.034 286.395 20.1987 285.633 20.1987ZM285.633 18.8237C286.052 18.8237 286.417 18.7127 286.728 18.4907C287.04 18.2687 287.28 17.9554 287.448 17.5508C287.62 17.1462 287.706 16.6717 287.706 16.1274V16.1167C287.706 15.5688 287.62 15.0944 287.448 14.6934C287.28 14.2887 287.04 13.9772 286.728 13.7588C286.417 13.5368 286.052 13.4258 285.633 13.4258C285.214 13.4258 284.848 13.5368 284.537 13.7588C284.225 13.9772 283.984 14.2887 283.812 14.6934C283.64 15.0944 283.554 15.5688 283.554 16.1167V16.1274C283.554 16.6717 283.638 17.1462 283.806 17.5508C283.978 17.9554 284.218 18.2687 284.526 18.4907C284.838 18.7127 285.206 18.8237 285.633 18.8237ZM290.902 20V12.2495H292.255L296.246 17.7603L295.113 17.1855H295.918V12.2495H297.47V20H296.128L292.126 14.4678L293.265 15.0425H292.454V20H290.902ZM299.356 20V12.2495H304.49V13.5869H300.978V15.4561H304.292V16.7021H300.978V18.6626H304.49V20H299.356Z",
                    fill: "#44546F"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                    x: "268.667",
                    y: "32",
                    width: "125.333",
                    height: "60",
                    rx: "4",
                    fill: "#F8F8F8"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M340.188 49.6931C334.808 48.176 338.951 38.3103 327.022 43.4904C327.022 43.4904 327.148 43.1976 327.148 43.1928C322.093 44.7723 315.259 52.5879 310.064 48.3056C309.847 48.9873 311.26 50.0483 311.942 50.0867C308.926 50.7444 309.455 47.163 308.475 45.0795C309.166 45.1131 309.251 46.9278 309.662 47.3454C308.931 37.9455 295.088 44.5562 297.967 44.5322C297.367 44.8299 294.893 46.4813 296.044 45.3147C289.098 48.4976 283.93 53.7354 280.211 43.5721C279.195 42.3767 274.74 42.5974 277.624 43.4856L277.426 43.6537C280.788 44.1721 279.597 46.3373 281.289 48.3633C280.134 52.2327 287.044 50.9988 288.881 50.5667C287.649 52.3814 295.164 46.8414 293.873 48.4256C314.496 36.486 301.429 59.9571 322.382 48.9969L322.282 48.9634C326.43 45.286 335.16 40.4419 336.392 49.4242C336.771 51.3589 342.314 51.4934 340.179 49.6931H340.188Z",
                    fill: "#091E42",
                    fillOpacity: "0.31"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                    x: "276.667",
                    y: "69",
                    width: "12",
                    height: "12",
                    fill: "#1868DB"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M370 73H386V77H370V73Z",
                    fill: "#DCDFE4"
                })
            ]
        }),
        /*#__PURE__*/ (0, $loA2J.jsxs)("defs", {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip0_2248_14874",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "125.333",
                        height: "223",
                        fill: "white"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip1_2248_14874",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "125.333",
                        height: "223",
                        fill: "white",
                        transform: "translate(134.333)"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip2_2248_14874",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "125.333",
                        height: "223",
                        fill: "white",
                        transform: "translate(268.667)"
                    })
                })
            ]
        })
    ]
});

});

parcelRegister("68XDU", function(module, exports) {

$parcel$export(module.exports, "HeaderArrow", function () { return $fbbfa43aa714b0d5$export$543942cb6490b677; });

var $loA2J = parcelRequire("loA2J");
const $fbbfa43aa714b0d5$export$543942cb6490b677 = /*#__PURE__*/ (0, $loA2J.jsx)("g", {
    transform: "translate(208 58)",
    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
        d: "M0.63677 29.461C0.510995 27.3554 8.77769 16.1704 10.2198 19.2047C8.13881 21.6898 6.7368 25.1785 5.14959 27.3829C5.21174 27.3762 5.16254 27.4709 5.16577 27.5687C5.63836 27.3785 6.60653 27.5734 7.01724 27.2155C10.0122 27.2469 12.6641 26.0293 15.5819 25.5525C15.635 25.9435 15.8748 25.7719 15.7001 25.5372C17.7479 25.5869 31.0338 21.8195 33.9459 17.937C19.8593 16.4584 36.1756 0.6226 37.8027 14.7589C41.0538 13.8939 44.3624 11.8452 46.4344 9.15073C48.312 6.78389 49.0548 4.04803 49.4375 2.41556C49.7679 0.779853 50.1374 0.209025 50.5703 1.98947L50.8266 1.82945C50.813 3.67253 50.6171 5.17526 50.3173 7.18855C50.1684 7.43334 49.1525 7.805 48.9926 8.02056C49.4561 8.16335 49.516 8.5758 49.3311 9.13245C49.1115 9.67194 48.6471 10.3556 48.0247 10.9454C46.8117 12.1736 45.1184 12.9889 44.8093 13.2553C45.2338 14.1095 43.4118 14.2587 43.2098 14.7842C43.2586 14.7993 43.5701 14.85 43.6128 14.8632C43.5751 15.2456 41.5916 16.049 39.8803 16.3808C38.9433 16.583 38.2414 16.6509 37.7309 16.7908C37.7905 17.3776 37.031 18.9973 36.3223 20.0191C34.2705 22.7779 28.0419 26.0908 28.0385 26.2318C25.9808 26.4311 23.6763 27.0194 21.7111 27.1567C17.8831 28.464 6.07315 29.8248 5.08006 29.6674C5.49872 29.9772 6.1325 30.2823 6.82298 30.5983C6.82298 30.5983 8.30762 31.2624 8.59188 31.4017C8.63134 31.317 8.70399 31.3846 8.76913 31.3465C9.29932 31.9878 10.65 32.3716 10.7219 33.0268L12.8995 33.7171C17.47 38.4516 3.07232 31.8714 1.30204 29.989L1.34227 29.9884C1.34227 29.9884 0.667665 29.3608 0.634951 29.4669L0.63677 29.461ZM34.9335 15.7933C34.7802 14.3186 35.5364 16.5668 35.1724 17.12C36.329 17.7218 36.0077 13.3469 34.6394 12.3052C33.4301 10.8992 35.4156 15.1603 33.9811 12.5998C29.4986 10.9604 32.79 16.7477 34.9335 15.7933Z",
        fill: "#101214"
    })
});

});



parcelRegister("dmnHD", function(module, exports) {

$parcel$export(module.exports, "PageWorkTypes", function () { return $03185899057bcde8$export$8f0833ce93bd222c; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $g9kzu = parcelRequire("g9kzu");

var $kbfAN = parcelRequire("kbfAN");

var $dWmS4 = parcelRequire("dWmS4");

var $hgNMu = parcelRequire("hgNMu");

var $hrj1e = parcelRequire("hrj1e");

var $45jab = parcelRequire("45jab");

var $EsCxi = parcelRequire("EsCxi");
const $03185899057bcde8$export$8f0833ce93bd222c = ({ defaultIssueTypes: defaultIssueTypes, onClickNext: onClickNext, projectName: projectName, selectedIssueTypes: selectedIssueTypes, onToggleIssueType: onToggleIssueType })=>{
    const issueTypeIcons = selectedIssueTypes.length === 0 ? [
        "Task"
    ] : selectedIssueTypes.map((issueType)=>issueType.icon);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { teamType: teamType, projectDetails: { template: template } } = (0, $hrj1e.useWizardConfiguration)();
    (0, $iSvIT.useEffect)(()=>{
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: `${(0, $kbfAN.ANALYTICS_PREFIX)}WorkTypes`,
            attributes: {
                teamType: teamType,
                template: template
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        teamType,
        template
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dWmS4.LeftHandSideWrapper), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $45jab.LeftHandSidePageWorkTypes), {
                    selectedIssueTypes: selectedIssueTypes,
                    onToggleIssueType: onToggleIssueType,
                    defaultIssueTypes: defaultIssueTypes,
                    onClickNext: onClickNext
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $hgNMu.RightHandSideWrapper), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $EsCxi.RightHandSidePageWorkTypes), {
                    projectName: projectName,
                    issueTypesIcons: issueTypeIcons
                })
            })
        ]
    });
};

});
parcelRegister("45jab", function(module, exports) {

$parcel$export(module.exports, "LeftHandSidePageWorkTypes", function () { return $64b6339258a5f855$export$48ad94500a77f89; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $3XfGP = parcelRequire("3XfGP");

var $hGQlB = parcelRequire("hGQlB");
var $kzsvd = parcelRequire("kzsvd");

var $gf1F9 = parcelRequire("gf1F9");

var $257fv = parcelRequire("257fv");
var $1Lr0O = parcelRequire("1Lr0O");
var $bZyGC = parcelRequire("bZyGC");
var $jXVyf = parcelRequire("jXVyf");
var $j7TVc = parcelRequire("j7TVc");

var $4HOGp = parcelRequire("4HOGp");

var $lxH7j = parcelRequire("lxH7j");
const $64b6339258a5f855$export$48ad94500a77f89 = ({ defaultIssueTypes: defaultIssueTypes, selectedIssueTypes: selectedIssueTypes, onToggleIssueType: onToggleIssueType, onClickNext: onClickNext })=>{
    const { formatMessage: formatMessage } = (0, $f6qj2.default)();
    const [showError, setShowError] = (0, $iSvIT.useState)(false);
    const handleNextClick = ()=>{
        if (selectedIssueTypes.length === 0) setShowError(true);
        else {
            setShowError(false);
            onClickNext();
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1Lr0O.default), {
        direction: "column",
        justifyContent: "space-between",
        xcss: $64b6339258a5f855$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jXVyf.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $gf1F9.default), {
                        as: "h1",
                        size: "xlarge",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            ...(0, $lxH7j.default).chooseWorkTypes
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        xcss: $64b6339258a5f855$var$subtextStyles,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            ...(0, $lxH7j.default).workTypesDescription
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        xcss: $64b6339258a5f855$var$scrollableContainerStyles,
                        role: "list",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jXVyf.default), {
                            space: "space.050",
                            children: defaultIssueTypes.map((option)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                                    xcss: [
                                        $64b6339258a5f855$var$pressStyles,
                                        selectedIssueTypes.includes(option) ? $64b6339258a5f855$var$activePressStyles : undefined
                                    ],
                                    testId: option.id,
                                    onClick: ()=>{
                                        onToggleIssueType(option);
                                        setShowError(false);
                                    },
                                    onKeyDown: (e)=>{
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            onToggleIssueType(option);
                                            setShowError(false);
                                        }
                                    },
                                    role: "listitem",
                                    tabIndex: 0,
                                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1Lr0O.default), {
                                        alignItems: "center",
                                        columnGap: "space.300",
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1Lr0O.default), {
                                                alignItems: "center",
                                                justifyContent: "center",
                                                xcss: $64b6339258a5f855$var$iconStyles,
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4HOGp.IssueTypeIcon), {
                                                    type: option.icon
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1Lr0O.default), {
                                                direction: "column",
                                                alignItems: "start",
                                                children: [
                                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                                                        as: "span",
                                                        id: `option-name-${option.name}`,
                                                        children: formatMessage(option.name)
                                                    }),
                                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                                                        xcss: $64b6339258a5f855$var$descriptionStyles,
                                                        id: `option-description-${option.name}`,
                                                        children: formatMessage(option.description)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, option.id))
                        })
                    }),
                    showError && /*#__PURE__*/ (0, $loA2J.jsx)((0, $hGQlB.ErrorMessage), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            ...(0, $lxH7j.default).issueTypeValidation
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $257fv.default), {
                        as: "p",
                        xcss: $64b6339258a5f855$var$subtextStyles,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            ...(0, $lxH7j.default).addMoreWorkTypesLater
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kzsvd.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1Lr0O.default), {
                    justifyContent: "space-between",
                    alignItems: "center",
                    xcss: $64b6339258a5f855$var$footerStyles,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            ...(0, $lxH7j.default).step
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $3XfGP.default), {
                            type: "submit",
                            appearance: "primary",
                            isLoading: false,
                            onClick: handleNextClick,
                            "aria-labelledby": "next-button step-label",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                ...(0, $lxH7j.default).nextButtonCta
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const $64b6339258a5f855$var$containerStyles = (0, $j7TVc.xcss)({
    height: "100%"
});
const $64b6339258a5f855$var$scrollableContainerStyles = (0, $j7TVc.xcss)({
    [(0, $bZyGC.media).above.sm]: {
        maxHeight: "360px",
        overflowY: "auto"
    }
});
const $64b6339258a5f855$var$pressStyles = (0, $j7TVc.xcss)({
    "border": "2px solid",
    "borderRadius": "border.radius.200",
    "borderColor": "color.border",
    "backgroundColor": "elevation.surface",
    "maxWidth": "420px",
    "minHeight": "64px",
    "padding": "space.050",
    ":hover": {
        borderColor: "color.border.focused"
    }
});
const $64b6339258a5f855$var$subtextStyles = (0, $j7TVc.xcss)({
    fontSize: "font.body.small",
    color: "color.text.subtle",
    margin: "space.0"
});
const $64b6339258a5f855$var$activePressStyles = (0, $j7TVc.xcss)({
    borderColor: "color.border.focused",
    borderWidth: "border.width.indicator"
});
const $64b6339258a5f855$var$iconStyles = (0, $j7TVc.xcss)({
    paddingInlineStart: "space.150"
});
const $64b6339258a5f855$var$descriptionStyles = (0, $j7TVc.xcss)({
    fontSize: "font.body.small",
    color: "color.text.subtle"
});
const $64b6339258a5f855$var$footerStyles = (0, $j7TVc.xcss)({
    width: "100%",
    color: "color.text.subtlest"
});

});
parcelRegister("4HOGp", function(module, exports) {

$parcel$export(module.exports, "IssueTypeIcon", function () { return $4254d130fabc42c8$export$f315b19fd9da0750; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");
const $4254d130fabc42c8$export$74ec5b47d9335d78 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            clipRule: "evenodd",
            d: "M16 2.75C16 2.33579 15.6642 2 15.25 2H0.75C0.335787 2 0 2.33579 0 2.75V13.25C0 13.6642 0.335787 14 0.75 14H15.25C15.6642 14 16 13.6642 16 13.25V2.75ZM14.5 3.5V12.5H1.5V3.5H14.5ZM4 7V4.5H2.5V7H4ZM10.5 8C10.5 6.52948 9.5452 5 8 5C6.4548 5 5.5 6.52948 5.5 8C5.5 9.47052 6.4548 11 8 11C9.5452 11 10.5 9.47052 10.5 8ZM8 6.5C8.38779 6.5 9 6.98524 9 8C9 9.01476 8.38779 9.5 8 9.5C7.61221 9.5 7 9.01476 7 8C7 6.98524 7.61221 6.5 8 6.5ZM13.5 11.5V9H12V11.5H13.5Z",
            fill: "#6A9A23",
            fillRule: "evenodd"
        })
    });
const $4254d130fabc42c8$export$7ecb76505f3f02fe = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            clipRule: "evenodd",
            d: "M1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5H3ZM12.3262 5.48014L7.32617 11.4801C7.18367 11.6511 6.97258 11.75 6.75 11.75C6.52742 11.75 6.31633 11.6511 6.17383 11.4801L3.67383 8.48014L4.82617 7.51986L6.75 9.82846L11.1738 4.51986L12.3262 5.48014Z",
            fill: "#4688EC",
            fillRule: "evenodd"
        })
    });
const $4254d130fabc42c8$export$eae503ee066bc00 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            clipRule: "evenodd",
            d: "M4.98291 2.5C4.70677 2.5 4.48291 2.72386 4.48291 3V12.8059L8.00015 10.3332L11.5179 12.806V3C11.5179 2.72386 11.294 2.5 11.0179 2.5H4.98291ZM2.98291 3C2.98291 1.89543 3.87834 1 4.98291 1H11.0179C12.1225 1 13.0179 1.89543 13.0179 3V14.25C13.0179 14.5299 12.862 14.7866 12.6136 14.9156C12.3652 15.0446 12.0656 15.0236 11.8366 14.8626L8.00015 12.1658L4.1642 14.8626C3.9352 15.0236 3.6356 15.0446 3.38718 14.9156C3.13875 14.7866 2.98291 14.5299 2.98291 14.25V3Z",
            fill: "#6A9A23",
            fillRule: "evenodd"
        })
    });
const $4254d130fabc42c8$export$6a890007100de1ac = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            clipRule: "evenodd",
            d: "M8 2.5C7.17157 2.5 6.5 3.17157 6.5 4H9.5C9.5 3.17157 8.82843 2.5 8 2.5ZM11 4.02074V4C11 2.34315 9.65685 1 8 1C6.34315 1 5 2.34315 5 4V4.02074C4.70952 4.06947 4.44734 4.2017 4.239 4.39189L3.35231 3.75855L2.43536 1.6954L1.06464 2.3046L2.00928 4.43004C2.0999 4.63393 2.24344 4.80985 2.425 4.93953L3.75 5.88596V7H0.5V8.5H3.75V9.64872L2.60021 10.6069C2.46773 10.7173 2.35953 10.8539 2.28241 11.0081L1.07918 13.4146L2.42082 14.0854L3.60066 11.7257L4.06124 11.3419C4.69682 12.9183 6.23827 14 8.00146 14H8.25C9.96908 14 11.4349 12.9156 12.0006 11.3934L12.3993 11.7257L13.5791 14.0854L14.9208 13.4146L13.7176 11.0081C13.6405 10.8539 13.5323 10.7173 13.3998 10.6069L12.25 9.64872V8.5H15.5V7H12.25V5.88596L13.575 4.93953C13.7566 4.80985 13.9001 4.63393 13.9907 4.43004L14.9353 2.3046L13.5646 1.6954L12.6477 3.75855L11.761 4.39189C11.5527 4.2017 11.2905 4.06947 11 4.02074ZM10.75 10V5.5H5.25V9.94265L5.28488 10.1694C5.49117 11.5102 6.64486 12.5 8.00146 12.5H8.25C9.63071 12.5 11 11.3807 11 10Z",
            fill: "#F15B50",
            fillRule: "evenodd"
        })
    });
const $4254d130fabc42c8$export$de8d5274b07acfbd = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            clipRule: "evenodd",
            d: "M0.219686 0.219656C0.407005 0.032337 0.679247 -0.0422694 0.935891 0.0233837L10.8966 2.5714C11.6642 2.76775 12.2435 3.3987 12.3737 4.18021L13.0165 8.037C13.2765 7.95209 13.5737 8.01295 13.7803 8.21958L15.7803 10.2196C16.0732 10.5124 16.0732 10.9873 15.7803 11.2802L11.2803 15.7802C10.9875 16.0731 10.5126 16.0731 10.2197 15.7802L8.21969 13.7802C8.01306 13.5736 7.9522 13.2764 8.03711 13.0164L4.18032 12.3736C3.39881 12.2434 2.76786 11.6641 2.57151 10.8965L0.0234143 0.935917C-0.0422389 0.679273 0.032367 0.406975 0.219686 0.219656ZM9.81068 13.25L10.75 14.1893L14.1894 10.75L13.25 9.81065L9.81068 13.25ZM11.697 9.24257L9.24278 11.6967L4.42709 10.8941C4.23172 10.8616 4.07398 10.7167 4.02489 10.5248L2.15506 3.21551L5.65846 6.71891C5.55656 6.95888 5.5002 7.22285 5.5002 7.49999C5.5002 8.60456 6.39563 9.49999 7.5002 9.49999C8.60477 9.49999 9.5002 8.60456 9.5002 7.49999C9.5002 6.39542 8.60477 5.49999 7.5002 5.49999C7.22306 5.49999 6.95909 5.55635 6.71912 5.65825L3.21572 2.15485L10.5251 4.02468C10.717 4.07377 10.8717 4.23151 10.9043 4.42688L11.697 9.24257ZM8.0002 7.49999C8.0002 7.22384 7.77634 6.99999 7.5002 6.99999C7.22405 6.99999 7.0002 7.22384 7.0002 7.49999C7.0002 7.77613 7.22405 7.99999 7.5002 7.99999C7.77634 7.99999 8.0002 7.77613 8.0002 7.49999Z",
            fill: "#4688EC",
            fillRule: "evenodd"
        })
    });
const $4254d130fabc42c8$export$53319be79ed3f398 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 1.5C5.51472 1.5 3.5 3.51472 3.5 6C3.5 7.55255 4.28559 8.92187 5.48441 9.73183C6.02899 10.0998 6.48633 10.726 6.4997 11.5H9.5003C9.51367 10.726 9.97101 10.0998 10.5156 9.73183C11.7144 8.92187 12.5 7.55255 12.5 6C12.5 3.51472 10.4853 1.5 8 1.5ZM9.5 13H6.5V14C6.5 14.2761 6.72386 14.5 7 14.5H9C9.27614 14.5 9.5 14.2761 9.5 14V13ZM2 6C2 2.68629 4.68629 0 8 0C11.3137 0 14 2.68629 14 6C14 8.0717 12.9494 9.89775 11.3553 10.9747C11.1084 11.1416 11 11.3597 11 11.5348V14C11 15.1046 10.1046 16 9 16H7C5.89543 16 5 15.1046 5 14V11.5348C5 11.3597 4.89163 11.1416 4.64466 10.9747C3.05062 9.89775 2 8.0717 2 6Z",
            fill: "#B38600"
        })
    });
const $4254d130fabc42c8$export$f368608f1cab20d2 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            clipRule: "evenodd",
            d: "M1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5H3ZM7.25 8.75V12H8.75V8.75H12V7.25H8.75V4H7.25V7.25H4V8.75H7.25Z",
            fill: "#6A9A23",
            fillRule: "evenodd"
        })
    });
const $4254d130fabc42c8$export$10903c8d76746678 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
            fill: "#E06C00",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    clipRule: "evenodd",
                    d: "M8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM8 5C7.41421 5 7 5.41421 7 6H5.5C5.5 4.58579 6.58579 3.5 8 3.5C9.41421 3.5 10.5 4.58579 10.5 6C10.5 7.13259 9.78738 7.7057 9.33837 8.05849C8.82691 8.46035 8.75 8.55198 8.75 8.75V9.5H7.25V8.75C7.25 7.77259 7.93895 7.24287 8.32821 6.94359C8.35791 6.92075 8.38586 6.89926 8.41163 6.87901C8.83763 6.5443 9 6.3673 9 6C9 5.41421 8.58579 5 8 5Z",
                    fillRule: "evenodd"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M9 11.5C9 12.0523 8.55228 12.5 8 12.5C7.44772 12.5 7 12.0523 7 11.5C7 10.9477 7.44772 10.5 8 10.5C8.55228 10.5 9 10.9477 9 11.5Z"
                })
            ]
        })
    });
const $4254d130fabc42c8$export$fdfabf40669c7635 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            clipRule: "evenodd",
            d: "M1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5H9.51305L8.34638 5.5H10.25C10.4976 5.5 10.7292 5.62219 10.869 5.82655C11.0088 6.0309 11.0387 6.29108 10.949 6.52183L9.199 11.0218L7.801 10.4782L9.15362 7H7.25C7.00241 7 6.77077 6.87781 6.63098 6.67345C6.49119 6.4691 6.46128 6.20892 6.551 5.97817L7.90362 2.5H3ZM5.5 7.5H4V9H5.5V7.5ZM10.5 7.5H12V9H10.5V7.5Z",
            fill: "#F15B50",
            fillRule: "evenodd"
        })
    });
const $4254d130fabc42c8$export$38479048465730c3 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            clipRule: "evenodd",
            d: "M1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V3ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5H3ZM4 5.5V4H12V5.5H4ZM4 8.5V7H12V8.5H4ZM4 11.5V10H8V11.5H4Z",
            fill: "#F15B50",
            fillRule: "evenodd"
        })
    });
const $4254d130fabc42c8$export$14600f001334856d = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            clipRule: "evenodd",
            d: "M1 3C1 1.89543 1.89543 1 3 1H13C14.1046 1 15 1.89543 15 3V9.75C15 10.2691 14.7938 10.7669 14.4268 11.1339L11.1339 14.4268C10.7669 14.7938 10.2691 15 9.75 15H3C1.89543 15 1 14.1046 1 13V3ZM3 2.5C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H9V9.75C9 9.33579 9.33579 9 9.75 9H13.5V3C13.5 2.72386 13.2761 2.5 13 2.5H3ZM12.9393 10H10.5V12.4393L12.9393 10ZM11 5.5H4V4H11V5.5ZM7 9H4V7.5H7V9Z",
            fill: "#4688EC",
            fillRule: "evenodd"
        })
    });
const $4254d130fabc42c8$export$10220554a3beaae8 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            clipRule: "evenodd",
            d: "M6.04021 1.52023L3.15132 4.52023C2.99257 4.68509 2.76722 4.76844 2.53939 4.74657C2.31157 4.72469 2.1062 4.59998 1.98172 4.40792L0.870606 2.69364L2.12934 1.87779L2.72641 2.79899L4.95973 0.479766L6.04021 1.52023ZM14.9998 3.5H6.99977V2H14.9998V3.5ZM5.99998 6.79046L3.11109 9.79046C2.95234 9.95532 2.72699 10.0386 2.49916 10.0168C2.27134 9.99492 2.06597 9.87021 1.94149 9.67815L0.830376 7.96387L2.0891 7.14802L2.68618 8.06922L4.9195 5.74999L5.99998 6.79046ZM14.9998 8.77023H6.99977V7.27023H14.9998V8.77023ZM5.99998 12.0605L3.11109 15.0605C2.95234 15.2254 2.72699 15.3087 2.49916 15.2869C2.27134 15.265 2.06597 15.1403 1.94149 14.9482L0.830376 13.2339L2.0891 12.4181L2.68618 13.3393L4.9195 11.02L5.99998 12.0605ZM14.9998 14.0403H6.99977V12.5403H14.9998V14.0403Z",
            fill: "#BF63F3",
            fillRule: "evenodd"
        })
    });
const $4254d130fabc42c8$export$d050c1878c6dc434 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 1.5C5.51472 1.5 3.5 3.51472 3.5 6C3.5 7.55255 4.28559 8.92187 5.48441 9.73183C6.02899 10.0998 6.48633 10.726 6.4997 11.5H9.5003C9.51367 10.726 9.97101 10.0998 10.5156 9.73183C11.7144 8.92187 12.5 7.55255 12.5 6C12.5 3.51472 10.4853 1.5 8 1.5ZM9.5 13H6.5V14C6.5 14.2761 6.72386 14.5 7 14.5H9C9.27614 14.5 9.5 14.2761 9.5 14V13ZM2 6C2 2.68629 4.68629 0 8 0C11.3137 0 14 2.68629 14 6C14 8.0717 12.9494 9.89775 11.3553 10.9747C11.1084 11.1416 11 11.3597 11 11.5348V14C11 15.1046 10.1046 16 9 16H7C5.89543 16 5 15.1046 5 14V11.5348C5 11.3597 4.89163 11.1416 4.64466 10.9747C3.05062 9.89775 2 8.0717 2 6Z",
            fill: "#B38600"
        })
    });
const $4254d130fabc42c8$export$6a73e76e8ec52970 = {
    Feature: $4254d130fabc42c8$export$74ec5b47d9335d78,
    Task: $4254d130fabc42c8$export$7ecb76505f3f02fe,
    Story: $4254d130fabc42c8$export$eae503ee066bc00,
    Bug: $4254d130fabc42c8$export$6a890007100de1ac,
    Asset: $4254d130fabc42c8$export$de8d5274b07acfbd,
    Contact: $4254d130fabc42c8$export$53319be79ed3f398,
    Request: $4254d130fabc42c8$export$f368608f1cab20d2,
    ResearchItem: $4254d130fabc42c8$export$10903c8d76746678,
    Incident: $4254d130fabc42c8$export$fdfabf40669c7635,
    ServiceRequest: $4254d130fabc42c8$export$38479048465730c3,
    Support: $4254d130fabc42c8$export$14600f001334856d,
    Campaign: $4254d130fabc42c8$export$10220554a3beaae8,
    Candidate: $4254d130fabc42c8$export$d050c1878c6dc434
};
const $4254d130fabc42c8$export$f315b19fd9da0750 = ({ type: type })=>{
    const IconComponent = $4254d130fabc42c8$export$6a73e76e8ec52970[type];
    return /*#__PURE__*/ (0, $loA2J.jsx)(IconComponent, {});
};

});

parcelRegister("lxH7j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa0c5ff7bb9c1222$export$2e2bcd8739ae039; });

var $6x1qA = parcelRequire("6x1qA");
var $fa0c5ff7bb9c1222$export$2e2bcd8739ae039 = (0, $6x1qA.defineMessages)({
    chooseWorkTypes: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-work-types.left-hand-side.choose-work-types",
        defaultMessage: "What types of work do you need?",
        description: "Choose the work types that your team will be working on"
    },
    workTypesDescription: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-work-types.left-hand-side.work-types-description",
        defaultMessage: "These form the building blocks of your project.",
        description: "Description of work types"
    },
    addMoreWorkTypesLater: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-work-types.left-hand-side.add-more-work-types-later",
        defaultMessage: "Don\u2019t worry, you can change these later.",
        description: "Message to inform user that they can add more work types later"
    },
    step: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-work-types.left-hand-side.step",
        defaultMessage: "Step 2 of 3",
        description: "Step in the onboarding flow"
    },
    nextButtonCta: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-work-types.left-hand-side.next-button-cta",
        defaultMessage: "Next",
        description: "CTA for the next button"
    },
    issueTypeValidation: {
        id: "software-onboarding-modals.welcome-modal.wizard.page-work-types.left-hand-side.issue-type-validation",
        defaultMessage: "Select at least one work type.",
        description: "Validation message for issue types"
    }
});

});


parcelRegister("EsCxi", function(module, exports) {

$parcel$export(module.exports, "RightHandSidePageWorkTypes", function () { return $ae550e8ed66ecf4e$export$8df7c6b6b74f4ea2; });

var $loA2J = parcelRequire("loA2J");

var $1Lr0O = parcelRequire("1Lr0O");
var $j7TVc = parcelRequire("j7TVc");

var $6Qct2 = parcelRequire("6Qct2");

var $6Lb1U = parcelRequire("6Lb1U");

var $iAWcs = parcelRequire("iAWcs");
const $ae550e8ed66ecf4e$export$8df7c6b6b74f4ea2 = ({ projectName: projectName, issueTypesIcons: issueTypesIcons })=>{
    const DynamicWorkTypesSvg = (0, $6Lb1U.getListIssueTypeDynamicView)(issueTypesIcons ?? []);
    const injections = {
        additionalObject: (0, $iAWcs.WorkTypeArrow),
        svgBody: DynamicWorkTypesSvg
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1Lr0O.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $ae550e8ed66ecf4e$var$containerStyles,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6Qct2.ProjectSvg), {
            projectName: projectName,
            activeView: "list",
            injections: injections
        })
    });
};
const $ae550e8ed66ecf4e$var$containerStyles = (0, $j7TVc.xcss)({
    height: "100%",
    backgroundColor: "elevation.surface"
});

});
parcelRegister("6Lb1U", function(module, exports) {

$parcel$export(module.exports, "getListIssueTypeDynamicView", function () { return $27933941bd51f880$export$81a42b8e9b2d91fb; });

var $loA2J = parcelRequire("loA2J");

var $fgSVg = parcelRequire("fgSVg");
const $27933941bd51f880$export$8e3ca10867cd07d4 = (icons, maxCount)=>{
    if (icons.length >= maxCount) return icons.slice(0, maxCount);
    const filler = icons[0] || "Task";
    return [
        ...icons,
        ...Array(maxCount - icons.length).fill(filler)
    ];
};
const $27933941bd51f880$export$81a42b8e9b2d91fb = (issueTypeIcons)=>{
    const iconsToBePlaced = $27933941bd51f880$export$8e3ca10867cd07d4(issueTypeIcons, issueTypeIcons.length);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fgSVg.ListIssueType), {
        issueTypeIcons: iconsToBePlaced
    });
};

});
parcelRegister("fgSVg", function(module, exports) {

$parcel$export(module.exports, "ListIssueType", function () { return $96433211f3743a1c$export$a52cd4f3fed9494b; });

var $loA2J = parcelRequire("loA2J");

var $4HOGp = parcelRequire("4HOGp");
const $96433211f3743a1c$export$a52cd4f3fed9494b = ({ issueTypeIcons: issueTypeIcons })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "394",
        height: "204",
        viewBox: "0 0 394 204",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                width: "394",
                height: "204",
                fill: "#F1F2F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                width: "386",
                height: "36",
                transform: "translate(4 4)",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("foreignObject", {
                x: "12",
                y: "12",
                width: "16",
                height: "20",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4HOGp.IssueTypeIcon), {
                    type: issueTypeIcons[0]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                transform: "translate(35 20)",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M0.252061 4.10018C0.929913 4.44311 1.65707 4.59448 2.4027 4.6903C3.1545 4.78612 3.93711 4.81133 4.84297 4.81133C5.06481 4.7256 5.10795 4.75586 5.04016 4.56423C5.08946 4.51884 5.16957 4.43808 5.11411 4.36748C4.92308 3.91865 5.47152 3.97415 5.68104 3.89347C5.84742 4.64992 7.14151 4.30703 8.34315 3.67665C9.5448 3.05132 10.7464 2.22424 11.1039 2.14355C11.5599 2.74872 12.4103 1.74004 12.9402 1.94176C12.9217 1.97706 12.8047 2.16366 12.7923 2.19896C13.0511 2.38555 14.4561 1.75022 15.6578 1.91664C16.2494 1.99229 16.7793 2.22415 16.9765 2.43092C17.1984 2.62255 17.1367 2.69323 16.6746 2.63776L16.8225 2.84953C16.8656 2.92517 16.9087 3.00585 16.9519 3.08653L17.0813 3.31849C17.1183 3.40422 17.1552 3.48996 17.1922 3.57569L17.3093 3.83289C17.3401 3.92366 17.3709 4.01951 17.4017 4.11028C17.4079 4.14054 17.4572 4.23632 17.4942 4.32205L17.6174 4.57925C17.7037 4.74567 17.8146 4.90714 17.944 5.05843C18.474 5.65855 19.4168 6.04175 20.4028 5.99636C20.8957 5.97619 21.3949 5.86527 21.8386 5.64338C22.1528 5.47696 22.4671 5.31559 22.7814 5.14412C23.2436 4.87684 23.7612 4.68526 24.2603 4.43815C24.5192 4.33225 24.7841 4.24142 25.0491 4.13552L25.4497 3.97916L25.8625 3.85308C26.9594 3.4799 28.1488 3.24286 29.375 3.07644C31.8276 2.74864 34.4466 2.86969 36.8684 3.22271C39.3025 3.5858 41.5517 4.16071 43.4312 4.86673L43.3943 4.77095C43.4497 4.81129 43.6531 4.80627 43.6716 4.91721C44.5343 4.79114 46.6664 4.97766 46.6664 4.97766C47.4306 5.01297 48.2009 5.03826 48.9711 5.05843C48.9711 5.05843 49.914 5.30546 51.091 5.47692C52.2618 5.66351 53.673 5.72908 54.4925 5.49206C56.4645 5.70891 58.4919 5.79463 60.5254 5.60804C60.5254 5.60804 61.1478 5.47192 61.8442 5.2702C62.5282 5.03318 63.28 4.73569 63.5511 4.43815C63.8962 4.09523 64.0441 3.76235 63.9886 3.51524C63.9332 3.26309 63.6682 3.09157 63.1875 3.07644C62.7131 3.07139 62.0167 3.19244 60.9938 3.46476C60.963 3.43954 60.8705 3.42446 60.8459 3.37907C59.7859 3.76234 58.6151 3.75218 57.4813 3.68662C56.3351 3.59081 55.2012 3.40928 53.9996 3.33364C54.0119 3.48493 53.9133 3.59088 53.8517 3.51019L53.901 3.32859C52.2372 3.53535 51.3559 2.79905 49.7291 3.18232C49.7291 3.18232 49.9571 2.9756 49.9633 2.97055C47.4121 2.61754 44.4172 1.9418 41.2744 1.35177C38.1317 0.771819 34.7732 0.307886 31.7044 0.494478L31.7352 0.519718L31.7229 0.544834C32.0063 0.640652 32.8198 0.746639 33.5346 0.8828C33.8982 0.943316 34.2371 0.998711 34.4836 1.05418C34.7301 1.10461 34.8965 1.13495 34.8965 1.13495C34.385 1.31146 33.8735 1.39217 33.3559 1.41234C32.8444 1.42243 32.3206 1.38705 31.7907 1.33157C30.7369 1.21054 29.6215 1.06934 28.5616 1.21055L28.5308 0.97354C28.993 0.928153 29.4243 0.862534 29.7879 0.786889C30.1453 0.716287 30.435 0.660878 30.5952 0.600362C28.919 0.509587 26.2631 0.711293 23.866 1.59382C23.2682 1.81571 22.6766 2.03758 22.1467 2.31999C21.8755 2.45615 21.6044 2.58225 21.3518 2.72345C21.1053 2.87474 20.8649 3.02105 20.6308 3.1673L20.4582 3.27823C20.4028 3.31353 20.4705 3.27825 20.4459 3.29842L20.4028 3.34373C20.3719 3.37399 20.3288 3.40433 20.2795 3.4245C20.1871 3.46989 20.0638 3.48494 19.9467 3.46981C19.8851 3.55554 19.9899 3.55047 20.0638 3.57064C20.1439 3.59082 20.1994 3.6463 20.2549 3.95897C20.0577 3.97409 19.8481 3.95396 19.6694 3.86823C19.4846 3.79258 19.3737 3.63624 19.2997 3.4799C19.7187 3.30844 19.6448 3.48494 19.7311 3.46981C19.7434 3.42946 19.7434 3.36903 19.7372 3.29842C19.7495 3.29842 19.7126 3.22276 19.6818 3.15721C19.651 3.09165 19.6201 3.02096 19.5893 2.94531C19.5277 2.79907 19.4106 2.63266 19.3059 2.45616C19.2011 2.27965 19.0655 2.08303 18.8868 1.88636C18.8006 1.78549 18.7081 1.68458 18.6157 1.57363C18.5048 1.47277 18.3877 1.36693 18.2644 1.26103C18.0364 1.03913 17.7037 0.852562 17.3709 0.650841C17.0073 0.479379 16.6191 0.302804 16.1754 0.201944C15.3065 -0.0249919 14.3699 -0.0401407 13.5133 0.0556766C12.6568 0.156537 11.8741 0.358277 11.1223 0.58017C9.61874 1.03404 8.2692 1.61399 6.99361 2.09812C5.72418 2.5873 4.55334 2.98071 3.57354 3.1673C2.59373 3.35389 1.83577 3.35388 1.26268 3.28328C0.695745 3.20764 0.289034 3.09659 0.0980033 3.18232C-0.0807032 3.24788 -0.0498887 3.50509 0.486231 3.95897L0.239733 4.08504L0.252061 4.10018Z",
                    fill: "#091E42",
                    fillOpacity: "0.31"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M217 18H257V26H217V18Z",
                fill: "#F1F2F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M269 18H349V26H269V18Z",
                fill: "#F1F2F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                width: "386",
                height: "36",
                transform: "translate(4 44)",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("foreignObject", {
                x: "12",
                y: "52",
                width: "16",
                height: "20",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4HOGp.IssueTypeIcon), {
                    type: issueTypeIcons[1] ?? issueTypeIcons[0]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M36.2521 63.1002C36.9299 63.4431 37.6571 63.5945 38.4027 63.6903C39.1545 63.7861 39.9371 63.8113 40.843 63.8113C41.0648 63.7256 41.1079 63.7559 41.0402 63.5642C41.0895 63.5188 41.1696 63.4381 41.1141 63.3675C40.9231 62.9187 41.4715 62.9742 41.681 62.8935C41.8474 63.6499 43.1415 63.307 44.3432 62.6767C45.5448 62.0513 46.7464 61.2242 47.1039 61.1436C47.5599 61.7487 48.4103 60.74 48.9402 60.9418C48.9217 60.9771 48.8047 61.1637 48.7923 61.199C49.0511 61.3855 50.4561 60.7502 51.6578 60.9166C52.2494 60.9923 52.7793 61.2242 52.9765 61.4309C53.1984 61.6226 53.1367 61.6932 52.6746 61.6378L52.8225 61.8495C52.8656 61.9252 52.9087 62.0058 52.9519 62.0865L53.0813 62.3185C53.1183 62.4042 53.1552 62.49 53.1922 62.5757L53.3093 62.8329C53.3401 62.9237 53.3709 63.0195 53.4017 63.1103C53.4079 63.1405 53.4572 63.2363 53.4942 63.322L53.6174 63.5792C53.7037 63.7457 53.8146 63.9071 53.944 64.0584C54.474 64.6586 55.4168 65.0418 56.4028 64.9964C56.8957 64.9762 57.3949 64.8653 57.8386 64.6434C58.1528 64.477 58.4671 64.3156 58.7814 64.1441C59.2436 63.8768 59.7612 63.6853 60.2603 63.4382C60.5192 63.3322 60.7841 63.2414 61.0491 63.1355L61.4497 62.9792L61.8625 62.8531C62.9594 62.4799 64.1488 62.2429 65.375 62.0764C67.8276 61.7486 70.4466 61.8697 72.8684 62.2227C75.3025 62.5858 77.5517 63.1607 79.4312 63.8667L79.3943 63.7709C79.4497 63.8113 79.6531 63.8063 79.6716 63.9172C80.5343 63.7911 82.6664 63.9777 82.6664 63.9777C83.4306 64.013 84.2009 64.0383 84.9711 64.0584C84.9711 64.0584 85.914 64.3055 87.091 64.4769C88.2618 64.6635 89.673 64.7291 90.4925 64.4921C92.4645 64.7089 94.4919 64.7946 96.5254 64.608C96.5254 64.608 97.1478 64.4719 97.8442 64.2702C98.5282 64.0332 99.28 63.7357 99.5511 63.4382C99.8962 63.0952 100.044 62.7623 99.9886 62.5152C99.9332 62.2631 99.6682 62.0916 99.1875 62.0764C98.7131 62.0714 98.0167 62.1924 96.9938 62.4648C96.963 62.4395 96.8705 62.4245 96.8459 62.3791C95.7859 62.7623 94.6151 62.7522 93.4813 62.6866C92.3351 62.5908 91.2012 62.4093 89.9996 62.3336C90.0119 62.4849 89.9133 62.5909 89.8517 62.5102L89.901 62.3286C88.2372 62.5354 87.3559 61.7991 85.7291 62.1823C85.7291 62.1823 85.9571 61.9756 85.9633 61.9706C83.4121 61.6175 80.4172 60.9418 77.2744 60.3518C74.1317 59.7718 70.7732 59.3079 67.7044 59.4945L67.7352 59.5197L67.7229 59.5448C68.0063 59.6407 68.8198 59.7466 69.5346 59.8828C69.8982 59.9433 70.2371 59.9987 70.4836 60.0542C70.7301 60.1046 70.8965 60.135 70.8965 60.135C70.385 60.3115 69.8735 60.3922 69.3559 60.4123C68.8444 60.4224 68.3206 60.387 67.7907 60.3316C66.7369 60.2105 65.6215 60.0693 64.5616 60.2105L64.5308 59.9735C64.993 59.9282 65.4243 59.8625 65.7879 59.7869C66.1453 59.7163 66.435 59.6609 66.5952 59.6004C64.919 59.5096 62.2631 59.7113 59.866 60.5938C59.2682 60.8157 58.6766 61.0376 58.1467 61.32C57.8755 61.4561 57.6044 61.5822 57.3518 61.7235C57.1053 61.8747 56.8649 62.0211 56.6308 62.1673L56.4582 62.2782C56.4028 62.3135 56.4705 62.2783 56.4459 62.2984L56.4028 62.3437C56.3719 62.374 56.3288 62.4043 56.2795 62.4245C56.1871 62.4699 56.0638 62.4849 55.9467 62.4698C55.8851 62.5555 55.9899 62.5505 56.0638 62.5706C56.1439 62.5908 56.1994 62.6463 56.2549 62.959C56.0577 62.9741 55.8481 62.954 55.6694 62.8682C55.4846 62.7926 55.3737 62.6362 55.2997 62.4799C55.7187 62.3084 55.6448 62.4849 55.7311 62.4698C55.7434 62.4295 55.7434 62.369 55.7372 62.2984C55.7495 62.2984 55.7126 62.2228 55.6818 62.1572C55.651 62.0916 55.6201 62.021 55.5893 61.9453C55.5277 61.7991 55.4106 61.6327 55.3059 61.4562C55.2011 61.2797 55.0655 61.083 54.8868 60.8864C54.8006 60.7855 54.7081 60.6846 54.6157 60.5736C54.5048 60.4728 54.3877 60.3669 54.2644 60.261C54.0364 60.0391 53.7037 59.8526 53.3709 59.6508C53.0073 59.4794 52.6191 59.3028 52.1754 59.2019C51.3065 58.975 50.3699 58.9599 49.5133 59.0557C48.6568 59.1565 47.8741 59.3583 47.1223 59.5802C45.6187 60.034 44.2692 60.614 42.9936 61.0981C41.7242 61.5873 40.5533 61.9807 39.5735 62.1673C38.5937 62.3539 37.8358 62.3539 37.2627 62.2833C36.6957 62.2076 36.289 62.0966 36.098 62.1823C35.9193 62.2479 35.9501 62.5051 36.4862 62.959L36.2397 63.085L36.2521 63.1002Z",
                fill: "#091E42",
                fillOpacity: "0.31"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M217 58H257V66H217V58Z",
                fill: "#F1F2F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M269 58H349V66H269V58Z",
                fill: "#F1F2F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                width: "386",
                height: "36",
                transform: "translate(4 84)",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("foreignObject", {
                x: "12",
                y: "92",
                width: "16",
                height: "20",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4HOGp.IssueTypeIcon), {
                    type: issueTypeIcons[2] ?? issueTypeIcons[0]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M99.9947 101.75C88.9658 103.959 80.8283 98.3066 69.6895 102.944C69.1695 100.958 67.8253 98.4706 65.8131 98.4342C67.4913 98.4797 70.1756 103.668 67.4786 100.192C65.8934 97.5459 58.9649 100.78 64.2744 98.4798C60.6093 98.9672 57.2487 102.188 54.7715 105.053C50.6499 109.134 53.7781 101.236 50.7979 97.2636C46.5748 91.7429 33.7578 106.1 36.3406 106.109C37.985 104.31 40.1917 103.19 41.1048 101.195C57.181 89.3833 45.5814 111.243 55.1562 107.581C70.797 92.3988 62.8921 106.141 72.0737 105.203C77.4254 99.7005 100.181 108.328 99.9989 101.75H99.9947Z",
                fill: "#091E42",
                fillOpacity: "0.31"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M217 98H257V106H217V98Z",
                fill: "#F1F2F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M269 98H349V106H269V98Z",
                fill: "#F1F2F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                width: "386",
                height: "36",
                transform: "translate(4 124)",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("foreignObject", {
                x: "12",
                y: "132",
                width: "16",
                height: "20",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4HOGp.IssueTypeIcon), {
                    type: issueTypeIcons[3] ?? issueTypeIcons[0]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M36.8617 144.721C37.2883 144.971 37.7493 144.944 38.1844 144.849C39.0634 144.64 39.9165 144.189 40.8686 143.731C41.1056 143.495 41.1487 143.522 41.0712 143.286C41.1229 143.199 41.209 143.044 41.1487 142.963C40.9376 142.41 41.5494 142.201 41.7821 141.999C41.8553 142.511 42.2345 142.484 42.7558 142.242C42.9066 142.175 42.9626 142.141 43.1048 142.121C43.2599 142.087 43.4236 142.046 43.596 142.006C43.932 141.952 44.3069 141.871 44.6515 141.932C45.0005 141.979 45.3323 142.134 45.5908 142.484C45.8536 142.828 46.0432 143.34 46.1897 143.832C46.3362 144.33 46.4439 144.795 46.5602 145.173C46.6679 145.55 46.78 145.799 46.836 145.948C46.7627 146.15 46.78 146.46 46.9437 146.675C47.0126 146.81 47.129 146.864 47.2453 146.938C47.3702 146.985 47.5081 147.005 47.646 146.999C47.9303 146.965 48.2018 146.817 48.4344 146.702C48.6413 146.567 48.8351 146.487 48.9816 146.493C48.9644 146.561 48.7791 146.884 48.7576 146.938C48.917 147.026 49.4857 146.668 50.132 146.042C50.7783 145.409 51.528 144.539 52.1786 143.704C53.4927 142.053 54.5095 140.672 53.8675 142.154C54.363 141.737 54.8843 141.285 55.4057 140.773C55.5349 140.645 55.6685 140.517 55.802 140.389L55.8925 140.301L55.9356 140.268C55.9615 140.248 55.9916 140.221 56.0175 140.214H56.108C56.108 140.214 56.1295 140.227 56.1553 140.227L56.2631 140.214C56.4052 140.187 56.5388 140.214 56.681 140.214C57.2282 140.254 57.7237 140.416 58.0726 140.82C58.4346 141.198 58.7275 141.844 59.0852 142.815C59.2661 143.293 59.4643 143.845 59.7616 144.438C60.0546 145.025 60.5156 145.692 61.1059 146.022C61.2523 146.089 61.3988 146.17 61.5453 146.217C61.6875 146.251 61.834 146.278 61.9805 146.298C62.2476 146.298 62.532 146.298 62.769 146.217C62.8896 146.183 63.0189 146.156 63.1352 146.109L63.4712 145.961C63.7039 145.867 63.8978 145.732 64.1089 145.611C65.716 144.56 67.0473 143.118 68.3657 141.642L69.1887 140.692L69.6066 140.443C69.766 140.342 69.9082 140.322 70.059 140.254C70.1366 140.214 70.2012 140.207 70.2658 140.207L70.4597 140.18C70.5243 140.167 70.5631 140.2 70.6191 140.2C70.6708 140.207 70.7268 140.2 70.7613 140.241C70.9293 140.288 71.0801 140.49 71.2869 140.827C71.6919 141.494 72.153 142.862 73.0448 143.765C73.2732 143.973 73.4972 144.189 73.7471 144.31C73.8678 144.378 73.9927 144.452 74.1133 144.506L74.4925 144.614L74.7338 144.674C74.8156 144.688 74.8932 144.742 74.9707 144.694L75.4188 144.546L75.9488 144.378C78.7666 143.461 81.537 143.549 83.8765 144.041L83.8076 143.926C83.8808 143.967 84.1135 143.913 84.1695 144.054C84.6348 143.859 85.4879 143.751 86.2246 143.677C86.9614 143.596 87.5818 143.589 87.5818 143.589L90.2402 143.387C90.2402 143.387 91.382 143.603 92.765 143.724C94.148 143.839 95.7724 143.839 96.6987 143.434C99.0124 143.542 101.356 143.535 103.683 143.023C103.683 143.023 103.864 142.97 104.148 142.882C104.428 142.767 104.812 142.592 105.217 142.397C105.622 142.188 106.053 142.006 106.419 141.743C106.785 141.474 107.1 141.218 107.285 141.002C107.75 140.463 108 139.964 108 139.614C108 139.264 107.741 139.062 107.177 139.122C106.897 139.156 106.539 139.25 106.096 139.432C105.656 139.621 105.105 139.762 104.463 140.052C104.428 140.025 104.316 140.018 104.295 139.965C102.942 140.625 101.533 140.78 100.124 140.786C99.4217 140.807 98.7065 140.712 97.9956 140.706C97.2804 140.679 96.5565 140.605 95.8241 140.632C95.8585 140.827 95.7594 140.982 95.6733 140.881L95.7077 140.638C93.7301 141.043 92.5237 140.146 90.6754 140.827C90.6754 140.827 90.8951 140.524 90.8994 140.517C89.3397 140.423 87.6422 140.247 85.8412 140.14C84.0445 140.012 82.1488 139.971 80.2185 140.126C79.736 140.18 79.2534 140.234 78.7666 140.288C78.284 140.355 77.7971 140.483 77.3146 140.584L76.5907 140.746L75.8712 140.989L75.156 141.238L74.8458 141.346C74.8803 141.346 74.8286 141.359 74.8242 141.346C74.8113 141.346 74.8242 141.346 74.7941 141.332L74.6864 141.312C74.6088 141.312 74.5614 141.245 74.4968 141.225C74.3675 141.184 74.2728 141.056 74.1564 140.975C73.9453 140.746 73.7213 140.369 73.4628 139.857C73.1999 139.358 72.9199 138.678 72.4072 138.031C72.2994 137.869 72.1314 137.734 71.9935 137.593C71.8514 137.445 71.6876 137.35 71.5239 137.263C71.1922 137.047 70.869 137.04 70.5545 137C70.5674 137.007 70.5846 137.027 70.6019 137.04L70.5803 137.074C70.6967 137.121 70.8647 137.189 71.0672 137.269C71.2654 137.337 71.511 137.553 71.7523 137.741C72.2348 138.213 72.5924 138.934 72.8337 139.52C73.0836 140.126 73.2559 140.598 73.4067 140.928C73.5575 141.231 73.6566 141.42 73.6566 141.406C73.1784 141.164 72.782 140.477 72.3684 139.749C72.1486 139.392 71.9332 139.001 71.6316 138.711C71.3473 138.388 70.994 138.219 70.645 138.132C70.3003 138.071 69.9427 138.071 69.6152 138.159C69.2619 138.206 68.9819 138.354 68.6243 138.496L68.4735 138.563C68.4261 138.597 68.383 138.644 68.3356 138.691L68.1072 138.907L67.7238 139.277C67.4696 139.533 67.224 139.789 66.9784 140.052L66.875 139.776C67.2972 139.338 67.6721 138.853 67.978 138.455L68.034 138.381L68.1331 138.26C68.1977 138.186 68.2494 138.092 68.3184 138.044C68.4476 137.957 68.5769 137.862 68.6458 137.808C68.8009 137.687 68.9302 137.579 69.025 137.492C68.8957 137.552 68.7664 137.606 68.6286 137.667C68.5467 137.707 68.4648 137.748 68.383 137.788L68.2279 137.869C68.1762 137.91 68.1331 137.963 68.0857 138.011C67.8487 138.253 67.6031 138.502 67.3446 138.765C66.8793 139.237 66.3752 139.736 65.8453 140.227C65.3196 140.719 64.7638 141.231 64.2037 141.656C63.6522 142.087 63.0662 142.491 62.5794 142.639C62.351 142.7 62.1313 142.747 62.015 142.7C61.8943 142.66 61.834 142.626 61.7134 142.471C61.597 142.323 61.4462 142.026 61.2825 141.642C61.1188 141.265 60.9508 140.827 60.7439 140.362C60.3519 139.446 59.7573 138.455 59.0593 137.91C58.3613 137.35 57.6676 137.236 57.1334 137.269C57.1592 137.33 57.2626 137.357 57.4091 137.364C57.5556 137.384 57.7538 137.424 57.9563 137.478C58.1588 137.552 58.3699 137.674 58.5294 137.835C58.6888 138.017 58.8008 138.226 58.818 138.462C58.3139 138.031 57.7538 137.883 57.2411 137.842L56.8576 137.829L56.4914 137.876C56.3708 137.889 56.2458 137.896 56.1338 137.93C55.9959 137.963 55.8581 137.99 55.7245 138.024C55.703 137.896 55.7374 137.809 55.8064 137.734C55.8408 137.701 55.8839 137.667 55.9313 137.64C55.9701 137.613 56.0002 137.6 56.039 137.579C56.1855 137.505 56.3578 137.512 56.4096 137.465C56.3578 137.458 56.2674 137.431 56.1553 137.445C56.0993 137.445 56.0347 137.451 55.9658 137.458C55.8624 137.472 55.7503 137.492 55.6297 137.505C55.5651 137.512 55.5004 137.526 55.4272 137.539L55.3195 137.553C55.285 137.573 55.2592 137.613 55.229 137.64C55.1084 137.775 54.9791 137.916 54.8412 138.071C54.6775 138.247 54.4923 138.442 54.2941 138.657C53.5142 139.5 52.4759 140.632 51.2738 141.858C50.6749 142.478 50.0286 143.084 49.3651 143.663C49.2014 143.798 49.0333 143.926 48.8653 144.061C48.7016 144.176 48.5378 144.29 48.3698 144.405L48.1372 144.526L48.0208 144.593L47.9777 144.607C47.9131 144.634 47.8916 144.634 47.8614 144.627C47.7968 144.627 47.758 144.533 47.7408 144.445L47.6115 143.771C47.5512 143.441 47.4736 143.044 47.3702 142.633C47.2668 142.215 47.116 141.763 46.9178 141.319C46.8015 141.103 46.6895 140.881 46.5559 140.685C46.4137 140.504 46.2759 140.295 46.1165 140.16C45.4831 139.547 44.811 139.385 44.2724 139.385C43.7037 139.365 43.2383 139.486 42.7386 139.634C42.661 139.668 42.5619 139.661 42.4714 139.729L42.2258 139.89L41.907 140.119C41.7045 140.274 41.5106 140.423 41.3297 140.578C40.5972 141.184 39.9423 141.757 39.3348 142.215C38.7316 142.673 38.1715 143.023 37.7406 143.172C37.5295 143.246 37.3529 143.259 37.2495 143.246C37.1504 143.239 37.0901 143.212 37.0168 143.158C36.8962 143.064 36.7497 142.714 36.6635 142.404C36.5644 142.1 36.5084 141.844 36.4352 141.764C36.3662 141.676 36.3059 141.743 36.2499 141.999C36.1939 142.262 36.1422 142.713 36.224 143.36C36.1508 143.32 36.0689 143.273 36 143.212C36.1293 143.899 36.4395 144.512 36.8703 144.748L36.8617 144.721Z",
                fill: "#091E42",
                fillOpacity: "0.31"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M217 138H257V146H217V138Z",
                fill: "#F1F2F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M269 138H349V146H269V138Z",
                fill: "#F1F2F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                width: "386",
                height: "36",
                transform: "translate(4 164)",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("foreignObject", {
                x: "12",
                y: "172",
                width: "16",
                height: "20",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4HOGp.IssueTypeIcon), {
                    type: issueTypeIcons[4] ?? issueTypeIcons[0]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M36.2521 183.1C36.9299 183.443 37.6571 183.594 38.4027 183.69C39.1545 183.786 39.9371 183.811 40.843 183.811C41.0648 183.726 41.1079 183.756 41.0402 183.564C41.0895 183.519 41.1696 183.438 41.1141 183.367C40.9231 182.919 41.4715 182.974 41.681 182.893C41.8474 183.65 43.1415 183.307 44.3432 182.677C45.5448 182.051 46.7464 181.224 47.1039 181.144C47.5599 181.749 48.4103 180.74 48.9402 180.942C48.9217 180.977 48.8047 181.164 48.7923 181.199C49.0511 181.386 50.4561 180.75 51.6578 180.917C52.2494 180.992 52.7793 181.224 52.9765 181.431C53.1984 181.623 53.1367 181.693 52.6746 181.638L52.8225 181.85C52.8656 181.925 52.9087 182.006 52.9519 182.087L53.0813 182.318C53.1183 182.404 53.1552 182.49 53.1922 182.576L53.3093 182.833C53.3401 182.924 53.3709 183.02 53.4017 183.11C53.4079 183.141 53.4572 183.236 53.4942 183.322L53.6174 183.579C53.7037 183.746 53.8146 183.907 53.944 184.058C54.474 184.659 55.4168 185.042 56.4028 184.996C56.8957 184.976 57.3949 184.865 57.8386 184.643C58.1528 184.477 58.4671 184.316 58.7814 184.144C59.2436 183.877 59.7612 183.685 60.2603 183.438C60.5192 183.332 60.7841 183.241 61.0491 183.136L61.4497 182.979L61.8625 182.853C62.9594 182.48 64.1488 182.243 65.375 182.076C67.8276 181.749 70.4466 181.87 72.8684 182.223C75.3025 182.586 77.5517 183.161 79.4312 183.867L79.3943 183.771C79.4497 183.811 79.6531 183.806 79.6716 183.917C80.5343 183.791 82.6664 183.978 82.6664 183.978C83.4306 184.013 84.2009 184.038 84.9711 184.058C84.9711 184.058 85.914 184.305 87.091 184.477C88.2618 184.664 89.673 184.729 90.4925 184.492C92.4645 184.709 94.4919 184.795 96.5254 184.608C96.5254 184.608 97.1478 184.472 97.8442 184.27C98.5282 184.033 99.28 183.736 99.5511 183.438C99.8962 183.095 100.044 182.762 99.9886 182.515C99.9332 182.263 99.6682 182.092 99.1875 182.076C98.7131 182.071 98.0167 182.192 96.9938 182.465C96.963 182.44 96.8705 182.424 96.8459 182.379C95.7859 182.762 94.6151 182.752 93.4813 182.687C92.3351 182.591 91.2012 182.409 89.9996 182.334C90.0119 182.485 89.9133 182.591 89.8517 182.51L89.901 182.329C88.2372 182.535 87.3559 181.799 85.7291 182.182C85.7291 182.182 85.9571 181.976 85.9633 181.971C83.4121 181.618 80.4172 180.942 77.2744 180.352C74.1317 179.772 70.7732 179.308 67.7044 179.494L67.7352 179.52L67.7229 179.545C68.0063 179.641 68.8198 179.747 69.5346 179.883C69.8982 179.943 70.2371 179.999 70.4836 180.054C70.7301 180.105 70.8965 180.135 70.8965 180.135C70.385 180.311 69.8735 180.392 69.3559 180.412C68.8444 180.422 68.3206 180.387 67.7907 180.332C66.7369 180.211 65.6215 180.069 64.5616 180.211L64.5308 179.974C64.993 179.928 65.4243 179.863 65.7879 179.787C66.1453 179.716 66.435 179.661 66.5952 179.6C64.919 179.51 62.2631 179.711 59.866 180.594C59.2682 180.816 58.6766 181.038 58.1467 181.32C57.8755 181.456 57.6044 181.582 57.3518 181.723C57.1053 181.875 56.8649 182.021 56.6308 182.167L56.4582 182.278C56.4028 182.314 56.4705 182.278 56.4459 182.298L56.4028 182.344C56.3719 182.374 56.3288 182.404 56.2795 182.424C56.1871 182.47 56.0638 182.485 55.9467 182.47C55.8851 182.556 55.9899 182.55 56.0638 182.571C56.1439 182.591 56.1994 182.646 56.2549 182.959C56.0577 182.974 55.8481 182.954 55.6694 182.868C55.4846 182.793 55.3737 182.636 55.2997 182.48C55.7187 182.308 55.6448 182.485 55.7311 182.47C55.7434 182.429 55.7434 182.369 55.7372 182.298C55.7495 182.298 55.7126 182.223 55.6818 182.157C55.651 182.092 55.6201 182.021 55.5893 181.945C55.5277 181.799 55.4106 181.633 55.3059 181.456C55.2011 181.28 55.0655 181.083 54.8868 180.886C54.8006 180.785 54.7081 180.685 54.6157 180.574C54.5048 180.473 54.3877 180.367 54.2644 180.261C54.0364 180.039 53.7037 179.853 53.3709 179.651C53.0073 179.479 52.6191 179.303 52.1754 179.202C51.3065 178.975 50.3699 178.96 49.5133 179.056C48.6568 179.157 47.8741 179.358 47.1223 179.58C45.6187 180.034 44.2692 180.614 42.9936 181.098C41.7242 181.587 40.5533 181.981 39.5735 182.167C38.5937 182.354 37.8358 182.354 37.2627 182.283C36.6957 182.208 36.289 182.097 36.098 182.182C35.9193 182.248 35.9501 182.505 36.4862 182.959L36.2397 183.085L36.2521 183.1Z",
                fill: "#091E42",
                fillOpacity: "0.31"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M217 178H257V186H217V178Z",
                fill: "#F1F2F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M269 178H349V186H269V178Z",
                fill: "#F1F2F4"
            })
        ]
    });

});


parcelRegister("iAWcs", function(module, exports) {

$parcel$export(module.exports, "WorkTypeArrow", function () { return $5f8e6ee60eeb2643$export$3100585c8af1d24c; });

var $loA2J = parcelRequire("loA2J");
const $5f8e6ee60eeb2643$export$3100585c8af1d24c = /*#__PURE__*/ (0, $loA2J.jsx)("path", {
    d: "M91.3924 183.885L91.4134 183.879L91.4312 183.885C91.4783 183.844 91.5414 183.751 91.616 183.645C91.6955 183.548 91.7804 183.434 91.8632 183.327C92.0265 183.119 92.1746 182.95 92.1746 182.95C92.3187 183.401 92.1717 183.684 91.9897 184.018C91.8873 184.177 91.8035 184.366 91.7282 184.565C91.6814 184.772 91.6342 185.007 91.7161 185.225L91.5453 185.263C91.4329 184.849 91.4031 184.482 91.3494 184.338C91.2284 184.663 91.1939 185.243 91.4388 185.799C91.5064 185.975 91.6051 186.125 91.7105 186.265C90.9474 186.93 90.5009 187.433 90.4783 187.663C90.4514 187.946 91.0685 187.794 92.5182 187.017C92.5218 187.018 92.5289 187.02 92.5314 187.025C93.3605 187.55 94.1578 187.716 94.6946 187.753C94.7107 187.622 94.3096 187.792 94.3744 187.357C94.6253 187.44 94.8929 187.455 95.1246 187.524C95.0432 187.795 94.9345 187.666 94.8946 187.708C94.9755 187.814 95.5528 188.065 96.3464 188.308C97.1412 188.546 98.1502 188.784 99.0907 188.938C100.972 189.247 102.573 189.274 101.688 188.518L101.764 188.382C101.269 188.233 100.858 188.113 100.38 187.74C100.303 187.748 100.296 187.719 100.271 187.867C100.246 187.886 100.208 187.922 100.205 187.983C100.151 188.332 100.011 188.165 99.9377 188.163C100.221 187.09 98.3293 187.761 98.1015 187.665C98.1635 187.136 97.6568 187.555 97.5671 187.31C97.5806 187.291 97.6659 187.189 97.6783 187.173C97.6496 186.997 97.0924 187.028 96.6205 187.034C96.1532 187.037 95.7804 187.01 96.1451 186.767C95.688 186.4 95.125 186.114 94.5552 185.838C95.1774 185.461 95.8719 185.025 96.6564 184.523C96.723 184.508 96.9181 184.415 96.9598 184.431C101.639 181.287 106.563 178.944 111.539 176.107C111.421 176.048 111.545 175.879 111.723 175.843L111.737 175.991C114.946 173.898 117.253 173.165 120.137 171.148C120.134 171.155 119.868 171.487 119.861 171.497C122.504 170.111 125.414 168.666 128.505 167.275C131.593 165.883 134.867 164.544 138.232 163.484C139.917 162.961 141.621 162.501 143.329 162.222C145.029 161.933 146.749 161.82 148.297 162.099C149.857 162.366 151.123 163.143 151.868 164.388C152.62 165.636 152.919 167.214 153.065 168.758L153.084 168.694L153.1 168.718C153.123 168.138 153.065 166.442 152.562 165.067C152.323 164.374 151.963 163.787 151.648 163.401C151.334 163.012 151.077 162.806 151.077 162.806C151.939 163.287 152.635 164.164 153.032 165.197C153.437 166.228 153.609 167.375 153.658 168.529C153.763 170.845 153.447 173.202 153.431 175.517L153.255 175.48C153.299 173.472 153.274 171.72 153.188 171.026C153.141 172.784 152.943 174.994 152.977 177.53C153.008 178.798 153.089 180.159 153.524 181.58C153.747 182.288 154.073 183.012 154.572 183.667C155.075 184.319 155.767 184.861 156.512 185.202C157.259 185.547 158.042 185.708 158.79 185.766C159.538 185.824 160.26 185.788 160.955 185.713C162.343 185.544 163.627 185.215 164.814 184.845C167.19 184.09 169.206 183.177 170.757 182.411C170.546 182.375 168.682 183.482 168.015 183.273C169.657 182.617 171.238 181.833 172.739 181.118C172.864 181.374 171.951 181.697 171.804 181.824C172.489 181.599 176.335 179.872 181.279 177.114C186.236 174.376 192.31 170.653 197.821 167.04C203.339 163.434 208.313 159.97 211.16 157.853C214.001 155.731 214.732 154.979 211.7 156.702L211.91 156.38C208.921 158.361 206.433 159.992 203.176 161.83C202.752 162.142 202.683 162.152 202.767 162.274C202.664 162.372 202.493 162.538 202.577 162.556C202.821 162.819 201.772 163.347 201.35 163.64C201.299 163.007 198.877 164.587 196.265 166.402C193.656 168.217 190.857 170.263 190.152 170.669C189.606 170.392 187.425 172.332 186.474 172.641C186.524 172.59 186.833 172.259 186.873 172.217C186.41 172.299 183.223 174.407 180.493 176.07C177.764 177.74 175.516 178.988 177.175 177.734C175.235 178.616 173.113 179.603 170.822 180.577C168.532 181.54 166.067 182.54 163.456 183.224C162.154 183.56 160.807 183.815 159.497 183.803C158.191 183.791 156.979 183.442 156.242 182.556C155.477 181.677 155.139 180.305 154.988 178.896C154.836 177.474 154.85 175.979 154.877 174.467C154.904 172.956 154.95 171.419 154.894 169.86C154.833 168.307 154.69 166.713 154.18 165.15C153.921 164.372 153.569 163.602 153.06 162.917C152.556 162.229 151.906 161.637 151.181 161.205C149.71 160.347 148.073 160.104 146.565 160.078C145.039 160.051 143.582 160.243 142.18 160.497C140.778 160.756 139.433 161.094 138.14 161.451C135.553 162.185 133.16 163.009 130.962 163.794L131.116 163.797C130.973 163.836 130.562 164.039 130.429 164.014C129.622 164.463 128.14 165.219 126.867 165.874C125.596 166.533 124.528 167.086 124.528 167.086C123.027 167.894 121.538 168.721 120.06 169.567C120.06 169.567 118.062 170.513 115.722 171.757C113.382 173 110.701 174.537 109.276 175.593C105.391 177.713 101.546 179.903 97.7248 182.131C97.7248 182.131 96.5517 182.867 95.2217 183.749C94.5706 184.183 93.8793 184.648 93.2716 185.079C93.1687 184.982 93.1167 184.896 93.0843 184.797C93.0302 184.641 93.0771 184.317 93.212 183.985C93.3362 183.649 93.5296 183.303 93.7436 182.979C94.1774 182.324 94.6974 181.758 95.2718 181.359L95.2077 181.34C95.2369 181.333 95.2466 181.262 95.3182 181.295C95.2906 180.961 95.5572 180.306 95.5572 180.306L95.7789 179.569C95.7789 179.569 96.7008 178.661 96.622 177.992C97.0204 177.494 97.4163 176.991 97.8072 176.479C97.8072 176.479 98.1277 175.736 98.0185 175.388C97.9509 175.174 97.8312 174.99 97.683 174.876C97.3819 174.649 96.9787 174.711 96.6996 175.419C96.6782 175.413 96.6422 175.429 96.6112 175.416C96.4155 176.236 95.6029 176.625 95.1976 177.327C95.2946 177.379 95.3508 177.45 95.2881 177.439L95.1809 177.357C95.1046 177.959 94.545 177.985 94.6477 178.665L94.5337 178.514C94.082 179.241 93.476 180.042 92.8742 180.907C92.5728 181.341 92.2753 181.787 92.0131 182.272C91.7494 182.749 91.5132 183.276 91.3992 183.875L91.3924 183.885Z",
    fill: "#101214"
});

});






parcelRegister("cO3jF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fd493f9700e4208$export$2e2bcd8739ae039; });
/* project-landing-selector-view.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $91nJf = parcelRequire("91nJf");

var $1LPIk = parcelRequire("1LPIk");

var $gLWQf = parcelRequire("gLWQf");

var $aO3Hl = parcelRequire("aO3Hl");

var $1Y3bT = parcelRequire("1Y3bT");

var $dkYGl = parcelRequire("dkYGl");

var $6bw3Y = parcelRequire("6bw3Y");

var $5FBeD = parcelRequire("5FBeD");

var $223ve = parcelRequire("223ve");

var $6vNGx = parcelRequire("6vNGx");
const $6fd493f9700e4208$var$buttonWrapperCss = null;
const $6fd493f9700e4208$var$gridWrapperCss = null;
const $6fd493f9700e4208$var$removeUrlParameters = (url, paramKeys)=>{
    const r = new URL(url);
    paramKeys.forEach((key)=>{
        r.searchParams.delete(key);
    });
    return r.href;
};
const $6fd493f9700e4208$var$selectionButtonData = [
    {
        key: (0, $223ve.SAMPLE_PROJECT_KEY),
        header: (0, $6vNGx.messages).exploreSampleProjectHeader,
        body: (0, $6vNGx.messages).exploreSampleProjectBody
    },
    {
        key: (0, $223ve.CREATE_PROJECT_KEY),
        header: (0, $6vNGx.messages).createProjectHeader,
        body: (0, $6vNGx.messages).createProjectBody
    }
];
const $6fd493f9700e4208$var$ProjectLandingSelectorView = ()=>{
    const { teamType: teamType } = (0, $6bw3Y.useGetTeamTypeData)();
    const { products: products, edition: edition } = (0, $aO3Hl.useSearchParameters)();
    const productKey = (0, $dkYGl.getPrimaryProduct)(products);
    const dataFoundationAttributes = {
        productKey: productKey,
        edition: edition,
        teamType: teamType
    };
    const [selectedKey, setSelectedKey] = (0, $iSvIT.useState)("");
    const [selectedIndex, setSelectedIndex] = (0, $iSvIT.useState)(-1);
    const [randomized, setRandomized] = (0, $iSvIT.useState)(false);
    const intl = (0, $f6qj2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const { prevScreen: prevScreen, nextScreen: nextScreen } = (0, $1Y3bT.useScreenManager)();
    const onSelection = (key, index)=>{
        setSelectedKey(key);
        setSelectedIndex(index);
    };
    (0, $iSvIT.useEffect)(()=>{
        if (!randomized) {
            const r = Math.floor(Math.random() * 2);
            if (r === 0) $6fd493f9700e4208$var$selectionButtonData.reverse();
            setRandomized(true);
        }
    }, [
        randomized
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1LPIk.DataFoundationsWrapper), {
        dataFoundationsEventOption: "ProjectLandingSelectionScreenViewed",
        attributes: dataFoundationAttributes,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $gLWQf.JiraOnboardingContainer), {
            header: intl.formatMessage({
                id: (0, $6vNGx.messages).header.id,
                defaultMessage: (0, $6vNGx.messages).header.defaultMessage
            }),
            subheader: intl.formatMessage({
                id: (0, $6vNGx.messages).subHeader.id,
                defaultMessage: (0, $6vNGx.messages).subHeader.defaultMessage
            }),
            hideFooterOnMobile: true,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c11p5 _19pkidpf _2hwx1wug _otyridpf _18u01wug _19itglyw _zulp1k8s _p12f1an8 _19d7glyw"
                    ]),
                    children: $6fd493f9700e4208$var$selectionButtonData.map((item, index)=>{
                        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5FBeD.ProjectLandingSelectorButton), {
                            isChecked: selectedKey === item.key,
                            header: intl.formatMessage({
                                id: item.header.id,
                                defaultMessage: item.header.defaultMessage
                            }),
                            body: intl.formatMessage({
                                id: item.body.id,
                                defaultMessage: item.body.defaultMessage
                            }),
                            onClickFunc: ()=>{
                                onSelection(item.key, index);
                            }
                        }, item.key);
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx2vrvc _1bah1h6o _19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0q14no _u5f3gktf _n3tdgktf _19bvgktf _19itglyw _zulpv47k _1bsb13xl _13zm1n9t _1eg6idpf _13khidpf _1j30u67f _1kmxdlk8 _1ggmf6fq _1ykzdlk8 _1maef6fq _1rfm1osq _13z4eysh"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                            variant: "secondary",
                            size: "small",
                            color: "black",
                            onClick: ()=>{
                                // Remove jtbd and template choices
                                const updatedUrl = $6fd493f9700e4208$var$removeUrlParameters(window.location.href, [
                                    "templateChoice",
                                    "jtbd",
                                    "jtbdTemplateOverride",
                                    "jtbdPersona"
                                ]);
                                history.replaceState({}, "", updatedUrl);
                                prevScreen();
                            },
                            children: intl.formatMessage({
                                id: (0, $6vNGx.messages).backButton.id,
                                defaultMessage: (0, $6vNGx.messages).backButton.defaultMessage
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                            variant: "primary",
                            size: "small",
                            color: "blue",
                            isDisabled: selectedKey === "",
                            onClick: ()=>{
                                createAnalyticsEvent({
                                    actionSubject: "button",
                                    action: "clicked",
                                    actionSubjectId: "projectLandingSelection",
                                    attributes: {
                                        selection: selectedKey,
                                        selectionIndex: selectedIndex
                                    }
                                }).fire();
                                nextScreen();
                            },
                            children: intl.formatMessage({
                                id: (0, $6vNGx.messages).continueButton.id,
                                defaultMessage: (0, $6vNGx.messages).continueButton.defaultMessage
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $6fd493f9700e4208$export$2e2bcd8739ae039 = $6fd493f9700e4208$var$ProjectLandingSelectorView;

});
parcelRegister("5FBeD", function(module, exports) {

$parcel$export(module.exports, "ProjectLandingSelectorButton", function () { return $f8a893e95f85ee81$export$352b2dda289571f4; });
/* selection-buttons.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");
const $f8a893e95f85ee81$var$wrapperCss = null;
const $f8a893e95f85ee81$var$headerCss = null;
const $f8a893e95f85ee81$var$bodyCss = null;
const $f8a893e95f85ee81$export$352b2dda289571f4 = ({ header: header, body: body, isChecked: isChecked, onClickFunc: onClickFunc })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
        onClick: (e)=>{
            e.preventDefault();
            onClickFunc();
        },
        onKeyDown: (e)=>{
            if (e.key === "Enter") onClickFunc();
        },
        className: (0, $esG4f.default)([
            "_ca0q8jkm _u5f37vkz _n3td8jkm _19bv7vkz _19it1rq2 _2rkoftgi _1ul91kdj _80omtlke _1e0c1txw _2lx21bp4 _4cvr1y6m _4cvx1ism _1eq11h6o _1vzltlke _wdod1e5h _szsuidpf _1raa1wug _12vridpf _4e0g1y44 _1wnttlke _12ultlke",
            isChecked === true && "_1h6d1ism"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_ect41pz4 _k48pni7l _syazqlpt _1wyb1j6v _vwz4qgp8 _y3gn1e5h"
                ]),
                style: {
                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                },
                children: header
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_ect41pz4 _syaz1gjq"
                ]),
                style: {
                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display"))
                },
                children: body
            })
        ]
    });
};

});

parcelRegister("223ve", function(module, exports) {

$parcel$export(module.exports, "SAMPLE_PROJECT_KEY", function () { return $70c772d2cd8c3f22$export$289daff4af5c2b06; });
$parcel$export(module.exports, "CREATE_PROJECT_KEY", function () { return $70c772d2cd8c3f22$export$739f62e606ac32a3; });
const $70c772d2cd8c3f22$export$d98e1ab525f5bfc3 = "#101214";
const $70c772d2cd8c3f22$export$289daff4af5c2b06 = "sampleProject";
const $70c772d2cd8c3f22$export$739f62e606ac32a3 = "createProject";

});

parcelRegister("6vNGx", function(module, exports) {

$parcel$export(module.exports, "messages", function () { return $3e3279d79b5e3b90$export$defe85febe8b728c; });

var $6x1qA = parcelRequire("6x1qA");
const $3e3279d79b5e3b90$export$defe85febe8b728c = (0, $6x1qA.defineMessages)({
    backButton: {
        id: "projectLandingSelector.backButton",
        defaultMessage: "Back"
    },
    continueButton: {
        id: "projectLandingSelector.continueButton",
        defaultMessage: "Continue"
    },
    header: {
        id: "projectLandingSelector.header",
        defaultMessage: "How would you like to get started?"
    },
    subHeader: {
        id: "projectLandingSelector.subHeader",
        defaultMessage: "Your choices won\u2019t limit what you can do in Jira later."
    },
    exploreSampleProjectHeader: {
        id: "projectLandingSelector.exploreSampleProject.header",
        defaultMessage: "Explore a sample project"
    },
    exploreSampleProjectBody: {
        id: "projectLandingSelector.exploreSampleProject.body",
        defaultMessage: "Use sample tasks to learn the basics of Jira"
    },
    createProjectHeader: {
        id: "projectLandingSelector.createProject.header",
        defaultMessage: "Create your first project"
    },
    createProjectBody: {
        id: "projectLandingSelector.createProject.body",
        defaultMessage: "Setup a new project for your team"
    }
});

});





parcelRegister("b24io", function(module, exports) {

$parcel$export(module.exports, "ApolloProvider", function () { return $808336a331327b74$export$c16b04c8a9956446; });

var $9z2vN = parcelRequire("9z2vN");

var $61oCp = parcelRequire("61oCp");

var $2nXj1 = parcelRequire("2nXj1");

var $YaVEb = parcelRequire("YaVEb");
var $808336a331327b74$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, $YaVEb.getApolloContext)();
    var parentContext = $2nXj1.useContext(ApolloContext);
    var context = $2nXj1.useMemo(function() {
        return (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, parentContext), {
            client: client || parentContext.client
        });
    }, [
        parentContext,
        client
    ]);
    (0, $61oCp.invariant)(context.client, 55);
    return $2nXj1.createElement(ApolloContext.Provider, {
        value: context
    }, children);
};

});





//# sourceMappingURL=confirmation-page.b5dcca2b.js.map
